import type { IState } from '~/types/country/models'

export async function getStateListData(): Promise<IState[]> {
  return [
    {
      id: 3901,
      name: 'Badakhshan',
      iso2: 'BDS',
      countryId: 1,
    },
    {
      id: 3871,
      name: 'Badghis',
      iso2: 'BDG',
      countryId: 1,
    },
    {
      id: 3875,
      name: 'Baghlan',
      iso2: 'BGL',
      countryId: 1,
    },
    {
      id: 3884,
      name: 'Balkh',
      iso2: 'BAL',
      countryId: 1,
    },
    {
      id: 3872,
      name: 'Bamyan',
      iso2: 'BAM',
      countryId: 1,
    },
    {
      id: 3892,
      name: 'Daykundi',
      iso2: 'DAY',
      countryId: 1,
    },
    {
      id: 3899,
      name: 'Farah',
      iso2: 'FRA',
      countryId: 1,
    },
    {
      id: 3889,
      name: 'Faryab',
      iso2: 'FYB',
      countryId: 1,
    },
    {
      id: 3870,
      name: 'Ghazni',
      iso2: 'GHA',
      countryId: 1,
    },
    {
      id: 3888,
      name: 'Ghōr',
      iso2: 'GHO',
      countryId: 1,
    },
    {
      id: 3873,
      name: 'Helmand',
      iso2: 'HEL',
      countryId: 1,
    },
    {
      id: 3887,
      name: 'Herat',
      iso2: 'HER',
      countryId: 1,
    },
    {
      id: 3886,
      name: 'Jowzjan',
      iso2: 'JOW',
      countryId: 1,
    },
    {
      id: 3902,
      name: 'Kabul',
      iso2: 'KAB',
      countryId: 1,
    },
    {
      id: 3890,
      name: 'Kandahar',
      iso2: 'KAN',
      countryId: 1,
    },
    {
      id: 3879,
      name: 'Kapisa',
      iso2: 'KAP',
      countryId: 1,
    },
    {
      id: 3878,
      name: 'Khost',
      iso2: 'KHO',
      countryId: 1,
    },
    {
      id: 3876,
      name: 'Kunar',
      iso2: 'KNR',
      countryId: 1,
    },
    {
      id: 3900,
      name: 'Kunduz Province',
      iso2: 'KDZ',
      countryId: 1,
    },
    {
      id: 3891,
      name: 'Laghman',
      iso2: 'LAG',
      countryId: 1,
    },
    {
      id: 3897,
      name: 'Logar',
      iso2: 'LOG',
      countryId: 1,
    },
    {
      id: 3882,
      name: 'Nangarhar',
      iso2: 'NAN',
      countryId: 1,
    },
    {
      id: 3896,
      name: 'Nimruz',
      iso2: 'NIM',
      countryId: 1,
    },
    {
      id: 3880,
      name: 'Nuristan',
      iso2: 'NUR',
      countryId: 1,
    },
    {
      id: 3894,
      name: 'Paktia',
      iso2: 'PIA',
      countryId: 1,
    },
    {
      id: 3877,
      name: 'Paktika',
      iso2: 'PKA',
      countryId: 1,
    },
    {
      id: 3881,
      name: 'Panjshir',
      iso2: 'PAN',
      countryId: 1,
    },
    {
      id: 3895,
      name: 'Parwan',
      iso2: 'PAR',
      countryId: 1,
    },
    {
      id: 3883,
      name: 'Samangan',
      iso2: 'SAM',
      countryId: 1,
    },
    {
      id: 3885,
      name: 'Sar-e Pol',
      iso2: 'SAR',
      countryId: 1,
    },
    {
      id: 3893,
      name: 'Takhar',
      iso2: 'TAK',
      countryId: 1,
    },
    {
      id: 3898,
      name: 'Urozgan',
      iso2: 'URU',
      countryId: 1,
    },
    {
      id: 5468,
      name: 'Wardak',
      iso2: 'WAR',
      countryId: 1,
    },
    {
      id: 3874,
      name: 'Zabul',
      iso2: 'ZAB',
      countryId: 1,
    },
    {
      id: 5298,
      name: 'Brändö',
      iso2: '12',
      countryId: 2,
    },
    {
      id: 5294,
      name: 'Eckerö',
      iso2: '08',
      countryId: 2,
    },
    {
      id: 5289,
      name: 'Finström',
      iso2: '03',
      countryId: 2,
    },
    {
      id: 5295,
      name: 'Föglö',
      iso2: '09',
      countryId: 2,
    },
    {
      id: 5296,
      name: 'Geta',
      iso2: '10',
      countryId: 2,
    },
    {
      id: 5292,
      name: 'Hammarland',
      iso2: '06',
      countryId: 2,
    },
    {
      id: 5288,
      name: 'Jomala',
      iso2: '02',
      countryId: 2,
    },
    {
      id: 5301,
      name: 'Kökar',
      iso2: '15',
      countryId: 2,
    },
    {
      id: 5300,
      name: 'Kumlinge',
      iso2: '14',
      countryId: 2,
    },
    {
      id: 5290,
      name: 'Lemland',
      iso2: '04',
      countryId: 2,
    },
    {
      id: 5299,
      name: 'Lumparland',
      iso2: '13',
      countryId: 2,
    },
    {
      id: 5287,
      name: 'Mariehamn',
      iso2: '01',
      countryId: 2,
    },
    {
      id: 5291,
      name: 'Saltvik',
      iso2: '05',
      countryId: 2,
    },
    {
      id: 5302,
      name: 'Sottunga',
      iso2: '16',
      countryId: 2,
    },
    {
      id: 5293,
      name: 'Sund',
      iso2: '07',
      countryId: 2,
    },
    {
      id: 5297,
      name: 'Vårdö',
      iso2: '11',
      countryId: 2,
    },
    {
      id: 603,
      name: 'Berat',
      iso2: '01',
      countryId: 3,
    },
    {
      id: 610,
      name: 'Dibër',
      iso2: '09',
      countryId: 3,
    },
    {
      id: 632,
      name: 'Durrës',
      iso2: '02',
      countryId: 3,
    },
    {
      id: 598,
      name: 'Elbasan',
      iso2: '03',
      countryId: 3,
    },
    {
      id: 631,
      name: 'Fier',
      iso2: '04',
      countryId: 3,
    },
    {
      id: 604,
      name: 'Gjirokastër',
      iso2: '05',
      countryId: 3,
    },
    {
      id: 630,
      name: 'Korçë',
      iso2: '06',
      countryId: 3,
    },
    {
      id: 601,
      name: 'Kukës',
      iso2: '07',
      countryId: 3,
    },
    {
      id: 609,
      name: 'Lezhë',
      iso2: '08',
      countryId: 3,
    },
    {
      id: 611,
      name: 'Shkodër',
      iso2: '10',
      countryId: 3,
    },
    {
      id: 615,
      name: 'Tirana',
      iso2: '11',
      countryId: 3,
    },
    {
      id: 634,
      name: 'Vlorë',
      iso2: '12',
      countryId: 3,
    },
    {
      id: 1118,
      name: 'Adrar',
      iso2: '01',
      countryId: 4,
    },
    {
      id: 1119,
      name: 'Aïn Defla',
      iso2: '44',
      countryId: 4,
    },
    {
      id: 1122,
      name: 'Aïn Témouchent',
      iso2: '46',
      countryId: 4,
    },
    {
      id: 1144,
      name: 'Algiers',
      iso2: '16',
      countryId: 4,
    },
    {
      id: 1103,
      name: 'Annaba',
      iso2: '23',
      countryId: 4,
    },
    {
      id: 1142,
      name: 'Batna',
      iso2: '05',
      countryId: 4,
    },
    {
      id: 1108,
      name: 'Béchar',
      iso2: '08',
      countryId: 4,
    },
    {
      id: 1128,
      name: 'Béjaïa',
      iso2: '06',
      countryId: 4,
    },
    {
      id: 4909,
      name: 'Béni Abbès',
      iso2: '53',
      countryId: 4,
    },
    {
      id: 1114,
      name: 'Biskra',
      iso2: '07',
      countryId: 4,
    },
    {
      id: 1111,
      name: 'Blida',
      iso2: '09',
      countryId: 4,
    },
    {
      id: 4908,
      name: 'Bordj Baji Mokhtar',
      iso2: '52',
      countryId: 4,
    },
    {
      id: 1116,
      name: 'Bordj Bou Arréridj',
      iso2: '34',
      countryId: 4,
    },
    {
      id: 1104,
      name: 'Bouïra',
      iso2: '10',
      countryId: 4,
    },
    {
      id: 1125,
      name: 'Boumerdès',
      iso2: '35',
      countryId: 4,
    },
    {
      id: 1105,
      name: 'Chlef',
      iso2: '02',
      countryId: 4,
    },
    {
      id: 1121,
      name: 'Constantine',
      iso2: '25',
      countryId: 4,
    },
    {
      id: 4912,
      name: 'Djanet',
      iso2: '56',
      countryId: 4,
    },
    {
      id: 1098,
      name: 'Djelfa',
      iso2: '17',
      countryId: 4,
    },
    {
      id: 1129,
      name: 'El Bayadh',
      iso2: '32',
      countryId: 4,
    },
    {
      id: 4905,
      name: "El M'ghair",
      iso2: '49',
      countryId: 4,
    },
    {
      id: 4906,
      name: 'El Menia',
      iso2: '50',
      countryId: 4,
    },
    {
      id: 1099,
      name: 'El Oued',
      iso2: '39',
      countryId: 4,
    },
    {
      id: 1100,
      name: 'El Tarf',
      iso2: '36',
      countryId: 4,
    },
    {
      id: 1127,
      name: 'Ghardaïa',
      iso2: '47',
      countryId: 4,
    },
    {
      id: 1137,
      name: 'Guelma',
      iso2: '24',
      countryId: 4,
    },
    {
      id: 1112,
      name: 'Illizi',
      iso2: '33',
      countryId: 4,
    },
    {
      id: 4914,
      name: 'In Guezzam',
      iso2: '58',
      countryId: 4,
    },
    {
      id: 4913,
      name: 'In Salah',
      iso2: '57',
      countryId: 4,
    },
    {
      id: 1113,
      name: 'Jijel',
      iso2: '18',
      countryId: 4,
    },
    {
      id: 1126,
      name: 'Khenchela',
      iso2: '40',
      countryId: 4,
    },
    {
      id: 1138,
      name: 'Laghouat',
      iso2: '03',
      countryId: 4,
    },
    {
      id: 1134,
      name: "M'Sila",
      iso2: '28',
      countryId: 4,
    },
    {
      id: 1124,
      name: 'Mascara',
      iso2: '29',
      countryId: 4,
    },
    {
      id: 1109,
      name: 'Médéa',
      iso2: '26',
      countryId: 4,
    },
    {
      id: 1132,
      name: 'Mila',
      iso2: '43',
      countryId: 4,
    },
    {
      id: 1140,
      name: 'Mostaganem',
      iso2: '27',
      countryId: 4,
    },
    {
      id: 1102,
      name: 'Naama',
      iso2: '45',
      countryId: 4,
    },
    {
      id: 1101,
      name: 'Oran',
      iso2: '31',
      countryId: 4,
    },
    {
      id: 1139,
      name: 'Ouargla',
      iso2: '30',
      countryId: 4,
    },
    {
      id: 4907,
      name: 'Ouled Djellal',
      iso2: '51',
      countryId: 4,
    },
    {
      id: 1136,
      name: 'Oum El Bouaghi',
      iso2: '04',
      countryId: 4,
    },
    {
      id: 1130,
      name: 'Relizane',
      iso2: '48',
      countryId: 4,
    },
    {
      id: 1123,
      name: 'Saïda',
      iso2: '20',
      countryId: 4,
    },
    {
      id: 1141,
      name: 'Sétif',
      iso2: '19',
      countryId: 4,
    },
    {
      id: 4902,
      name: 'Sidi Bel Abbès',
      iso2: '22',
      countryId: 4,
    },
    {
      id: 1110,
      name: 'Skikda',
      iso2: '21',
      countryId: 4,
    },
    {
      id: 1143,
      name: 'Souk Ahras',
      iso2: '41',
      countryId: 4,
    },
    {
      id: 1135,
      name: 'Tamanghasset',
      iso2: '11',
      countryId: 4,
    },
    {
      id: 1117,
      name: 'Tébessa',
      iso2: '12',
      countryId: 4,
    },
    {
      id: 1106,
      name: 'Tiaret',
      iso2: '14',
      countryId: 4,
    },
    {
      id: 4910,
      name: 'Timimoun',
      iso2: '54',
      countryId: 4,
    },
    {
      id: 1120,
      name: 'Tindouf',
      iso2: '37',
      countryId: 4,
    },
    {
      id: 1115,
      name: 'Tipasa',
      iso2: '42',
      countryId: 4,
    },
    {
      id: 1133,
      name: 'Tissemsilt',
      iso2: '38',
      countryId: 4,
    },
    {
      id: 1131,
      name: 'Tizi Ouzou',
      iso2: '15',
      countryId: 4,
    },
    {
      id: 1107,
      name: 'Tlemcen',
      iso2: '13',
      countryId: 4,
    },
    {
      id: 4911,
      name: 'Touggourt',
      iso2: '55',
      countryId: 4,
    },
    {
      id: 5375,
      name: 'Eastern',
      iso2: '02',
      countryId: 5,
    },
    {
      id: 5376,
      name: 'Manuʻa',
      iso2: '03',
      countryId: 5,
    },
    {
      id: 5378,
      name: 'Rose',
      iso2: '05',
      countryId: 5,
    },
    {
      id: 5377,
      name: 'Swains',
      iso2: '04',
      countryId: 5,
    },
    {
      id: 5374,
      name: 'Western',
      iso2: '01',
      countryId: 5,
    },
    {
      id: 488,
      name: 'Andorra la Vella',
      iso2: '07',
      countryId: 6,
    },
    {
      id: 489,
      name: 'Canillo',
      iso2: '02',
      countryId: 6,
    },
    {
      id: 487,
      name: 'Encamp',
      iso2: '03',
      countryId: 6,
    },
    {
      id: 492,
      name: 'Escaldes-Engordany',
      iso2: '08',
      countryId: 6,
    },
    {
      id: 493,
      name: 'La Massana',
      iso2: '04',
      countryId: 6,
    },
    {
      id: 491,
      name: 'Ordino',
      iso2: '05',
      countryId: 6,
    },
    {
      id: 490,
      name: 'Sant Julià de Lòria',
      iso2: '06',
      countryId: 6,
    },
    {
      id: 221,
      name: 'Bengo',
      iso2: 'BGO',
      countryId: 7,
    },
    {
      id: 218,
      name: 'Benguela',
      iso2: 'BGU',
      countryId: 7,
    },
    {
      id: 212,
      name: 'Bié',
      iso2: 'BIE',
      countryId: 7,
    },
    {
      id: 228,
      name: 'Cabinda',
      iso2: 'CAB',
      countryId: 7,
    },
    {
      id: 226,
      name: 'Cuando Cubango',
      iso2: 'CCU',
      countryId: 7,
    },
    {
      id: 216,
      name: 'Cuanza',
      iso2: 'CUS',
      countryId: 7,
    },
    {
      id: 217,
      name: 'Cuanza Norte',
      iso2: 'CNO',
      countryId: 7,
    },
    {
      id: 215,
      name: 'Cunene',
      iso2: 'CNN',
      countryId: 7,
    },
    {
      id: 213,
      name: 'Huambo',
      iso2: 'HUA',
      countryId: 7,
    },
    {
      id: 225,
      name: 'Huíla',
      iso2: 'HUI',
      countryId: 7,
    },
    {
      id: 222,
      name: 'Luanda',
      iso2: 'LUA',
      countryId: 7,
    },
    {
      id: 223,
      name: 'Lunda Norte',
      iso2: 'LNO',
      countryId: 7,
    },
    {
      id: 220,
      name: 'Lunda Sul',
      iso2: 'LSU',
      countryId: 7,
    },
    {
      id: 227,
      name: 'Malanje',
      iso2: 'MAL',
      countryId: 7,
    },
    {
      id: 219,
      name: 'Moxico',
      iso2: 'MOX',
      countryId: 7,
    },
    {
      id: 5469,
      name: 'Namibe',
      iso2: 'NAM',
      countryId: 7,
    },
    {
      id: 224,
      name: 'Uíge',
      iso2: 'UIG',
      countryId: 7,
    },
    {
      id: 214,
      name: 'Zaire',
      iso2: 'ZAI',
      countryId: 7,
    },
    {
      id: 5273,
      name: 'Blowing Point',
      iso2: '01',
      countryId: 8,
    },
    {
      id: 5274,
      name: 'East End',
      iso2: '02',
      countryId: 8,
    },
    {
      id: 5275,
      name: 'George Hill',
      iso2: '03',
      countryId: 8,
    },
    {
      id: 5276,
      name: 'Island Harbour',
      iso2: '04',
      countryId: 8,
    },
    {
      id: 5277,
      name: 'North Hill',
      iso2: '05',
      countryId: 8,
    },
    {
      id: 5278,
      name: 'North Side',
      iso2: '06',
      countryId: 8,
    },
    {
      id: 5279,
      name: 'Sandy Ground',
      iso2: '07',
      countryId: 8,
    },
    {
      id: 5280,
      name: 'Sandy Hill',
      iso2: '08',
      countryId: 8,
    },
    {
      id: 5281,
      name: 'South Hill',
      iso2: '09',
      countryId: 8,
    },
    {
      id: 5282,
      name: 'Stoney Ground',
      iso2: '10',
      countryId: 8,
    },
    {
      id: 5283,
      name: 'The Farrington',
      iso2: '11',
      countryId: 8,
    },
    {
      id: 5284,
      name: 'The Quarter',
      iso2: '12',
      countryId: 8,
    },
    {
      id: 5285,
      name: 'The Valley',
      iso2: '13',
      countryId: 8,
    },
    {
      id: 5286,
      name: 'West End',
      iso2: '14',
      countryId: 8,
    },
    {
      id: 3708,
      name: 'Barbuda',
      iso2: '10',
      countryId: 10,
    },
    {
      id: 3703,
      name: 'Redonda',
      iso2: '11',
      countryId: 10,
    },
    {
      id: 3709,
      name: 'Saint George',
      iso2: '03',
      countryId: 10,
    },
    {
      id: 3706,
      name: 'Saint John',
      iso2: '04',
      countryId: 10,
    },
    {
      id: 3707,
      name: 'Saint Mary',
      iso2: '05',
      countryId: 10,
    },
    {
      id: 3705,
      name: 'Saint Paul',
      iso2: '06',
      countryId: 10,
    },
    {
      id: 3704,
      name: 'Saint Peter',
      iso2: '07',
      countryId: 10,
    },
    {
      id: 3710,
      name: 'Saint Philip',
      iso2: '08',
      countryId: 10,
    },
    {
      id: 4880,
      name: 'Autonomous City of Buenos Aires',
      iso2: 'C',
      countryId: 11,
    },
    {
      id: 3656,
      name: 'Buenos Aires',
      iso2: 'B',
      countryId: 11,
    },
    {
      id: 3647,
      name: 'Catamarca',
      iso2: 'K',
      countryId: 11,
    },
    {
      id: 3640,
      name: 'Chaco',
      iso2: 'H',
      countryId: 11,
    },
    {
      id: 3651,
      name: 'Chubut',
      iso2: 'U',
      countryId: 11,
    },
    {
      id: 3642,
      name: 'Córdoba',
      iso2: 'X',
      countryId: 11,
    },
    {
      id: 3638,
      name: 'Corrientes',
      iso2: 'W',
      countryId: 11,
    },
    {
      id: 3654,
      name: 'Entre Ríos',
      iso2: 'E',
      countryId: 11,
    },
    {
      id: 3652,
      name: 'Formosa',
      iso2: 'P',
      countryId: 11,
    },
    {
      id: 3645,
      name: 'Jujuy',
      iso2: 'Y',
      countryId: 11,
    },
    {
      id: 3655,
      name: 'La Pampa',
      iso2: 'L',
      countryId: 11,
    },
    {
      id: 3653,
      name: 'La Rioja',
      iso2: 'F',
      countryId: 11,
    },
    {
      id: 3646,
      name: 'Mendoza',
      iso2: 'M',
      countryId: 11,
    },
    {
      id: 3644,
      name: 'Misiones',
      iso2: 'N',
      countryId: 11,
    },
    {
      id: 3648,
      name: 'Neuquén',
      iso2: 'Q',
      countryId: 11,
    },
    {
      id: 3639,
      name: 'Río Negro',
      iso2: 'R',
      countryId: 11,
    },
    {
      id: 3643,
      name: 'Salta',
      iso2: 'A',
      countryId: 11,
    },
    {
      id: 3634,
      name: 'San Juan',
      iso2: 'J',
      countryId: 11,
    },
    {
      id: 3636,
      name: 'San Luis',
      iso2: 'D',
      countryId: 11,
    },
    {
      id: 3649,
      name: 'Santa Cruz',
      iso2: 'Z',
      countryId: 11,
    },
    {
      id: 3641,
      name: 'Santa Fe',
      iso2: 'S',
      countryId: 11,
    },
    {
      id: 3635,
      name: 'Santiago del Estero',
      iso2: 'G',
      countryId: 11,
    },
    {
      id: 3650,
      name: 'Tierra del Fuego',
      iso2: 'V',
      countryId: 11,
    },
    {
      id: 3637,
      name: 'Tucumán',
      iso2: 'T',
      countryId: 11,
    },
    {
      id: 2023,
      name: 'Aragatsotn',
      iso2: 'AG',
      countryId: 12,
    },
    {
      id: 2024,
      name: 'Ararat',
      iso2: 'AR',
      countryId: 12,
    },
    {
      id: 2026,
      name: 'Armavir',
      iso2: 'AV',
      countryId: 12,
    },
    {
      id: 2028,
      name: 'Gegharkunik',
      iso2: 'GR',
      countryId: 12,
    },
    {
      id: 2033,
      name: 'Kotayk',
      iso2: 'KT',
      countryId: 12,
    },
    {
      id: 2029,
      name: 'Lori',
      iso2: 'LO',
      countryId: 12,
    },
    {
      id: 2031,
      name: 'Shirak',
      iso2: 'SH',
      countryId: 12,
    },
    {
      id: 2027,
      name: 'Syunik',
      iso2: 'SU',
      countryId: 12,
    },
    {
      id: 2032,
      name: 'Tavush',
      iso2: 'TV',
      countryId: 12,
    },
    {
      id: 2025,
      name: 'Vayots Dzor',
      iso2: 'VD',
      countryId: 12,
    },
    {
      id: 2030,
      name: 'Yerevan',
      iso2: 'ER',
      countryId: 12,
    },
    {
      id: 5243,
      name: 'Noord',
      iso2: '01',
      countryId: 13,
    },
    {
      id: 5341,
      name: 'Oranjestad',
      iso2: '09',
      countryId: 13,
    },
    {
      id: 5245,
      name: 'Oranjestad East',
      iso2: '03',
      countryId: 13,
    },
    {
      id: 5244,
      name: 'Oranjestad West',
      iso2: '02',
      countryId: 13,
    },
    {
      id: 5246,
      name: 'Paradera',
      iso2: '04',
      countryId: 13,
    },
    {
      id: 5247,
      name: 'San Nicolaas Noord',
      iso2: '05',
      countryId: 13,
    },
    {
      id: 5248,
      name: 'San Nicolaas Zuid',
      iso2: '06',
      countryId: 13,
    },
    {
      id: 5249,
      name: 'Santa Cruz',
      iso2: '07',
      countryId: 13,
    },
    {
      id: 5250,
      name: 'Savaneta',
      iso2: '08',
      countryId: 13,
    },
    {
      id: 3907,
      name: 'Australian Capital Territory',
      iso2: 'ACT',
      countryId: 14,
    },
    {
      id: 3909,
      name: 'New South Wales',
      iso2: 'NSW',
      countryId: 14,
    },
    {
      id: 3910,
      name: 'Northern Territory',
      iso2: 'NT',
      countryId: 14,
    },
    {
      id: 3905,
      name: 'Queensland',
      iso2: 'QLD',
      countryId: 14,
    },
    {
      id: 3904,
      name: 'South Australia',
      iso2: 'SA',
      countryId: 14,
    },
    {
      id: 3908,
      name: 'Tasmania',
      iso2: 'TAS',
      countryId: 14,
    },
    {
      id: 3903,
      name: 'Victoria',
      iso2: 'VIC',
      countryId: 14,
    },
    {
      id: 3906,
      name: 'Western Australia',
      iso2: 'WA',
      countryId: 14,
    },
    {
      id: 2062,
      name: 'Burgenland',
      iso2: '1',
      countryId: 15,
    },
    {
      id: 2057,
      name: 'Carinthia',
      iso2: '2',
      countryId: 15,
    },
    {
      id: 2065,
      name: 'Lower Austria',
      iso2: '3',
      countryId: 15,
    },
    {
      id: 2061,
      name: 'Salzburg',
      iso2: '5',
      countryId: 15,
    },
    {
      id: 2059,
      name: 'Styria',
      iso2: '6',
      countryId: 15,
    },
    {
      id: 2064,
      name: 'Tyrol',
      iso2: '7',
      countryId: 15,
    },
    {
      id: 2058,
      name: 'Upper Austria',
      iso2: '4',
      countryId: 15,
    },
    {
      id: 2060,
      name: 'Vienna',
      iso2: '9',
      countryId: 15,
    },
    {
      id: 2063,
      name: 'Vorarlberg',
      iso2: '8',
      countryId: 15,
    },
    {
      id: 540,
      name: 'Absheron',
      iso2: 'ABS',
      countryId: 16,
    },
    {
      id: 559,
      name: 'Agdam',
      iso2: 'AGM',
      countryId: 16,
    },
    {
      id: 553,
      name: 'Agdash',
      iso2: 'AGS',
      countryId: 16,
    },
    {
      id: 577,
      name: 'Aghjabadi',
      iso2: 'AGC',
      countryId: 16,
    },
    {
      id: 543,
      name: 'Agstafa',
      iso2: 'AGA',
      countryId: 16,
    },
    {
      id: 547,
      name: 'Agsu',
      iso2: 'AGU',
      countryId: 16,
    },
    {
      id: 528,
      name: 'Astara',
      iso2: 'AST',
      countryId: 16,
    },
    {
      id: 575,
      name: 'Babek',
      iso2: 'BAB',
      countryId: 16,
    },
    {
      id: 552,
      name: 'Baku',
      iso2: 'BA',
      countryId: 16,
    },
    {
      id: 560,
      name: 'Balakan',
      iso2: 'BAL',
      countryId: 16,
    },
    {
      id: 569,
      name: 'Barda',
      iso2: 'BAR',
      countryId: 16,
    },
    {
      id: 554,
      name: 'Beylagan',
      iso2: 'BEY',
      countryId: 16,
    },
    {
      id: 532,
      name: 'Bilasuvar',
      iso2: 'BIL',
      countryId: 16,
    },
    {
      id: 561,
      name: 'Dashkasan',
      iso2: 'DAS',
      countryId: 16,
    },
    {
      id: 527,
      name: 'Fizuli',
      iso2: 'FUZ',
      countryId: 16,
    },
    {
      id: 585,
      name: 'Ganja',
      iso2: 'GA',
      countryId: 16,
    },
    {
      id: 589,
      name: 'Gədəbəy',
      iso2: 'GAD',
      countryId: 16,
    },
    {
      id: 573,
      name: 'Gobustan',
      iso2: 'QOB',
      countryId: 16,
    },
    {
      id: 551,
      name: 'Goranboy',
      iso2: 'GOR',
      countryId: 16,
    },
    {
      id: 531,
      name: 'Goychay',
      iso2: 'GOY',
      countryId: 16,
    },
    {
      id: 574,
      name: 'Goygol',
      iso2: 'GYG',
      countryId: 16,
    },
    {
      id: 571,
      name: 'Hajigabul',
      iso2: 'HAC',
      countryId: 16,
    },
    {
      id: 544,
      name: 'Imishli',
      iso2: 'IMI',
      countryId: 16,
    },
    {
      id: 564,
      name: 'Ismailli',
      iso2: 'ISM',
      countryId: 16,
    },
    {
      id: 570,
      name: 'Jabrayil',
      iso2: 'CAB',
      countryId: 16,
    },
    {
      id: 578,
      name: 'Jalilabad',
      iso2: 'CAL',
      countryId: 16,
    },
    {
      id: 572,
      name: 'Julfa',
      iso2: 'CUL',
      countryId: 16,
    },
    {
      id: 525,
      name: 'Kalbajar',
      iso2: 'KAL',
      countryId: 16,
    },
    {
      id: 567,
      name: 'Kangarli',
      iso2: 'KAN',
      countryId: 16,
    },
    {
      id: 590,
      name: 'Khachmaz',
      iso2: 'XAC',
      countryId: 16,
    },
    {
      id: 5472,
      name: 'Khankendi',
      iso2: 'XA',
      countryId: 16,
    },
    {
      id: 537,
      name: 'Khizi',
      iso2: 'XIZ',
      countryId: 16,
    },
    {
      id: 524,
      name: 'Khojali',
      iso2: 'XCI',
      countryId: 16,
    },
    {
      id: 549,
      name: 'Kurdamir',
      iso2: 'KUR',
      countryId: 16,
    },
    {
      id: 541,
      name: 'Lachin',
      iso2: 'LAC',
      countryId: 16,
    },
    {
      id: 587,
      name: 'Lankaran',
      iso2: 'LAN',
      countryId: 16,
    },
    {
      id: 558,
      name: 'Lankaran',
      iso2: 'LA',
      countryId: 16,
    },
    {
      id: 546,
      name: 'Lerik',
      iso2: 'LER',
      countryId: 16,
    },
    {
      id: 568,
      name: 'Martuni',
      iso2: 'XVD',
      countryId: 16,
    },
    {
      id: 555,
      name: 'Masally',
      iso2: 'MAS',
      countryId: 16,
    },
    {
      id: 580,
      name: 'Mingachevir',
      iso2: 'MI',
      countryId: 16,
    },
    {
      id: 5470,
      name: 'Naftalan',
      iso2: 'NA',
      countryId: 16,
    },
    {
      id: 5471,
      name: 'Nakhchivan',
      iso2: 'NV',
      countryId: 16,
    },
    {
      id: 562,
      name: 'Nakhchivan',
      iso2: 'NX',
      countryId: 16,
    },
    {
      id: 530,
      name: 'Neftchala',
      iso2: 'NEF',
      countryId: 16,
    },
    {
      id: 556,
      name: 'Oghuz',
      iso2: 'OGU',
      countryId: 16,
    },
    {
      id: 534,
      name: 'Ordubad',
      iso2: 'ORD',
      countryId: 16,
    },
    {
      id: 542,
      name: 'Qabala',
      iso2: 'QAB',
      countryId: 16,
    },
    {
      id: 526,
      name: 'Qakh',
      iso2: 'QAX',
      countryId: 16,
    },
    {
      id: 521,
      name: 'Qazakh',
      iso2: 'QAZ',
      countryId: 16,
    },
    {
      id: 563,
      name: 'Quba',
      iso2: 'QBA',
      countryId: 16,
    },
    {
      id: 548,
      name: 'Qubadli',
      iso2: 'QBI',
      countryId: 16,
    },
    {
      id: 588,
      name: 'Qusar',
      iso2: 'QUS',
      countryId: 16,
    },
    {
      id: 557,
      name: 'Saatly',
      iso2: 'SAT',
      countryId: 16,
    },
    {
      id: 565,
      name: 'Sabirabad',
      iso2: 'SAB',
      countryId: 16,
    },
    {
      id: 522,
      name: 'Sadarak',
      iso2: 'SAD',
      countryId: 16,
    },
    {
      id: 545,
      name: 'Salyan',
      iso2: 'SAL',
      countryId: 16,
    },
    {
      id: 536,
      name: 'Samukh',
      iso2: 'SMX',
      countryId: 16,
    },
    {
      id: 591,
      name: 'Shabran',
      iso2: 'SBN',
      countryId: 16,
    },
    {
      id: 579,
      name: 'Shahbuz',
      iso2: 'SAH',
      countryId: 16,
    },
    {
      id: 518,
      name: 'Shaki',
      iso2: 'SA',
      countryId: 16,
    },
    {
      id: 586,
      name: 'Shaki',
      iso2: 'SAK',
      countryId: 16,
    },
    {
      id: 529,
      name: 'Shamakhi',
      iso2: 'SMI',
      countryId: 16,
    },
    {
      id: 583,
      name: 'Shamkir',
      iso2: 'SKR',
      countryId: 16,
    },
    {
      id: 535,
      name: 'Sharur',
      iso2: 'SAR',
      countryId: 16,
    },
    {
      id: 520,
      name: 'Shirvan',
      iso2: 'SR',
      countryId: 16,
    },
    {
      id: 592,
      name: 'Shusha',
      iso2: 'SUS',
      countryId: 16,
    },
    {
      id: 584,
      name: 'Siazan',
      iso2: 'SIY',
      countryId: 16,
    },
    {
      id: 582,
      name: 'Sumqayit',
      iso2: 'SM',
      countryId: 16,
    },
    {
      id: 519,
      name: 'Tartar',
      iso2: 'TAR',
      countryId: 16,
    },
    {
      id: 533,
      name: 'Tovuz',
      iso2: 'TOV',
      countryId: 16,
    },
    {
      id: 539,
      name: 'Ujar',
      iso2: 'UCA',
      countryId: 16,
    },
    {
      id: 550,
      name: 'Yardymli',
      iso2: 'YAR',
      countryId: 16,
    },
    {
      id: 523,
      name: 'Yevlakh',
      iso2: 'YEV',
      countryId: 16,
    },
    {
      id: 538,
      name: 'Yevlakh',
      iso2: 'YE',
      countryId: 16,
    },
    {
      id: 581,
      name: 'Zangilan',
      iso2: 'ZAN',
      countryId: 16,
    },
    {
      id: 566,
      name: 'Zaqatala',
      iso2: 'ZAQ',
      countryId: 16,
    },
    {
      id: 576,
      name: 'Zardab',
      iso2: 'ZAR',
      countryId: 16,
    },
    {
      id: 1992,
      name: 'Capital',
      iso2: '13',
      countryId: 18,
    },
    {
      id: 1995,
      name: 'Muharraq',
      iso2: '15',
      countryId: 18,
    },
    {
      id: 1994,
      name: 'Northern',
      iso2: '17',
      countryId: 18,
    },
    {
      id: 1993,
      name: 'Southern',
      iso2: '14',
      countryId: 18,
    },
    {
      id: 5473,
      name: 'Bagerhat',
      iso2: '05',
      countryId: 19,
    },
    {
      id: 5474,
      name: 'Bandarban',
      iso2: '01',
      countryId: 19,
    },
    {
      id: 5475,
      name: 'Barguna',
      iso2: '02',
      countryId: 19,
    },
    {
      id: 807,
      name: 'Barisal ',
      iso2: 'A',
      countryId: 19,
    },
    {
      id: 5476,
      name: 'Barishal',
      iso2: '06',
      countryId: 19,
    },
    {
      id: 5477,
      name: 'Bhola',
      iso2: '07',
      countryId: 19,
    },
    {
      id: 5478,
      name: 'Bogura',
      iso2: '03',
      countryId: 19,
    },
    {
      id: 5479,
      name: 'Brahmanbaria',
      iso2: '04',
      countryId: 19,
    },
    {
      id: 5480,
      name: 'Chandpur',
      iso2: '09',
      countryId: 19,
    },
    {
      id: 5481,
      name: 'Chapai Nawabganj',
      iso2: '45',
      countryId: 19,
    },
    {
      id: 5482,
      name: 'Chattogram',
      iso2: '10',
      countryId: 19,
    },
    {
      id: 803,
      name: 'Chittagong ',
      iso2: 'B',
      countryId: 19,
    },
    {
      id: 5483,
      name: 'Chuadanga',
      iso2: '12',
      countryId: 19,
    },
    {
      id: 5484,
      name: "Cox's Bazar",
      iso2: '11',
      countryId: 19,
    },
    {
      id: 5485,
      name: 'Cumilla',
      iso2: '08',
      countryId: 19,
    },
    {
      id: 5486,
      name: 'Dhaka',
      iso2: '13',
      countryId: 19,
    },
    {
      id: 760,
      name: 'Dhaka ',
      iso2: 'C',
      countryId: 19,
    },
    {
      id: 5487,
      name: 'Dinajpur',
      iso2: '14',
      countryId: 19,
    },
    {
      id: 5488,
      name: 'Faridpur',
      iso2: '15',
      countryId: 19,
    },
    {
      id: 5489,
      name: 'Feni',
      iso2: '16',
      countryId: 19,
    },
    {
      id: 5490,
      name: 'Gaibandha',
      iso2: '19',
      countryId: 19,
    },
    {
      id: 5491,
      name: 'Gazipur',
      iso2: '18',
      countryId: 19,
    },
    {
      id: 5492,
      name: 'Gopalganj',
      iso2: '17',
      countryId: 19,
    },
    {
      id: 5493,
      name: 'Habiganj',
      iso2: '20',
      countryId: 19,
    },
    {
      id: 5494,
      name: 'Jamalpur',
      iso2: '21',
      countryId: 19,
    },
    {
      id: 5495,
      name: 'Jashore',
      iso2: '22',
      countryId: 19,
    },
    {
      id: 5496,
      name: 'Jhalakathi',
      iso2: '25',
      countryId: 19,
    },
    {
      id: 5497,
      name: 'Jhenaidah',
      iso2: '23',
      countryId: 19,
    },
    {
      id: 5498,
      name: 'Joypurhat',
      iso2: '24',
      countryId: 19,
    },
    {
      id: 5499,
      name: 'Khagrachhari',
      iso2: '29',
      countryId: 19,
    },
    {
      id: 5500,
      name: 'Khulna',
      iso2: '27',
      countryId: 19,
    },
    {
      id: 775,
      name: 'Khulna ',
      iso2: 'D',
      countryId: 19,
    },
    {
      id: 5501,
      name: 'Kishoreganj',
      iso2: '26',
      countryId: 19,
    },
    {
      id: 5502,
      name: 'Kurigram',
      iso2: '28',
      countryId: 19,
    },
    {
      id: 5503,
      name: 'Kushtia',
      iso2: '30',
      countryId: 19,
    },
    {
      id: 5504,
      name: 'Lakshmipur',
      iso2: '31',
      countryId: 19,
    },
    {
      id: 5505,
      name: 'Lalmonirhat',
      iso2: '32',
      countryId: 19,
    },
    {
      id: 5506,
      name: 'Madaripur',
      iso2: '36',
      countryId: 19,
    },
    {
      id: 5507,
      name: 'Magura',
      iso2: '37',
      countryId: 19,
    },
    {
      id: 5508,
      name: 'Manikganj',
      iso2: '33',
      countryId: 19,
    },
    {
      id: 5509,
      name: 'Meherpur',
      iso2: '39',
      countryId: 19,
    },
    {
      id: 5510,
      name: 'Moulvibazar',
      iso2: '38',
      countryId: 19,
    },
    {
      id: 5511,
      name: 'Munshiganj',
      iso2: '35',
      countryId: 19,
    },
    {
      id: 5512,
      name: 'Mymensingh',
      iso2: '34',
      countryId: 19,
    },
    {
      id: 758,
      name: 'Mymensingh ',
      iso2: 'H',
      countryId: 19,
    },
    {
      id: 5513,
      name: 'Naogaon',
      iso2: '48',
      countryId: 19,
    },
    {
      id: 5514,
      name: 'Narail',
      iso2: '43',
      countryId: 19,
    },
    {
      id: 5515,
      name: 'Narayanganj',
      iso2: '40',
      countryId: 19,
    },
    {
      id: 5516,
      name: 'Narsingdi',
      iso2: '42',
      countryId: 19,
    },
    {
      id: 5517,
      name: 'Natore',
      iso2: '44',
      countryId: 19,
    },
    {
      id: 5518,
      name: 'Netrakona',
      iso2: '41',
      countryId: 19,
    },
    {
      id: 5519,
      name: 'Nilphamari',
      iso2: '46',
      countryId: 19,
    },
    {
      id: 5520,
      name: 'Noakhali',
      iso2: '47',
      countryId: 19,
    },
    {
      id: 5521,
      name: 'Pabna',
      iso2: '49',
      countryId: 19,
    },
    {
      id: 5522,
      name: 'Panchagarh',
      iso2: '52',
      countryId: 19,
    },
    {
      id: 5523,
      name: 'Patuakhali',
      iso2: '51',
      countryId: 19,
    },
    {
      id: 5524,
      name: 'Pirojpur',
      iso2: '50',
      countryId: 19,
    },
    {
      id: 5525,
      name: 'Rajbari',
      iso2: '53',
      countryId: 19,
    },
    {
      id: 5526,
      name: 'Rajshahi',
      iso2: '54',
      countryId: 19,
    },
    {
      id: 753,
      name: 'Rajshahi ',
      iso2: 'E',
      countryId: 19,
    },
    {
      id: 5527,
      name: 'Rangamati',
      iso2: '56',
      countryId: 19,
    },
    {
      id: 750,
      name: 'Rangpur ',
      iso2: 'F',
      countryId: 19,
    },
    {
      id: 5528,
      name: 'Rangpur',
      iso2: '55',
      countryId: 19,
    },
    {
      id: 5529,
      name: 'Satkhira',
      iso2: '58',
      countryId: 19,
    },
    {
      id: 5530,
      name: 'Shariatpur',
      iso2: '62',
      countryId: 19,
    },
    {
      id: 5531,
      name: 'Sherpur',
      iso2: '57',
      countryId: 19,
    },
    {
      id: 5532,
      name: 'Sirajganj',
      iso2: '59',
      countryId: 19,
    },
    {
      id: 5533,
      name: 'Sunamganj',
      iso2: '61',
      countryId: 19,
    },
    {
      id: 765,
      name: 'Sylhet ',
      iso2: 'G',
      countryId: 19,
    },
    {
      id: 5534,
      name: 'Sylhet',
      iso2: '60',
      countryId: 19,
    },
    {
      id: 5535,
      name: 'Tangail',
      iso2: '63',
      countryId: 19,
    },
    {
      id: 5536,
      name: 'Thakurgaon',
      iso2: '64',
      countryId: 19,
    },
    {
      id: 1228,
      name: 'Christ Church',
      iso2: '01',
      countryId: 20,
    },
    {
      id: 1229,
      name: 'Saint Andrew',
      iso2: '02',
      countryId: 20,
    },
    {
      id: 1226,
      name: 'Saint George',
      iso2: '03',
      countryId: 20,
    },
    {
      id: 1224,
      name: 'Saint James',
      iso2: '04',
      countryId: 20,
    },
    {
      id: 1227,
      name: 'Saint John',
      iso2: '05',
      countryId: 20,
    },
    {
      id: 1223,
      name: 'Saint Joseph',
      iso2: '06',
      countryId: 20,
    },
    {
      id: 1221,
      name: 'Saint Lucy',
      iso2: '07',
      countryId: 20,
    },
    {
      id: 1230,
      name: 'Saint Michael',
      iso2: '08',
      countryId: 20,
    },
    {
      id: 1222,
      name: 'Saint Peter',
      iso2: '09',
      countryId: 20,
    },
    {
      id: 1220,
      name: 'Saint Philip',
      iso2: '10',
      countryId: 20,
    },
    {
      id: 1225,
      name: 'Saint Thomas',
      iso2: '11',
      countryId: 20,
    },
    {
      id: 2959,
      name: 'Brest',
      iso2: 'BR',
      countryId: 21,
    },
    {
      id: 2955,
      name: 'Gomel',
      iso2: 'HO',
      countryId: 21,
    },
    {
      id: 2956,
      name: 'Grodno',
      iso2: 'HR',
      countryId: 21,
    },
    {
      id: 2957,
      name: 'Minsk',
      iso2: 'MI',
      countryId: 21,
    },
    {
      id: 2958,
      name: 'Minsk',
      iso2: 'HM',
      countryId: 21,
    },
    {
      id: 2954,
      name: 'Mogilev',
      iso2: 'MA',
      countryId: 21,
    },
    {
      id: 2960,
      name: 'Vitebsk',
      iso2: 'VI',
      countryId: 21,
    },
    {
      id: 1381,
      name: 'Antwerp',
      iso2: 'VAN',
      countryId: 22,
    },
    {
      id: 1376,
      name: 'Brussels-Capital ',
      iso2: 'BRU',
      countryId: 22,
    },
    {
      id: 1377,
      name: 'East Flanders',
      iso2: 'VOV',
      countryId: 22,
    },
    {
      id: 1373,
      name: 'Flanders',
      iso2: 'VLG',
      countryId: 22,
    },
    {
      id: 1374,
      name: 'Flemish Brabant',
      iso2: 'VBR',
      countryId: 22,
    },
    {
      id: 1375,
      name: 'Hainaut',
      iso2: 'WHT',
      countryId: 22,
    },
    {
      id: 1384,
      name: 'Liège',
      iso2: 'WLG',
      countryId: 22,
    },
    {
      id: 1372,
      name: 'Limburg',
      iso2: 'VLI',
      countryId: 22,
    },
    {
      id: 1379,
      name: 'Luxembourg',
      iso2: 'WLX',
      countryId: 22,
    },
    {
      id: 1378,
      name: 'Namur',
      iso2: 'WNA',
      countryId: 22,
    },
    {
      id: 1380,
      name: 'Wallonia',
      iso2: 'WAL',
      countryId: 22,
    },
    {
      id: 1382,
      name: 'Walloon Brabant',
      iso2: 'WBR',
      countryId: 22,
    },
    {
      id: 1383,
      name: 'West Flanders',
      iso2: 'VWV',
      countryId: 22,
    },
    {
      id: 264,
      name: 'Belize',
      iso2: 'BZ',
      countryId: 23,
    },
    {
      id: 269,
      name: 'Cayo',
      iso2: 'CY',
      countryId: 23,
    },
    {
      id: 266,
      name: 'Corozal',
      iso2: 'CZL',
      countryId: 23,
    },
    {
      id: 268,
      name: 'Orange Walk',
      iso2: 'OW',
      countryId: 23,
    },
    {
      id: 265,
      name: 'Stann Creek',
      iso2: 'SC',
      countryId: 23,
    },
    {
      id: 267,
      name: 'Toledo',
      iso2: 'TOL',
      countryId: 23,
    },
    {
      id: 3077,
      name: 'Alibori',
      iso2: 'AL',
      countryId: 24,
    },
    {
      id: 3076,
      name: 'Atakora',
      iso2: 'AK',
      countryId: 24,
    },
    {
      id: 3079,
      name: 'Atlantique',
      iso2: 'AQ',
      countryId: 24,
    },
    {
      id: 3078,
      name: 'Borgou',
      iso2: 'BO',
      countryId: 24,
    },
    {
      id: 3070,
      name: 'Collines',
      iso2: 'CO',
      countryId: 24,
    },
    {
      id: 3072,
      name: 'Donga',
      iso2: 'DO',
      countryId: 24,
    },
    {
      id: 3071,
      name: 'Kouffo',
      iso2: 'KO',
      countryId: 24,
    },
    {
      id: 3081,
      name: 'Littoral',
      iso2: 'LI',
      countryId: 24,
    },
    {
      id: 3075,
      name: 'Mono',
      iso2: 'MO',
      countryId: 24,
    },
    {
      id: 3080,
      name: 'Ouémé',
      iso2: 'OU',
      countryId: 24,
    },
    {
      id: 3074,
      name: 'Plateau',
      iso2: 'PL',
      countryId: 24,
    },
    {
      id: 3073,
      name: 'Zou',
      iso2: 'ZO',
      countryId: 24,
    },
    {
      id: 4860,
      name: 'Devonshire',
      iso2: 'DEV',
      countryId: 25,
    },
    {
      id: 4861,
      name: 'Hamilton',
      iso2: 'HA',
      countryId: 25,
    },
    {
      id: 4863,
      name: 'Paget',
      iso2: 'PAG',
      countryId: 25,
    },
    {
      id: 4864,
      name: 'Pembroke',
      iso2: 'PEM',
      countryId: 25,
    },
    {
      id: 4866,
      name: "Saint George's",
      iso2: 'SGE',
      countryId: 25,
    },
    {
      id: 4867,
      name: 'Sandys',
      iso2: 'SAN',
      countryId: 25,
    },
    {
      id: 4868,
      name: "Smith's",
      iso2: 'SMI',
      countryId: 25,
    },
    {
      id: 4869,
      name: 'Southampton',
      iso2: 'SOU',
      countryId: 25,
    },
    {
      id: 4870,
      name: 'Warwick',
      iso2: 'WAR',
      countryId: 25,
    },
    {
      id: 240,
      name: 'Bumthang ',
      iso2: '33',
      countryId: 26,
    },
    {
      id: 239,
      name: 'Chukha ',
      iso2: '12',
      countryId: 26,
    },
    {
      id: 238,
      name: 'Dagana ',
      iso2: '22',
      countryId: 26,
    },
    {
      id: 229,
      name: 'Gasa ',
      iso2: 'GA',
      countryId: 26,
    },
    {
      id: 232,
      name: 'Haa ',
      iso2: '13',
      countryId: 26,
    },
    {
      id: 234,
      name: 'Lhuntse ',
      iso2: '44',
      countryId: 26,
    },
    {
      id: 242,
      name: 'Mongar ',
      iso2: '42',
      countryId: 26,
    },
    {
      id: 237,
      name: 'Paro ',
      iso2: '11',
      countryId: 26,
    },
    {
      id: 244,
      name: 'Pemagatshel ',
      iso2: '43',
      countryId: 26,
    },
    {
      id: 235,
      name: 'Punakha ',
      iso2: '23',
      countryId: 26,
    },
    {
      id: 243,
      name: 'Samdrup Jongkhar ',
      iso2: '45',
      countryId: 26,
    },
    {
      id: 246,
      name: 'Samtse ',
      iso2: '14',
      countryId: 26,
    },
    {
      id: 247,
      name: 'Sarpang ',
      iso2: '31',
      countryId: 26,
    },
    {
      id: 241,
      name: 'Thimphu ',
      iso2: '15',
      countryId: 26,
    },
    {
      id: 5242,
      name: 'Trashi Yangtse\t',
      iso2: 'TY',
      countryId: 26,
    },
    {
      id: 236,
      name: 'Trashigang ',
      iso2: '41',
      countryId: 26,
    },
    {
      id: 245,
      name: 'Trongsa ',
      iso2: '32',
      countryId: 26,
    },
    {
      id: 230,
      name: 'Tsirang ',
      iso2: '21',
      countryId: 26,
    },
    {
      id: 231,
      name: 'Wangdue Phodrang ',
      iso2: '24',
      countryId: 26,
    },
    {
      id: 233,
      name: 'Zhemgang ',
      iso2: '34',
      countryId: 26,
    },
    {
      id: 3375,
      name: 'Beni',
      iso2: 'B',
      countryId: 27,
    },
    {
      id: 3382,
      name: 'Chuquisaca',
      iso2: 'H',
      countryId: 27,
    },
    {
      id: 3381,
      name: 'Cochabamba',
      iso2: 'C',
      countryId: 27,
    },
    {
      id: 3380,
      name: 'La Paz',
      iso2: 'L',
      countryId: 27,
    },
    {
      id: 3376,
      name: 'Oruro',
      iso2: 'O',
      countryId: 27,
    },
    {
      id: 3379,
      name: 'Pando',
      iso2: 'N',
      countryId: 27,
    },
    {
      id: 3383,
      name: 'Potosí',
      iso2: 'P',
      countryId: 27,
    },
    {
      id: 3377,
      name: 'Santa Cruz',
      iso2: 'S',
      countryId: 27,
    },
    {
      id: 3378,
      name: 'Tarija',
      iso2: 'T',
      countryId: 27,
    },
    {
      id: 5086,
      name: 'Bonaire',
      iso2: 'BQ1',
      countryId: 155,
    },
    {
      id: 5087,
      name: 'Saba',
      iso2: 'BQ2',
      countryId: 155,
    },
    {
      id: 5088,
      name: 'Sint Eustatius',
      iso2: 'BQ3',
      countryId: 155,
    },
    {
      id: 460,
      name: 'Brčko',
      iso2: 'BRC',
      countryId: 28,
    },
    {
      id: 467,
      name: 'Federation of Bosnia and Herzegovina',
      iso2: 'BIH',
      countryId: 28,
    },
    {
      id: 470,
      name: 'Republika Srpska',
      iso2: 'SRP',
      countryId: 28,
    },
    {
      id: 3067,
      name: 'Central',
      iso2: 'CE',
      countryId: 29,
    },
    {
      id: 5710,
      name: 'Chobe',
      iso2: 'CH',
      countryId: 29,
    },
    {
      id: 5711,
      name: 'Francistown',
      iso2: 'FR',
      countryId: 29,
    },
    {
      id: 5712,
      name: 'Gaborone',
      iso2: 'GA',
      countryId: 29,
    },
    {
      id: 3061,
      name: 'Ghanzi',
      iso2: 'GH',
      countryId: 29,
    },
    {
      id: 5713,
      name: 'Jwaneng',
      iso2: 'JW',
      countryId: 29,
    },
    {
      id: 3066,
      name: 'Kgalagadi',
      iso2: 'KG',
      countryId: 29,
    },
    {
      id: 3062,
      name: 'Kgatleng',
      iso2: 'KL',
      countryId: 29,
    },
    {
      id: 3069,
      name: 'Kweneng',
      iso2: 'KW',
      countryId: 29,
    },
    {
      id: 5714,
      name: 'Lobatse',
      iso2: 'LO',
      countryId: 29,
    },
    {
      id: 3068,
      name: 'North-East',
      iso2: 'NE',
      countryId: 29,
    },
    {
      id: 3065,
      name: 'North-West',
      iso2: 'NW',
      countryId: 29,
    },
    {
      id: 5715,
      name: 'Selibe Phikwe',
      iso2: 'SP',
      countryId: 29,
    },
    {
      id: 3064,
      name: 'South-East',
      iso2: 'SE',
      countryId: 29,
    },
    {
      id: 3063,
      name: 'Southern',
      iso2: 'SO',
      countryId: 29,
    },
    {
      id: 5716,
      name: 'Sowa Town',
      iso2: 'ST',
      countryId: 29,
    },
    {
      id: 2012,
      name: 'Acre',
      iso2: 'AC',
      countryId: 31,
    },
    {
      id: 2007,
      name: 'Alagoas',
      iso2: 'AL',
      countryId: 31,
    },
    {
      id: 1999,
      name: 'Amapá',
      iso2: 'AP',
      countryId: 31,
    },
    {
      id: 2004,
      name: 'Amazonas',
      iso2: 'AM',
      countryId: 31,
    },
    {
      id: 2002,
      name: 'Bahia',
      iso2: 'BA',
      countryId: 31,
    },
    {
      id: 2016,
      name: 'Ceará',
      iso2: 'CE',
      countryId: 31,
    },
    {
      id: 2017,
      name: 'Distrito Federal',
      iso2: 'DF',
      countryId: 31,
    },
    {
      id: 2018,
      name: 'Espírito Santo',
      iso2: 'ES',
      countryId: 31,
    },
    {
      id: 2000,
      name: 'Goiás',
      iso2: 'GO',
      countryId: 31,
    },
    {
      id: 2015,
      name: 'Maranhão',
      iso2: 'MA',
      countryId: 31,
    },
    {
      id: 2011,
      name: 'Mato Grosso',
      iso2: 'MT',
      countryId: 31,
    },
    {
      id: 2010,
      name: 'Mato Grosso do Sul',
      iso2: 'MS',
      countryId: 31,
    },
    {
      id: 1998,
      name: 'Minas Gerais',
      iso2: 'MG',
      countryId: 31,
    },
    {
      id: 2009,
      name: 'Pará',
      iso2: 'PA',
      countryId: 31,
    },
    {
      id: 2005,
      name: 'Paraíba',
      iso2: 'PB',
      countryId: 31,
    },
    {
      id: 2022,
      name: 'Paraná',
      iso2: 'PR',
      countryId: 31,
    },
    {
      id: 2006,
      name: 'Pernambuco',
      iso2: 'PE',
      countryId: 31,
    },
    {
      id: 2008,
      name: 'Piauí',
      iso2: 'PI',
      countryId: 31,
    },
    {
      id: 1997,
      name: 'Rio de Janeiro',
      iso2: 'RJ',
      countryId: 31,
    },
    {
      id: 2019,
      name: 'Rio Grande do Norte',
      iso2: 'RN',
      countryId: 31,
    },
    {
      id: 2001,
      name: 'Rio Grande do Sul',
      iso2: 'RS',
      countryId: 31,
    },
    {
      id: 2013,
      name: 'Rondônia',
      iso2: 'RO',
      countryId: 31,
    },
    {
      id: 4858,
      name: 'Roraima',
      iso2: 'RR',
      countryId: 31,
    },
    {
      id: 2014,
      name: 'Santa Catarina',
      iso2: 'SC',
      countryId: 31,
    },
    {
      id: 2021,
      name: 'São Paulo',
      iso2: 'SP',
      countryId: 31,
    },
    {
      id: 2003,
      name: 'Sergipe',
      iso2: 'SE',
      countryId: 31,
    },
    {
      id: 2020,
      name: 'Tocantins',
      iso2: 'TO',
      countryId: 31,
    },
    {
      id: 1217,
      name: 'Belait',
      iso2: 'BE',
      countryId: 33,
    },
    {
      id: 1216,
      name: 'Brunei-Muara',
      iso2: 'BM',
      countryId: 33,
    },
    {
      id: 1218,
      name: 'Temburong',
      iso2: 'TE',
      countryId: 33,
    },
    {
      id: 1219,
      name: 'Tutong',
      iso2: 'TU',
      countryId: 33,
    },
    {
      id: 4699,
      name: 'Blagoevgrad',
      iso2: '01',
      countryId: 34,
    },
    {
      id: 4715,
      name: 'Burgas',
      iso2: '02',
      countryId: 34,
    },
    {
      id: 4718,
      name: 'Dobrich',
      iso2: '08',
      countryId: 34,
    },
    {
      id: 4693,
      name: 'Gabrovo',
      iso2: '07',
      countryId: 34,
    },
    {
      id: 4704,
      name: 'Haskovo',
      iso2: '26',
      countryId: 34,
    },
    {
      id: 4702,
      name: 'Kardzhali',
      iso2: '09',
      countryId: 34,
    },
    {
      id: 4703,
      name: 'Kyustendil',
      iso2: '10',
      countryId: 34,
    },
    {
      id: 4710,
      name: 'Lovech',
      iso2: '11',
      countryId: 34,
    },
    {
      id: 4696,
      name: 'Montana',
      iso2: '12',
      countryId: 34,
    },
    {
      id: 4712,
      name: 'Pazardzhik',
      iso2: '13',
      countryId: 34,
    },
    {
      id: 4695,
      name: 'Pernik',
      iso2: '14',
      countryId: 34,
    },
    {
      id: 4706,
      name: 'Pleven',
      iso2: '15',
      countryId: 34,
    },
    {
      id: 4701,
      name: 'Plovdiv',
      iso2: '16',
      countryId: 34,
    },
    {
      id: 4698,
      name: 'Razgrad',
      iso2: '17',
      countryId: 34,
    },
    {
      id: 4713,
      name: 'Ruse',
      iso2: '18',
      countryId: 34,
    },
    {
      id: 4882,
      name: 'Shumen',
      iso2: '27',
      countryId: 34,
    },
    {
      id: 4708,
      name: 'Silistra',
      iso2: '19',
      countryId: 34,
    },
    {
      id: 4700,
      name: 'Sliven',
      iso2: '20',
      countryId: 34,
    },
    {
      id: 4694,
      name: 'Smolyan',
      iso2: '21',
      countryId: 34,
    },
    {
      id: 4719,
      name: 'Sofia',
      iso2: '23',
      countryId: 34,
    },
    {
      id: 4705,
      name: 'Sofia City',
      iso2: '22',
      countryId: 34,
    },
    {
      id: 4707,
      name: 'Stara Zagora',
      iso2: '24',
      countryId: 34,
    },
    {
      id: 4714,
      name: 'Targovishte',
      iso2: '25',
      countryId: 34,
    },
    {
      id: 4717,
      name: 'Varna',
      iso2: '03',
      countryId: 34,
    },
    {
      id: 4709,
      name: 'Veliko Tarnovo',
      iso2: '04',
      countryId: 34,
    },
    {
      id: 4697,
      name: 'Vidin',
      iso2: '05',
      countryId: 34,
    },
    {
      id: 4711,
      name: 'Vratsa',
      iso2: '06',
      countryId: 34,
    },
    {
      id: 4716,
      name: 'Yambol',
      iso2: '28',
      countryId: 34,
    },
    {
      id: 3160,
      name: 'Balé',
      iso2: 'BAL',
      countryId: 35,
    },
    {
      id: 3155,
      name: 'Bam',
      iso2: 'BAM',
      countryId: 35,
    },
    {
      id: 3120,
      name: 'Banwa',
      iso2: 'BAN',
      countryId: 35,
    },
    {
      id: 3152,
      name: 'Bazèga',
      iso2: 'BAZ',
      countryId: 35,
    },
    {
      id: 3138,
      name: 'Boucle du Mouhoun',
      iso2: '01',
      countryId: 35,
    },
    {
      id: 3121,
      name: 'Bougouriba',
      iso2: 'BGR',
      countryId: 35,
    },
    {
      id: 3131,
      name: 'Boulgou',
      iso2: 'BLG',
      countryId: 35,
    },
    {
      id: 5343,
      name: 'Boulkiemde',
      iso2: 'BLK',
      countryId: 35,
    },
    {
      id: 3153,
      name: 'Cascades',
      iso2: '02',
      countryId: 35,
    },
    {
      id: 3136,
      name: 'Centre',
      iso2: '03',
      countryId: 35,
    },
    {
      id: 3162,
      name: 'Centre-Est',
      iso2: '04',
      countryId: 35,
    },
    {
      id: 3127,
      name: 'Centre-Nord',
      iso2: '05',
      countryId: 35,
    },
    {
      id: 3115,
      name: 'Centre-Ouest',
      iso2: '06',
      countryId: 35,
    },
    {
      id: 3149,
      name: 'Centre-Sud',
      iso2: '07',
      countryId: 35,
    },
    {
      id: 3167,
      name: 'Comoé',
      iso2: 'COM',
      countryId: 35,
    },
    {
      id: 3158,
      name: 'Est',
      iso2: '08',
      countryId: 35,
    },
    {
      id: 3148,
      name: 'Ganzourgou',
      iso2: 'GAN',
      countryId: 35,
    },
    {
      id: 3122,
      name: 'Gnagna',
      iso2: 'GNA',
      countryId: 35,
    },
    {
      id: 3143,
      name: 'Gourma',
      iso2: 'GOU',
      countryId: 35,
    },
    {
      id: 3165,
      name: 'Hauts-Bassins',
      iso2: '09',
      countryId: 35,
    },
    {
      id: 3129,
      name: 'Houet',
      iso2: 'HOU',
      countryId: 35,
    },
    {
      id: 3135,
      name: 'Ioba',
      iso2: 'IOB',
      countryId: 35,
    },
    {
      id: 3168,
      name: 'Kadiogo',
      iso2: 'KAD',
      countryId: 35,
    },
    {
      id: 3112,
      name: 'Kénédougou',
      iso2: 'KEN',
      countryId: 35,
    },
    {
      id: 3132,
      name: 'Komondjari',
      iso2: 'KMD',
      countryId: 35,
    },
    {
      id: 3157,
      name: 'Kompienga',
      iso2: 'KMP',
      countryId: 35,
    },
    {
      id: 3146,
      name: 'Kossi',
      iso2: 'KOS',
      countryId: 35,
    },
    {
      id: 3133,
      name: 'Koulpélogo',
      iso2: 'KOP',
      countryId: 35,
    },
    {
      id: 3161,
      name: 'Kouritenga',
      iso2: 'KOT',
      countryId: 35,
    },
    {
      id: 3147,
      name: 'Kourwéogo',
      iso2: 'KOW',
      countryId: 35,
    },
    {
      id: 3159,
      name: 'Léraba',
      iso2: 'LER',
      countryId: 35,
    },
    {
      id: 3151,
      name: 'Loroum',
      iso2: 'LOR',
      countryId: 35,
    },
    {
      id: 3123,
      name: 'Mouhoun',
      iso2: 'MOU',
      countryId: 35,
    },
    {
      id: 3116,
      name: 'Nahouri',
      iso2: 'NAO',
      countryId: 35,
    },
    {
      id: 3113,
      name: 'Namentenga',
      iso2: 'NAM',
      countryId: 35,
    },
    {
      id: 3142,
      name: 'Nayala',
      iso2: 'NAY',
      countryId: 35,
    },
    {
      id: 3164,
      name: 'Nord',
      iso2: '10',
      countryId: 35,
    },
    {
      id: 3156,
      name: 'Noumbiel',
      iso2: 'NOU',
      countryId: 35,
    },
    {
      id: 3141,
      name: 'Oubritenga',
      iso2: 'OUB',
      countryId: 35,
    },
    {
      id: 3144,
      name: 'Oudalan',
      iso2: 'OUD',
      countryId: 35,
    },
    {
      id: 3117,
      name: 'Passoré',
      iso2: 'PAS',
      countryId: 35,
    },
    {
      id: 3125,
      name: 'Plateau-Central',
      iso2: '11',
      countryId: 35,
    },
    {
      id: 3163,
      name: 'Poni',
      iso2: 'PON',
      countryId: 35,
    },
    {
      id: 3114,
      name: 'Sahel',
      iso2: '12',
      countryId: 35,
    },
    {
      id: 3154,
      name: 'Sanguié',
      iso2: 'SNG',
      countryId: 35,
    },
    {
      id: 3126,
      name: 'Sanmatenga',
      iso2: 'SMT',
      countryId: 35,
    },
    {
      id: 3139,
      name: 'Séno',
      iso2: 'SEN',
      countryId: 35,
    },
    {
      id: 3119,
      name: 'Sissili',
      iso2: 'SIS',
      countryId: 35,
    },
    {
      id: 3166,
      name: 'Soum',
      iso2: 'SOM',
      countryId: 35,
    },
    {
      id: 3137,
      name: 'Sourou',
      iso2: 'SOR',
      countryId: 35,
    },
    {
      id: 3140,
      name: 'Sud-Ouest',
      iso2: '13',
      countryId: 35,
    },
    {
      id: 3128,
      name: 'Tapoa',
      iso2: 'TAP',
      countryId: 35,
    },
    {
      id: 3134,
      name: 'Tuy',
      iso2: 'TUI',
      countryId: 35,
    },
    {
      id: 3124,
      name: 'Yagha',
      iso2: 'YAG',
      countryId: 35,
    },
    {
      id: 3150,
      name: 'Yatenga',
      iso2: 'YAT',
      countryId: 35,
    },
    {
      id: 3145,
      name: 'Ziro',
      iso2: 'ZIR',
      countryId: 35,
    },
    {
      id: 3130,
      name: 'Zondoma',
      iso2: 'ZON',
      countryId: 35,
    },
    {
      id: 3118,
      name: 'Zoundwéogo',
      iso2: 'ZOU',
      countryId: 35,
    },
    {
      id: 3196,
      name: 'Bubanza',
      iso2: 'BB',
      countryId: 36,
    },
    {
      id: 3198,
      name: 'Bujumbura Mairie',
      iso2: 'BM',
      countryId: 36,
    },
    {
      id: 3200,
      name: 'Bujumbura Rural',
      iso2: 'BL',
      countryId: 36,
    },
    {
      id: 3202,
      name: 'Bururi',
      iso2: 'BR',
      countryId: 36,
    },
    {
      id: 3201,
      name: 'Cankuzo',
      iso2: 'CA',
      countryId: 36,
    },
    {
      id: 3190,
      name: 'Cibitoke',
      iso2: 'CI',
      countryId: 36,
    },
    {
      id: 3197,
      name: 'Gitega',
      iso2: 'GI',
      countryId: 36,
    },
    {
      id: 3194,
      name: 'Karuzi',
      iso2: 'KR',
      countryId: 36,
    },
    {
      id: 3192,
      name: 'Kayanza',
      iso2: 'KY',
      countryId: 36,
    },
    {
      id: 3195,
      name: 'Kirundo',
      iso2: 'KI',
      countryId: 36,
    },
    {
      id: 3188,
      name: 'Makamba',
      iso2: 'MA',
      countryId: 36,
    },
    {
      id: 3193,
      name: 'Muramvya',
      iso2: 'MU',
      countryId: 36,
    },
    {
      id: 3186,
      name: 'Muyinga',
      iso2: 'MY',
      countryId: 36,
    },
    {
      id: 3187,
      name: 'Mwaro',
      iso2: 'MW',
      countryId: 36,
    },
    {
      id: 3199,
      name: 'Ngozi',
      iso2: 'NG',
      countryId: 36,
    },
    {
      id: 3185,
      name: 'Rumonge',
      iso2: 'RM',
      countryId: 36,
    },
    {
      id: 3189,
      name: 'Rutana',
      iso2: 'RT',
      countryId: 36,
    },
    {
      id: 3191,
      name: 'Ruyigi',
      iso2: 'RY',
      countryId: 36,
    },
    {
      id: 3984,
      name: 'Banteay Meanchey',
      iso2: '1',
      countryId: 37,
    },
    {
      id: 3976,
      name: 'Battambang',
      iso2: '2',
      countryId: 37,
    },
    {
      id: 3991,
      name: 'Kampong Cham',
      iso2: '3',
      countryId: 37,
    },
    {
      id: 3979,
      name: 'Kampong Chhnang',
      iso2: '4',
      countryId: 37,
    },
    {
      id: 3988,
      name: 'Kampong Speu',
      iso2: '5',
      countryId: 37,
    },
    {
      id: 5070,
      name: 'Kampong Thom',
      iso2: '6',
      countryId: 37,
    },
    {
      id: 3981,
      name: 'Kampot',
      iso2: '7',
      countryId: 37,
    },
    {
      id: 3983,
      name: 'Kandal',
      iso2: '8',
      countryId: 37,
    },
    {
      id: 3978,
      name: 'Kep',
      iso2: '23',
      countryId: 37,
    },
    {
      id: 3982,
      name: 'Koh Kong',
      iso2: '9',
      countryId: 37,
    },
    {
      id: 3986,
      name: 'Kratie',
      iso2: '10',
      countryId: 37,
    },
    {
      id: 3985,
      name: 'Mondulkiri',
      iso2: '11',
      countryId: 37,
    },
    {
      id: 3987,
      name: 'Oddar Meanchey',
      iso2: '22',
      countryId: 37,
    },
    {
      id: 3980,
      name: 'Pailin',
      iso2: '24',
      countryId: 37,
    },
    {
      id: 3994,
      name: 'Phnom Penh',
      iso2: '12',
      countryId: 37,
    },
    {
      id: 3973,
      name: 'Preah Vihear',
      iso2: '13',
      countryId: 37,
    },
    {
      id: 3974,
      name: 'Prey Veng',
      iso2: '14',
      countryId: 37,
    },
    {
      id: 3977,
      name: 'Pursat',
      iso2: '15',
      countryId: 37,
    },
    {
      id: 3990,
      name: 'Ratanakiri',
      iso2: '16',
      countryId: 37,
    },
    {
      id: 3992,
      name: 'Siem Reap',
      iso2: '17',
      countryId: 37,
    },
    {
      id: 3989,
      name: 'Sihanoukville',
      iso2: '18',
      countryId: 37,
    },
    {
      id: 3993,
      name: 'Stung Treng',
      iso2: '19',
      countryId: 37,
    },
    {
      id: 3972,
      name: 'Svay Rieng',
      iso2: '20',
      countryId: 37,
    },
    {
      id: 3975,
      name: 'Takeo',
      iso2: '21',
      countryId: 37,
    },
    {
      id: 5537,
      name: 'Tboung Khmum',
      iso2: '25',
      countryId: 37,
    },
    {
      id: 2663,
      name: 'Adamawa',
      iso2: 'AD',
      countryId: 38,
    },
    {
      id: 2660,
      name: 'Centre',
      iso2: 'CE',
      countryId: 38,
    },
    {
      id: 2661,
      name: 'East',
      iso2: 'ES',
      countryId: 38,
    },
    {
      id: 2656,
      name: 'Far North',
      iso2: 'EN',
      countryId: 38,
    },
    {
      id: 2662,
      name: 'Littoral',
      iso2: 'LT',
      countryId: 38,
    },
    {
      id: 2665,
      name: 'North',
      iso2: 'NO',
      countryId: 38,
    },
    {
      id: 2657,
      name: 'Northwest',
      iso2: 'NW',
      countryId: 38,
    },
    {
      id: 2659,
      name: 'South',
      iso2: 'SU',
      countryId: 38,
    },
    {
      id: 2658,
      name: 'Southwest',
      iso2: 'SW',
      countryId: 38,
    },
    {
      id: 2664,
      name: 'West',
      iso2: 'OU',
      countryId: 38,
    },
    {
      id: 872,
      name: 'Alberta',
      iso2: 'AB',
      countryId: 39,
    },
    {
      id: 875,
      name: 'British Columbia',
      iso2: 'BC',
      countryId: 39,
    },
    {
      id: 867,
      name: 'Manitoba',
      iso2: 'MB',
      countryId: 39,
    },
    {
      id: 868,
      name: 'New Brunswick',
      iso2: 'NB',
      countryId: 39,
    },
    {
      id: 877,
      name: 'Newfoundland and Labrador',
      iso2: 'NL',
      countryId: 39,
    },
    {
      id: 878,
      name: 'Northwest Territories',
      iso2: 'NT',
      countryId: 39,
    },
    {
      id: 874,
      name: 'Nova Scotia',
      iso2: 'NS',
      countryId: 39,
    },
    {
      id: 876,
      name: 'Nunavut',
      iso2: 'NU',
      countryId: 39,
    },
    {
      id: 866,
      name: 'Ontario',
      iso2: 'ON',
      countryId: 39,
    },
    {
      id: 871,
      name: 'Prince Edward Island',
      iso2: 'PE',
      countryId: 39,
    },
    {
      id: 873,
      name: 'Quebec',
      iso2: 'QC',
      countryId: 39,
    },
    {
      id: 870,
      name: 'Saskatchewan',
      iso2: 'SK',
      countryId: 39,
    },
    {
      id: 869,
      name: 'Yukon',
      iso2: 'YT',
      countryId: 39,
    },
    {
      id: 2994,
      name: 'Barlavento Islands',
      iso2: 'B',
      countryId: 40,
    },
    {
      id: 2999,
      name: 'Boa Vista',
      iso2: 'BV',
      countryId: 40,
    },
    {
      id: 2996,
      name: 'Brava',
      iso2: 'BR',
      countryId: 40,
    },
    {
      id: 2991,
      name: 'Maio',
      iso2: 'MA',
      countryId: 40,
    },
    {
      id: 2987,
      name: 'Mosteiros',
      iso2: 'MO',
      countryId: 40,
    },
    {
      id: 2997,
      name: 'Paul',
      iso2: 'PA',
      countryId: 40,
    },
    {
      id: 2989,
      name: 'Porto Novo',
      iso2: 'PN',
      countryId: 40,
    },
    {
      id: 2988,
      name: 'Praia',
      iso2: 'PR',
      countryId: 40,
    },
    {
      id: 2982,
      name: 'Ribeira Brava',
      iso2: 'RB',
      countryId: 40,
    },
    {
      id: 3002,
      name: 'Ribeira Grande',
      iso2: 'RG',
      countryId: 40,
    },
    {
      id: 2984,
      name: 'Ribeira Grande de Santiago',
      iso2: 'RS',
      countryId: 40,
    },
    {
      id: 2998,
      name: 'Sal',
      iso2: 'SL',
      countryId: 40,
    },
    {
      id: 2985,
      name: 'Santa Catarina',
      iso2: 'CA',
      countryId: 40,
    },
    {
      id: 2995,
      name: 'Santa Catarina do Fogo',
      iso2: 'CF',
      countryId: 40,
    },
    {
      id: 3004,
      name: 'Santa Cruz',
      iso2: 'CR',
      countryId: 40,
    },
    {
      id: 2986,
      name: 'São Domingos',
      iso2: 'SD',
      countryId: 40,
    },
    {
      id: 3000,
      name: 'São Filipe',
      iso2: 'SF',
      countryId: 40,
    },
    {
      id: 2993,
      name: 'São Lourenço dos Órgãos',
      iso2: 'SO',
      countryId: 40,
    },
    {
      id: 2990,
      name: 'São Miguel',
      iso2: 'SM',
      countryId: 40,
    },
    {
      id: 5552,
      name: 'São Salvador do Mundo',
      iso2: 'SS',
      countryId: 40,
    },
    {
      id: 3001,
      name: 'São Vicente',
      iso2: 'SV',
      countryId: 40,
    },
    {
      id: 2992,
      name: 'Sotavento Islands',
      iso2: 'S',
      countryId: 40,
    },
    {
      id: 2983,
      name: 'Tarrafal',
      iso2: 'TA',
      countryId: 40,
    },
    {
      id: 3003,
      name: 'Tarrafal de São Nicolau',
      iso2: 'TS',
      countryId: 40,
    },
    {
      id: 5252,
      name: 'Cayman Brac',
      iso2: '02',
      countryId: 41,
    },
    {
      id: 5251,
      name: 'Grand Cayman',
      iso2: '01',
      countryId: 41,
    },
    {
      id: 5253,
      name: 'Little Cayman',
      iso2: '03',
      countryId: 41,
    },
    {
      id: 1259,
      name: 'Bamingui-Bangoran',
      iso2: 'BB',
      countryId: 42,
    },
    {
      id: 1262,
      name: 'Bangui',
      iso2: 'BGF',
      countryId: 42,
    },
    {
      id: 1264,
      name: 'Basse-Kotto',
      iso2: 'BK',
      countryId: 42,
    },
    {
      id: 1258,
      name: 'Haut-Mbomou',
      iso2: 'HM',
      countryId: 42,
    },
    {
      id: 1268,
      name: 'Haute-Kotto',
      iso2: 'HK',
      countryId: 42,
    },
    {
      id: 1263,
      name: 'Kémo',
      iso2: 'KG',
      countryId: 42,
    },
    {
      id: 1256,
      name: 'Lobaye',
      iso2: 'LB',
      countryId: 42,
    },
    {
      id: 1257,
      name: 'Mambéré-Kadéï',
      iso2: 'HS',
      countryId: 42,
    },
    {
      id: 1266,
      name: 'Mbomou',
      iso2: 'MB',
      countryId: 42,
    },
    {
      id: 1253,
      name: 'Nana-Grébizi',
      iso2: 'KB',
      countryId: 42,
    },
    {
      id: 1260,
      name: 'Nana-Mambéré',
      iso2: 'NM',
      countryId: 42,
    },
    {
      id: 1255,
      name: "Ombella-M'Poko",
      iso2: 'MP',
      countryId: 42,
    },
    {
      id: 1265,
      name: 'Ouaka',
      iso2: 'UK',
      countryId: 42,
    },
    {
      id: 1254,
      name: 'Ouham',
      iso2: 'AC',
      countryId: 42,
    },
    {
      id: 1267,
      name: 'Ouham-Pendé',
      iso2: 'OP',
      countryId: 42,
    },
    {
      id: 1252,
      name: 'Sangha-Mbaéré',
      iso2: 'SE',
      countryId: 42,
    },
    {
      id: 1261,
      name: 'Vakaga',
      iso2: 'VK',
      countryId: 42,
    },
    {
      id: 3583,
      name: 'Bahr el Gazel',
      iso2: 'BG',
      countryId: 43,
    },
    {
      id: 3590,
      name: 'Batha',
      iso2: 'BA',
      countryId: 43,
    },
    {
      id: 3574,
      name: 'Borkou',
      iso2: 'BO',
      countryId: 43,
    },
    {
      id: 5114,
      name: 'Chari-Baguirmi',
      iso2: 'CB',
      countryId: 43,
    },
    {
      id: 3575,
      name: 'Ennedi-Est',
      iso2: 'EE',
      countryId: 43,
    },
    {
      id: 3584,
      name: 'Ennedi-Ouest',
      iso2: 'EO',
      countryId: 43,
    },
    {
      id: 3576,
      name: 'Guéra',
      iso2: 'GR',
      countryId: 43,
    },
    {
      id: 3573,
      name: 'Hadjer-Lamis',
      iso2: 'HL',
      countryId: 43,
    },
    {
      id: 3588,
      name: 'Kanem',
      iso2: 'KA',
      countryId: 43,
    },
    {
      id: 3577,
      name: 'Lac',
      iso2: 'LC',
      countryId: 43,
    },
    {
      id: 3585,
      name: 'Logone Occidental',
      iso2: 'LO',
      countryId: 43,
    },
    {
      id: 3591,
      name: 'Logone Oriental',
      iso2: 'LR',
      countryId: 43,
    },
    {
      id: 3589,
      name: 'Mandoul',
      iso2: 'MA',
      countryId: 43,
    },
    {
      id: 3580,
      name: 'Mayo-Kebbi Est',
      iso2: 'ME',
      countryId: 43,
    },
    {
      id: 3571,
      name: 'Mayo-Kebbi Ouest',
      iso2: 'MO',
      countryId: 43,
    },
    {
      id: 3570,
      name: 'Moyen-Chari',
      iso2: 'MC',
      countryId: 43,
    },
    {
      id: 3586,
      name: "N'Djamena",
      iso2: 'ND',
      countryId: 43,
    },
    {
      id: 3582,
      name: 'Ouaddaï',
      iso2: 'OD',
      countryId: 43,
    },
    {
      id: 3592,
      name: 'Salamat',
      iso2: 'SA',
      countryId: 43,
    },
    {
      id: 3572,
      name: 'Sila',
      iso2: 'SI',
      countryId: 43,
    },
    {
      id: 3579,
      name: 'Tandjilé',
      iso2: 'TA',
      countryId: 43,
    },
    {
      id: 3587,
      name: 'Tibesti',
      iso2: 'TI',
      countryId: 43,
    },
    {
      id: 3581,
      name: 'Wadi Fira',
      iso2: 'WF',
      countryId: 43,
    },
    {
      id: 2828,
      name: 'Aisén del General Carlos Ibañez del Campo',
      iso2: 'AI',
      countryId: 44,
    },
    {
      id: 2832,
      name: 'Antofagasta',
      iso2: 'AN',
      countryId: 44,
    },
    {
      id: 2829,
      name: 'Arica y Parinacota',
      iso2: 'AP',
      countryId: 44,
    },
    {
      id: 2823,
      name: 'Atacama',
      iso2: 'AT',
      countryId: 44,
    },
    {
      id: 2827,
      name: 'Biobío',
      iso2: 'BI',
      countryId: 44,
    },
    {
      id: 2825,
      name: 'Coquimbo',
      iso2: 'CO',
      countryId: 44,
    },
    {
      id: 2826,
      name: 'La Araucanía',
      iso2: 'AR',
      countryId: 44,
    },
    {
      id: 2838,
      name: "Libertador General Bernardo O'Higgins",
      iso2: 'LI',
      countryId: 44,
    },
    {
      id: 2835,
      name: 'Los Lagos',
      iso2: 'LL',
      countryId: 44,
    },
    {
      id: 2834,
      name: 'Los Ríos',
      iso2: 'LR',
      countryId: 44,
    },
    {
      id: 2836,
      name: 'Magallanes y de la Antártica Chilena',
      iso2: 'MA',
      countryId: 44,
    },
    {
      id: 2833,
      name: 'Maule',
      iso2: 'ML',
      countryId: 44,
    },
    {
      id: 2831,
      name: 'Ñuble',
      iso2: 'NB',
      countryId: 44,
    },
    {
      id: 2824,
      name: 'Región Metropolitana de Santiago',
      iso2: 'RM',
      countryId: 44,
    },
    {
      id: 2837,
      name: 'Tarapacá',
      iso2: 'TA',
      countryId: 44,
    },
    {
      id: 2830,
      name: 'Valparaíso',
      iso2: 'VS',
      countryId: 44,
    },
    {
      id: 2251,
      name: 'Anhui',
      iso2: 'AH',
      countryId: 45,
    },
    {
      id: 2257,
      name: 'Beijing',
      iso2: 'BJ',
      countryId: 45,
    },
    {
      id: 2271,
      name: 'Chongqing',
      iso2: 'CQ',
      countryId: 45,
    },
    {
      id: 2248,
      name: 'Fujian',
      iso2: 'FJ',
      countryId: 45,
    },
    {
      id: 2275,
      name: 'Gansu',
      iso2: 'GS',
      countryId: 45,
    },
    {
      id: 2279,
      name: 'Guangdong',
      iso2: 'GD',
      countryId: 45,
    },
    {
      id: 2278,
      name: 'Guangxi',
      iso2: 'GX',
      countryId: 45,
    },
    {
      id: 2261,
      name: 'Guizhou',
      iso2: 'GZ',
      countryId: 45,
    },
    {
      id: 2273,
      name: 'Hainan',
      iso2: 'HI',
      countryId: 45,
    },
    {
      id: 2280,
      name: 'Hebei',
      iso2: 'HE',
      countryId: 45,
    },
    {
      id: 2265,
      name: 'Heilongjiang',
      iso2: 'HL',
      countryId: 45,
    },
    {
      id: 2259,
      name: 'Henan',
      iso2: 'HA',
      countryId: 45,
    },
    {
      id: 2267,
      name: 'Hong Kong SAR',
      iso2: 'HK',
      countryId: 45,
    },
    {
      id: 2274,
      name: 'Hubei',
      iso2: 'HB',
      countryId: 45,
    },
    {
      id: 2258,
      name: 'Hunan',
      iso2: 'HN',
      countryId: 45,
    },
    {
      id: 2269,
      name: 'Inner Mongolia',
      iso2: 'NM',
      countryId: 45,
    },
    {
      id: 2250,
      name: 'Jiangsu',
      iso2: 'JS',
      countryId: 45,
    },
    {
      id: 2256,
      name: 'Jiangxi',
      iso2: 'JX',
      countryId: 45,
    },
    {
      id: 2253,
      name: 'Jilin',
      iso2: 'JL',
      countryId: 45,
    },
    {
      id: 2268,
      name: 'Liaoning',
      iso2: 'LN',
      countryId: 45,
    },
    {
      id: 2266,
      name: 'Macau SAR',
      iso2: 'MO',
      countryId: 45,
    },
    {
      id: 2262,
      name: 'Ningxia',
      iso2: 'NX',
      countryId: 45,
    },
    {
      id: 2270,
      name: 'Qinghai',
      iso2: 'QH',
      countryId: 45,
    },
    {
      id: 2272,
      name: 'Shaanxi',
      iso2: 'SN',
      countryId: 45,
    },
    {
      id: 2252,
      name: 'Shandong',
      iso2: 'SD',
      countryId: 45,
    },
    {
      id: 2249,
      name: 'Shanghai',
      iso2: 'SH',
      countryId: 45,
    },
    {
      id: 2254,
      name: 'Shanxi',
      iso2: 'SX',
      countryId: 45,
    },
    {
      id: 2277,
      name: 'Sichuan',
      iso2: 'SC',
      countryId: 45,
    },
    {
      id: 2255,
      name: 'Taiwan',
      iso2: 'TW',
      countryId: 45,
    },
    {
      id: 2276,
      name: 'Tianjin',
      iso2: 'TJ',
      countryId: 45,
    },
    {
      id: 2264,
      name: 'Tibet',
      iso2: 'XZ',
      countryId: 45,
    },
    {
      id: 2263,
      name: 'Xinjiang',
      iso2: 'XJ',
      countryId: 45,
    },
    {
      id: 2260,
      name: 'Yunnan',
      iso2: 'YN',
      countryId: 45,
    },
    {
      id: 2247,
      name: 'Zhejiang',
      iso2: 'ZJ',
      countryId: 45,
    },
    {
      id: 2895,
      name: 'Amazonas',
      iso2: 'AMA',
      countryId: 48,
    },
    {
      id: 2890,
      name: 'Antioquia',
      iso2: 'ANT',
      countryId: 48,
    },
    {
      id: 2881,
      name: 'Arauca',
      iso2: 'ARA',
      countryId: 48,
    },
    {
      id: 2880,
      name: 'Atlántico',
      iso2: 'ATL',
      countryId: 48,
    },
    {
      id: 4921,
      name: 'Bogotá D.C.',
      iso2: 'DC',
      countryId: 48,
    },
    {
      id: 2893,
      name: 'Bolívar',
      iso2: 'BOL',
      countryId: 48,
    },
    {
      id: 2903,
      name: 'Boyacá',
      iso2: 'BOY',
      countryId: 48,
    },
    {
      id: 2887,
      name: 'Caldas',
      iso2: 'CAL',
      countryId: 48,
    },
    {
      id: 2891,
      name: 'Caquetá',
      iso2: 'CAQ',
      countryId: 48,
    },
    {
      id: 2892,
      name: 'Casanare',
      iso2: 'CAS',
      countryId: 48,
    },
    {
      id: 2884,
      name: 'Cauca',
      iso2: 'CAU',
      countryId: 48,
    },
    {
      id: 2899,
      name: 'Cesar',
      iso2: 'CES',
      countryId: 48,
    },
    {
      id: 2876,
      name: 'Chocó',
      iso2: 'CHO',
      countryId: 48,
    },
    {
      id: 2898,
      name: 'Córdoba',
      iso2: 'COR',
      countryId: 48,
    },
    {
      id: 2875,
      name: 'Cundinamarca',
      iso2: 'CUN',
      countryId: 48,
    },
    {
      id: 2882,
      name: 'Guainía',
      iso2: 'GUA',
      countryId: 48,
    },
    {
      id: 2888,
      name: 'Guaviare',
      iso2: 'GUV',
      countryId: 48,
    },
    {
      id: 4871,
      name: 'Huila',
      iso2: 'HUI',
      countryId: 48,
    },
    {
      id: 2889,
      name: 'La Guajira',
      iso2: 'LAG',
      countryId: 48,
    },
    {
      id: 2886,
      name: 'Magdalena',
      iso2: 'MAG',
      countryId: 48,
    },
    {
      id: 2878,
      name: 'Meta',
      iso2: 'MET',
      countryId: 48,
    },
    {
      id: 2897,
      name: 'Nariño',
      iso2: 'NAR',
      countryId: 48,
    },
    {
      id: 2877,
      name: 'Norte de Santander',
      iso2: 'NSA',
      countryId: 48,
    },
    {
      id: 2896,
      name: 'Putumayo',
      iso2: 'PUT',
      countryId: 48,
    },
    {
      id: 2874,
      name: 'Quindío',
      iso2: 'QUI',
      countryId: 48,
    },
    {
      id: 2879,
      name: 'Risaralda',
      iso2: 'RIS',
      countryId: 48,
    },
    {
      id: 2900,
      name: 'San Andrés, Providencia y Santa Catalina',
      iso2: 'SAP',
      countryId: 48,
    },
    {
      id: 2901,
      name: 'Santander',
      iso2: 'SAN',
      countryId: 48,
    },
    {
      id: 2902,
      name: 'Sucre',
      iso2: 'SUC',
      countryId: 48,
    },
    {
      id: 2883,
      name: 'Tolima',
      iso2: 'TOL',
      countryId: 48,
    },
    {
      id: 2904,
      name: 'Valle del Cauca',
      iso2: 'VAC',
      countryId: 48,
    },
    {
      id: 2885,
      name: 'Vaupés',
      iso2: 'VAU',
      countryId: 48,
    },
    {
      id: 2894,
      name: 'Vichada',
      iso2: 'VID',
      countryId: 48,
    },
    {
      id: 2821,
      name: 'Anjouan',
      iso2: 'A',
      countryId: 49,
    },
    {
      id: 2822,
      name: 'Grande Comore',
      iso2: 'G',
      countryId: 49,
    },
    {
      id: 2820,
      name: 'Mohéli',
      iso2: 'M',
      countryId: 49,
    },
    {
      id: 2866,
      name: 'Bouenza',
      iso2: '11',
      countryId: 50,
    },
    {
      id: 2870,
      name: 'Brazzaville',
      iso2: 'BZV',
      countryId: 50,
    },
    {
      id: 2864,
      name: 'Cuvette',
      iso2: '8',
      countryId: 50,
    },
    {
      id: 2869,
      name: 'Cuvette-Ouest',
      iso2: '15',
      countryId: 50,
    },
    {
      id: 2867,
      name: 'Kouilou',
      iso2: '5',
      countryId: 50,
    },
    {
      id: 2868,
      name: 'Lékoumou',
      iso2: '2',
      countryId: 50,
    },
    {
      id: 2865,
      name: 'Likouala',
      iso2: '7',
      countryId: 50,
    },
    {
      id: 2872,
      name: 'Niari',
      iso2: '9',
      countryId: 50,
    },
    {
      id: 2862,
      name: 'Plateaux',
      iso2: '14',
      countryId: 50,
    },
    {
      id: 2863,
      name: 'Pointe-Noire',
      iso2: '16',
      countryId: 50,
    },
    {
      id: 2873,
      name: 'Pool',
      iso2: '12',
      countryId: 50,
    },
    {
      id: 2871,
      name: 'Sangha',
      iso2: '13',
      countryId: 50,
    },
    {
      id: 1215,
      name: 'Alajuela',
      iso2: 'A',
      countryId: 53,
    },
    {
      id: 1211,
      name: 'Cartago',
      iso2: 'C',
      countryId: 53,
    },
    {
      id: 1209,
      name: 'Guanacaste',
      iso2: 'G',
      countryId: 53,
    },
    {
      id: 1212,
      name: 'Heredia',
      iso2: 'H',
      countryId: 53,
    },
    {
      id: 1213,
      name: 'Limón',
      iso2: 'L',
      countryId: 53,
    },
    {
      id: 1210,
      name: 'Puntarenas',
      iso2: 'P',
      countryId: 53,
    },
    {
      id: 1214,
      name: 'San José',
      iso2: 'SJ',
      countryId: 53,
    },
    {
      id: 734,
      name: 'Bjelovar-Bilogora',
      iso2: '07',
      countryId: 55,
    },
    {
      id: 737,
      name: 'Brod-Posavina',
      iso2: '12',
      countryId: 55,
    },
    {
      id: 728,
      name: 'Dubrovnik-Neretva',
      iso2: '19',
      countryId: 55,
    },
    {
      id: 743,
      name: 'Istria',
      iso2: '18',
      countryId: 55,
    },
    {
      id: 5069,
      name: 'Karlovac',
      iso2: '04',
      countryId: 55,
    },
    {
      id: 742,
      name: 'Koprivnica-Križevci',
      iso2: '06',
      countryId: 55,
    },
    {
      id: 729,
      name: 'Krapina-Zagorje',
      iso2: '02',
      countryId: 55,
    },
    {
      id: 731,
      name: 'Lika-Senj',
      iso2: '09',
      countryId: 55,
    },
    {
      id: 726,
      name: 'Međimurje',
      iso2: '20',
      countryId: 55,
    },
    {
      id: 740,
      name: 'Osijek-Baranja',
      iso2: '14',
      countryId: 55,
    },
    {
      id: 724,
      name: 'Požega-Slavonia',
      iso2: '11',
      countryId: 55,
    },
    {
      id: 735,
      name: 'Primorje-Gorski Kotar',
      iso2: '08',
      countryId: 55,
    },
    {
      id: 730,
      name: 'Šibenik-Knin',
      iso2: '15',
      countryId: 55,
    },
    {
      id: 733,
      name: 'Sisak-Moslavina',
      iso2: '03',
      countryId: 55,
    },
    {
      id: 725,
      name: 'Split-Dalmatia',
      iso2: '17',
      countryId: 55,
    },
    {
      id: 739,
      name: 'Varaždin',
      iso2: '05',
      countryId: 55,
    },
    {
      id: 732,
      name: 'Virovitica-Podravina',
      iso2: '10',
      countryId: 55,
    },
    {
      id: 741,
      name: 'Vukovar-Syrmia',
      iso2: '16',
      countryId: 55,
    },
    {
      id: 727,
      name: 'Zadar',
      iso2: '13',
      countryId: 55,
    },
    {
      id: 736,
      name: 'Zagreb',
      iso2: '01',
      countryId: 55,
    },
    {
      id: 283,
      name: 'Artemisa',
      iso2: '15',
      countryId: 56,
    },
    {
      id: 286,
      name: 'Camagüey',
      iso2: '09',
      countryId: 56,
    },
    {
      id: 282,
      name: 'Ciego de Ávila',
      iso2: '08',
      countryId: 56,
    },
    {
      id: 287,
      name: 'Cienfuegos',
      iso2: '06',
      countryId: 56,
    },
    {
      id: 275,
      name: 'Granma',
      iso2: '12',
      countryId: 56,
    },
    {
      id: 285,
      name: 'Guantánamo',
      iso2: '14',
      countryId: 56,
    },
    {
      id: 272,
      name: 'Havana',
      iso2: '03',
      countryId: 56,
    },
    {
      id: 279,
      name: 'Holguín',
      iso2: '11',
      countryId: 56,
    },
    {
      id: 278,
      name: 'Isla de la Juventud',
      iso2: '99',
      countryId: 56,
    },
    {
      id: 281,
      name: 'Las Tunas',
      iso2: '10',
      countryId: 56,
    },
    {
      id: 284,
      name: 'Matanzas',
      iso2: '04',
      countryId: 56,
    },
    {
      id: 276,
      name: 'Mayabeque',
      iso2: '16',
      countryId: 56,
    },
    {
      id: 277,
      name: 'Pinar del Río',
      iso2: '01',
      countryId: 56,
    },
    {
      id: 274,
      name: 'Sancti Spíritus',
      iso2: '07',
      countryId: 56,
    },
    {
      id: 273,
      name: 'Santiago de Cuba',
      iso2: '13',
      countryId: 56,
    },
    {
      id: 280,
      name: 'Villa Clara',
      iso2: '05',
      countryId: 56,
    },
    {
      id: 749,
      name: 'Famagusta (Mağusa)',
      iso2: '04',
      countryId: 57,
    },
    {
      id: 744,
      name: 'Kyrenia (Keryneia)',
      iso2: '06',
      countryId: 57,
    },
    {
      id: 747,
      name: 'Larnaca (Larnaka)',
      iso2: '03',
      countryId: 57,
    },
    {
      id: 748,
      name: 'Limassol (Leymasun)',
      iso2: '02',
      countryId: 57,
    },
    {
      id: 745,
      name: 'Nicosia (Lefkoşa)',
      iso2: '01',
      countryId: 57,
    },
    {
      id: 746,
      name: 'Paphos (Pafos)',
      iso2: '05',
      countryId: 57,
    },
    {
      id: 4627,
      name: 'Benešov',
      iso2: '201',
      countryId: 58,
    },
    {
      id: 4620,
      name: 'Beroun',
      iso2: '202',
      countryId: 58,
    },
    {
      id: 4615,
      name: 'Blansko',
      iso2: '641',
      countryId: 58,
    },
    {
      id: 4542,
      name: 'Břeclav',
      iso2: '644',
      countryId: 58,
    },
    {
      id: 4568,
      name: 'Brno-město',
      iso2: '642',
      countryId: 58,
    },
    {
      id: 4545,
      name: 'Brno-venkov',
      iso2: '643',
      countryId: 58,
    },
    {
      id: 4644,
      name: 'Bruntál',
      iso2: '801',
      countryId: 58,
    },
    {
      id: 4633,
      name: 'Česká Lípa',
      iso2: '511',
      countryId: 58,
    },
    {
      id: 4556,
      name: 'České Budějovice',
      iso2: '311',
      countryId: 58,
    },
    {
      id: 4543,
      name: 'Český Krumlov',
      iso2: '312',
      countryId: 58,
    },
    {
      id: 4573,
      name: 'Cheb',
      iso2: '411',
      countryId: 58,
    },
    {
      id: 4553,
      name: 'Chomutov',
      iso2: '422',
      countryId: 58,
    },
    {
      id: 4634,
      name: 'Chrudim',
      iso2: '531',
      countryId: 58,
    },
    {
      id: 4609,
      name: 'Děčín',
      iso2: '421',
      countryId: 58,
    },
    {
      id: 4641,
      name: 'Domažlice',
      iso2: '321',
      countryId: 58,
    },
    {
      id: 4559,
      name: 'Frýdek-Místek',
      iso2: '802',
      countryId: 58,
    },
    {
      id: 4611,
      name: 'Havlíčkův Brod',
      iso2: '631',
      countryId: 58,
    },
    {
      id: 4561,
      name: 'Hodonín',
      iso2: '645',
      countryId: 58,
    },
    {
      id: 4580,
      name: 'Hradec Králové',
      iso2: '521',
      countryId: 58,
    },
    {
      id: 4612,
      name: 'Jablonec nad Nisou',
      iso2: '512',
      countryId: 58,
    },
    {
      id: 4625,
      name: 'Jeseník',
      iso2: '711',
      countryId: 58,
    },
    {
      id: 4640,
      name: 'Jičín',
      iso2: '522',
      countryId: 58,
    },
    {
      id: 4613,
      name: 'Jihlava',
      iso2: '632',
      countryId: 58,
    },
    {
      id: 4639,
      name: 'Jihočeský kraj',
      iso2: '31',
      countryId: 58,
    },
    {
      id: 4602,
      name: 'Jihomoravský kraj',
      iso2: '64',
      countryId: 58,
    },
    {
      id: 4624,
      name: 'Jindřichův Hradec',
      iso2: '313',
      countryId: 58,
    },
    {
      id: 4581,
      name: 'Karlovarský kraj',
      iso2: '41',
      countryId: 58,
    },
    {
      id: 4604,
      name: 'Karlovy Vary',
      iso2: '412',
      countryId: 58,
    },
    {
      id: 4586,
      name: 'Karviná',
      iso2: '803',
      countryId: 58,
    },
    {
      id: 4631,
      name: 'Kladno',
      iso2: '203',
      countryId: 58,
    },
    {
      id: 4591,
      name: 'Klatovy',
      iso2: '322',
      countryId: 58,
    },
    {
      id: 4618,
      name: 'Kolín',
      iso2: '204',
      countryId: 58,
    },
    {
      id: 4575,
      name: 'Kraj Vysočina',
      iso2: '63',
      countryId: 58,
    },
    {
      id: 4614,
      name: 'Královéhradecký kraj',
      iso2: '52',
      countryId: 58,
    },
    {
      id: 4593,
      name: 'Kroměříž',
      iso2: '721',
      countryId: 58,
    },
    {
      id: 4923,
      name: 'Kutná Hora',
      iso2: '205',
      countryId: 58,
    },
    {
      id: 4590,
      name: 'Liberec',
      iso2: '513',
      countryId: 58,
    },
    {
      id: 4601,
      name: 'Liberecký kraj',
      iso2: '51',
      countryId: 58,
    },
    {
      id: 4605,
      name: 'Litoměřice',
      iso2: '423',
      countryId: 58,
    },
    {
      id: 4617,
      name: 'Louny',
      iso2: '424',
      countryId: 58,
    },
    {
      id: 4638,
      name: 'Mělník',
      iso2: '206',
      countryId: 58,
    },
    {
      id: 4643,
      name: 'Mladá Boleslav',
      iso2: '207',
      countryId: 58,
    },
    {
      id: 4600,
      name: 'Moravskoslezský kraj',
      iso2: '80',
      countryId: 58,
    },
    {
      id: 4629,
      name: 'Most',
      iso2: '425',
      countryId: 58,
    },
    {
      id: 4550,
      name: 'Náchod',
      iso2: '523',
      countryId: 58,
    },
    {
      id: 4548,
      name: 'Nový Jičín',
      iso2: '804',
      countryId: 58,
    },
    {
      id: 4582,
      name: 'Nymburk',
      iso2: '208',
      countryId: 58,
    },
    {
      id: 4574,
      name: 'Olomouc',
      iso2: '712',
      countryId: 58,
    },
    {
      id: 4589,
      name: 'Olomoucký kraj',
      iso2: '71',
      countryId: 58,
    },
    {
      id: 4623,
      name: 'Opava',
      iso2: '805',
      countryId: 58,
    },
    {
      id: 4584,
      name: 'Ostrava-město',
      iso2: '806',
      countryId: 58,
    },
    {
      id: 4547,
      name: 'Pardubice',
      iso2: '532',
      countryId: 58,
    },
    {
      id: 4588,
      name: 'Pardubický kraj',
      iso2: '53',
      countryId: 58,
    },
    {
      id: 4645,
      name: 'Pelhřimov',
      iso2: '633',
      countryId: 58,
    },
    {
      id: 4560,
      name: 'Písek',
      iso2: '314',
      countryId: 58,
    },
    {
      id: 4608,
      name: 'Plzeň-jih',
      iso2: '324',
      countryId: 58,
    },
    {
      id: 4544,
      name: 'Plzeň-město',
      iso2: '323',
      countryId: 58,
    },
    {
      id: 4564,
      name: 'Plzeň-sever',
      iso2: '325',
      countryId: 58,
    },
    {
      id: 4607,
      name: 'Plzeňský kraj',
      iso2: '32',
      countryId: 58,
    },
    {
      id: 4578,
      name: 'Prachatice',
      iso2: '315',
      countryId: 58,
    },
    {
      id: 4606,
      name: 'Praha-východ',
      iso2: '209',
      countryId: 58,
    },
    {
      id: 4619,
      name: 'Praha-západ',
      iso2: '20A',
      countryId: 58,
    },
    {
      id: 4598,
      name: 'Praha, Hlavní město',
      iso2: '10',
      countryId: 58,
    },
    {
      id: 4626,
      name: 'Přerov',
      iso2: '714',
      countryId: 58,
    },
    {
      id: 4546,
      name: 'Příbram',
      iso2: '20B',
      countryId: 58,
    },
    {
      id: 4551,
      name: 'Prostějov',
      iso2: '713',
      countryId: 58,
    },
    {
      id: 4558,
      name: 'Rakovník',
      iso2: '20C',
      countryId: 58,
    },
    {
      id: 4583,
      name: 'Rokycany',
      iso2: '326',
      countryId: 58,
    },
    {
      id: 4636,
      name: 'Rychnov nad Kněžnou',
      iso2: '524',
      countryId: 58,
    },
    {
      id: 4596,
      name: 'Semily',
      iso2: '514',
      countryId: 58,
    },
    {
      id: 4595,
      name: 'Sokolov',
      iso2: '413',
      countryId: 58,
    },
    {
      id: 4628,
      name: 'Strakonice',
      iso2: '316',
      countryId: 58,
    },
    {
      id: 4554,
      name: 'Středočeský kraj',
      iso2: '20',
      countryId: 58,
    },
    {
      id: 4642,
      name: 'Šumperk',
      iso2: '715',
      countryId: 58,
    },
    {
      id: 4571,
      name: 'Svitavy',
      iso2: '533',
      countryId: 58,
    },
    {
      id: 4565,
      name: 'Tábor',
      iso2: '317',
      countryId: 58,
    },
    {
      id: 4646,
      name: 'Tachov',
      iso2: '327',
      countryId: 58,
    },
    {
      id: 4621,
      name: 'Teplice',
      iso2: '426',
      countryId: 58,
    },
    {
      id: 4597,
      name: 'Třebíč',
      iso2: '634',
      countryId: 58,
    },
    {
      id: 4579,
      name: 'Trutnov',
      iso2: '525',
      countryId: 58,
    },
    {
      id: 4592,
      name: 'Uherské Hradiště',
      iso2: '722',
      countryId: 58,
    },
    {
      id: 4576,
      name: 'Ústecký kraj',
      iso2: '42',
      countryId: 58,
    },
    {
      id: 4599,
      name: 'Ústí nad Labem',
      iso2: '427',
      countryId: 58,
    },
    {
      id: 4647,
      name: 'Ústí nad Orlicí',
      iso2: '534',
      countryId: 58,
    },
    {
      id: 4572,
      name: 'Vsetín',
      iso2: '723',
      countryId: 58,
    },
    {
      id: 4622,
      name: 'Vyškov',
      iso2: '646',
      countryId: 58,
    },
    {
      id: 4648,
      name: 'Žďár nad Sázavou',
      iso2: '635',
      countryId: 58,
    },
    {
      id: 4563,
      name: 'Zlín',
      iso2: '724',
      countryId: 58,
    },
    {
      id: 4552,
      name: 'Zlínský kraj',
      iso2: '72',
      countryId: 58,
    },
    {
      id: 4630,
      name: 'Znojmo',
      iso2: '647',
      countryId: 58,
    },
    {
      id: 2753,
      name: 'Bas-Uélé',
      iso2: 'BU',
      countryId: 51,
    },
    {
      id: 2744,
      name: 'Équateur',
      iso2: 'EQ',
      countryId: 51,
    },
    {
      id: 2750,
      name: 'Haut-Katanga',
      iso2: 'HK',
      countryId: 51,
    },
    {
      id: 2758,
      name: 'Haut-Lomami',
      iso2: 'HL',
      countryId: 51,
    },
    {
      id: 2734,
      name: 'Haut-Uélé',
      iso2: 'HU',
      countryId: 51,
    },
    {
      id: 2751,
      name: 'Ituri',
      iso2: 'IT',
      countryId: 51,
    },
    {
      id: 2757,
      name: 'Kasaï',
      iso2: 'KS',
      countryId: 51,
    },
    {
      id: 2742,
      name: 'Kasaï Central',
      iso2: 'KC',
      countryId: 51,
    },
    {
      id: 2735,
      name: 'Kasaï Oriental',
      iso2: 'KE',
      countryId: 51,
    },
    {
      id: 2741,
      name: 'Kinshasa',
      iso2: 'KN',
      countryId: 51,
    },
    {
      id: 2746,
      name: 'Kongo Central',
      iso2: 'BC',
      countryId: 51,
    },
    {
      id: 2740,
      name: 'Kwango',
      iso2: 'KG',
      countryId: 51,
    },
    {
      id: 2759,
      name: 'Kwilu',
      iso2: 'KL',
      countryId: 51,
    },
    {
      id: 2747,
      name: 'Lomami',
      iso2: 'LO',
      countryId: 51,
    },
    {
      id: 4953,
      name: 'Lualaba',
      iso2: 'LU',
      countryId: 51,
    },
    {
      id: 2755,
      name: 'Mai-Ndombe',
      iso2: 'MN',
      countryId: 51,
    },
    {
      id: 2745,
      name: 'Maniema',
      iso2: 'MA',
      countryId: 51,
    },
    {
      id: 2752,
      name: 'Mongala',
      iso2: 'MO',
      countryId: 51,
    },
    {
      id: 2749,
      name: 'Nord-Kivu',
      iso2: 'NK',
      countryId: 51,
    },
    {
      id: 2739,
      name: 'Nord-Ubangi',
      iso2: 'NU',
      countryId: 51,
    },
    {
      id: 2743,
      name: 'Sankuru',
      iso2: 'SA',
      countryId: 51,
    },
    {
      id: 2738,
      name: 'Sud-Kivu',
      iso2: 'SK',
      countryId: 51,
    },
    {
      id: 2748,
      name: 'Sud-Ubangi',
      iso2: 'SU',
      countryId: 51,
    },
    {
      id: 2733,
      name: 'Tanganyika',
      iso2: 'TA',
      countryId: 51,
    },
    {
      id: 2756,
      name: 'Tshopo',
      iso2: 'TO',
      countryId: 51,
    },
    {
      id: 2732,
      name: 'Tshuapa',
      iso2: 'TU',
      countryId: 51,
    },
    {
      id: 1531,
      name: 'Central Denmark',
      iso2: '82',
      countryId: 59,
    },
    {
      id: 1530,
      name: 'Denmark',
      iso2: '84',
      countryId: 59,
    },
    {
      id: 1532,
      name: 'North Denmark',
      iso2: '81',
      countryId: 59,
    },
    {
      id: 1529,
      name: 'Southern Denmark',
      iso2: '83',
      countryId: 59,
    },
    {
      id: 1528,
      name: 'Zealand',
      iso2: '85',
      countryId: 59,
    },
    {
      id: 2933,
      name: 'Ali Sabieh',
      iso2: 'AS',
      countryId: 60,
    },
    {
      id: 2932,
      name: 'Arta',
      iso2: 'AR',
      countryId: 60,
    },
    {
      id: 2930,
      name: 'Dikhil',
      iso2: 'DI',
      countryId: 60,
    },
    {
      id: 2929,
      name: 'Djibouti',
      iso2: 'DJ',
      countryId: 60,
    },
    {
      id: 2928,
      name: 'Obock',
      iso2: 'OB',
      countryId: 60,
    },
    {
      id: 2931,
      name: 'Tadjourah',
      iso2: 'TA',
      countryId: 60,
    },
    {
      id: 4082,
      name: 'Saint Andrew',
      iso2: '02',
      countryId: 61,
    },
    {
      id: 4078,
      name: 'Saint David',
      iso2: '03',
      countryId: 61,
    },
    {
      id: 4079,
      name: 'Saint George',
      iso2: '04',
      countryId: 61,
    },
    {
      id: 4076,
      name: 'Saint John',
      iso2: '05',
      countryId: 61,
    },
    {
      id: 4085,
      name: 'Saint Joseph',
      iso2: '06',
      countryId: 61,
    },
    {
      id: 4083,
      name: 'Saint Luke',
      iso2: '07',
      countryId: 61,
    },
    {
      id: 4077,
      name: 'Saint Mark',
      iso2: '08',
      countryId: 61,
    },
    {
      id: 4080,
      name: 'Saint Patrick',
      iso2: '09',
      countryId: 61,
    },
    {
      id: 4084,
      name: 'Saint Paul',
      iso2: '10',
      countryId: 61,
    },
    {
      id: 4081,
      name: 'Saint Peter',
      iso2: '11',
      countryId: 61,
    },
    {
      id: 4114,
      name: 'Azua',
      iso2: '02',
      countryId: 62,
    },
    {
      id: 4105,
      name: 'Baoruco',
      iso2: '03',
      countryId: 62,
    },
    {
      id: 4090,
      name: 'Barahona',
      iso2: '04',
      countryId: 62,
    },
    {
      id: 5540,
      name: 'Cibao Nordeste',
      iso2: '33',
      countryId: 62,
    },
    {
      id: 5541,
      name: 'Cibao Noroeste',
      iso2: '34',
      countryId: 62,
    },
    {
      id: 5542,
      name: 'Cibao Norte',
      iso2: '35',
      countryId: 62,
    },
    {
      id: 5543,
      name: 'Cibao Sur',
      iso2: '36',
      countryId: 62,
    },
    {
      id: 4107,
      name: 'Dajabón',
      iso2: '05',
      countryId: 62,
    },
    {
      id: 4095,
      name: 'Distrito Nacional',
      iso2: '01',
      countryId: 62,
    },
    {
      id: 4113,
      name: 'Duarte',
      iso2: '06',
      countryId: 62,
    },
    {
      id: 4086,
      name: 'El Seibo',
      iso2: '08',
      countryId: 62,
    },
    {
      id: 5544,
      name: 'El Valle',
      iso2: '37',
      countryId: 62,
    },
    {
      id: 5539,
      name: 'Elías Piña',
      iso2: '07',
      countryId: 62,
    },
    {
      id: 5545,
      name: 'Enriquillo',
      iso2: '38',
      countryId: 62,
    },
    {
      id: 4102,
      name: 'Espaillat',
      iso2: '09',
      countryId: 62,
    },
    {
      id: 4106,
      name: 'Hato Mayor',
      iso2: '30',
      countryId: 62,
    },
    {
      id: 4089,
      name: 'Hermanas Mirabal',
      iso2: '19',
      countryId: 62,
    },
    {
      id: 5546,
      name: 'Higuamo',
      iso2: '39',
      countryId: 62,
    },
    {
      id: 4097,
      name: 'Independencia',
      iso2: '10',
      countryId: 62,
    },
    {
      id: 4109,
      name: 'La Altagracia',
      iso2: '11',
      countryId: 62,
    },
    {
      id: 4087,
      name: 'La Romana',
      iso2: '12',
      countryId: 62,
    },
    {
      id: 4116,
      name: 'La Vega',
      iso2: '13',
      countryId: 62,
    },
    {
      id: 4094,
      name: 'María Trinidad Sánchez',
      iso2: '14',
      countryId: 62,
    },
    {
      id: 4099,
      name: 'Monseñor Nouel',
      iso2: '28',
      countryId: 62,
    },
    {
      id: 4115,
      name: 'Monte Cristi',
      iso2: '15',
      countryId: 62,
    },
    {
      id: 4111,
      name: 'Monte Plata',
      iso2: '29',
      countryId: 62,
    },
    {
      id: 5547,
      name: 'Ozama',
      iso2: '40',
      countryId: 62,
    },
    {
      id: 4101,
      name: 'Pedernales',
      iso2: '16',
      countryId: 62,
    },
    {
      id: 4096,
      name: 'Peravia',
      iso2: '17',
      countryId: 62,
    },
    {
      id: 4092,
      name: 'Puerto Plata',
      iso2: '18',
      countryId: 62,
    },
    {
      id: 4103,
      name: 'Samaná',
      iso2: '20',
      countryId: 62,
    },
    {
      id: 4091,
      name: 'San Cristóbal',
      iso2: '21',
      countryId: 62,
    },
    {
      id: 4112,
      name: 'San José de Ocoa',
      iso2: '31',
      countryId: 62,
    },
    {
      id: 4098,
      name: 'San Juan',
      iso2: '22',
      countryId: 62,
    },
    {
      id: 4110,
      name: 'San Pedro de Macorís',
      iso2: '23',
      countryId: 62,
    },
    {
      id: 4088,
      name: 'Sánchez Ramírez',
      iso2: '24',
      countryId: 62,
    },
    {
      id: 4108,
      name: 'Santiago',
      iso2: '25',
      countryId: 62,
    },
    {
      id: 4100,
      name: 'Santiago Rodríguez',
      iso2: '26',
      countryId: 62,
    },
    {
      id: 4093,
      name: 'Santo Domingo',
      iso2: '32',
      countryId: 62,
    },
    {
      id: 5548,
      name: 'Valdesia',
      iso2: '41',
      countryId: 62,
    },
    {
      id: 4104,
      name: 'Valverde',
      iso2: '27',
      countryId: 62,
    },
    {
      id: 5549,
      name: 'Yuma',
      iso2: '42',
      countryId: 62,
    },
    {
      id: 2923,
      name: 'Azuay',
      iso2: 'A',
      countryId: 64,
    },
    {
      id: 2920,
      name: 'Bolívar',
      iso2: 'B',
      countryId: 64,
    },
    {
      id: 2917,
      name: 'Cañar',
      iso2: 'F',
      countryId: 64,
    },
    {
      id: 2915,
      name: 'Carchi',
      iso2: 'C',
      countryId: 64,
    },
    {
      id: 2925,
      name: 'Chimborazo',
      iso2: 'H',
      countryId: 64,
    },
    {
      id: 2921,
      name: 'Cotopaxi',
      iso2: 'X',
      countryId: 64,
    },
    {
      id: 2924,
      name: 'El Oro',
      iso2: 'O',
      countryId: 64,
    },
    {
      id: 2922,
      name: 'Esmeraldas',
      iso2: 'E',
      countryId: 64,
    },
    {
      id: 2905,
      name: 'Galápagos',
      iso2: 'W',
      countryId: 64,
    },
    {
      id: 2914,
      name: 'Guayas',
      iso2: 'G',
      countryId: 64,
    },
    {
      id: 2911,
      name: 'Imbabura',
      iso2: 'I',
      countryId: 64,
    },
    {
      id: 5068,
      name: 'Loja',
      iso2: 'L',
      countryId: 64,
    },
    {
      id: 2910,
      name: 'Los Ríos',
      iso2: 'R',
      countryId: 64,
    },
    {
      id: 2913,
      name: 'Manabí',
      iso2: 'M',
      countryId: 64,
    },
    {
      id: 2918,
      name: 'Morona-Santiago',
      iso2: 'S',
      countryId: 64,
    },
    {
      id: 2916,
      name: 'Napo',
      iso2: 'N',
      countryId: 64,
    },
    {
      id: 2926,
      name: 'Orellana',
      iso2: 'D',
      countryId: 64,
    },
    {
      id: 2907,
      name: 'Pastaza',
      iso2: 'Y',
      countryId: 64,
    },
    {
      id: 2927,
      name: 'Pichincha',
      iso2: 'P',
      countryId: 64,
    },
    {
      id: 2912,
      name: 'Santa Elena',
      iso2: 'SE',
      countryId: 64,
    },
    {
      id: 2919,
      name: 'Santo Domingo de los Tsáchilas',
      iso2: 'SD',
      countryId: 64,
    },
    {
      id: 2906,
      name: 'Sucumbíos',
      iso2: 'U',
      countryId: 64,
    },
    {
      id: 2908,
      name: 'Tungurahua',
      iso2: 'T',
      countryId: 64,
    },
    {
      id: 2909,
      name: 'Zamora Chinchipe',
      iso2: 'Z',
      countryId: 64,
    },
    {
      id: 3235,
      name: 'Alexandria',
      iso2: 'ALX',
      countryId: 65,
    },
    {
      id: 3225,
      name: 'Aswan',
      iso2: 'ASN',
      countryId: 65,
    },
    {
      id: 3236,
      name: 'Asyut',
      iso2: 'AST',
      countryId: 65,
    },
    {
      id: 3241,
      name: 'Beheira',
      iso2: 'BH',
      countryId: 65,
    },
    {
      id: 3230,
      name: 'Beni Suef',
      iso2: 'BNS',
      countryId: 65,
    },
    {
      id: 3223,
      name: 'Cairo',
      iso2: 'C',
      countryId: 65,
    },
    {
      id: 3245,
      name: 'Dakahlia',
      iso2: 'DK',
      countryId: 65,
    },
    {
      id: 3224,
      name: 'Damietta',
      iso2: 'DT',
      countryId: 65,
    },
    {
      id: 3238,
      name: 'Faiyum',
      iso2: 'FYM',
      countryId: 65,
    },
    {
      id: 3234,
      name: 'Gharbia',
      iso2: 'GH',
      countryId: 65,
    },
    {
      id: 3239,
      name: 'Giza',
      iso2: 'GZ',
      countryId: 65,
    },
    {
      id: 3244,
      name: 'Ismailia',
      iso2: 'IS',
      countryId: 65,
    },
    {
      id: 3222,
      name: 'Kafr El-Sheikh',
      iso2: 'KFS',
      countryId: 65,
    },
    {
      id: 3242,
      name: 'Luxor',
      iso2: 'LX',
      countryId: 65,
    },
    {
      id: 3231,
      name: 'Matrouh',
      iso2: 'MT',
      countryId: 65,
    },
    {
      id: 3243,
      name: 'Minya',
      iso2: 'MN',
      countryId: 65,
    },
    {
      id: 3228,
      name: 'Monufia',
      iso2: 'MNF',
      countryId: 65,
    },
    {
      id: 3246,
      name: 'New Valley',
      iso2: 'WAD',
      countryId: 65,
    },
    {
      id: 3227,
      name: 'North Sinai',
      iso2: 'SIN',
      countryId: 65,
    },
    {
      id: 3229,
      name: 'Port Said',
      iso2: 'PTS',
      countryId: 65,
    },
    {
      id: 3232,
      name: 'Qalyubia',
      iso2: 'KB',
      countryId: 65,
    },
    {
      id: 3247,
      name: 'Qena',
      iso2: 'KN',
      countryId: 65,
    },
    {
      id: 3240,
      name: 'Red Sea',
      iso2: 'BA',
      countryId: 65,
    },
    {
      id: 5067,
      name: 'Sharqia',
      iso2: 'SHR',
      countryId: 65,
    },
    {
      id: 3226,
      name: 'Sohag',
      iso2: 'SHG',
      countryId: 65,
    },
    {
      id: 3237,
      name: 'South Sinai',
      iso2: 'JS',
      countryId: 65,
    },
    {
      id: 3233,
      name: 'Suez',
      iso2: 'SUZ',
      countryId: 65,
    },
    {
      id: 4139,
      name: 'Ahuachapán',
      iso2: 'AH',
      countryId: 66,
    },
    {
      id: 4132,
      name: 'Cabañas',
      iso2: 'CA',
      countryId: 66,
    },
    {
      id: 4131,
      name: 'Chalatenango',
      iso2: 'CH',
      countryId: 66,
    },
    {
      id: 4137,
      name: 'Cuscatlán',
      iso2: 'CU',
      countryId: 66,
    },
    {
      id: 4134,
      name: 'La Libertad',
      iso2: 'LI',
      countryId: 66,
    },
    {
      id: 4136,
      name: 'La Paz',
      iso2: 'PA',
      countryId: 66,
    },
    {
      id: 4138,
      name: 'La Unión ',
      iso2: 'UN',
      countryId: 66,
    },
    {
      id: 4130,
      name: 'Morazán',
      iso2: 'MO',
      countryId: 66,
    },
    {
      id: 4135,
      name: 'San Miguel',
      iso2: 'SM',
      countryId: 66,
    },
    {
      id: 4133,
      name: 'San Salvador',
      iso2: 'SS',
      countryId: 66,
    },
    {
      id: 4127,
      name: 'San Vicente',
      iso2: 'SV',
      countryId: 66,
    },
    {
      id: 4128,
      name: 'Santa Ana',
      iso2: 'SA',
      countryId: 66,
    },
    {
      id: 4140,
      name: 'Sonsonate',
      iso2: 'SO',
      countryId: 66,
    },
    {
      id: 4129,
      name: 'Usulután',
      iso2: 'US',
      countryId: 66,
    },
    {
      id: 3444,
      name: 'Annobón',
      iso2: 'AN',
      countryId: 67,
    },
    {
      id: 3446,
      name: 'Bioko Norte',
      iso2: 'BN',
      countryId: 67,
    },
    {
      id: 3443,
      name: 'Bioko Sur',
      iso2: 'BS',
      countryId: 67,
    },
    {
      id: 3445,
      name: 'Centro Sur',
      iso2: 'CS',
      countryId: 67,
    },
    {
      id: 5551,
      name: 'Djibloho',
      iso2: 'DJ',
      countryId: 67,
    },
    {
      id: 3442,
      name: 'Insular',
      iso2: 'I',
      countryId: 67,
    },
    {
      id: 3439,
      name: 'Kié-Ntem',
      iso2: 'KN',
      countryId: 67,
    },
    {
      id: 3441,
      name: 'Litoral',
      iso2: 'LI',
      countryId: 67,
    },
    {
      id: 3438,
      name: 'Río Muni',
      iso2: 'C',
      countryId: 67,
    },
    {
      id: 3440,
      name: 'Wele-Nzas',
      iso2: 'WN',
      countryId: 67,
    },
    {
      id: 3425,
      name: 'Anseba',
      iso2: 'AN',
      countryId: 68,
    },
    {
      id: 3427,
      name: 'Debub',
      iso2: 'DU',
      countryId: 68,
    },
    {
      id: 3428,
      name: 'Gash-Barka',
      iso2: 'GB',
      countryId: 68,
    },
    {
      id: 3426,
      name: 'Maekel',
      iso2: 'MA',
      countryId: 68,
    },
    {
      id: 3424,
      name: 'Northern Red Sea',
      iso2: 'SK',
      countryId: 68,
    },
    {
      id: 3429,
      name: 'Southern Red Sea',
      iso2: 'DK',
      countryId: 68,
    },
    {
      id: 5736,
      name: 'Alutaguse',
      iso2: '130',
      countryId: 69,
    },
    {
      id: 5737,
      name: 'Anija',
      iso2: '141',
      countryId: 69,
    },
    {
      id: 5738,
      name: 'Antsla',
      iso2: '142',
      countryId: 69,
    },
    {
      id: 5739,
      name: 'Elva',
      iso2: '171',
      countryId: 69,
    },
    {
      id: 5743,
      name: 'Häädemeeste',
      iso2: '214',
      countryId: 69,
    },
    {
      id: 5800,
      name: 'Haapsalu',
      iso2: '184',
      countryId: 69,
    },
    {
      id: 5740,
      name: 'Haljala',
      iso2: '191',
      countryId: 69,
    },
    {
      id: 3567,
      name: 'Harju',
      iso2: '37',
      countryId: 69,
    },
    {
      id: 5741,
      name: 'Harku',
      iso2: '198',
      countryId: 69,
    },
    {
      id: 3555,
      name: 'Hiiu',
      iso2: '39',
      countryId: 69,
    },
    {
      id: 5742,
      name: 'Hiiumaa',
      iso2: '205',
      countryId: 69,
    },
    {
      id: 3569,
      name: 'Ida-Viru',
      iso2: '45',
      countryId: 69,
    },
    {
      id: 3566,
      name: 'Järva',
      iso2: '52',
      countryId: 69,
    },
    {
      id: 5747,
      name: 'Järva',
      iso2: '255',
      countryId: 69,
    },
    {
      id: 5744,
      name: 'Joelähtme',
      iso2: '245',
      countryId: 69,
    },
    {
      id: 3565,
      name: 'Jõgeva',
      iso2: '50',
      countryId: 69,
    },
    {
      id: 5745,
      name: 'Jõgeva',
      iso2: '247',
      countryId: 69,
    },
    {
      id: 5746,
      name: 'Jõhvi',
      iso2: '251',
      countryId: 69,
    },
    {
      id: 5748,
      name: 'Kadrina',
      iso2: '272',
      countryId: 69,
    },
    {
      id: 5749,
      name: 'Kambja',
      iso2: '283',
      countryId: 69,
    },
    {
      id: 5750,
      name: 'Kanepi',
      iso2: '284',
      countryId: 69,
    },
    {
      id: 5751,
      name: 'Kastre',
      iso2: '291',
      countryId: 69,
    },
    {
      id: 5752,
      name: 'Kehtna',
      iso2: '293',
      countryId: 69,
    },
    {
      id: 5801,
      name: 'Keila',
      iso2: '296',
      countryId: 69,
    },
    {
      id: 5753,
      name: 'Kihnu',
      iso2: '303',
      countryId: 69,
    },
    {
      id: 5754,
      name: 'Kiili',
      iso2: '305',
      countryId: 69,
    },
    {
      id: 5755,
      name: 'Kohila',
      iso2: '317',
      countryId: 69,
    },
    {
      id: 5802,
      name: 'Kohtla-Järve',
      iso2: '321',
      countryId: 69,
    },
    {
      id: 5756,
      name: 'Kose',
      iso2: '338',
      countryId: 69,
    },
    {
      id: 5757,
      name: 'Kuusalu',
      iso2: '353',
      countryId: 69,
    },
    {
      id: 3568,
      name: 'Lääne',
      iso2: '56',
      countryId: 69,
    },
    {
      id: 5758,
      name: 'Lääne-Harju',
      iso2: '430',
      countryId: 69,
    },
    {
      id: 5761,
      name: 'Lääne-Nigula',
      iso2: '441',
      countryId: 69,
    },
    {
      id: 3564,
      name: 'Lääne-Viru',
      iso2: '60',
      countryId: 69,
    },
    {
      id: 5759,
      name: 'Lääneranna',
      iso2: '431',
      countryId: 69,
    },
    {
      id: 5803,
      name: 'Loksa',
      iso2: '424',
      countryId: 69,
    },
    {
      id: 5762,
      name: 'Lüganuse',
      iso2: '442',
      countryId: 69,
    },
    {
      id: 5760,
      name: 'Luunja',
      iso2: '432',
      countryId: 69,
    },
    {
      id: 5804,
      name: 'Maardu',
      iso2: '446',
      countryId: 69,
    },
    {
      id: 5766,
      name: 'Märjamaa',
      iso2: '503',
      countryId: 69,
    },
    {
      id: 5763,
      name: 'Muhu',
      iso2: '478',
      countryId: 69,
    },
    {
      id: 5764,
      name: 'Mulgi',
      iso2: '480',
      countryId: 69,
    },
    {
      id: 5765,
      name: 'Mustvee',
      iso2: '486',
      countryId: 69,
    },
    {
      id: 5805,
      name: 'Narva',
      iso2: '511',
      countryId: 69,
    },
    {
      id: 5806,
      name: 'Narva-Jõesuu',
      iso2: '514',
      countryId: 69,
    },
    {
      id: 5767,
      name: 'Noo',
      iso2: '528',
      countryId: 69,
    },
    {
      id: 5768,
      name: 'Otepää',
      iso2: '557',
      countryId: 69,
    },
    {
      id: 5807,
      name: 'Paide',
      iso2: '567',
      countryId: 69,
    },
    {
      id: 3562,
      name: 'Pärnu',
      iso2: '68',
      countryId: 69,
    },
    {
      id: 5808,
      name: 'Pärnu',
      iso2: '624',
      countryId: 69,
    },
    {
      id: 5769,
      name: 'Peipsiääre',
      iso2: '586',
      countryId: 69,
    },
    {
      id: 5773,
      name: 'Põhja-Pärnu',
      iso2: '638',
      countryId: 69,
    },
    {
      id: 5770,
      name: 'Põhja-Sakala',
      iso2: '615',
      countryId: 69,
    },
    {
      id: 5771,
      name: 'Poltsamaa',
      iso2: '618',
      countryId: 69,
    },
    {
      id: 5772,
      name: 'Põlva',
      iso2: '622',
      countryId: 69,
    },
    {
      id: 3563,
      name: 'Põlva',
      iso2: '64',
      countryId: 69,
    },
    {
      id: 5774,
      name: 'Raasiku',
      iso2: '651',
      countryId: 69,
    },
    {
      id: 5775,
      name: 'Rae',
      iso2: '653',
      countryId: 69,
    },
    {
      id: 5809,
      name: 'Rakvere',
      iso2: '663',
      countryId: 69,
    },
    {
      id: 5776,
      name: 'Rakvere',
      iso2: '661',
      countryId: 69,
    },
    {
      id: 5780,
      name: 'Räpina',
      iso2: '708',
      countryId: 69,
    },
    {
      id: 5777,
      name: 'Rapla',
      iso2: '668',
      countryId: 69,
    },
    {
      id: 3559,
      name: 'Rapla',
      iso2: '71',
      countryId: 69,
    },
    {
      id: 5779,
      name: 'Rõuge',
      iso2: '698',
      countryId: 69,
    },
    {
      id: 5778,
      name: 'Ruhnu',
      iso2: '689',
      countryId: 69,
    },
    {
      id: 5781,
      name: 'Saarde',
      iso2: '712',
      countryId: 69,
    },
    {
      id: 3561,
      name: 'Saare',
      iso2: '74',
      countryId: 69,
    },
    {
      id: 5782,
      name: 'Saaremaa',
      iso2: '714',
      countryId: 69,
    },
    {
      id: 5783,
      name: 'Saku',
      iso2: '719',
      countryId: 69,
    },
    {
      id: 5784,
      name: 'Saue',
      iso2: '726',
      countryId: 69,
    },
    {
      id: 5785,
      name: 'Setomaa',
      iso2: '732',
      countryId: 69,
    },
    {
      id: 5810,
      name: 'Sillamäe',
      iso2: '735',
      countryId: 69,
    },
    {
      id: 5811,
      name: 'Tallinn',
      iso2: '784',
      countryId: 69,
    },
    {
      id: 5786,
      name: 'Tapa',
      iso2: '792',
      countryId: 69,
    },
    {
      id: 5812,
      name: 'Tartu',
      iso2: '793',
      countryId: 69,
    },
    {
      id: 3557,
      name: 'Tartu',
      iso2: '79',
      countryId: 69,
    },
    {
      id: 5787,
      name: 'Tartu',
      iso2: '796',
      countryId: 69,
    },
    {
      id: 5788,
      name: 'Toila',
      iso2: '803',
      countryId: 69,
    },
    {
      id: 5789,
      name: 'Tori',
      iso2: '809',
      countryId: 69,
    },
    {
      id: 5790,
      name: 'Tõrva',
      iso2: '824',
      countryId: 69,
    },
    {
      id: 5791,
      name: 'Türi',
      iso2: '834',
      countryId: 69,
    },
    {
      id: 5799,
      name: 'Väike-Maarja',
      iso2: '928',
      countryId: 69,
    },
    {
      id: 5792,
      name: 'Valga',
      iso2: '855',
      countryId: 69,
    },
    {
      id: 3558,
      name: 'Valga',
      iso2: '81',
      countryId: 69,
    },
    {
      id: 5793,
      name: 'Viimsi',
      iso2: '890',
      countryId: 69,
    },
    {
      id: 5813,
      name: 'Viljandi',
      iso2: '897',
      countryId: 69,
    },
    {
      id: 3556,
      name: 'Viljandi',
      iso2: '84',
      countryId: 69,
    },
    {
      id: 5794,
      name: 'Viljandi',
      iso2: '899',
      countryId: 69,
    },
    {
      id: 5795,
      name: 'Vinni',
      iso2: '901',
      countryId: 69,
    },
    {
      id: 5796,
      name: 'Viru-Nigula',
      iso2: '903',
      countryId: 69,
    },
    {
      id: 5797,
      name: 'Vormsi',
      iso2: '907',
      countryId: 69,
    },
    {
      id: 5798,
      name: 'Võru',
      iso2: '917',
      countryId: 69,
    },
    {
      id: 3560,
      name: 'Võru',
      iso2: '87',
      countryId: 69,
    },
    {
      id: 5814,
      name: 'Võru',
      iso2: '919',
      countryId: 69,
    },
    {
      id: 969,
      name: 'Hhohho',
      iso2: 'HH',
      countryId: 212,
    },
    {
      id: 970,
      name: 'Lubombo',
      iso2: 'LU',
      countryId: 212,
    },
    {
      id: 968,
      name: 'Manzini',
      iso2: 'MA',
      countryId: 212,
    },
    {
      id: 971,
      name: 'Shiselweni',
      iso2: 'SH',
      countryId: 212,
    },
    {
      id: 11,
      name: 'Addis Ababa',
      iso2: 'AA',
      countryId: 70,
    },
    {
      id: 6,
      name: 'Afar',
      iso2: 'AF',
      countryId: 70,
    },
    {
      id: 3,
      name: 'Amhara',
      iso2: 'AM',
      countryId: 70,
    },
    {
      id: 9,
      name: 'Benishangul-Gumuz',
      iso2: 'BE',
      countryId: 70,
    },
    {
      id: 8,
      name: 'Dire Dawa',
      iso2: 'DD',
      countryId: 70,
    },
    {
      id: 10,
      name: 'Gambela',
      iso2: 'GA',
      countryId: 70,
    },
    {
      id: 7,
      name: 'Harari',
      iso2: 'HA',
      countryId: 70,
    },
    {
      id: 5,
      name: 'Oromia',
      iso2: 'OR',
      countryId: 70,
    },
    {
      id: 5465,
      name: 'Sidama',
      iso2: 'SI',
      countryId: 70,
    },
    {
      id: 2,
      name: 'Somali',
      iso2: 'SO',
      countryId: 70,
    },
    {
      id: 1,
      name: 'Southern Nations, Nationalities, and Peoples',
      iso2: 'SN',
      countryId: 70,
    },
    {
      id: 5466,
      name: 'Southwest Ethiopia Peoples',
      iso2: 'SW',
      countryId: 70,
    },
    {
      id: 4,
      name: 'Tigray',
      iso2: 'TI',
      countryId: 70,
    },
    {
      id: 5229,
      name: 'Eysturoy',
      iso2: 'EY',
      countryId: 72,
    },
    {
      id: 5230,
      name: 'Northern Isles',
      iso2: 'NO',
      countryId: 72,
    },
    {
      id: 5231,
      name: 'Sandoy',
      iso2: 'SA',
      countryId: 72,
    },
    {
      id: 5232,
      name: 'Streymoy',
      iso2: 'ST',
      countryId: 72,
    },
    {
      id: 5233,
      name: 'Suðuroy',
      iso2: 'SU',
      countryId: 72,
    },
    {
      id: 5234,
      name: 'Vágar',
      iso2: 'VA',
      countryId: 72,
    },
    {
      id: 1917,
      name: 'Ba',
      iso2: '01',
      countryId: 73,
    },
    {
      id: 1930,
      name: 'Bua',
      iso2: '02',
      countryId: 73,
    },
    {
      id: 1924,
      name: 'Cakaudrove',
      iso2: '03',
      countryId: 73,
    },
    {
      id: 1929,
      name: 'Central',
      iso2: 'C',
      countryId: 73,
    },
    {
      id: 1932,
      name: 'Eastern',
      iso2: 'E',
      countryId: 73,
    },
    {
      id: 1934,
      name: 'Kadavu',
      iso2: '04',
      countryId: 73,
    },
    {
      id: 1933,
      name: 'Lau',
      iso2: '05',
      countryId: 73,
    },
    {
      id: 1916,
      name: 'Lomaiviti',
      iso2: '06',
      countryId: 73,
    },
    {
      id: 1922,
      name: 'Macuata',
      iso2: '07',
      countryId: 73,
    },
    {
      id: 1919,
      name: 'Nadroga-Navosa',
      iso2: '08',
      countryId: 73,
    },
    {
      id: 1927,
      name: 'Naitasiri',
      iso2: '09',
      countryId: 73,
    },
    {
      id: 1928,
      name: 'Namosi',
      iso2: '10',
      countryId: 73,
    },
    {
      id: 1921,
      name: 'Northern',
      iso2: 'N',
      countryId: 73,
    },
    {
      id: 1926,
      name: 'Ra',
      iso2: '11',
      countryId: 73,
    },
    {
      id: 1920,
      name: 'Rewa',
      iso2: '12',
      countryId: 73,
    },
    {
      id: 1931,
      name: 'Rotuma',
      iso2: 'R',
      countryId: 73,
    },
    {
      id: 1925,
      name: 'Serua',
      iso2: '13',
      countryId: 73,
    },
    {
      id: 1918,
      name: 'Tailevu',
      iso2: '14',
      countryId: 73,
    },
    {
      id: 1923,
      name: 'Western',
      iso2: 'W',
      countryId: 73,
    },
    {
      id: 1511,
      name: 'Central Finland',
      iso2: '08',
      countryId: 74,
    },
    {
      id: 1494,
      name: 'Central Ostrobothnia',
      iso2: '07',
      countryId: 74,
    },
    {
      id: 1507,
      name: 'Finland Proper',
      iso2: '19',
      countryId: 74,
    },
    {
      id: 1496,
      name: 'Kainuu',
      iso2: '05',
      countryId: 74,
    },
    {
      id: 1512,
      name: 'Kymenlaakso',
      iso2: '09',
      countryId: 74,
    },
    {
      id: 1500,
      name: 'Lapland',
      iso2: '10',
      countryId: 74,
    },
    {
      id: 1504,
      name: 'North Karelia',
      iso2: '13',
      countryId: 74,
    },
    {
      id: 1505,
      name: 'Northern Ostrobothnia',
      iso2: '14',
      countryId: 74,
    },
    {
      id: 1503,
      name: 'Northern Savonia',
      iso2: '15',
      countryId: 74,
    },
    {
      id: 1508,
      name: 'Ostrobothnia',
      iso2: '12',
      countryId: 74,
    },
    {
      id: 1502,
      name: 'Päijänne Tavastia',
      iso2: '16',
      countryId: 74,
    },
    {
      id: 1506,
      name: 'Pirkanmaa',
      iso2: '11',
      countryId: 74,
    },
    {
      id: 1501,
      name: 'Satakunta',
      iso2: '17',
      countryId: 74,
    },
    {
      id: 1497,
      name: 'South Karelia',
      iso2: '02',
      countryId: 74,
    },
    {
      id: 1498,
      name: 'Southern Ostrobothnia',
      iso2: '03',
      countryId: 74,
    },
    {
      id: 1495,
      name: 'Southern Savonia',
      iso2: '04',
      countryId: 74,
    },
    {
      id: 1493,
      name: 'Tavastia Proper',
      iso2: '06',
      countryId: 74,
    },
    {
      id: 1510,
      name: 'Uusimaa',
      iso2: '18',
      countryId: 74,
    },
    {
      id: 4967,
      name: 'Ain',
      iso2: '01',
      countryId: 75,
    },
    {
      id: 4968,
      name: 'Aisne',
      iso2: '02',
      countryId: 75,
    },
    {
      id: 4969,
      name: 'Allier',
      iso2: '03',
      countryId: 75,
    },
    {
      id: 4970,
      name: 'Alpes-de-Haute-Provence',
      iso2: '04',
      countryId: 75,
    },
    {
      id: 4972,
      name: 'Alpes-Maritimes',
      iso2: '06',
      countryId: 75,
    },
    {
      id: 4811,
      name: 'Alsace',
      iso2: '6AE',
      countryId: 75,
    },
    {
      id: 4973,
      name: 'Ardèche',
      iso2: '07',
      countryId: 75,
    },
    {
      id: 4974,
      name: 'Ardennes',
      iso2: '08',
      countryId: 75,
    },
    {
      id: 4975,
      name: 'Ariège',
      iso2: '09',
      countryId: 75,
    },
    {
      id: 4976,
      name: 'Aube',
      iso2: '10',
      countryId: 75,
    },
    {
      id: 4977,
      name: 'Aude',
      iso2: '11',
      countryId: 75,
    },
    {
      id: 4798,
      name: 'Auvergne-Rhône-Alpes',
      iso2: 'ARA',
      countryId: 75,
    },
    {
      id: 4978,
      name: 'Aveyron',
      iso2: '12',
      countryId: 75,
    },
    {
      id: 5035,
      name: 'Bas-Rhin',
      iso2: '67',
      countryId: 75,
    },
    {
      id: 4979,
      name: 'Bouches-du-Rhône',
      iso2: '13',
      countryId: 75,
    },
    {
      id: 4825,
      name: 'Bourgogne-Franche-Comté',
      iso2: 'BFC',
      countryId: 75,
    },
    {
      id: 4807,
      name: 'Bretagne',
      iso2: 'BRE',
      countryId: 75,
    },
    {
      id: 4981,
      name: 'Calvados',
      iso2: '14',
      countryId: 75,
    },
    {
      id: 4982,
      name: 'Cantal',
      iso2: '15',
      countryId: 75,
    },
    {
      id: 4818,
      name: 'Centre-Val de Loire',
      iso2: 'CVL',
      countryId: 75,
    },
    {
      id: 4983,
      name: 'Charente',
      iso2: '16',
      countryId: 75,
    },
    {
      id: 4984,
      name: 'Charente-Maritime',
      iso2: '17',
      countryId: 75,
    },
    {
      id: 4985,
      name: 'Cher',
      iso2: '18',
      countryId: 75,
    },
    {
      id: 5064,
      name: 'Clipperton',
      iso2: 'CP',
      countryId: 75,
    },
    {
      id: 4986,
      name: 'Corrèze',
      iso2: '19',
      countryId: 75,
    },
    {
      id: 4806,
      name: 'Corse',
      iso2: '20R',
      countryId: 75,
    },
    {
      id: 4996,
      name: 'Corse-du-Sud',
      iso2: '2A',
      countryId: 75,
    },
    {
      id: 4987,
      name: "Côte-d'Or",
      iso2: '21',
      countryId: 75,
    },
    {
      id: 4988,
      name: "Côtes-d'Armor",
      iso2: '22',
      countryId: 75,
    },
    {
      id: 4989,
      name: 'Creuse',
      iso2: '23',
      countryId: 75,
    },
    {
      id: 5047,
      name: 'Deux-Sèvres',
      iso2: '79',
      countryId: 75,
    },
    {
      id: 4990,
      name: 'Dordogne',
      iso2: '24',
      countryId: 75,
    },
    {
      id: 4991,
      name: 'Doubs',
      iso2: '25',
      countryId: 75,
    },
    {
      id: 4992,
      name: 'Drôme',
      iso2: '26',
      countryId: 75,
    },
    {
      id: 5059,
      name: 'Essonne',
      iso2: '91',
      countryId: 75,
    },
    {
      id: 4993,
      name: 'Eure',
      iso2: '27',
      countryId: 75,
    },
    {
      id: 4994,
      name: 'Eure-et-Loir',
      iso2: '28',
      countryId: 75,
    },
    {
      id: 4995,
      name: 'Finistère',
      iso2: '29',
      countryId: 75,
    },
    {
      id: 4822,
      name: 'French Guiana',
      iso2: '973',
      countryId: 75,
    },
    {
      id: 4824,
      name: 'French Polynesia',
      iso2: 'PF',
      countryId: 75,
    },
    {
      id: 5065,
      name: 'French Southern and Antarctic Lands',
      iso2: 'TF',
      countryId: 75,
    },
    {
      id: 4998,
      name: 'Gard',
      iso2: '30',
      countryId: 75,
    },
    {
      id: 5000,
      name: 'Gers',
      iso2: '32',
      countryId: 75,
    },
    {
      id: 5001,
      name: 'Gironde',
      iso2: '33',
      countryId: 75,
    },
    {
      id: 4820,
      name: 'Grand-Est',
      iso2: 'GES',
      countryId: 75,
    },
    {
      id: 4829,
      name: 'Guadeloupe',
      iso2: '971',
      countryId: 75,
    },
    {
      id: 5036,
      name: 'Haut-Rhin',
      iso2: '68',
      countryId: 75,
    },
    {
      id: 4997,
      name: 'Haute-Corse',
      iso2: '2B',
      countryId: 75,
    },
    {
      id: 4999,
      name: 'Haute-Garonne',
      iso2: '31',
      countryId: 75,
    },
    {
      id: 5011,
      name: 'Haute-Loire',
      iso2: '43',
      countryId: 75,
    },
    {
      id: 5020,
      name: 'Haute-Marne',
      iso2: '52',
      countryId: 75,
    },
    {
      id: 5039,
      name: 'Haute-Saône',
      iso2: '70',
      countryId: 75,
    },
    {
      id: 5043,
      name: 'Haute-Savoie',
      iso2: '74',
      countryId: 75,
    },
    {
      id: 5055,
      name: 'Haute-Vienne',
      iso2: '87',
      countryId: 75,
    },
    {
      id: 4971,
      name: 'Hautes-Alpes',
      iso2: '05',
      countryId: 75,
    },
    {
      id: 5033,
      name: 'Hautes-Pyrénées',
      iso2: '65',
      countryId: 75,
    },
    {
      id: 4828,
      name: 'Hauts-de-France',
      iso2: 'HDF',
      countryId: 75,
    },
    {
      id: 5060,
      name: 'Hauts-de-Seine',
      iso2: '92',
      countryId: 75,
    },
    {
      id: 5002,
      name: 'Hérault',
      iso2: '34',
      countryId: 75,
    },
    {
      id: 4796,
      name: 'Île-de-France',
      iso2: 'IDF',
      countryId: 75,
    },
    {
      id: 5003,
      name: 'Ille-et-Vilaine',
      iso2: '35',
      countryId: 75,
    },
    {
      id: 5004,
      name: 'Indre',
      iso2: '36',
      countryId: 75,
    },
    {
      id: 5005,
      name: 'Indre-et-Loire',
      iso2: '37',
      countryId: 75,
    },
    {
      id: 5006,
      name: 'Isère',
      iso2: '38',
      countryId: 75,
    },
    {
      id: 5007,
      name: 'Jura',
      iso2: '39',
      countryId: 75,
    },
    {
      id: 4823,
      name: 'La Réunion',
      iso2: '974',
      countryId: 75,
    },
    {
      id: 5008,
      name: 'Landes',
      iso2: '40',
      countryId: 75,
    },
    {
      id: 5009,
      name: 'Loir-et-Cher',
      iso2: '41',
      countryId: 75,
    },
    {
      id: 5010,
      name: 'Loire',
      iso2: '42',
      countryId: 75,
    },
    {
      id: 5012,
      name: 'Loire-Atlantique',
      iso2: '44',
      countryId: 75,
    },
    {
      id: 5013,
      name: 'Loiret',
      iso2: '45',
      countryId: 75,
    },
    {
      id: 5014,
      name: 'Lot',
      iso2: '46',
      countryId: 75,
    },
    {
      id: 5015,
      name: 'Lot-et-Garonne',
      iso2: '47',
      countryId: 75,
    },
    {
      id: 5016,
      name: 'Lozère',
      iso2: '48',
      countryId: 75,
    },
    {
      id: 5017,
      name: 'Maine-et-Loire',
      iso2: '49',
      countryId: 75,
    },
    {
      id: 5018,
      name: 'Manche',
      iso2: '50',
      countryId: 75,
    },
    {
      id: 5019,
      name: 'Marne',
      iso2: '51',
      countryId: 75,
    },
    {
      id: 4827,
      name: 'Martinique',
      iso2: '972',
      countryId: 75,
    },
    {
      id: 5021,
      name: 'Mayenne',
      iso2: '53',
      countryId: 75,
    },
    {
      id: 4797,
      name: 'Mayotte',
      iso2: '976',
      countryId: 75,
    },
    {
      id: 5038,
      name: 'Métropole de Lyon',
      iso2: '69M',
      countryId: 75,
    },
    {
      id: 5022,
      name: 'Meurthe-et-Moselle',
      iso2: '54',
      countryId: 75,
    },
    {
      id: 5023,
      name: 'Meuse',
      iso2: '55',
      countryId: 75,
    },
    {
      id: 5024,
      name: 'Morbihan',
      iso2: '56',
      countryId: 75,
    },
    {
      id: 5025,
      name: 'Moselle',
      iso2: '57',
      countryId: 75,
    },
    {
      id: 5026,
      name: 'Nièvre',
      iso2: '58',
      countryId: 75,
    },
    {
      id: 5027,
      name: 'Nord',
      iso2: '59',
      countryId: 75,
    },
    {
      id: 4804,
      name: 'Normandie',
      iso2: 'NOR',
      countryId: 75,
    },
    {
      id: 4795,
      name: 'Nouvelle-Aquitaine',
      iso2: 'NAQ',
      countryId: 75,
    },
    {
      id: 5538,
      name: 'Nouvelle-Calédonie',
      iso2: 'NC',
      countryId: 75,
    },
    {
      id: 4799,
      name: 'Occitanie',
      iso2: 'OCC',
      countryId: 75,
    },
    {
      id: 5028,
      name: 'Oise',
      iso2: '60',
      countryId: 75,
    },
    {
      id: 5029,
      name: 'Orne',
      iso2: '61',
      countryId: 75,
    },
    {
      id: 4816,
      name: 'Paris',
      iso2: '75C',
      countryId: 75,
    },
    {
      id: 5030,
      name: 'Pas-de-Calais',
      iso2: '62',
      countryId: 75,
    },
    {
      id: 4802,
      name: 'Pays-de-la-Loire',
      iso2: 'PDL',
      countryId: 75,
    },
    {
      id: 4812,
      name: 'Provence-Alpes-Côte-d’Azur',
      iso2: 'PAC',
      countryId: 75,
    },
    {
      id: 5031,
      name: 'Puy-de-Dôme',
      iso2: '63',
      countryId: 75,
    },
    {
      id: 5032,
      name: 'Pyrénées-Atlantiques',
      iso2: '64',
      countryId: 75,
    },
    {
      id: 5034,
      name: 'Pyrénées-Orientales',
      iso2: '66',
      countryId: 75,
    },
    {
      id: 5037,
      name: 'Rhône',
      iso2: '69',
      countryId: 75,
    },
    {
      id: 4821,
      name: 'Saint Pierre and Miquelon',
      iso2: 'PM',
      countryId: 75,
    },
    {
      id: 4794,
      name: 'Saint-Barthélemy',
      iso2: 'BL',
      countryId: 75,
    },
    {
      id: 4809,
      name: 'Saint-Martin',
      iso2: 'MF',
      countryId: 75,
    },
    {
      id: 5040,
      name: 'Saône-et-Loire',
      iso2: '71',
      countryId: 75,
    },
    {
      id: 5041,
      name: 'Sarthe',
      iso2: '72',
      countryId: 75,
    },
    {
      id: 5042,
      name: 'Savoie',
      iso2: '73',
      countryId: 75,
    },
    {
      id: 5045,
      name: 'Seine-et-Marne',
      iso2: '77',
      countryId: 75,
    },
    {
      id: 5044,
      name: 'Seine-Maritime',
      iso2: '76',
      countryId: 75,
    },
    {
      id: 5061,
      name: 'Seine-Saint-Denis',
      iso2: '93',
      countryId: 75,
    },
    {
      id: 5048,
      name: 'Somme',
      iso2: '80',
      countryId: 75,
    },
    {
      id: 5049,
      name: 'Tarn',
      iso2: '81',
      countryId: 75,
    },
    {
      id: 5050,
      name: 'Tarn-et-Garonne',
      iso2: '82',
      countryId: 75,
    },
    {
      id: 5058,
      name: 'Territoire de Belfort',
      iso2: '90',
      countryId: 75,
    },
    {
      id: 5063,
      name: "Val-d'Oise",
      iso2: '95',
      countryId: 75,
    },
    {
      id: 5062,
      name: 'Val-de-Marne',
      iso2: '94',
      countryId: 75,
    },
    {
      id: 5051,
      name: 'Var',
      iso2: '83',
      countryId: 75,
    },
    {
      id: 5052,
      name: 'Vaucluse',
      iso2: '84',
      countryId: 75,
    },
    {
      id: 5053,
      name: 'Vendée',
      iso2: '85',
      countryId: 75,
    },
    {
      id: 5054,
      name: 'Vienne',
      iso2: '86',
      countryId: 75,
    },
    {
      id: 5056,
      name: 'Vosges',
      iso2: '88',
      countryId: 75,
    },
    {
      id: 4810,
      name: 'Wallis and Futuna',
      iso2: 'WF',
      countryId: 75,
    },
    {
      id: 5057,
      name: 'Yonne',
      iso2: '89',
      countryId: 75,
    },
    {
      id: 5046,
      name: 'Yvelines',
      iso2: '78',
      countryId: 75,
    },
    {
      id: 5369,
      name: 'Austral Islands',
      iso2: '01',
      countryId: 77,
    },
    {
      id: 5370,
      name: 'Leeward Islands',
      iso2: '02',
      countryId: 77,
    },
    {
      id: 5371,
      name: 'Marquesas Islands',
      iso2: '03',
      countryId: 77,
    },
    {
      id: 5372,
      name: 'Tuamotu-Gambier',
      iso2: '04',
      countryId: 77,
    },
    {
      id: 5373,
      name: 'Windward Islands',
      iso2: '05',
      countryId: 77,
    },
    {
      id: 2727,
      name: 'Estuaire',
      iso2: '1',
      countryId: 79,
    },
    {
      id: 2726,
      name: 'Haut-Ogooué',
      iso2: '2',
      countryId: 79,
    },
    {
      id: 2730,
      name: 'Moyen-Ogooué',
      iso2: '3',
      countryId: 79,
    },
    {
      id: 2731,
      name: 'Ngounié',
      iso2: '4',
      countryId: 79,
    },
    {
      id: 2725,
      name: 'Nyanga',
      iso2: '5',
      countryId: 79,
    },
    {
      id: 2724,
      name: 'Ogooué-Ivindo',
      iso2: '6',
      countryId: 79,
    },
    {
      id: 2729,
      name: 'Ogooué-Lolo',
      iso2: '7',
      countryId: 79,
    },
    {
      id: 2728,
      name: 'Ogooué-Maritime',
      iso2: '8',
      countryId: 79,
    },
    {
      id: 2723,
      name: 'Woleu-Ntem',
      iso2: '9',
      countryId: 79,
    },
    {
      id: 901,
      name: 'Abkhazia',
      iso2: 'AB',
      countryId: 81,
    },
    {
      id: 900,
      name: 'Adjara',
      iso2: 'AJ',
      countryId: 81,
    },
    {
      id: 907,
      name: 'Guria',
      iso2: 'GU',
      countryId: 81,
    },
    {
      id: 905,
      name: 'Imereti',
      iso2: 'IM',
      countryId: 81,
    },
    {
      id: 910,
      name: 'Kakheti',
      iso2: 'KA',
      countryId: 81,
    },
    {
      id: 904,
      name: 'Kvemo Kartli',
      iso2: 'KK',
      countryId: 81,
    },
    {
      id: 902,
      name: 'Mtskheta-Mtianeti',
      iso2: 'MM',
      countryId: 81,
    },
    {
      id: 909,
      name: 'Racha-Lechkhumi and Kvemo Svaneti',
      iso2: 'RL',
      countryId: 81,
    },
    {
      id: 908,
      name: 'Samegrelo-Zemo Svaneti',
      iso2: 'SZ',
      countryId: 81,
    },
    {
      id: 906,
      name: 'Samtskhe-Javakheti',
      iso2: 'SJ',
      countryId: 81,
    },
    {
      id: 903,
      name: 'Shida Kartli',
      iso2: 'SK',
      countryId: 81,
    },
    {
      id: 899,
      name: 'Tbilisi',
      iso2: 'TB',
      countryId: 81,
    },
    {
      id: 3006,
      name: 'Baden-Württemberg',
      iso2: 'BW',
      countryId: 82,
    },
    {
      id: 3009,
      name: 'Bavaria',
      iso2: 'BY',
      countryId: 82,
    },
    {
      id: 3010,
      name: 'Berlin',
      iso2: 'BE',
      countryId: 82,
    },
    {
      id: 3013,
      name: 'Brandenburg',
      iso2: 'BB',
      countryId: 82,
    },
    {
      id: 3014,
      name: 'Bremen',
      iso2: 'HB',
      countryId: 82,
    },
    {
      id: 3016,
      name: 'Hamburg',
      iso2: 'HH',
      countryId: 82,
    },
    {
      id: 3018,
      name: 'Hessen',
      iso2: 'HE',
      countryId: 82,
    },
    {
      id: 3008,
      name: 'Lower Saxony',
      iso2: 'NI',
      countryId: 82,
    },
    {
      id: 3007,
      name: 'Mecklenburg-Vorpommern',
      iso2: 'MV',
      countryId: 82,
    },
    {
      id: 3017,
      name: 'North Rhine-Westphalia',
      iso2: 'NW',
      countryId: 82,
    },
    {
      id: 3019,
      name: 'Rhineland-Palatinate',
      iso2: 'RP',
      countryId: 82,
    },
    {
      id: 3020,
      name: 'Saarland',
      iso2: 'SL',
      countryId: 82,
    },
    {
      id: 3021,
      name: 'Saxony',
      iso2: 'SN',
      countryId: 82,
    },
    {
      id: 3011,
      name: 'Saxony-Anhalt',
      iso2: 'ST',
      countryId: 82,
    },
    {
      id: 3005,
      name: 'Schleswig-Holstein',
      iso2: 'SH',
      countryId: 82,
    },
    {
      id: 3015,
      name: 'Thuringia',
      iso2: 'TH',
      countryId: 82,
    },
    {
      id: 53,
      name: 'Ahafo',
      iso2: 'AF',
      countryId: 83,
    },
    {
      id: 48,
      name: 'Ashanti',
      iso2: 'AH',
      countryId: 83,
    },
    {
      id: 4959,
      name: 'Bono',
      iso2: 'BO',
      countryId: 83,
    },
    {
      id: 4958,
      name: 'Bono East',
      iso2: 'BE',
      countryId: 83,
    },
    {
      id: 52,
      name: 'Central',
      iso2: 'CP',
      countryId: 83,
    },
    {
      id: 50,
      name: 'Eastern',
      iso2: 'EP',
      countryId: 83,
    },
    {
      id: 54,
      name: 'Greater Accra',
      iso2: 'AA',
      countryId: 83,
    },
    {
      id: 4960,
      name: 'North East',
      iso2: 'NE',
      countryId: 83,
    },
    {
      id: 51,
      name: 'Northern',
      iso2: 'NP',
      countryId: 83,
    },
    {
      id: 4961,
      name: 'Oti',
      iso2: 'OT',
      countryId: 83,
    },
    {
      id: 4962,
      name: 'Savannah',
      iso2: 'SV',
      countryId: 83,
    },
    {
      id: 55,
      name: 'Upper East',
      iso2: 'UE',
      countryId: 83,
    },
    {
      id: 57,
      name: 'Upper West',
      iso2: 'UW',
      countryId: 83,
    },
    {
      id: 56,
      name: 'Volta',
      iso2: 'TV',
      countryId: 83,
    },
    {
      id: 49,
      name: 'Western',
      iso2: 'WP',
      countryId: 83,
    },
    {
      id: 4963,
      name: 'Western North',
      iso2: 'WN',
      countryId: 83,
    },
    {
      id: 2116,
      name: 'Achaea',
      iso2: '13',
      countryId: 85,
    },
    {
      id: 2122,
      name: 'Attica',
      iso2: 'I',
      countryId: 85,
    },
    {
      id: 2128,
      name: 'Central Greece',
      iso2: 'H',
      countryId: 85,
    },
    {
      id: 2125,
      name: 'Central Macedonia',
      iso2: 'B',
      countryId: 85,
    },
    {
      id: 2109,
      name: 'Crete',
      iso2: 'M',
      countryId: 85,
    },
    {
      id: 2120,
      name: 'East Attica',
      iso2: 'A2',
      countryId: 85,
    },
    {
      id: 2117,
      name: 'East Macedonia and Thrace',
      iso2: 'A',
      countryId: 85,
    },
    {
      id: 2110,
      name: 'Epirus',
      iso2: 'D',
      countryId: 85,
    },
    {
      id: 2131,
      name: 'Ionian Islands',
      iso2: 'F',
      countryId: 85,
    },
    {
      id: 5464,
      name: 'North Aegean',
      iso2: 'K',
      countryId: 85,
    },
    {
      id: 2119,
      name: 'Peloponnese',
      iso2: 'J',
      countryId: 85,
    },
    {
      id: 2118,
      name: 'South Aegean',
      iso2: 'L',
      countryId: 85,
    },
    {
      id: 5463,
      name: 'Thessaly',
      iso2: 'E',
      countryId: 85,
    },
    {
      id: 2096,
      name: 'West Greece',
      iso2: 'G',
      countryId: 85,
    },
    {
      id: 2108,
      name: 'West Macedonia',
      iso2: 'C',
      countryId: 85,
    },
    {
      id: 5379,
      name: 'Avannaata',
      iso2: 'AV',
      countryId: 86,
    },
    {
      id: 5380,
      name: 'Kujalleq',
      iso2: 'KU',
      countryId: 86,
    },
    {
      id: 5381,
      name: 'Qeqertalik',
      iso2: 'QT',
      countryId: 86,
    },
    {
      id: 5382,
      name: 'Qeqqata',
      iso2: 'QE',
      countryId: 86,
    },
    {
      id: 5383,
      name: 'Sermersooq',
      iso2: 'SM',
      countryId: 86,
    },
    {
      id: 3867,
      name: 'Carriacou',
      iso2: '10',
      countryId: 87,
    },
    {
      id: 3865,
      name: 'Saint Andrew',
      iso2: '01',
      countryId: 87,
    },
    {
      id: 3869,
      name: 'Saint David',
      iso2: '02',
      countryId: 87,
    },
    {
      id: 3864,
      name: 'Saint George',
      iso2: '03',
      countryId: 87,
    },
    {
      id: 3868,
      name: 'Saint John',
      iso2: '04',
      countryId: 87,
    },
    {
      id: 3866,
      name: 'Saint Mark',
      iso2: '05',
      countryId: 87,
    },
    {
      id: 3863,
      name: 'Saint Patrick',
      iso2: '06',
      countryId: 87,
    },
    {
      id: 5384,
      name: 'Basse-Terre',
      iso2: '01',
      countryId: 88,
    },
    {
      id: 5385,
      name: 'Pointe-à-Pitre',
      iso2: '02',
      countryId: 88,
    },
    {
      id: 5254,
      name: 'Agana Heights',
      iso2: '01',
      countryId: 89,
    },
    {
      id: 5255,
      name: 'Asan-Maina',
      iso2: '02',
      countryId: 89,
    },
    {
      id: 5256,
      name: 'Barrigada',
      iso2: '03',
      countryId: 89,
    },
    {
      id: 5257,
      name: 'Chalan Pago-Ordot',
      iso2: '04',
      countryId: 89,
    },
    {
      id: 5258,
      name: 'Dededo',
      iso2: '05',
      countryId: 89,
    },
    {
      id: 5259,
      name: 'Hågat',
      iso2: '06',
      countryId: 89,
    },
    {
      id: 5265,
      name: 'Hagåtña',
      iso2: '12',
      countryId: 89,
    },
    {
      id: 5261,
      name: 'Inarajan (Inalåhan)',
      iso2: '08',
      countryId: 89,
    },
    {
      id: 5263,
      name: 'Mangilao',
      iso2: '10',
      countryId: 89,
    },
    {
      id: 5262,
      name: 'Merizo (Malesso)',
      iso2: '09',
      countryId: 89,
    },
    {
      id: 5264,
      name: 'Mongmong-Toto-Maite',
      iso2: '11',
      countryId: 89,
    },
    {
      id: 5266,
      name: 'Piti',
      iso2: '13',
      countryId: 89,
    },
    {
      id: 5267,
      name: 'Santa Rita (Sånta Rita-Sumai)',
      iso2: '14',
      countryId: 89,
    },
    {
      id: 5268,
      name: 'Sinajana',
      iso2: '15',
      countryId: 89,
    },
    {
      id: 5269,
      name: "Talofofo (Talo'fo'fo)",
      iso2: '16',
      countryId: 89,
    },
    {
      id: 5270,
      name: 'Tamuning',
      iso2: '17',
      countryId: 89,
    },
    {
      id: 5260,
      name: 'Umatac (Humåtak)',
      iso2: '07',
      countryId: 89,
    },
    {
      id: 5271,
      name: 'Yigo',
      iso2: '18',
      countryId: 89,
    },
    {
      id: 5272,
      name: 'Yona',
      iso2: '19',
      countryId: 89,
    },
    {
      id: 3671,
      name: 'Alta Verapaz ',
      iso2: '16',
      countryId: 90,
    },
    {
      id: 3674,
      name: 'Baja Verapaz ',
      iso2: '15',
      countryId: 90,
    },
    {
      id: 3675,
      name: 'Chimaltenango ',
      iso2: '04',
      countryId: 90,
    },
    {
      id: 3666,
      name: 'Chiquimula ',
      iso2: '20',
      countryId: 90,
    },
    {
      id: 3662,
      name: 'El Progreso ',
      iso2: '02',
      countryId: 90,
    },
    {
      id: 3677,
      name: 'Escuintla ',
      iso2: '05',
      countryId: 90,
    },
    {
      id: 3672,
      name: 'Guatemala ',
      iso2: '01',
      countryId: 90,
    },
    {
      id: 3670,
      name: 'Huehuetenango ',
      iso2: '13',
      countryId: 90,
    },
    {
      id: 3659,
      name: 'Izabal ',
      iso2: '18',
      countryId: 90,
    },
    {
      id: 3658,
      name: 'Jalapa ',
      iso2: '21',
      countryId: 90,
    },
    {
      id: 3673,
      name: 'Jutiapa ',
      iso2: '22',
      countryId: 90,
    },
    {
      id: 3669,
      name: 'Petén ',
      iso2: '17',
      countryId: 90,
    },
    {
      id: 3668,
      name: 'Quetzaltenango ',
      iso2: '09',
      countryId: 90,
    },
    {
      id: 3657,
      name: 'Quiché ',
      iso2: '14',
      countryId: 90,
    },
    {
      id: 3664,
      name: 'Retalhuleu ',
      iso2: '11',
      countryId: 90,
    },
    {
      id: 3676,
      name: 'Sacatepéquez ',
      iso2: '03',
      countryId: 90,
    },
    {
      id: 3667,
      name: 'San Marcos ',
      iso2: '12',
      countryId: 90,
    },
    {
      id: 3665,
      name: 'Santa Rosa ',
      iso2: '06',
      countryId: 90,
    },
    {
      id: 3661,
      name: 'Sololá ',
      iso2: '07',
      countryId: 90,
    },
    {
      id: 3660,
      name: 'Suchitepéquez ',
      iso2: '10',
      countryId: 90,
    },
    {
      id: 3663,
      name: 'Totonicapán ',
      iso2: '08',
      countryId: 90,
    },
    {
      id: 5239,
      name: 'Zacapa',
      iso2: '19',
      countryId: 90,
    },
    {
      id: 5389,
      name: 'Alderney',
      iso2: '04',
      countryId: 91,
    },
    {
      id: 5386,
      name: 'Castel',
      iso2: '01',
      countryId: 91,
    },
    {
      id: 5387,
      name: 'Forest',
      iso2: '02',
      countryId: 91,
    },
    {
      id: 5392,
      name: 'Sark',
      iso2: '07',
      countryId: 91,
    },
    {
      id: 5388,
      name: 'St Andrew',
      iso2: '03',
      countryId: 91,
    },
    {
      id: 5390,
      name: 'St Martin',
      iso2: '05',
      countryId: 91,
    },
    {
      id: 5391,
      name: 'St Peter Port',
      iso2: '06',
      countryId: 91,
    },
    {
      id: 5393,
      name: 'St Pierre du Bois',
      iso2: '08',
      countryId: 91,
    },
    {
      id: 5394,
      name: 'St Sampson',
      iso2: '09',
      countryId: 91,
    },
    {
      id: 5395,
      name: 'St Saviour',
      iso2: '10',
      countryId: 91,
    },
    {
      id: 5396,
      name: 'Torteval',
      iso2: '11',
      countryId: 91,
    },
    {
      id: 5397,
      name: 'Vale',
      iso2: '12',
      countryId: 91,
    },
    {
      id: 2672,
      name: 'Beyla',
      iso2: 'BE',
      countryId: 92,
    },
    {
      id: 2699,
      name: 'Boffa',
      iso2: 'BF',
      countryId: 92,
    },
    {
      id: 2676,
      name: 'Boké',
      iso2: 'B',
      countryId: 92,
    },
    {
      id: 2709,
      name: 'Boké',
      iso2: 'BK',
      countryId: 92,
    },
    {
      id: 2686,
      name: 'Conakry',
      iso2: 'C',
      countryId: 92,
    },
    {
      id: 2705,
      name: 'Coyah',
      iso2: 'CO',
      countryId: 92,
    },
    {
      id: 2679,
      name: 'Dabola',
      iso2: 'DB',
      countryId: 92,
    },
    {
      id: 2706,
      name: 'Dalaba',
      iso2: 'DL',
      countryId: 92,
    },
    {
      id: 2688,
      name: 'Dinguiraye',
      iso2: 'DI',
      countryId: 92,
    },
    {
      id: 2681,
      name: 'Dubréka',
      iso2: 'DU',
      countryId: 92,
    },
    {
      id: 5344,
      name: 'Faranah',
      iso2: 'F',
      countryId: 92,
    },
    {
      id: 2682,
      name: 'Faranah',
      iso2: 'FA',
      countryId: 92,
    },
    {
      id: 2683,
      name: 'Forécariah',
      iso2: 'FO',
      countryId: 92,
    },
    {
      id: 2675,
      name: 'Fria',
      iso2: 'FR',
      countryId: 92,
    },
    {
      id: 2685,
      name: 'Gaoual',
      iso2: 'GA',
      countryId: 92,
    },
    {
      id: 2711,
      name: 'Guéckédou',
      iso2: 'GU',
      countryId: 92,
    },
    {
      id: 2704,
      name: 'Kankan',
      iso2: 'KA',
      countryId: 92,
    },
    {
      id: 2697,
      name: 'Kankan',
      iso2: 'K',
      countryId: 92,
    },
    {
      id: 2710,
      name: 'Kérouané',
      iso2: 'KE',
      countryId: 92,
    },
    {
      id: 2701,
      name: 'Kindia',
      iso2: 'D',
      countryId: 92,
    },
    {
      id: 2693,
      name: 'Kindia',
      iso2: 'KD',
      countryId: 92,
    },
    {
      id: 2691,
      name: 'Kissidougou',
      iso2: 'KS',
      countryId: 92,
    },
    {
      id: 2692,
      name: 'Koubia',
      iso2: 'KB',
      countryId: 92,
    },
    {
      id: 2703,
      name: 'Koundara',
      iso2: 'KN',
      countryId: 92,
    },
    {
      id: 2695,
      name: 'Kouroussa',
      iso2: 'KO',
      countryId: 92,
    },
    {
      id: 2680,
      name: 'Labé',
      iso2: 'LA',
      countryId: 92,
    },
    {
      id: 2677,
      name: 'Labé',
      iso2: 'L',
      countryId: 92,
    },
    {
      id: 2690,
      name: 'Lélouma',
      iso2: 'LE',
      countryId: 92,
    },
    {
      id: 2708,
      name: 'Lola',
      iso2: 'LO',
      countryId: 92,
    },
    {
      id: 2702,
      name: 'Macenta',
      iso2: 'MC',
      countryId: 92,
    },
    {
      id: 2700,
      name: 'Mali',
      iso2: 'ML',
      countryId: 92,
    },
    {
      id: 2698,
      name: 'Mamou',
      iso2: 'M',
      countryId: 92,
    },
    {
      id: 2689,
      name: 'Mamou',
      iso2: 'MM',
      countryId: 92,
    },
    {
      id: 2673,
      name: 'Mandiana',
      iso2: 'MD',
      countryId: 92,
    },
    {
      id: 2684,
      name: 'Nzérékoré',
      iso2: 'N',
      countryId: 92,
    },
    {
      id: 2678,
      name: 'Nzérékoré',
      iso2: 'NZ',
      countryId: 92,
    },
    {
      id: 2694,
      name: 'Pita',
      iso2: 'PI',
      countryId: 92,
    },
    {
      id: 2707,
      name: 'Siguiri',
      iso2: 'SI',
      countryId: 92,
    },
    {
      id: 2687,
      name: 'Télimélé',
      iso2: 'TE',
      countryId: 92,
    },
    {
      id: 2696,
      name: 'Tougué',
      iso2: 'TO',
      countryId: 92,
    },
    {
      id: 2674,
      name: 'Yomou',
      iso2: 'YO',
      countryId: 92,
    },
    {
      id: 2720,
      name: 'Bafatá',
      iso2: 'BA',
      countryId: 93,
    },
    {
      id: 2714,
      name: 'Biombo',
      iso2: 'BM',
      countryId: 93,
    },
    {
      id: 5553,
      name: 'Bissau',
      iso2: 'BS',
      countryId: 93,
    },
    {
      id: 2722,
      name: 'Bolama',
      iso2: 'BL',
      countryId: 93,
    },
    {
      id: 2713,
      name: 'Cacheu',
      iso2: 'CA',
      countryId: 93,
    },
    {
      id: 2719,
      name: 'Gabú',
      iso2: 'GA',
      countryId: 93,
    },
    {
      id: 2721,
      name: 'Leste',
      iso2: 'L',
      countryId: 93,
    },
    {
      id: 2717,
      name: 'Norte',
      iso2: 'N',
      countryId: 93,
    },
    {
      id: 2718,
      name: 'Oio',
      iso2: 'OI',
      countryId: 93,
    },
    {
      id: 2715,
      name: 'Quinara',
      iso2: 'QU',
      countryId: 93,
    },
    {
      id: 2716,
      name: 'Sul',
      iso2: 'S',
      countryId: 93,
    },
    {
      id: 2712,
      name: 'Tombali',
      iso2: 'TO',
      countryId: 93,
    },
    {
      id: 2764,
      name: 'Barima-Waini',
      iso2: 'BA',
      countryId: 94,
    },
    {
      id: 2760,
      name: 'Cuyuni-Mazaruni',
      iso2: 'CU',
      countryId: 94,
    },
    {
      id: 2767,
      name: 'Demerara-Mahaica',
      iso2: 'DE',
      countryId: 94,
    },
    {
      id: 2766,
      name: 'East Berbice-Corentyne',
      iso2: 'EB',
      countryId: 94,
    },
    {
      id: 2768,
      name: 'Essequibo Islands-West Demerara',
      iso2: 'ES',
      countryId: 94,
    },
    {
      id: 2762,
      name: 'Mahaica-Berbice',
      iso2: 'MA',
      countryId: 94,
    },
    {
      id: 2765,
      name: 'Pomeroon-Supenaam',
      iso2: 'PM',
      countryId: 94,
    },
    {
      id: 2761,
      name: 'Potaro-Siparuni',
      iso2: 'PT',
      countryId: 94,
    },
    {
      id: 2763,
      name: 'Upper Demerara-Berbice',
      iso2: 'UD',
      countryId: 94,
    },
    {
      id: 2769,
      name: 'Upper Takutu-Upper Essequibo',
      iso2: 'UT',
      countryId: 94,
    },
    {
      id: 4123,
      name: 'Artibonite',
      iso2: 'AR',
      countryId: 95,
    },
    {
      id: 4125,
      name: 'Centre',
      iso2: 'CE',
      countryId: 95,
    },
    {
      id: 4119,
      name: "Grand'Anse",
      iso2: 'GA',
      countryId: 95,
    },
    {
      id: 4118,
      name: 'Nippes',
      iso2: 'NI',
      countryId: 95,
    },
    {
      id: 4117,
      name: 'Nord',
      iso2: 'ND',
      countryId: 95,
    },
    {
      id: 4121,
      name: 'Nord-Est',
      iso2: 'NE',
      countryId: 95,
    },
    {
      id: 4126,
      name: 'Nord-Ouest',
      iso2: 'NO',
      countryId: 95,
    },
    {
      id: 4120,
      name: 'Ouest',
      iso2: 'OU',
      countryId: 95,
    },
    {
      id: 4122,
      name: 'Sud',
      iso2: 'SD',
      countryId: 95,
    },
    {
      id: 4124,
      name: 'Sud-Est',
      iso2: 'SE',
      countryId: 95,
    },
    {
      id: 4047,
      name: 'Atlántida',
      iso2: 'AT',
      countryId: 97,
    },
    {
      id: 4045,
      name: 'Bay Islands',
      iso2: 'IB',
      countryId: 97,
    },
    {
      id: 4041,
      name: 'Choluteca',
      iso2: 'CH',
      countryId: 97,
    },
    {
      id: 4051,
      name: 'Colón',
      iso2: 'CL',
      countryId: 97,
    },
    {
      id: 4042,
      name: 'Comayagua',
      iso2: 'CM',
      countryId: 97,
    },
    {
      id: 4049,
      name: 'Copán',
      iso2: 'CP',
      countryId: 97,
    },
    {
      id: 4046,
      name: 'Cortés',
      iso2: 'CR',
      countryId: 97,
    },
    {
      id: 4043,
      name: 'El Paraíso',
      iso2: 'EP',
      countryId: 97,
    },
    {
      id: 4052,
      name: 'Francisco Morazán',
      iso2: 'FM',
      countryId: 97,
    },
    {
      id: 4048,
      name: 'Gracias a Dios',
      iso2: 'GD',
      countryId: 97,
    },
    {
      id: 4044,
      name: 'Intibucá',
      iso2: 'IN',
      countryId: 97,
    },
    {
      id: 4058,
      name: 'La Paz',
      iso2: 'LP',
      countryId: 97,
    },
    {
      id: 4054,
      name: 'Lempira',
      iso2: 'LE',
      countryId: 97,
    },
    {
      id: 4056,
      name: 'Ocotepeque',
      iso2: 'OC',
      countryId: 97,
    },
    {
      id: 4050,
      name: 'Olancho',
      iso2: 'OL',
      countryId: 97,
    },
    {
      id: 4053,
      name: 'Santa Bárbara',
      iso2: 'SB',
      countryId: 97,
    },
    {
      id: 4055,
      name: 'Valle',
      iso2: 'VA',
      countryId: 97,
    },
    {
      id: 4057,
      name: 'Yoro',
      iso2: 'YO',
      countryId: 97,
    },
    {
      id: 4889,
      name: 'Central and Western',
      iso2: 'HCW',
      countryId: 98,
    },
    {
      id: 4891,
      name: 'Eastern',
      iso2: 'HEA',
      countryId: 98,
    },
    {
      id: 4888,
      name: 'Islands',
      iso2: 'NIS',
      countryId: 98,
    },
    {
      id: 4895,
      name: 'Kowloon City',
      iso2: 'KKC',
      countryId: 98,
    },
    {
      id: 4898,
      name: 'Kwai Tsing',
      iso2: 'NKT',
      countryId: 98,
    },
    {
      id: 4897,
      name: 'Kwun Tong',
      iso2: 'KKT',
      countryId: 98,
    },
    {
      id: 4900,
      name: 'North',
      iso2: 'NNO',
      countryId: 98,
    },
    {
      id: 4887,
      name: 'Sai Kung',
      iso2: 'NSK',
      countryId: 98,
    },
    {
      id: 4901,
      name: 'Sha Tin',
      iso2: 'NST',
      countryId: 98,
    },
    {
      id: 4894,
      name: 'Sham Shui Po',
      iso2: 'KSS',
      countryId: 98,
    },
    {
      id: 4892,
      name: 'Southern',
      iso2: 'HSO',
      countryId: 98,
    },
    {
      id: 4885,
      name: 'Tai Po',
      iso2: 'NTP',
      countryId: 98,
    },
    {
      id: 4884,
      name: 'Tsuen Wan',
      iso2: 'NTW',
      countryId: 98,
    },
    {
      id: 4899,
      name: 'Tuen Mun',
      iso2: 'NTM',
      countryId: 98,
    },
    {
      id: 4890,
      name: 'Wan Chai',
      iso2: 'HWC',
      countryId: 98,
    },
    {
      id: 4896,
      name: 'Wong Tai Sin',
      iso2: 'KWT',
      countryId: 98,
    },
    {
      id: 4893,
      name: 'Yau Tsim Mong',
      iso2: 'KYT',
      countryId: 98,
    },
    {
      id: 4883,
      name: 'Yuen Long',
      iso2: 'NYL',
      countryId: 98,
    },
    {
      id: 1048,
      name: 'Bács-Kiskun',
      iso2: 'BK',
      countryId: 99,
    },
    {
      id: 1055,
      name: 'Baranya',
      iso2: 'BA',
      countryId: 99,
    },
    {
      id: 1060,
      name: 'Békés',
      iso2: 'BE',
      countryId: 99,
    },
    {
      id: 1036,
      name: 'Békéscsaba',
      iso2: 'BC',
      countryId: 99,
    },
    {
      id: 1058,
      name: 'Borsod-Abaúj-Zemplén',
      iso2: 'BZ',
      countryId: 99,
    },
    {
      id: 1064,
      name: 'Budapest',
      iso2: 'BU',
      countryId: 99,
    },
    {
      id: 1031,
      name: 'Csongrád County',
      iso2: 'CS',
      countryId: 99,
    },
    {
      id: 1032,
      name: 'Debrecen',
      iso2: 'DE',
      countryId: 99,
    },
    {
      id: 1049,
      name: 'Dunaújváros',
      iso2: 'DU',
      countryId: 99,
    },
    {
      id: 1037,
      name: 'Eger',
      iso2: 'EG',
      countryId: 99,
    },
    {
      id: 1028,
      name: 'Érd',
      iso2: 'ER',
      countryId: 99,
    },
    {
      id: 1044,
      name: 'Fejér County',
      iso2: 'FE',
      countryId: 99,
    },
    {
      id: 1041,
      name: 'Győr',
      iso2: 'GY',
      countryId: 99,
    },
    {
      id: 1042,
      name: 'Győr-Moson-Sopron County',
      iso2: 'GS',
      countryId: 99,
    },
    {
      id: 1063,
      name: 'Hajdú-Bihar County',
      iso2: 'HB',
      countryId: 99,
    },
    {
      id: 1040,
      name: 'Heves County',
      iso2: 'HE',
      countryId: 99,
    },
    {
      id: 1027,
      name: 'Hódmezővásárhely',
      iso2: 'HV',
      countryId: 99,
    },
    {
      id: 1043,
      name: 'Jász-Nagykun-Szolnok County',
      iso2: 'JN',
      countryId: 99,
    },
    {
      id: 1067,
      name: 'Kaposvár',
      iso2: 'KV',
      countryId: 99,
    },
    {
      id: 1056,
      name: 'Kecskemét',
      iso2: 'KM',
      countryId: 99,
    },
    {
      id: 5085,
      name: 'Komárom-Esztergom',
      iso2: 'KE',
      countryId: 99,
    },
    {
      id: 1065,
      name: 'Miskolc',
      iso2: 'MI',
      countryId: 99,
    },
    {
      id: 1030,
      name: 'Nagykanizsa',
      iso2: 'NK',
      countryId: 99,
    },
    {
      id: 1051,
      name: 'Nógrád County',
      iso2: 'NO',
      countryId: 99,
    },
    {
      id: 1034,
      name: 'Nyíregyháza',
      iso2: 'NY',
      countryId: 99,
    },
    {
      id: 1053,
      name: 'Pécs',
      iso2: 'PS',
      countryId: 99,
    },
    {
      id: 1059,
      name: 'Pest County',
      iso2: 'PE',
      countryId: 99,
    },
    {
      id: 1068,
      name: 'Salgótarján',
      iso2: 'ST',
      countryId: 99,
    },
    {
      id: 1035,
      name: 'Somogy County',
      iso2: 'SO',
      countryId: 99,
    },
    {
      id: 1057,
      name: 'Sopron',
      iso2: 'SN',
      countryId: 99,
    },
    {
      id: 1045,
      name: 'Szabolcs-Szatmár-Bereg County',
      iso2: 'SZ',
      countryId: 99,
    },
    {
      id: 1029,
      name: 'Szeged',
      iso2: 'SD',
      countryId: 99,
    },
    {
      id: 1033,
      name: 'Székesfehérvár',
      iso2: 'SF',
      countryId: 99,
    },
    {
      id: 1061,
      name: 'Szekszárd',
      iso2: 'SS',
      countryId: 99,
    },
    {
      id: 1047,
      name: 'Szolnok',
      iso2: 'SK',
      countryId: 99,
    },
    {
      id: 1052,
      name: 'Szombathely',
      iso2: 'SH',
      countryId: 99,
    },
    {
      id: 1066,
      name: 'Tatabánya',
      iso2: 'TB',
      countryId: 99,
    },
    {
      id: 1038,
      name: 'Tolna County',
      iso2: 'TO',
      countryId: 99,
    },
    {
      id: 1039,
      name: 'Vas County',
      iso2: 'VA',
      countryId: 99,
    },
    {
      id: 1062,
      name: 'Veszprém',
      iso2: 'VM',
      countryId: 99,
    },
    {
      id: 1054,
      name: 'Veszprém County',
      iso2: 'VE',
      countryId: 99,
    },
    {
      id: 1046,
      name: 'Zala County',
      iso2: 'ZA',
      countryId: 99,
    },
    {
      id: 1050,
      name: 'Zalaegerszeg',
      iso2: 'ZE',
      countryId: 99,
    },
    {
      id: 5554,
      name: 'Akranes',
      iso2: 'AKN',
      countryId: 100,
    },
    {
      id: 5555,
      name: 'Akureyri',
      iso2: 'AKU',
      countryId: 100,
    },
    {
      id: 5599,
      name: 'Árborg',
      iso2: 'SFA',
      countryId: 100,
    },
    {
      id: 5556,
      name: 'Árneshreppur',
      iso2: 'ARN',
      countryId: 100,
    },
    {
      id: 5557,
      name: 'Ásahreppur',
      iso2: 'ASA',
      countryId: 100,
    },
    {
      id: 5558,
      name: 'Bláskógabyggð',
      iso2: 'BLA',
      countryId: 100,
    },
    {
      id: 5560,
      name: 'Bolungarvík',
      iso2: 'BOL',
      countryId: 100,
    },
    {
      id: 5559,
      name: 'Borgarbyggð',
      iso2: 'BOG',
      countryId: 100,
    },
    {
      id: 3431,
      name: 'Capital',
      iso2: '1',
      countryId: 100,
    },
    {
      id: 5561,
      name: 'Dalabyggð',
      iso2: 'DAB',
      countryId: 100,
    },
    {
      id: 5562,
      name: 'Dalvíkurbyggð',
      iso2: 'DAV',
      countryId: 100,
    },
    {
      id: 3433,
      name: 'Eastern',
      iso2: '7',
      countryId: 100,
    },
    {
      id: 5563,
      name: 'Eyja- og Miklaholtshreppur',
      iso2: 'EOM',
      countryId: 100,
    },
    {
      id: 5564,
      name: 'Eyjafjarðarsveit',
      iso2: 'EYF',
      countryId: 100,
    },
    {
      id: 5566,
      name: 'Fjallabyggð',
      iso2: 'FJL',
      countryId: 100,
    },
    {
      id: 5565,
      name: 'Fjarðabyggð',
      iso2: 'FJD',
      countryId: 100,
    },
    {
      id: 5568,
      name: 'Fljótsdalshreppur',
      iso2: 'FLR',
      countryId: 100,
    },
    {
      id: 5567,
      name: 'Flóahreppur',
      iso2: 'FLA',
      countryId: 100,
    },
    {
      id: 5569,
      name: 'Garðabær',
      iso2: 'GAR',
      countryId: 100,
    },
    {
      id: 5570,
      name: 'Grímsnes- og Grafningshreppur',
      iso2: 'GOG',
      countryId: 100,
    },
    {
      id: 5571,
      name: 'Grindavík',
      iso2: 'GRN',
      countryId: 100,
    },
    {
      id: 5572,
      name: 'Grundarfjörður',
      iso2: 'GRU',
      countryId: 100,
    },
    {
      id: 5573,
      name: 'Grýtubakkahreppur',
      iso2: 'GRY',
      countryId: 100,
    },
    {
      id: 5574,
      name: 'Hafnarfjörður',
      iso2: 'HAF',
      countryId: 100,
    },
    {
      id: 5575,
      name: 'Hörðarsveit',
      iso2: 'HRG',
      countryId: 100,
    },
    {
      id: 5600,
      name: 'Hornafjörður',
      iso2: 'SHF',
      countryId: 100,
    },
    {
      id: 5576,
      name: 'Hrunamannahreppur',
      iso2: 'HRU',
      countryId: 100,
    },
    {
      id: 5577,
      name: 'Húnabyggð',
      iso2: 'HUG',
      countryId: 100,
    },
    {
      id: 5578,
      name: 'Húnaþing vestra',
      iso2: 'HUV',
      countryId: 100,
    },
    {
      id: 5579,
      name: 'Hvalfjarðarsveit',
      iso2: 'HVA',
      countryId: 100,
    },
    {
      id: 5580,
      name: 'Hveragerði',
      iso2: 'HVE',
      countryId: 100,
    },
    {
      id: 5581,
      name: 'Ísafjörður',
      iso2: 'ISA',
      countryId: 100,
    },
    {
      id: 5582,
      name: 'Kaldrananeshreppur',
      iso2: 'KAL',
      countryId: 100,
    },
    {
      id: 5583,
      name: 'Kjósarhreppur',
      iso2: 'KJO',
      countryId: 100,
    },
    {
      id: 5584,
      name: 'Kópavogur',
      iso2: 'KOP',
      countryId: 100,
    },
    {
      id: 5585,
      name: 'Langanesbyggð',
      iso2: 'LAN',
      countryId: 100,
    },
    {
      id: 5586,
      name: 'Mosfellsbær',
      iso2: 'MOS',
      countryId: 100,
    },
    {
      id: 5587,
      name: 'Múlaþing',
      iso2: 'MUL',
      countryId: 100,
    },
    {
      id: 5588,
      name: 'Mýrdalshreppur',
      iso2: 'MYR',
      countryId: 100,
    },
    {
      id: 5589,
      name: 'Norðurþing',
      iso2: 'NOR',
      countryId: 100,
    },
    {
      id: 3437,
      name: 'Northeastern',
      iso2: '6',
      countryId: 100,
    },
    {
      id: 3435,
      name: 'Northwestern',
      iso2: '5',
      countryId: 100,
    },
    {
      id: 5607,
      name: 'Ölfus',
      iso2: 'SOL',
      countryId: 100,
    },
    {
      id: 5590,
      name: 'Rangárþing eystra',
      iso2: 'RGE',
      countryId: 100,
    },
    {
      id: 5591,
      name: 'Rangárþing ytra',
      iso2: 'RGY',
      countryId: 100,
    },
    {
      id: 5592,
      name: 'Reykhólahreppur',
      iso2: 'RHH',
      countryId: 100,
    },
    {
      id: 5593,
      name: 'Reykjanesbær',
      iso2: 'RKN',
      countryId: 100,
    },
    {
      id: 5594,
      name: 'Reykjavík',
      iso2: 'RKV',
      countryId: 100,
    },
    {
      id: 5598,
      name: 'Seltjarnarnes',
      iso2: 'SEL',
      countryId: 100,
    },
    {
      id: 5601,
      name: 'Skaftárhreppur',
      iso2: 'SKF',
      countryId: 100,
    },
    {
      id: 5602,
      name: 'Skagabyggð',
      iso2: 'SKG',
      countryId: 100,
    },
    {
      id: 5604,
      name: 'Skagafjörður',
      iso2: 'SKR',
      countryId: 100,
    },
    {
      id: 5608,
      name: 'Skagaströnd',
      iso2: 'SSS',
      countryId: 100,
    },
    {
      id: 5606,
      name: 'Skeiða- og Gnúpverjahreppur',
      iso2: 'SOG',
      countryId: 100,
    },
    {
      id: 5603,
      name: 'Skorradalshreppur',
      iso2: 'SKO',
      countryId: 100,
    },
    {
      id: 5605,
      name: 'Snæfellsbær',
      iso2: 'SNF',
      countryId: 100,
    },
    {
      id: 3434,
      name: 'Southern',
      iso2: '8',
      countryId: 100,
    },
    {
      id: 3430,
      name: 'Southern Peninsula',
      iso2: '2',
      countryId: 100,
    },
    {
      id: 5609,
      name: 'Strandabyggð',
      iso2: 'STR',
      countryId: 100,
    },
    {
      id: 5610,
      name: 'Stykkishólmur',
      iso2: 'STY',
      countryId: 100,
    },
    {
      id: 5597,
      name: 'Súðavík',
      iso2: 'SDV',
      countryId: 100,
    },
    {
      id: 5596,
      name: 'Suðurnesjabær',
      iso2: 'SDN',
      countryId: 100,
    },
    {
      id: 5595,
      name: 'Svalbardsstrandarhreppur',
      iso2: 'SBT',
      countryId: 100,
    },
    {
      id: 5612,
      name: 'Tálknafjarðarhreppur',
      iso2: 'TAL',
      countryId: 100,
    },
    {
      id: 5614,
      name: 'Tjörneshreppur',
      iso2: 'TJO',
      countryId: 100,
    },
    {
      id: 5615,
      name: 'Vestmannaeyjar',
      iso2: 'VEM',
      countryId: 100,
    },
    {
      id: 5616,
      name: 'Vesturbyggð',
      iso2: 'VER',
      countryId: 100,
    },
    {
      id: 5611,
      name: 'Vogar',
      iso2: 'SVG',
      countryId: 100,
    },
    {
      id: 5617,
      name: 'Vopnafjarðarhreppur',
      iso2: 'VOP',
      countryId: 100,
    },
    {
      id: 3436,
      name: 'Western',
      iso2: '3',
      countryId: 100,
    },
    {
      id: 3432,
      name: 'Westfjords',
      iso2: '4',
      countryId: 100,
    },
    {
      id: 5613,
      name: 'Þingeyjarsveit',
      iso2: 'THG',
      countryId: 100,
    },
    {
      id: 4023,
      name: 'Andaman and Nicobar Islands',
      iso2: 'AN',
      countryId: 101,
    },
    {
      id: 4017,
      name: 'Andhra Pradesh',
      iso2: 'AP',
      countryId: 101,
    },
    {
      id: 4024,
      name: 'Arunachal Pradesh',
      iso2: 'AR',
      countryId: 101,
    },
    {
      id: 4027,
      name: 'Assam',
      iso2: 'AS',
      countryId: 101,
    },
    {
      id: 4037,
      name: 'Bihar',
      iso2: 'BR',
      countryId: 101,
    },
    {
      id: 4031,
      name: 'Chandigarh',
      iso2: 'CH',
      countryId: 101,
    },
    {
      id: 4040,
      name: 'Chhattisgarh',
      iso2: 'CT',
      countryId: 101,
    },
    {
      id: 4033,
      name: 'Dadra and Nagar Haveli and Daman and Diu',
      iso2: 'DH',
      countryId: 101,
    },
    {
      id: 4021,
      name: 'Delhi',
      iso2: 'DL',
      countryId: 101,
    },
    {
      id: 4009,
      name: 'Goa',
      iso2: 'GA',
      countryId: 101,
    },
    {
      id: 4030,
      name: 'Gujarat',
      iso2: 'GJ',
      countryId: 101,
    },
    {
      id: 4007,
      name: 'Haryana',
      iso2: 'HR',
      countryId: 101,
    },
    {
      id: 4020,
      name: 'Himachal Pradesh',
      iso2: 'HP',
      countryId: 101,
    },
    {
      id: 4029,
      name: 'Jammu and Kashmir',
      iso2: 'JK',
      countryId: 101,
    },
    {
      id: 4025,
      name: 'Jharkhand',
      iso2: 'JH',
      countryId: 101,
    },
    {
      id: 4026,
      name: 'Karnataka',
      iso2: 'KA',
      countryId: 101,
    },
    {
      id: 4028,
      name: 'Kerala',
      iso2: 'KL',
      countryId: 101,
    },
    {
      id: 4852,
      name: 'Ladakh',
      iso2: 'LA',
      countryId: 101,
    },
    {
      id: 4019,
      name: 'Lakshadweep',
      iso2: 'LD',
      countryId: 101,
    },
    {
      id: 4039,
      name: 'Madhya Pradesh',
      iso2: 'MP',
      countryId: 101,
    },
    {
      id: 4008,
      name: 'Maharashtra',
      iso2: 'MH',
      countryId: 101,
    },
    {
      id: 4010,
      name: 'Manipur',
      iso2: 'MN',
      countryId: 101,
    },
    {
      id: 4006,
      name: 'Meghalaya',
      iso2: 'ML',
      countryId: 101,
    },
    {
      id: 4036,
      name: 'Mizoram',
      iso2: 'MZ',
      countryId: 101,
    },
    {
      id: 4018,
      name: 'Nagaland',
      iso2: 'NL',
      countryId: 101,
    },
    {
      id: 4013,
      name: 'Odisha',
      iso2: 'OR',
      countryId: 101,
    },
    {
      id: 4011,
      name: 'Puducherry',
      iso2: 'PY',
      countryId: 101,
    },
    {
      id: 4015,
      name: 'Punjab',
      iso2: 'PB',
      countryId: 101,
    },
    {
      id: 4014,
      name: 'Rajasthan',
      iso2: 'RJ',
      countryId: 101,
    },
    {
      id: 4034,
      name: 'Sikkim',
      iso2: 'SK',
      countryId: 101,
    },
    {
      id: 4035,
      name: 'Tamil Nadu',
      iso2: 'TN',
      countryId: 101,
    },
    {
      id: 4012,
      name: 'Telangana',
      iso2: 'TG',
      countryId: 101,
    },
    {
      id: 4038,
      name: 'Tripura',
      iso2: 'TR',
      countryId: 101,
    },
    {
      id: 4022,
      name: 'Uttar Pradesh',
      iso2: 'UP',
      countryId: 101,
    },
    {
      id: 4016,
      name: 'Uttarakhand',
      iso2: 'UK',
      countryId: 101,
    },
    {
      id: 4853,
      name: 'West Bengal',
      iso2: 'WB',
      countryId: 101,
    },
    {
      id: 1822,
      name: 'Aceh',
      iso2: 'AC',
      countryId: 102,
    },
    {
      id: 1826,
      name: 'Bali',
      iso2: 'BA',
      countryId: 102,
    },
    {
      id: 1810,
      name: 'Banten',
      iso2: 'BT',
      countryId: 102,
    },
    {
      id: 1793,
      name: 'Bengkulu',
      iso2: 'BE',
      countryId: 102,
    },
    {
      id: 1829,
      name: 'DI Yogyakarta',
      iso2: 'YO',
      countryId: 102,
    },
    {
      id: 1805,
      name: 'DKI Jakarta',
      iso2: 'JK',
      countryId: 102,
    },
    {
      id: 1812,
      name: 'Gorontalo',
      iso2: 'GO',
      countryId: 102,
    },
    {
      id: 1815,
      name: 'Jambi',
      iso2: 'JA',
      countryId: 102,
    },
    {
      id: 5618,
      name: 'Jawa',
      iso2: 'JW',
      countryId: 102,
    },
    {
      id: 1825,
      name: 'Jawa Barat',
      iso2: 'JB',
      countryId: 102,
    },
    {
      id: 1802,
      name: 'Jawa Tengah',
      iso2: 'JT',
      countryId: 102,
    },
    {
      id: 1827,
      name: 'Jawa Timur',
      iso2: 'JI',
      countryId: 102,
    },
    {
      id: 5619,
      name: 'Kalimantan',
      iso2: 'KA',
      countryId: 102,
    },
    {
      id: 1806,
      name: 'Kalimantan Barat',
      iso2: 'KB',
      countryId: 102,
    },
    {
      id: 1819,
      name: 'Kalimantan Selatan',
      iso2: 'KS',
      countryId: 102,
    },
    {
      id: 1794,
      name: 'Kalimantan Tengah',
      iso2: 'KT',
      countryId: 102,
    },
    {
      id: 1804,
      name: 'Kalimantan Timur',
      iso2: 'KI',
      countryId: 102,
    },
    {
      id: 1824,
      name: 'Kalimantan Utara',
      iso2: 'KU',
      countryId: 102,
    },
    {
      id: 1820,
      name: 'Kepulauan Bangka Belitung',
      iso2: 'BB',
      countryId: 102,
    },
    {
      id: 1807,
      name: 'Kepulauan Riau',
      iso2: 'KR',
      countryId: 102,
    },
    {
      id: 1811,
      name: 'Lampung',
      iso2: 'LA',
      countryId: 102,
    },
    {
      id: 5620,
      name: 'Maluku',
      iso2: 'ML',
      countryId: 102,
    },
    {
      id: 1800,
      name: 'Maluku',
      iso2: 'MA',
      countryId: 102,
    },
    {
      id: 1801,
      name: 'Maluku Utara',
      iso2: 'MU',
      countryId: 102,
    },
    {
      id: 5621,
      name: 'Nusa Tenggara',
      iso2: 'NU',
      countryId: 102,
    },
    {
      id: 1814,
      name: 'Nusa Tenggara Barat',
      iso2: 'NB',
      countryId: 102,
    },
    {
      id: 1818,
      name: 'Nusa Tenggara Timur',
      iso2: 'NT',
      countryId: 102,
    },
    {
      id: 1798,
      name: 'Papua',
      iso2: 'PA',
      countryId: 102,
    },
    {
      id: 5622,
      name: 'Papua',
      iso2: 'PP',
      countryId: 102,
    },
    {
      id: 1799,
      name: 'Papua Barat',
      iso2: 'PB',
      countryId: 102,
    },
    {
      id: 5238,
      name: 'Papua Barat Daya',
      iso2: 'PD',
      countryId: 102,
    },
    {
      id: 5236,
      name: 'Papua Pegunungan',
      iso2: 'PE',
      countryId: 102,
    },
    {
      id: 5237,
      name: 'Papua Selatan',
      iso2: 'PS',
      countryId: 102,
    },
    {
      id: 5235,
      name: 'Papua Tengah',
      iso2: 'PT',
      countryId: 102,
    },
    {
      id: 1809,
      name: 'Riau',
      iso2: 'RI',
      countryId: 102,
    },
    {
      id: 5623,
      name: 'Sulawesi',
      iso2: 'SL',
      countryId: 102,
    },
    {
      id: 1817,
      name: 'Sulawesi Barat',
      iso2: 'SR',
      countryId: 102,
    },
    {
      id: 1795,
      name: 'Sulawesi Selatan',
      iso2: 'SN',
      countryId: 102,
    },
    {
      id: 1813,
      name: 'Sulawesi Tengah',
      iso2: 'ST',
      countryId: 102,
    },
    {
      id: 1796,
      name: 'Sulawesi Tenggara',
      iso2: 'SG',
      countryId: 102,
    },
    {
      id: 1808,
      name: 'Sulawesi Utara',
      iso2: 'SA',
      countryId: 102,
    },
    {
      id: 5624,
      name: 'Sumatera',
      iso2: 'SM',
      countryId: 102,
    },
    {
      id: 1828,
      name: 'Sumatera Barat',
      iso2: 'SB',
      countryId: 102,
    },
    {
      id: 1816,
      name: 'Sumatera Selatan',
      iso2: 'SS',
      countryId: 102,
    },
    {
      id: 1792,
      name: 'Sumatera Utara',
      iso2: 'SU',
      countryId: 102,
    },
    {
      id: 3929,
      name: 'Alborz',
      iso2: '30',
      countryId: 103,
    },
    {
      id: 3934,
      name: 'Ardabil',
      iso2: '24',
      countryId: 103,
    },
    {
      id: 3932,
      name: 'Bushehr',
      iso2: '18',
      countryId: 103,
    },
    {
      id: 3921,
      name: 'Chaharmahal and Bakhtiari',
      iso2: '14',
      countryId: 103,
    },
    {
      id: 3944,
      name: 'East Azerbaijan',
      iso2: '03',
      countryId: 103,
    },
    {
      id: 3939,
      name: 'Fars',
      iso2: '07',
      countryId: 103,
    },
    {
      id: 3920,
      name: 'Gilan',
      iso2: '01',
      countryId: 103,
    },
    {
      id: 3933,
      name: 'Golestan',
      iso2: '27',
      countryId: 103,
    },
    {
      id: 4920,
      name: 'Hamadan',
      iso2: '13',
      countryId: 103,
    },
    {
      id: 3937,
      name: 'Hormozgan',
      iso2: '22',
      countryId: 103,
    },
    {
      id: 3918,
      name: 'Ilam',
      iso2: '16',
      countryId: 103,
    },
    {
      id: 3923,
      name: 'Isfahan',
      iso2: '10',
      countryId: 103,
    },
    {
      id: 3943,
      name: 'Kerman',
      iso2: '08',
      countryId: 103,
    },
    {
      id: 3919,
      name: 'Kermanshah',
      iso2: '05',
      countryId: 103,
    },
    {
      id: 3917,
      name: 'Khuzestan',
      iso2: '06',
      countryId: 103,
    },
    {
      id: 3926,
      name: 'Kohgiluyeh and Boyer-Ahmad',
      iso2: '17',
      countryId: 103,
    },
    {
      id: 3935,
      name: 'Kurdistan',
      iso2: '12',
      countryId: 103,
    },
    {
      id: 3928,
      name: 'Lorestan',
      iso2: '15',
      countryId: 103,
    },
    {
      id: 3916,
      name: 'Markazi',
      iso2: '00',
      countryId: 103,
    },
    {
      id: 3938,
      name: 'Mazandaran',
      iso2: '02',
      countryId: 103,
    },
    {
      id: 3942,
      name: 'North Khorasan',
      iso2: '28',
      countryId: 103,
    },
    {
      id: 3941,
      name: 'Qazvin',
      iso2: '26',
      countryId: 103,
    },
    {
      id: 3922,
      name: 'Qom',
      iso2: '25',
      countryId: 103,
    },
    {
      id: 3927,
      name: 'Razavi Khorasan',
      iso2: '09',
      countryId: 103,
    },
    {
      id: 3940,
      name: 'Semnan',
      iso2: '20',
      countryId: 103,
    },
    {
      id: 3931,
      name: 'Sistan and Baluchestan',
      iso2: '11',
      countryId: 103,
    },
    {
      id: 3930,
      name: 'South Khorasan',
      iso2: '29',
      countryId: 103,
    },
    {
      id: 3945,
      name: 'Tehran',
      iso2: '23',
      countryId: 103,
    },
    {
      id: 3924,
      name: 'West Azarbaijan',
      iso2: '04',
      countryId: 103,
    },
    {
      id: 3936,
      name: 'Yazd',
      iso2: '21',
      countryId: 103,
    },
    {
      id: 3925,
      name: 'Zanjan',
      iso2: '19',
      countryId: 103,
    },
    {
      id: 3964,
      name: 'Al Anbar',
      iso2: 'AN',
      countryId: 104,
    },
    {
      id: 3958,
      name: 'Al Muthanna',
      iso2: 'MU',
      countryId: 104,
    },
    {
      id: 3956,
      name: 'Al-Qādisiyyah',
      iso2: 'QA',
      countryId: 104,
    },
    {
      id: 3955,
      name: 'Babylon',
      iso2: 'BB',
      countryId: 104,
    },
    {
      id: 3959,
      name: 'Baghdad',
      iso2: 'BG',
      countryId: 104,
    },
    {
      id: 3960,
      name: 'Basra',
      iso2: 'BA',
      countryId: 104,
    },
    {
      id: 3954,
      name: 'Dhi Qar',
      iso2: 'DQ',
      countryId: 104,
    },
    {
      id: 3965,
      name: 'Diyala',
      iso2: 'DI',
      countryId: 104,
    },
    {
      id: 3967,
      name: 'Dohuk',
      iso2: 'DA',
      countryId: 104,
    },
    {
      id: 3968,
      name: 'Erbil',
      iso2: 'AR',
      countryId: 104,
    },
    {
      id: 5625,
      name: 'Iqlim Kurdistan',
      iso2: 'KR',
      countryId: 104,
    },
    {
      id: 3957,
      name: 'Karbala',
      iso2: 'KA',
      countryId: 104,
    },
    {
      id: 3971,
      name: 'Kirkuk',
      iso2: 'KI',
      countryId: 104,
    },
    {
      id: 3966,
      name: 'Maysan',
      iso2: 'MA',
      countryId: 104,
    },
    {
      id: 3962,
      name: 'Najaf',
      iso2: 'NA',
      countryId: 104,
    },
    {
      id: 3963,
      name: 'Nineveh',
      iso2: 'NI',
      countryId: 104,
    },
    {
      id: 3961,
      name: 'Saladin',
      iso2: 'SD',
      countryId: 104,
    },
    {
      id: 3969,
      name: 'Sulaymaniyah',
      iso2: 'SU',
      countryId: 104,
    },
    {
      id: 3970,
      name: 'Wasit',
      iso2: 'WA',
      countryId: 104,
    },
    {
      id: 1095,
      name: 'Carlow',
      iso2: 'CW',
      countryId: 105,
    },
    {
      id: 1088,
      name: 'Cavan',
      iso2: 'CN',
      countryId: 105,
    },
    {
      id: 1091,
      name: 'Clare',
      iso2: 'CE',
      countryId: 105,
    },
    {
      id: 1087,
      name: 'Connacht',
      iso2: 'C',
      countryId: 105,
    },
    {
      id: 1074,
      name: 'Cork',
      iso2: 'CO',
      countryId: 105,
    },
    {
      id: 1071,
      name: 'Donegal',
      iso2: 'DL',
      countryId: 105,
    },
    {
      id: 1072,
      name: 'Dublin',
      iso2: 'D',
      countryId: 105,
    },
    {
      id: 1079,
      name: 'Galway',
      iso2: 'G',
      countryId: 105,
    },
    {
      id: 1077,
      name: 'Kerry',
      iso2: 'KY',
      countryId: 105,
    },
    {
      id: 1082,
      name: 'Kildare',
      iso2: 'KE',
      countryId: 105,
    },
    {
      id: 1090,
      name: 'Kilkenny',
      iso2: 'KK',
      countryId: 105,
    },
    {
      id: 1096,
      name: 'Laois',
      iso2: 'LS',
      countryId: 105,
    },
    {
      id: 1073,
      name: 'Leinster',
      iso2: 'L',
      countryId: 105,
    },
    {
      id: 5345,
      name: 'Leitrim',
      iso2: 'LM',
      countryId: 105,
    },
    {
      id: 1094,
      name: 'Limerick',
      iso2: 'LK',
      countryId: 105,
    },
    {
      id: 1076,
      name: 'Longford',
      iso2: 'LD',
      countryId: 105,
    },
    {
      id: 1083,
      name: 'Louth',
      iso2: 'LH',
      countryId: 105,
    },
    {
      id: 1084,
      name: 'Mayo',
      iso2: 'MO',
      countryId: 105,
    },
    {
      id: 1092,
      name: 'Meath',
      iso2: 'MH',
      countryId: 105,
    },
    {
      id: 1075,
      name: 'Monaghan',
      iso2: 'MN',
      countryId: 105,
    },
    {
      id: 1080,
      name: 'Munster',
      iso2: 'M',
      countryId: 105,
    },
    {
      id: 1078,
      name: 'Offaly',
      iso2: 'OY',
      countryId: 105,
    },
    {
      id: 1081,
      name: 'Roscommon',
      iso2: 'RN',
      countryId: 105,
    },
    {
      id: 1070,
      name: 'Sligo',
      iso2: 'SO',
      countryId: 105,
    },
    {
      id: 1069,
      name: 'Tipperary',
      iso2: 'TA',
      countryId: 105,
    },
    {
      id: 1086,
      name: 'Ulster',
      iso2: 'U',
      countryId: 105,
    },
    {
      id: 1089,
      name: 'Waterford',
      iso2: 'WD',
      countryId: 105,
    },
    {
      id: 1097,
      name: 'Westmeath',
      iso2: 'WH',
      countryId: 105,
    },
    {
      id: 1093,
      name: 'Wexford',
      iso2: 'WX',
      countryId: 105,
    },
    {
      id: 1085,
      name: 'Wicklow',
      iso2: 'WW',
      countryId: 105,
    },
    {
      id: 1367,
      name: 'Central',
      iso2: 'M',
      countryId: 106,
    },
    {
      id: 1369,
      name: 'Haifa',
      iso2: 'HA',
      countryId: 106,
    },
    {
      id: 1370,
      name: 'Jerusalem',
      iso2: 'JM',
      countryId: 106,
    },
    {
      id: 1366,
      name: 'Northern',
      iso2: 'Z',
      countryId: 106,
    },
    {
      id: 1368,
      name: 'Southern',
      iso2: 'D',
      countryId: 106,
    },
    {
      id: 1371,
      name: 'Tel Aviv',
      iso2: 'TA',
      countryId: 106,
    },
    {
      id: 1679,
      name: 'Abruzzo',
      iso2: '65',
      countryId: 107,
    },
    {
      id: 1727,
      name: 'Agrigento',
      iso2: 'AG',
      countryId: 107,
    },
    {
      id: 1783,
      name: 'Alessandria',
      iso2: 'AL',
      countryId: 107,
    },
    {
      id: 1672,
      name: 'Ancona',
      iso2: 'AN',
      countryId: 107,
    },
    {
      id: 1716,
      name: 'Aosta Valley',
      iso2: '23',
      countryId: 107,
    },
    {
      id: 1688,
      name: 'Apulia',
      iso2: '75',
      countryId: 107,
    },
    {
      id: 1761,
      name: 'Arezzo',
      iso2: 'AR',
      countryId: 107,
    },
    {
      id: 1681,
      name: 'Ascoli Piceno',
      iso2: 'AP',
      countryId: 107,
    },
    {
      id: 1780,
      name: 'Asti',
      iso2: 'AT',
      countryId: 107,
    },
    {
      id: 1692,
      name: 'Avellino',
      iso2: 'AV',
      countryId: 107,
    },
    {
      id: 5626,
      name: 'Bari',
      iso2: 'BA',
      countryId: 107,
    },
    {
      id: 1686,
      name: 'Barletta-Andria-Trani',
      iso2: 'BT',
      countryId: 107,
    },
    {
      id: 1706,
      name: 'Basilicata',
      iso2: '77',
      countryId: 107,
    },
    {
      id: 1689,
      name: 'Belluno',
      iso2: 'BL',
      countryId: 107,
    },
    {
      id: 1701,
      name: 'Benevento',
      iso2: 'BN',
      countryId: 107,
    },
    {
      id: 1704,
      name: 'Bergamo',
      iso2: 'BG',
      countryId: 107,
    },
    {
      id: 1778,
      name: 'Biella',
      iso2: 'BI',
      countryId: 107,
    },
    {
      id: 5627,
      name: 'Bologna',
      iso2: 'BO',
      countryId: 107,
    },
    {
      id: 1717,
      name: 'Brescia',
      iso2: 'BS',
      countryId: 107,
    },
    {
      id: 1714,
      name: 'Brindisi',
      iso2: 'BR',
      countryId: 107,
    },
    {
      id: 5628,
      name: 'Cagliari',
      iso2: 'CA',
      countryId: 107,
    },
    {
      id: 1703,
      name: 'Calabria',
      iso2: '78',
      countryId: 107,
    },
    {
      id: 1718,
      name: 'Caltanissetta',
      iso2: 'CL',
      countryId: 107,
    },
    {
      id: 1669,
      name: 'Campania',
      iso2: '72',
      countryId: 107,
    },
    {
      id: 1721,
      name: 'Campobasso',
      iso2: 'CB',
      countryId: 107,
    },
    {
      id: 1731,
      name: 'Caserta',
      iso2: 'CE',
      countryId: 107,
    },
    {
      id: 5629,
      name: 'Catania',
      iso2: 'CT',
      countryId: 107,
    },
    {
      id: 1728,
      name: 'Catanzaro',
      iso2: 'CZ',
      countryId: 107,
    },
    {
      id: 1739,
      name: 'Chieti',
      iso2: 'CH',
      countryId: 107,
    },
    {
      id: 1740,
      name: 'Como',
      iso2: 'CO',
      countryId: 107,
    },
    {
      id: 1742,
      name: 'Cosenza',
      iso2: 'CS',
      countryId: 107,
    },
    {
      id: 1751,
      name: 'Cremona',
      iso2: 'CR',
      countryId: 107,
    },
    {
      id: 1754,
      name: 'Crotone',
      iso2: 'KR',
      countryId: 107,
    },
    {
      id: 1775,
      name: 'Cuneo',
      iso2: 'CN',
      countryId: 107,
    },
    {
      id: 1773,
      name: 'Emilia-Romagna',
      iso2: '45',
      countryId: 107,
    },
    {
      id: 1723,
      name: 'Enna',
      iso2: 'EN',
      countryId: 107,
    },
    {
      id: 1744,
      name: 'Fermo',
      iso2: 'FM',
      countryId: 107,
    },
    {
      id: 1746,
      name: 'Ferrara',
      iso2: 'FE',
      countryId: 107,
    },
    {
      id: 5630,
      name: 'Florence',
      iso2: 'FI',
      countryId: 107,
    },
    {
      id: 1771,
      name: 'Foggia',
      iso2: 'FG',
      countryId: 107,
    },
    {
      id: 1779,
      name: 'Forlì-Cesena',
      iso2: 'FC',
      countryId: 107,
    },
    {
      id: 1756,
      name: 'Friuli–Venezia Giulia',
      iso2: '36',
      countryId: 107,
    },
    {
      id: 1776,
      name: 'Frosinone',
      iso2: 'FR',
      countryId: 107,
    },
    {
      id: 5631,
      name: 'Genoa',
      iso2: 'GE',
      countryId: 107,
    },
    {
      id: 1777,
      name: 'Gorizia',
      iso2: 'GO',
      countryId: 107,
    },
    {
      id: 1787,
      name: 'Grosseto',
      iso2: 'GR',
      countryId: 107,
    },
    {
      id: 1788,
      name: 'Imperia',
      iso2: 'IM',
      countryId: 107,
    },
    {
      id: 1789,
      name: 'Isernia',
      iso2: 'IS',
      countryId: 107,
    },
    {
      id: 1781,
      name: "L'Aquila",
      iso2: 'AQ',
      countryId: 107,
    },
    {
      id: 1791,
      name: 'La Spezia',
      iso2: 'SP',
      countryId: 107,
    },
    {
      id: 1674,
      name: 'Latina',
      iso2: 'LT',
      countryId: 107,
    },
    {
      id: 1678,
      name: 'Lazio',
      iso2: '62',
      countryId: 107,
    },
    {
      id: 1675,
      name: 'Lecce',
      iso2: 'LE',
      countryId: 107,
    },
    {
      id: 1677,
      name: 'Lecco',
      iso2: 'LC',
      countryId: 107,
    },
    {
      id: 1768,
      name: 'Liguria',
      iso2: '42',
      countryId: 107,
    },
    {
      id: 1745,
      name: 'Livorno',
      iso2: 'LI',
      countryId: 107,
    },
    {
      id: 1747,
      name: 'Lodi',
      iso2: 'LO',
      countryId: 107,
    },
    {
      id: 1705,
      name: 'Lombardy',
      iso2: '25',
      countryId: 107,
    },
    {
      id: 1749,
      name: 'Lucca',
      iso2: 'LU',
      countryId: 107,
    },
    {
      id: 1750,
      name: 'Macerata',
      iso2: 'MC',
      countryId: 107,
    },
    {
      id: 1758,
      name: 'Mantua',
      iso2: 'MN',
      countryId: 107,
    },
    {
      id: 1670,
      name: 'Marche',
      iso2: '57',
      countryId: 107,
    },
    {
      id: 1759,
      name: 'Massa and Carrara',
      iso2: 'MS',
      countryId: 107,
    },
    {
      id: 1760,
      name: 'Matera',
      iso2: 'MT',
      countryId: 107,
    },
    {
      id: 5632,
      name: 'Messina',
      iso2: 'ME',
      countryId: 107,
    },
    {
      id: 5633,
      name: 'Milan',
      iso2: 'MI',
      countryId: 107,
    },
    {
      id: 1757,
      name: 'Modena',
      iso2: 'MO',
      countryId: 107,
    },
    {
      id: 1695,
      name: 'Molise',
      iso2: '67',
      countryId: 107,
    },
    {
      id: 1769,
      name: 'Monza and Brianza',
      iso2: 'MB',
      countryId: 107,
    },
    {
      id: 5634,
      name: 'Naples',
      iso2: 'NA',
      countryId: 107,
    },
    {
      id: 1774,
      name: 'Novara',
      iso2: 'NO',
      countryId: 107,
    },
    {
      id: 1790,
      name: 'Nuoro',
      iso2: 'NU',
      countryId: 107,
    },
    {
      id: 1786,
      name: 'Oristano',
      iso2: 'OR',
      countryId: 107,
    },
    {
      id: 1665,
      name: 'Padua',
      iso2: 'PD',
      countryId: 107,
    },
    {
      id: 1668,
      name: 'Palermo',
      iso2: 'PA',
      countryId: 107,
    },
    {
      id: 1666,
      name: 'Parma',
      iso2: 'PR',
      countryId: 107,
    },
    {
      id: 1676,
      name: 'Pavia',
      iso2: 'PV',
      countryId: 107,
    },
    {
      id: 1691,
      name: 'Perugia',
      iso2: 'PG',
      countryId: 107,
    },
    {
      id: 1693,
      name: 'Pesaro and Urbino',
      iso2: 'PU',
      countryId: 107,
    },
    {
      id: 1694,
      name: 'Pescara',
      iso2: 'PE',
      countryId: 107,
    },
    {
      id: 1696,
      name: 'Piacenza',
      iso2: 'PC',
      countryId: 107,
    },
    {
      id: 1702,
      name: 'Piedmont',
      iso2: '21',
      countryId: 107,
    },
    {
      id: 1685,
      name: 'Pisa',
      iso2: 'PI',
      countryId: 107,
    },
    {
      id: 1687,
      name: 'Pistoia',
      iso2: 'PT',
      countryId: 107,
    },
    {
      id: 1690,
      name: 'Pordenone',
      iso2: 'PN',
      countryId: 107,
    },
    {
      id: 1697,
      name: 'Potenza',
      iso2: 'PZ',
      countryId: 107,
    },
    {
      id: 1700,
      name: 'Prato',
      iso2: 'PO',
      countryId: 107,
    },
    {
      id: 1729,
      name: 'Ragusa',
      iso2: 'RG',
      countryId: 107,
    },
    {
      id: 1707,
      name: 'Ravenna',
      iso2: 'RA',
      countryId: 107,
    },
    {
      id: 5635,
      name: 'Reggio Calabria',
      iso2: 'RC',
      countryId: 107,
    },
    {
      id: 1708,
      name: 'Reggio Emilia',
      iso2: 'RE',
      countryId: 107,
    },
    {
      id: 1712,
      name: 'Rieti',
      iso2: 'RI',
      countryId: 107,
    },
    {
      id: 1713,
      name: 'Rimini',
      iso2: 'RN',
      countryId: 107,
    },
    {
      id: 5636,
      name: 'Rome',
      iso2: 'RM',
      countryId: 107,
    },
    {
      id: 1719,
      name: 'Rovigo',
      iso2: 'RO',
      countryId: 107,
    },
    {
      id: 1720,
      name: 'Salerno',
      iso2: 'SA',
      countryId: 107,
    },
    {
      id: 1715,
      name: 'Sardinia',
      iso2: '88',
      countryId: 107,
    },
    {
      id: 1722,
      name: 'Sassari',
      iso2: 'SS',
      countryId: 107,
    },
    {
      id: 1732,
      name: 'Savona',
      iso2: 'SV',
      countryId: 107,
    },
    {
      id: 1709,
      name: 'Sicily',
      iso2: '82',
      countryId: 107,
    },
    {
      id: 1734,
      name: 'Siena',
      iso2: 'SI',
      countryId: 107,
    },
    {
      id: 1667,
      name: 'Siracusa',
      iso2: 'SR',
      countryId: 107,
    },
    {
      id: 1741,
      name: 'Sondrio',
      iso2: 'SO',
      countryId: 107,
    },
    {
      id: 1730,
      name: 'South Sardinia',
      iso2: 'SU',
      countryId: 107,
    },
    {
      id: 5639,
      name: 'South Tyrol',
      iso2: 'BZ',
      countryId: 107,
    },
    {
      id: 1743,
      name: 'Taranto',
      iso2: 'TA',
      countryId: 107,
    },
    {
      id: 1752,
      name: 'Teramo',
      iso2: 'TE',
      countryId: 107,
    },
    {
      id: 1755,
      name: 'Terni',
      iso2: 'TR',
      countryId: 107,
    },
    {
      id: 1733,
      name: 'Trapani',
      iso2: 'TP',
      countryId: 107,
    },
    {
      id: 5640,
      name: 'Trentino',
      iso2: 'TN',
      countryId: 107,
    },
    {
      id: 1725,
      name: 'Trentino-South Tyrol',
      iso2: '32',
      countryId: 107,
    },
    {
      id: 1762,
      name: 'Treviso',
      iso2: 'TV',
      countryId: 107,
    },
    {
      id: 1763,
      name: 'Trieste',
      iso2: 'TS',
      countryId: 107,
    },
    {
      id: 5637,
      name: 'Turin',
      iso2: 'TO',
      countryId: 107,
    },
    {
      id: 1664,
      name: 'Tuscany',
      iso2: '52',
      countryId: 107,
    },
    {
      id: 1764,
      name: 'Udine',
      iso2: 'UD',
      countryId: 107,
    },
    {
      id: 1683,
      name: 'Umbria',
      iso2: '55',
      countryId: 107,
    },
    {
      id: 1765,
      name: 'Varese',
      iso2: 'VA',
      countryId: 107,
    },
    {
      id: 1753,
      name: 'Veneto',
      iso2: '34',
      countryId: 107,
    },
    {
      id: 5638,
      name: 'Venice',
      iso2: 'VE',
      countryId: 107,
    },
    {
      id: 1726,
      name: 'Verbano-Cusio-Ossola',
      iso2: 'VB',
      countryId: 107,
    },
    {
      id: 1785,
      name: 'Vercelli',
      iso2: 'VC',
      countryId: 107,
    },
    {
      id: 1736,
      name: 'Verona',
      iso2: 'VR',
      countryId: 107,
    },
    {
      id: 1737,
      name: 'Vibo Valentia',
      iso2: 'VV',
      countryId: 107,
    },
    {
      id: 1738,
      name: 'Vicenza',
      iso2: 'VI',
      countryId: 107,
    },
    {
      id: 1735,
      name: 'Viterbo',
      iso2: 'VT',
      countryId: 107,
    },
    {
      id: 2634,
      name: 'Abidjan',
      iso2: 'AB',
      countryId: 54,
    },
    {
      id: 2643,
      name: 'Bas-Sassandra',
      iso2: 'BS',
      countryId: 54,
    },
    {
      id: 2654,
      name: 'Comoé',
      iso2: 'CM',
      countryId: 54,
    },
    {
      id: 2644,
      name: 'Denguélé',
      iso2: 'DN',
      countryId: 54,
    },
    {
      id: 2651,
      name: 'Gôh-Djiboua',
      iso2: 'GD',
      countryId: 54,
    },
    {
      id: 2632,
      name: 'Lacs',
      iso2: 'LC',
      countryId: 54,
    },
    {
      id: 2627,
      name: 'Lagunes',
      iso2: 'LG',
      countryId: 54,
    },
    {
      id: 2629,
      name: 'Montagnes',
      iso2: 'MG',
      countryId: 54,
    },
    {
      id: 2648,
      name: 'Sassandra-Marahoué',
      iso2: 'SM',
      countryId: 54,
    },
    {
      id: 2625,
      name: 'Savanes',
      iso2: 'SV',
      countryId: 54,
    },
    {
      id: 2637,
      name: 'Vallée du Bandama',
      iso2: 'VB',
      countryId: 54,
    },
    {
      id: 2650,
      name: 'Woroba',
      iso2: 'WR',
      countryId: 54,
    },
    {
      id: 2653,
      name: 'Yamoussoukro',
      iso2: 'YM',
      countryId: 54,
    },
    {
      id: 2641,
      name: 'Zanzan',
      iso2: 'ZZ',
      countryId: 54,
    },
    {
      id: 3753,
      name: 'Clarendon',
      iso2: '13',
      countryId: 108,
    },
    {
      id: 3749,
      name: 'Hanover',
      iso2: '09',
      countryId: 108,
    },
    {
      id: 3748,
      name: 'Kingston',
      iso2: '01',
      countryId: 108,
    },
    {
      id: 3754,
      name: 'Manchester',
      iso2: '12',
      countryId: 108,
    },
    {
      id: 3752,
      name: 'Portland',
      iso2: '04',
      countryId: 108,
    },
    {
      id: 3751,
      name: 'Saint Andrew',
      iso2: '02',
      countryId: 108,
    },
    {
      id: 3744,
      name: 'Saint Ann',
      iso2: '06',
      countryId: 108,
    },
    {
      id: 3746,
      name: 'Saint Catherine',
      iso2: '14',
      countryId: 108,
    },
    {
      id: 3743,
      name: 'Saint Elizabeth',
      iso2: '11',
      countryId: 108,
    },
    {
      id: 3745,
      name: 'Saint James',
      iso2: '08',
      countryId: 108,
    },
    {
      id: 3747,
      name: 'Saint Mary',
      iso2: '05',
      countryId: 108,
    },
    {
      id: 3750,
      name: 'Saint Thomas',
      iso2: '03',
      countryId: 108,
    },
    {
      id: 3755,
      name: 'Trelawny',
      iso2: '07',
      countryId: 108,
    },
    {
      id: 3742,
      name: 'Westmoreland',
      iso2: '10',
      countryId: 108,
    },
    {
      id: 827,
      name: 'Aichi',
      iso2: '23',
      countryId: 109,
    },
    {
      id: 829,
      name: 'Akita',
      iso2: '05',
      countryId: 109,
    },
    {
      id: 839,
      name: 'Aomori',
      iso2: '02',
      countryId: 109,
    },
    {
      id: 821,
      name: 'Chiba',
      iso2: '12',
      countryId: 109,
    },
    {
      id: 865,
      name: 'Ehime',
      iso2: '38',
      countryId: 109,
    },
    {
      id: 848,
      name: 'Fukui',
      iso2: '18',
      countryId: 109,
    },
    {
      id: 861,
      name: 'Fukuoka',
      iso2: '40',
      countryId: 109,
    },
    {
      id: 847,
      name: 'Fukushima',
      iso2: '07',
      countryId: 109,
    },
    {
      id: 858,
      name: 'Gifu',
      iso2: '21',
      countryId: 109,
    },
    {
      id: 862,
      name: 'Gunma',
      iso2: '10',
      countryId: 109,
    },
    {
      id: 828,
      name: 'Hiroshima',
      iso2: '34',
      countryId: 109,
    },
    {
      id: 832,
      name: 'Hokkaidō',
      iso2: '01',
      countryId: 109,
    },
    {
      id: 831,
      name: 'Hyōgo',
      iso2: '28',
      countryId: 109,
    },
    {
      id: 851,
      name: 'Ibaraki',
      iso2: '08',
      countryId: 109,
    },
    {
      id: 830,
      name: 'Ishikawa',
      iso2: '17',
      countryId: 109,
    },
    {
      id: 856,
      name: 'Iwate',
      iso2: '03',
      countryId: 109,
    },
    {
      id: 864,
      name: 'Kagawa',
      iso2: '37',
      countryId: 109,
    },
    {
      id: 840,
      name: 'Kagoshima',
      iso2: '46',
      countryId: 109,
    },
    {
      id: 842,
      name: 'Kanagawa',
      iso2: '14',
      countryId: 109,
    },
    {
      id: 4924,
      name: 'Kōchi',
      iso2: '39',
      countryId: 109,
    },
    {
      id: 846,
      name: 'Kumamoto',
      iso2: '43',
      countryId: 109,
    },
    {
      id: 834,
      name: 'Kyōto',
      iso2: '26',
      countryId: 109,
    },
    {
      id: 833,
      name: 'Mie',
      iso2: '24',
      countryId: 109,
    },
    {
      id: 857,
      name: 'Miyagi',
      iso2: '04',
      countryId: 109,
    },
    {
      id: 855,
      name: 'Miyazaki',
      iso2: '45',
      countryId: 109,
    },
    {
      id: 843,
      name: 'Nagano',
      iso2: '20',
      countryId: 109,
    },
    {
      id: 849,
      name: 'Nagasaki',
      iso2: '42',
      countryId: 109,
    },
    {
      id: 824,
      name: 'Nara',
      iso2: '29',
      countryId: 109,
    },
    {
      id: 841,
      name: 'Niigata',
      iso2: '15',
      countryId: 109,
    },
    {
      id: 822,
      name: 'Ōita',
      iso2: '44',
      countryId: 109,
    },
    {
      id: 820,
      name: 'Okayama',
      iso2: '33',
      countryId: 109,
    },
    {
      id: 853,
      name: 'Okinawa',
      iso2: '47',
      countryId: 109,
    },
    {
      id: 859,
      name: 'Ōsaka',
      iso2: '27',
      countryId: 109,
    },
    {
      id: 863,
      name: 'Saga',
      iso2: '41',
      countryId: 109,
    },
    {
      id: 860,
      name: 'Saitama',
      iso2: '11',
      countryId: 109,
    },
    {
      id: 845,
      name: 'Shiga',
      iso2: '25',
      countryId: 109,
    },
    {
      id: 826,
      name: 'Shimane',
      iso2: '32',
      countryId: 109,
    },
    {
      id: 825,
      name: 'Shizuoka',
      iso2: '22',
      countryId: 109,
    },
    {
      id: 854,
      name: 'Tochigi',
      iso2: '09',
      countryId: 109,
    },
    {
      id: 836,
      name: 'Tokushima',
      iso2: '36',
      countryId: 109,
    },
    {
      id: 823,
      name: 'Tokyo',
      iso2: '13',
      countryId: 109,
    },
    {
      id: 850,
      name: 'Tottori',
      iso2: '31',
      countryId: 109,
    },
    {
      id: 838,
      name: 'Toyama',
      iso2: '16',
      countryId: 109,
    },
    {
      id: 844,
      name: 'Wakayama',
      iso2: '30',
      countryId: 109,
    },
    {
      id: 837,
      name: 'Yamagata',
      iso2: '06',
      countryId: 109,
    },
    {
      id: 835,
      name: 'Yamaguchi',
      iso2: '35',
      countryId: 109,
    },
    {
      id: 852,
      name: 'Yamanashi',
      iso2: '19',
      countryId: 109,
    },
    {
      id: 5309,
      name: 'Grouville',
      iso2: '01',
      countryId: 110,
    },
    {
      id: 5310,
      name: 'St Brelade',
      iso2: '02',
      countryId: 110,
    },
    {
      id: 5311,
      name: 'St Clement',
      iso2: '03',
      countryId: 110,
    },
    {
      id: 5312,
      name: 'St Helier',
      iso2: '04',
      countryId: 110,
    },
    {
      id: 5313,
      name: 'St John',
      iso2: '05',
      countryId: 110,
    },
    {
      id: 5314,
      name: 'St Lawrence',
      iso2: '06',
      countryId: 110,
    },
    {
      id: 5315,
      name: 'St Martin',
      iso2: '07',
      countryId: 110,
    },
    {
      id: 5316,
      name: 'St Mary',
      iso2: '08',
      countryId: 110,
    },
    {
      id: 5317,
      name: 'St Ouen',
      iso2: '09',
      countryId: 110,
    },
    {
      id: 5318,
      name: 'St Peter',
      iso2: '10',
      countryId: 110,
    },
    {
      id: 5319,
      name: 'St Saviour',
      iso2: '11',
      countryId: 110,
    },
    {
      id: 5320,
      name: 'Trinity',
      iso2: '12',
      countryId: 110,
    },
    {
      id: 963,
      name: 'Ajloun',
      iso2: 'AJ',
      countryId: 111,
    },
    {
      id: 965,
      name: 'Amman',
      iso2: 'AM',
      countryId: 111,
    },
    {
      id: 959,
      name: 'Aqaba',
      iso2: 'AQ',
      countryId: 111,
    },
    {
      id: 961,
      name: 'Balqa',
      iso2: 'BA',
      countryId: 111,
    },
    {
      id: 960,
      name: 'Irbid',
      iso2: 'IR',
      countryId: 111,
    },
    {
      id: 966,
      name: 'Jerash',
      iso2: 'JA',
      countryId: 111,
    },
    {
      id: 956,
      name: 'Karak',
      iso2: 'KA',
      countryId: 111,
    },
    {
      id: 964,
      name: "Ma'an",
      iso2: 'MN',
      countryId: 111,
    },
    {
      id: 958,
      name: 'Madaba',
      iso2: 'MD',
      countryId: 111,
    },
    {
      id: 962,
      name: 'Mafraq',
      iso2: 'MA',
      countryId: 111,
    },
    {
      id: 957,
      name: 'Tafilah',
      iso2: 'AT',
      countryId: 111,
    },
    {
      id: 967,
      name: 'Zarqa',
      iso2: 'AZ',
      countryId: 111,
    },
    {
      id: 5455,
      name: 'Abai',
      iso2: '10',
      countryId: 112,
    },
    {
      id: 145,
      name: 'Akmola',
      iso2: '11',
      countryId: 112,
    },
    {
      id: 151,
      name: 'Aktobe',
      iso2: '15',
      countryId: 112,
    },
    {
      id: 143,
      name: 'Almaty',
      iso2: '19',
      countryId: 112,
    },
    {
      id: 152,
      name: 'Almaty',
      iso2: '75',
      countryId: 112,
    },
    {
      id: 156,
      name: 'Astana',
      iso2: '71',
      countryId: 112,
    },
    {
      id: 153,
      name: 'Atyrau',
      iso2: '23',
      countryId: 112,
    },
    {
      id: 154,
      name: 'East Kazakhstan',
      iso2: '63',
      countryId: 112,
    },
    {
      id: 147,
      name: 'Jambyl',
      iso2: '31',
      countryId: 112,
    },
    {
      id: 5456,
      name: 'Jetisu',
      iso2: '33',
      countryId: 112,
    },
    {
      id: 150,
      name: 'Karaganda',
      iso2: '35',
      countryId: 112,
    },
    {
      id: 157,
      name: 'Kostanay',
      iso2: '39',
      countryId: 112,
    },
    {
      id: 142,
      name: 'Kyzylorda',
      iso2: '43',
      countryId: 112,
    },
    {
      id: 141,
      name: 'Mangystau',
      iso2: '47',
      countryId: 112,
    },
    {
      id: 144,
      name: 'North Kazakhstan',
      iso2: '59',
      countryId: 112,
    },
    {
      id: 146,
      name: 'Pavlodar',
      iso2: '55',
      countryId: 112,
    },
    {
      id: 5454,
      name: 'Shymkent',
      iso2: '79',
      countryId: 112,
    },
    {
      id: 149,
      name: 'Turkistan',
      iso2: '61',
      countryId: 112,
    },
    {
      id: 5457,
      name: 'Ulytau',
      iso2: '62',
      countryId: 112,
    },
    {
      id: 148,
      name: 'West Kazakhstan',
      iso2: '27',
      countryId: 112,
    },
    {
      id: 181,
      name: 'Baringo',
      iso2: '01',
      countryId: 113,
    },
    {
      id: 210,
      name: 'Bomet',
      iso2: '02',
      countryId: 113,
    },
    {
      id: 168,
      name: 'Bungoma',
      iso2: '03',
      countryId: 113,
    },
    {
      id: 161,
      name: 'Busia',
      iso2: '04',
      countryId: 113,
    },
    {
      id: 201,
      name: 'Elgeyo-Marakwet',
      iso2: '05',
      countryId: 113,
    },
    {
      id: 163,
      name: 'Embu',
      iso2: '06',
      countryId: 113,
    },
    {
      id: 196,
      name: 'Garissa',
      iso2: '07',
      countryId: 113,
    },
    {
      id: 195,
      name: 'Homa Bay',
      iso2: '08',
      countryId: 113,
    },
    {
      id: 170,
      name: 'Isiolo',
      iso2: '09',
      countryId: 113,
    },
    {
      id: 197,
      name: 'Kajiado',
      iso2: '10',
      countryId: 113,
    },
    {
      id: 158,
      name: 'Kakamega',
      iso2: '11',
      countryId: 113,
    },
    {
      id: 193,
      name: 'Kericho',
      iso2: '12',
      countryId: 113,
    },
    {
      id: 199,
      name: 'Kiambu',
      iso2: '13',
      countryId: 113,
    },
    {
      id: 174,
      name: 'Kilifi',
      iso2: '14',
      countryId: 113,
    },
    {
      id: 167,
      name: 'Kirinyaga',
      iso2: '15',
      countryId: 113,
    },
    {
      id: 159,
      name: 'Kisii',
      iso2: '16',
      countryId: 113,
    },
    {
      id: 171,
      name: 'Kisumu',
      iso2: '17',
      countryId: 113,
    },
    {
      id: 211,
      name: 'Kitui',
      iso2: '18',
      countryId: 113,
    },
    {
      id: 173,
      name: 'Kwale',
      iso2: '19',
      countryId: 113,
    },
    {
      id: 164,
      name: 'Laikipia',
      iso2: '20',
      countryId: 113,
    },
    {
      id: 166,
      name: 'Lamu',
      iso2: '21',
      countryId: 113,
    },
    {
      id: 184,
      name: 'Machakos',
      iso2: '22',
      countryId: 113,
    },
    {
      id: 188,
      name: 'Makueni',
      iso2: '23',
      countryId: 113,
    },
    {
      id: 187,
      name: 'Mandera',
      iso2: '24',
      countryId: 113,
    },
    {
      id: 194,
      name: 'Marsabit',
      iso2: '25',
      countryId: 113,
    },
    {
      id: 198,
      name: 'Meru',
      iso2: '26',
      countryId: 113,
    },
    {
      id: 190,
      name: 'Migori',
      iso2: '27',
      countryId: 113,
    },
    {
      id: 200,
      name: 'Mombasa',
      iso2: '28',
      countryId: 113,
    },
    {
      id: 178,
      name: "Murang'a",
      iso2: '29',
      countryId: 113,
    },
    {
      id: 191,
      name: 'Nairobi City',
      iso2: '30',
      countryId: 113,
    },
    {
      id: 203,
      name: 'Nakuru',
      iso2: '31',
      countryId: 113,
    },
    {
      id: 165,
      name: 'Nandi',
      iso2: '32',
      countryId: 113,
    },
    {
      id: 175,
      name: 'Narok',
      iso2: '33',
      countryId: 113,
    },
    {
      id: 209,
      name: 'Nyamira',
      iso2: '34',
      countryId: 113,
    },
    {
      id: 192,
      name: 'Nyandarua',
      iso2: '35',
      countryId: 113,
    },
    {
      id: 180,
      name: 'Nyeri',
      iso2: '36',
      countryId: 113,
    },
    {
      id: 207,
      name: 'Samburu',
      iso2: '37',
      countryId: 113,
    },
    {
      id: 186,
      name: 'Siaya',
      iso2: '38',
      countryId: 113,
    },
    {
      id: 176,
      name: 'Taita–Taveta',
      iso2: '39',
      countryId: 113,
    },
    {
      id: 205,
      name: 'Tana River',
      iso2: '40',
      countryId: 113,
    },
    {
      id: 185,
      name: 'Tharaka-Nithi',
      iso2: '41',
      countryId: 113,
    },
    {
      id: 183,
      name: 'Trans Nzoia',
      iso2: '42',
      countryId: 113,
    },
    {
      id: 206,
      name: 'Turkana',
      iso2: '43',
      countryId: 113,
    },
    {
      id: 169,
      name: 'Uasin Gishu',
      iso2: '44',
      countryId: 113,
    },
    {
      id: 202,
      name: 'Vihiga',
      iso2: '45',
      countryId: 113,
    },
    {
      id: 182,
      name: 'Wajir',
      iso2: '46',
      countryId: 113,
    },
    {
      id: 208,
      name: 'West Pokot',
      iso2: '47',
      countryId: 113,
    },
    {
      id: 1831,
      name: 'Gilbert',
      iso2: 'G',
      countryId: 114,
    },
    {
      id: 1832,
      name: 'Line',
      iso2: 'L',
      countryId: 114,
    },
    {
      id: 1830,
      name: 'Phoenix',
      iso2: 'P',
      countryId: 114,
    },
    {
      id: 4874,
      name: 'Ferizaj',
      iso2: 'XUF',
      countryId: 248,
    },
    {
      id: 4876,
      name: 'Gjakove',
      iso2: 'XDG',
      countryId: 248,
    },
    {
      id: 4877,
      name: 'Gjilan',
      iso2: 'XGJ',
      countryId: 248,
    },
    {
      id: 4878,
      name: 'Mitrovica',
      iso2: 'XKM',
      countryId: 248,
    },
    {
      id: 5321,
      name: 'Peja',
      iso2: 'PEJ',
      countryId: 248,
    },
    {
      id: 4879,
      name: 'Pristina',
      iso2: 'XPI',
      countryId: 248,
    },
    {
      id: 5322,
      name: 'Prizren',
      iso2: 'PRI',
      countryId: 248,
    },
    {
      id: 977,
      name: 'Al Ahmadi',
      iso2: 'AH',
      countryId: 117,
    },
    {
      id: 976,
      name: 'Al Asimah',
      iso2: 'KU',
      countryId: 117,
    },
    {
      id: 975,
      name: 'Al Farwaniyah',
      iso2: 'FA',
      countryId: 117,
    },
    {
      id: 972,
      name: 'Al Jahra',
      iso2: 'JA',
      countryId: 117,
    },
    {
      id: 973,
      name: 'Hawalli',
      iso2: 'HA',
      countryId: 117,
    },
    {
      id: 974,
      name: 'Mubarak Al-Kabeer',
      iso2: 'MU',
      countryId: 117,
    },
    {
      id: 998,
      name: 'Batken',
      iso2: 'B',
      countryId: 118,
    },
    {
      id: 1001,
      name: 'Bishkek',
      iso2: 'GB',
      countryId: 118,
    },
    {
      id: 1004,
      name: 'Chuy',
      iso2: 'C',
      countryId: 118,
    },
    {
      id: 1002,
      name: 'Issyk-Kul',
      iso2: 'Y',
      countryId: 118,
    },
    {
      id: 1000,
      name: 'Jalal-Abad',
      iso2: 'J',
      countryId: 118,
    },
    {
      id: 999,
      name: 'Naryn',
      iso2: 'N',
      countryId: 118,
    },
    {
      id: 1003,
      name: 'Osh',
      iso2: 'GO',
      countryId: 118,
    },
    {
      id: 1005,
      name: 'Osh',
      iso2: 'O',
      countryId: 118,
    },
    {
      id: 997,
      name: 'Talas',
      iso2: 'T',
      countryId: 118,
    },
    {
      id: 982,
      name: 'Attapeu',
      iso2: 'AT',
      countryId: 119,
    },
    {
      id: 991,
      name: 'Bokeo',
      iso2: 'BK',
      countryId: 119,
    },
    {
      id: 985,
      name: 'Bolikhamsai',
      iso2: 'BL',
      countryId: 119,
    },
    {
      id: 996,
      name: 'Champasak',
      iso2: 'CH',
      countryId: 119,
    },
    {
      id: 989,
      name: 'Houaphanh',
      iso2: 'HO',
      countryId: 119,
    },
    {
      id: 986,
      name: 'Khammouane',
      iso2: 'KH',
      countryId: 119,
    },
    {
      id: 992,
      name: 'Luang Namtha',
      iso2: 'LM',
      countryId: 119,
    },
    {
      id: 978,
      name: 'Luang Prabang',
      iso2: 'LP',
      countryId: 119,
    },
    {
      id: 988,
      name: 'Oudomxay',
      iso2: 'OU',
      countryId: 119,
    },
    {
      id: 987,
      name: 'Phongsaly',
      iso2: 'PH',
      countryId: 119,
    },
    {
      id: 993,
      name: 'Sainyabuli',
      iso2: 'XA',
      countryId: 119,
    },
    {
      id: 981,
      name: 'Salavan',
      iso2: 'SL',
      countryId: 119,
    },
    {
      id: 990,
      name: 'Savannakhet',
      iso2: 'SV',
      countryId: 119,
    },
    {
      id: 984,
      name: 'Sekong',
      iso2: 'XE',
      countryId: 119,
    },
    {
      id: 980,
      name: 'Vientiane',
      iso2: 'VI',
      countryId: 119,
    },
    {
      id: 979,
      name: 'Vientiane',
      iso2: 'VT',
      countryId: 119,
    },
    {
      id: 983,
      name: 'Xaisomboun',
      iso2: 'XS',
      countryId: 119,
    },
    {
      id: 995,
      name: 'Xiangkhouang',
      iso2: 'XI',
      countryId: 119,
    },
    {
      id: 4454,
      name: 'Ādaži',
      iso2: '011',
      countryId: 120,
    },
    {
      id: 4472,
      name: 'Aizkraukle',
      iso2: '002',
      countryId: 120,
    },
    {
      id: 4487,
      name: 'Alūksne',
      iso2: '007',
      countryId: 120,
    },
    {
      id: 4492,
      name: 'Augšdaugava',
      iso2: '111',
      countryId: 120,
    },
    {
      id: 4505,
      name: 'Balvi',
      iso2: '015',
      countryId: 120,
    },
    {
      id: 4465,
      name: 'Bauska',
      iso2: '016',
      countryId: 120,
    },
    {
      id: 4469,
      name: 'Cēsis',
      iso2: '022',
      countryId: 120,
    },
    {
      id: 4463,
      name: 'Daugavpils',
      iso2: 'DGV',
      countryId: 120,
    },
    {
      id: 4508,
      name: 'Dienvidkurzemes',
      iso2: '112',
      countryId: 120,
    },
    {
      id: 4437,
      name: 'Dobele',
      iso2: '026',
      countryId: 120,
    },
    {
      id: 4400,
      name: 'Gulbene',
      iso2: '033',
      countryId: 120,
    },
    {
      id: 4438,
      name: 'Jēkabpils',
      iso2: '042',
      countryId: 120,
    },
    {
      id: 4424,
      name: 'Jelgava',
      iso2: '041',
      countryId: 120,
    },
    {
      id: 4500,
      name: 'Jelgava',
      iso2: 'JEL',
      countryId: 120,
    },
    {
      id: 4446,
      name: 'Jūrmala',
      iso2: 'JUR',
      countryId: 120,
    },
    {
      id: 4435,
      name: 'Ķekava',
      iso2: '052',
      countryId: 120,
    },
    {
      id: 4474,
      name: 'Krāslava',
      iso2: '047',
      countryId: 120,
    },
    {
      id: 4490,
      name: 'Kuldīga',
      iso2: '050',
      countryId: 120,
    },
    {
      id: 4460,
      name: 'Liepāja',
      iso2: 'LPX',
      countryId: 120,
    },
    {
      id: 4418,
      name: 'Limbaži',
      iso2: '054',
      countryId: 120,
    },
    {
      id: 4401,
      name: 'Līvāni',
      iso2: '056',
      countryId: 120,
    },
    {
      id: 4501,
      name: 'Ludza',
      iso2: '058',
      countryId: 120,
    },
    {
      id: 4433,
      name: 'Madona',
      iso2: '059',
      countryId: 120,
    },
    {
      id: 4450,
      name: 'Mārupe',
      iso2: '062',
      countryId: 120,
    },
    {
      id: 4416,
      name: 'Ogre',
      iso2: '067',
      countryId: 120,
    },
    {
      id: 4417,
      name: 'Olaine',
      iso2: '068',
      countryId: 120,
    },
    {
      id: 4483,
      name: 'Preiļi',
      iso2: '073',
      countryId: 120,
    },
    {
      id: 4509,
      name: 'Rēzekne',
      iso2: 'REZ',
      countryId: 120,
    },
    {
      id: 4455,
      name: 'Rēzekne',
      iso2: '077',
      countryId: 120,
    },
    {
      id: 4491,
      name: 'Riga',
      iso2: 'RIX',
      countryId: 120,
    },
    {
      id: 4493,
      name: 'Ropaži',
      iso2: '080',
      countryId: 120,
    },
    {
      id: 4402,
      name: 'Salaspils',
      iso2: '087',
      countryId: 120,
    },
    {
      id: 4439,
      name: 'Saldus',
      iso2: '088',
      countryId: 120,
    },
    {
      id: 4443,
      name: 'Saulkrasti',
      iso2: '089',
      countryId: 120,
    },
    {
      id: 4476,
      name: 'Sigulda',
      iso2: '091',
      countryId: 120,
    },
    {
      id: 4462,
      name: 'Smiltene',
      iso2: '094',
      countryId: 120,
    },
    {
      id: 4459,
      name: 'Talsi',
      iso2: '097',
      countryId: 120,
    },
    {
      id: 4409,
      name: 'Tukums',
      iso2: '099',
      countryId: 120,
    },
    {
      id: 4425,
      name: 'Valka',
      iso2: '101',
      countryId: 120,
    },
    {
      id: 4473,
      name: 'Valmiera',
      iso2: '113',
      countryId: 120,
    },
    {
      id: 4431,
      name: 'Varakļāni',
      iso2: '102',
      countryId: 120,
    },
    {
      id: 4421,
      name: 'Ventspils',
      iso2: 'VEN',
      countryId: 120,
    },
    {
      id: 4403,
      name: 'Ventspils',
      iso2: '106',
      countryId: 120,
    },
    {
      id: 2285,
      name: 'Akkar',
      iso2: 'AK',
      countryId: 121,
    },
    {
      id: 2283,
      name: 'Baalbek-Hermel',
      iso2: 'BH',
      countryId: 121,
    },
    {
      id: 2286,
      name: 'Beirut',
      iso2: 'BA',
      countryId: 121,
    },
    {
      id: 2287,
      name: 'Beqaa',
      iso2: 'BI',
      countryId: 121,
    },
    {
      id: 2282,
      name: 'Mount Lebanon',
      iso2: 'JL',
      countryId: 121,
    },
    {
      id: 2288,
      name: 'Nabatieh',
      iso2: 'NA',
      countryId: 121,
    },
    {
      id: 2284,
      name: 'North',
      iso2: 'AS',
      countryId: 121,
    },
    {
      id: 2281,
      name: 'South',
      iso2: 'JA',
      countryId: 121,
    },
    {
      id: 3030,
      name: 'Berea',
      iso2: 'D',
      countryId: 122,
    },
    {
      id: 3029,
      name: 'Butha-Buthe',
      iso2: 'B',
      countryId: 122,
    },
    {
      id: 3026,
      name: 'Leribe',
      iso2: 'C',
      countryId: 122,
    },
    {
      id: 3022,
      name: 'Mafeteng',
      iso2: 'E',
      countryId: 122,
    },
    {
      id: 3028,
      name: 'Maseru',
      iso2: 'A',
      countryId: 122,
    },
    {
      id: 3023,
      name: "Mohale's Hoek",
      iso2: 'F',
      countryId: 122,
    },
    {
      id: 3024,
      name: 'Mokhotlong',
      iso2: 'J',
      countryId: 122,
    },
    {
      id: 3025,
      name: "Qacha's Nek",
      iso2: 'H',
      countryId: 122,
    },
    {
      id: 3027,
      name: 'Quthing',
      iso2: 'G',
      countryId: 122,
    },
    {
      id: 3031,
      name: 'Thaba-Tseka',
      iso2: 'K',
      countryId: 122,
    },
    {
      id: 3041,
      name: 'Bomi',
      iso2: 'BM',
      countryId: 123,
    },
    {
      id: 3034,
      name: 'Bong',
      iso2: 'BG',
      countryId: 123,
    },
    {
      id: 3044,
      name: 'Gbarpolu',
      iso2: 'GP',
      countryId: 123,
    },
    {
      id: 3040,
      name: 'Grand Bassa',
      iso2: 'GB',
      countryId: 123,
    },
    {
      id: 3036,
      name: 'Grand Cape Mount',
      iso2: 'CM',
      countryId: 123,
    },
    {
      id: 3039,
      name: 'Grand Gedeh',
      iso2: 'GG',
      countryId: 123,
    },
    {
      id: 3045,
      name: 'Grand Kru',
      iso2: 'GK',
      countryId: 123,
    },
    {
      id: 3037,
      name: 'Lofa',
      iso2: 'LO',
      countryId: 123,
    },
    {
      id: 3043,
      name: 'Margibi',
      iso2: 'MG',
      countryId: 123,
    },
    {
      id: 3042,
      name: 'Maryland',
      iso2: 'MY',
      countryId: 123,
    },
    {
      id: 3032,
      name: 'Montserrado',
      iso2: 'MO',
      countryId: 123,
    },
    {
      id: 3046,
      name: 'Nimba',
      iso2: 'NI',
      countryId: 123,
    },
    {
      id: 3033,
      name: 'River Cess',
      iso2: 'RI',
      countryId: 123,
    },
    {
      id: 3038,
      name: 'River Gee',
      iso2: 'RG',
      countryId: 123,
    },
    {
      id: 3035,
      name: 'Sinoe',
      iso2: 'SI',
      countryId: 123,
    },
    {
      id: 5641,
      name: 'Al Butnan',
      iso2: 'BU',
      countryId: 124,
    },
    {
      id: 2964,
      name: 'Al Wahat',
      iso2: 'WA',
      countryId: 124,
    },
    {
      id: 2981,
      name: 'Benghazi',
      iso2: 'BA',
      countryId: 124,
    },
    {
      id: 2966,
      name: 'Derna',
      iso2: 'DR',
      countryId: 124,
    },
    {
      id: 2969,
      name: 'Ghat',
      iso2: 'GT',
      countryId: 124,
    },
    {
      id: 2980,
      name: 'Jabal al Akhdar',
      iso2: 'JA',
      countryId: 124,
    },
    {
      id: 2974,
      name: 'Jabal al Gharbi',
      iso2: 'JG',
      countryId: 124,
    },
    {
      id: 2979,
      name: 'Jafara',
      iso2: 'JI',
      countryId: 124,
    },
    {
      id: 2970,
      name: 'Jufra',
      iso2: 'JU',
      countryId: 124,
    },
    {
      id: 2972,
      name: 'Kufra',
      iso2: 'KF',
      countryId: 124,
    },
    {
      id: 2968,
      name: 'Marj',
      iso2: 'MJ',
      countryId: 124,
    },
    {
      id: 2978,
      name: 'Misrata',
      iso2: 'MI',
      countryId: 124,
    },
    {
      id: 2961,
      name: 'Murqub',
      iso2: 'MB',
      countryId: 124,
    },
    {
      id: 2967,
      name: 'Murzuq',
      iso2: 'MQ',
      countryId: 124,
    },
    {
      id: 2976,
      name: 'Nalut',
      iso2: 'NL',
      countryId: 124,
    },
    {
      id: 2962,
      name: 'Nuqat al Khams',
      iso2: 'NQ',
      countryId: 124,
    },
    {
      id: 2965,
      name: 'Sabha',
      iso2: 'SB',
      countryId: 124,
    },
    {
      id: 2977,
      name: 'Sirte',
      iso2: 'SR',
      countryId: 124,
    },
    {
      id: 2971,
      name: 'Tripoli',
      iso2: 'TB',
      countryId: 124,
    },
    {
      id: 2973,
      name: 'Wadi al Hayaa',
      iso2: 'WD',
      countryId: 124,
    },
    {
      id: 2975,
      name: 'Wadi al Shatii',
      iso2: 'WS',
      countryId: 124,
    },
    {
      id: 2963,
      name: 'Zawiya',
      iso2: 'ZA',
      countryId: 124,
    },
    {
      id: 458,
      name: 'Balzers',
      iso2: '01',
      countryId: 125,
    },
    {
      id: 451,
      name: 'Eschen',
      iso2: '02',
      countryId: 125,
    },
    {
      id: 457,
      name: 'Gamprin',
      iso2: '03',
      countryId: 125,
    },
    {
      id: 455,
      name: 'Mauren',
      iso2: '04',
      countryId: 125,
    },
    {
      id: 454,
      name: 'Planken',
      iso2: '05',
      countryId: 125,
    },
    {
      id: 453,
      name: 'Ruggell',
      iso2: '06',
      countryId: 125,
    },
    {
      id: 450,
      name: 'Schaan',
      iso2: '07',
      countryId: 125,
    },
    {
      id: 449,
      name: 'Schellenberg',
      iso2: '08',
      countryId: 125,
    },
    {
      id: 459,
      name: 'Triesen',
      iso2: '09',
      countryId: 125,
    },
    {
      id: 456,
      name: 'Triesenberg',
      iso2: '10',
      countryId: 125,
    },
    {
      id: 452,
      name: 'Vaduz',
      iso2: '11',
      countryId: 125,
    },
    {
      id: 1561,
      name: 'Akmenė',
      iso2: '01',
      countryId: 126,
    },
    {
      id: 5722,
      name: 'Alytus',
      iso2: '03',
      countryId: 126,
    },
    {
      id: 1605,
      name: 'Alytus',
      iso2: '02',
      countryId: 126,
    },
    {
      id: 1574,
      name: 'Alytus',
      iso2: 'AL',
      countryId: 126,
    },
    {
      id: 5346,
      name: 'Anykščiai',
      iso2: '04',
      countryId: 126,
    },
    {
      id: 1603,
      name: 'Birštonas',
      iso2: '05',
      countryId: 126,
    },
    {
      id: 1566,
      name: 'Biržai',
      iso2: '06',
      countryId: 126,
    },
    {
      id: 1579,
      name: 'Druskininkai',
      iso2: '07',
      countryId: 126,
    },
    {
      id: 1559,
      name: 'Elektrėnai',
      iso2: '08',
      countryId: 126,
    },
    {
      id: 1562,
      name: 'Ignalina',
      iso2: '09',
      countryId: 126,
    },
    {
      id: 1567,
      name: 'Jonava',
      iso2: '10',
      countryId: 126,
    },
    {
      id: 1581,
      name: 'Joniškis',
      iso2: '11',
      countryId: 126,
    },
    {
      id: 1555,
      name: 'Jurbarkas',
      iso2: '12',
      countryId: 126,
    },
    {
      id: 1583,
      name: 'Kaišiadorys',
      iso2: '13',
      countryId: 126,
    },
    {
      id: 1591,
      name: 'Kalvarija',
      iso2: '14',
      countryId: 126,
    },
    {
      id: 1556,
      name: 'Kaunas',
      iso2: 'KU',
      countryId: 126,
    },
    {
      id: 5723,
      name: 'Kaunas',
      iso2: '16',
      countryId: 126,
    },
    {
      id: 1580,
      name: 'Kaunas',
      iso2: '15',
      countryId: 126,
    },
    {
      id: 1575,
      name: 'Kazlų Rūda',
      iso2: '17',
      countryId: 126,
    },
    {
      id: 1584,
      name: 'Kėdainiai',
      iso2: '18',
      countryId: 126,
    },
    {
      id: 1618,
      name: 'Kelmė',
      iso2: '19',
      countryId: 126,
    },
    {
      id: 1600,
      name: 'Klaipėda',
      iso2: 'KL',
      countryId: 126,
    },
    {
      id: 1604,
      name: 'Klaipėda',
      iso2: '21',
      countryId: 126,
    },
    {
      id: 5720,
      name: 'Klaipėdos miestas',
      iso2: '20',
      countryId: 126,
    },
    {
      id: 1571,
      name: 'Kretinga',
      iso2: '22',
      countryId: 126,
    },
    {
      id: 1585,
      name: 'Kupiškis',
      iso2: '23',
      countryId: 126,
    },
    {
      id: 1611,
      name: 'Lazdijai',
      iso2: '24',
      countryId: 126,
    },
    {
      id: 1610,
      name: 'Marijampolė',
      iso2: '25',
      countryId: 126,
    },
    {
      id: 1570,
      name: 'Marijampolė',
      iso2: 'MR',
      countryId: 126,
    },
    {
      id: 1557,
      name: 'Mažeikiai',
      iso2: '26',
      countryId: 126,
    },
    {
      id: 1582,
      name: 'Molėtai',
      iso2: '27',
      countryId: 126,
    },
    {
      id: 1563,
      name: 'Neringa',
      iso2: '28',
      countryId: 126,
    },
    {
      id: 1612,
      name: 'Pagėgiai',
      iso2: '29',
      countryId: 126,
    },
    {
      id: 1595,
      name: 'Pakruojis',
      iso2: '30',
      countryId: 126,
    },
    {
      id: 1588,
      name: 'Palanga',
      iso2: '31',
      countryId: 126,
    },
    {
      id: 5721,
      name: 'Panevėžio miestas',
      iso2: '32',
      countryId: 126,
    },
    {
      id: 1614,
      name: 'Panevėžys',
      iso2: '33',
      countryId: 126,
    },
    {
      id: 1558,
      name: 'Panevėžys',
      iso2: 'PN',
      countryId: 126,
    },
    {
      id: 1616,
      name: 'Pasvalys',
      iso2: '34',
      countryId: 126,
    },
    {
      id: 1553,
      name: 'Plungė',
      iso2: '35',
      countryId: 126,
    },
    {
      id: 1578,
      name: 'Prienai',
      iso2: '36',
      countryId: 126,
    },
    {
      id: 1568,
      name: 'Radviliškis',
      iso2: '37',
      countryId: 126,
    },
    {
      id: 1587,
      name: 'Raseiniai',
      iso2: '38',
      countryId: 126,
    },
    {
      id: 1590,
      name: 'Rietavas',
      iso2: '39',
      countryId: 126,
    },
    {
      id: 1615,
      name: 'Rokiškis',
      iso2: '40',
      countryId: 126,
    },
    {
      id: 1576,
      name: 'Šakiai',
      iso2: '41',
      countryId: 126,
    },
    {
      id: 1577,
      name: 'Šalčininkai',
      iso2: '42',
      countryId: 126,
    },
    {
      id: 1586,
      name: 'Šiauliai',
      iso2: 'SA',
      countryId: 126,
    },
    {
      id: 1609,
      name: 'Šiauliai',
      iso2: '43',
      countryId: 126,
    },
    {
      id: 5724,
      name: 'Šiauliai',
      iso2: '44',
      countryId: 126,
    },
    {
      id: 1613,
      name: 'Šilalė ',
      iso2: '45',
      countryId: 126,
    },
    {
      id: 1607,
      name: 'Šilutė',
      iso2: '46',
      countryId: 126,
    },
    {
      id: 1594,
      name: 'Širvintos',
      iso2: '47',
      countryId: 126,
    },
    {
      id: 1617,
      name: 'Skuodas',
      iso2: '48',
      countryId: 126,
    },
    {
      id: 1560,
      name: 'Švenčionys',
      iso2: '49',
      countryId: 126,
    },
    {
      id: 1573,
      name: 'Tauragė',
      iso2: 'TA',
      countryId: 126,
    },
    {
      id: 1572,
      name: 'Tauragė',
      iso2: '50',
      countryId: 126,
    },
    {
      id: 1608,
      name: 'Telšiai',
      iso2: '51',
      countryId: 126,
    },
    {
      id: 1569,
      name: 'Telšiai',
      iso2: 'TE',
      countryId: 126,
    },
    {
      id: 1593,
      name: 'Trakai',
      iso2: '52',
      countryId: 126,
    },
    {
      id: 1596,
      name: 'Ukmergė',
      iso2: '53',
      countryId: 126,
    },
    {
      id: 1598,
      name: 'Utena',
      iso2: '54',
      countryId: 126,
    },
    {
      id: 1621,
      name: 'Utena',
      iso2: 'UT',
      countryId: 126,
    },
    {
      id: 1602,
      name: 'Varėna',
      iso2: '55',
      countryId: 126,
    },
    {
      id: 1620,
      name: 'Vilkaviškis',
      iso2: '56',
      countryId: 126,
    },
    {
      id: 5725,
      name: 'Vilnius',
      iso2: '58',
      countryId: 126,
    },
    {
      id: 1606,
      name: 'Vilnius',
      iso2: '57',
      countryId: 126,
    },
    {
      id: 1601,
      name: 'Vilnius',
      iso2: 'VL',
      countryId: 126,
    },
    {
      id: 1564,
      name: 'Visaginas',
      iso2: '59',
      countryId: 126,
    },
    {
      id: 1619,
      name: 'Zarasai',
      iso2: '60',
      countryId: 126,
    },
    {
      id: 1518,
      name: 'Capellen',
      iso2: 'CA',
      countryId: 127,
    },
    {
      id: 1521,
      name: 'Clervaux',
      iso2: 'CL',
      countryId: 127,
    },
    {
      id: 1513,
      name: 'Diekirch',
      iso2: 'DI',
      countryId: 127,
    },
    {
      id: 1515,
      name: 'Echternach',
      iso2: 'EC',
      countryId: 127,
    },
    {
      id: 1517,
      name: 'Esch-sur-Alzette',
      iso2: 'ES',
      countryId: 127,
    },
    {
      id: 1520,
      name: 'Grevenmacher',
      iso2: 'G',
      countryId: 127,
    },
    {
      id: 1514,
      name: 'Luxembourg ',
      iso2: 'L',
      countryId: 127,
    },
    {
      id: 1522,
      name: 'Mersch',
      iso2: 'ME',
      countryId: 127,
    },
    {
      id: 1516,
      name: 'Redange',
      iso2: 'RD',
      countryId: 127,
    },
    {
      id: 1519,
      name: 'Remich',
      iso2: 'RM',
      countryId: 127,
    },
    {
      id: 1523,
      name: 'Vianden',
      iso2: 'VD',
      countryId: 127,
    },
    {
      id: 1526,
      name: 'Wiltz',
      iso2: 'WI',
      countryId: 127,
    },
    {
      id: 2951,
      name: 'Antananarivo',
      iso2: 'T',
      countryId: 130,
    },
    {
      id: 2950,
      name: 'Antsiranana',
      iso2: 'D',
      countryId: 130,
    },
    {
      id: 2948,
      name: 'Fianarantsoa',
      iso2: 'F',
      countryId: 130,
    },
    {
      id: 2953,
      name: 'Mahajanga',
      iso2: 'M',
      countryId: 130,
    },
    {
      id: 2952,
      name: 'Toamasina',
      iso2: 'A',
      countryId: 130,
    },
    {
      id: 2949,
      name: 'Toliara',
      iso2: 'U',
      countryId: 130,
    },
    {
      id: 3096,
      name: 'Balaka',
      iso2: 'BA',
      countryId: 131,
    },
    {
      id: 3102,
      name: 'Blantyre',
      iso2: 'BL',
      countryId: 131,
    },
    {
      id: 3092,
      name: 'Central',
      iso2: 'C',
      countryId: 131,
    },
    {
      id: 3107,
      name: 'Chikwawa',
      iso2: 'CK',
      countryId: 131,
    },
    {
      id: 3109,
      name: 'Chiradzulu',
      iso2: 'CR',
      countryId: 131,
    },
    {
      id: 3087,
      name: 'Chitipa',
      iso2: 'CT',
      countryId: 131,
    },
    {
      id: 3097,
      name: 'Dedza',
      iso2: 'DE',
      countryId: 131,
    },
    {
      id: 3090,
      name: 'Dowa',
      iso2: 'DO',
      countryId: 131,
    },
    {
      id: 3091,
      name: 'Karonga',
      iso2: 'KR',
      countryId: 131,
    },
    {
      id: 3094,
      name: 'Kasungu',
      iso2: 'KS',
      countryId: 131,
    },
    {
      id: 3093,
      name: 'Likoma',
      iso2: 'LK',
      countryId: 131,
    },
    {
      id: 3101,
      name: 'Lilongwe',
      iso2: 'LI',
      countryId: 131,
    },
    {
      id: 3082,
      name: 'Machinga',
      iso2: 'MH',
      countryId: 131,
    },
    {
      id: 3110,
      name: 'Mangochi',
      iso2: 'MG',
      countryId: 131,
    },
    {
      id: 3099,
      name: 'Mchinji',
      iso2: 'MC',
      countryId: 131,
    },
    {
      id: 3103,
      name: 'Mulanje',
      iso2: 'MU',
      countryId: 131,
    },
    {
      id: 3084,
      name: 'Mwanza',
      iso2: 'MW',
      countryId: 131,
    },
    {
      id: 3104,
      name: 'Mzimba',
      iso2: 'MZ',
      countryId: 131,
    },
    {
      id: 5347,
      name: 'Neno',
      iso2: 'NE',
      countryId: 131,
    },
    {
      id: 3095,
      name: 'Nkhata Bay',
      iso2: 'NB',
      countryId: 131,
    },
    {
      id: 3100,
      name: 'Nkhotakota',
      iso2: 'NK',
      countryId: 131,
    },
    {
      id: 3105,
      name: 'Northern',
      iso2: 'N',
      countryId: 131,
    },
    {
      id: 3085,
      name: 'Nsanje',
      iso2: 'NS',
      countryId: 131,
    },
    {
      id: 3088,
      name: 'Ntcheu',
      iso2: 'NU',
      countryId: 131,
    },
    {
      id: 3111,
      name: 'Ntchisi',
      iso2: 'NI',
      countryId: 131,
    },
    {
      id: 3108,
      name: 'Phalombe',
      iso2: 'PH',
      countryId: 131,
    },
    {
      id: 3089,
      name: 'Rumphi',
      iso2: 'RU',
      countryId: 131,
    },
    {
      id: 3086,
      name: 'Salima',
      iso2: 'SA',
      countryId: 131,
    },
    {
      id: 3106,
      name: 'Southern',
      iso2: 'S',
      countryId: 131,
    },
    {
      id: 3098,
      name: 'Thyolo',
      iso2: 'TH',
      countryId: 131,
    },
    {
      id: 3083,
      name: 'Zomba',
      iso2: 'ZO',
      countryId: 131,
    },
    {
      id: 1950,
      name: 'Johor',
      iso2: '01',
      countryId: 132,
    },
    {
      id: 1947,
      name: 'Kedah',
      iso2: '02',
      countryId: 132,
    },
    {
      id: 1946,
      name: 'Kelantan',
      iso2: '03',
      countryId: 132,
    },
    {
      id: 1949,
      name: 'Kuala Lumpur',
      iso2: '14',
      countryId: 132,
    },
    {
      id: 1935,
      name: 'Labuan',
      iso2: '15',
      countryId: 132,
    },
    {
      id: 1941,
      name: 'Malacca',
      iso2: '04',
      countryId: 132,
    },
    {
      id: 1948,
      name: 'Negeri Sembilan',
      iso2: '05',
      countryId: 132,
    },
    {
      id: 1940,
      name: 'Pahang',
      iso2: '06',
      countryId: 132,
    },
    {
      id: 1939,
      name: 'Penang',
      iso2: '07',
      countryId: 132,
    },
    {
      id: 1943,
      name: 'Perak',
      iso2: '08',
      countryId: 132,
    },
    {
      id: 1938,
      name: 'Perlis',
      iso2: '09',
      countryId: 132,
    },
    {
      id: 1945,
      name: 'Putrajaya',
      iso2: '16',
      countryId: 132,
    },
    {
      id: 1936,
      name: 'Sabah',
      iso2: '12',
      countryId: 132,
    },
    {
      id: 1937,
      name: 'Sarawak',
      iso2: '13',
      countryId: 132,
    },
    {
      id: 1944,
      name: 'Selangor',
      iso2: '10',
      countryId: 132,
    },
    {
      id: 1942,
      name: 'Terengganu',
      iso2: '11',
      countryId: 132,
    },
    {
      id: 2594,
      name: 'Addu',
      iso2: '01',
      countryId: 133,
    },
    {
      id: 2587,
      name: 'Alif Alif',
      iso2: '02',
      countryId: 133,
    },
    {
      id: 2600,
      name: 'Alif Dhaal',
      iso2: '00',
      countryId: 133,
    },
    {
      id: 5727,
      name: 'Baa',
      iso2: '20',
      countryId: 133,
    },
    {
      id: 2590,
      name: 'Dhaalu',
      iso2: '17',
      countryId: 133,
    },
    {
      id: 2599,
      name: 'Faafu',
      iso2: '14',
      countryId: 133,
    },
    {
      id: 2598,
      name: 'Gaafu Alif',
      iso2: '27',
      countryId: 133,
    },
    {
      id: 2603,
      name: 'Gaafu Dhaalu',
      iso2: '28',
      countryId: 133,
    },
    {
      id: 2595,
      name: 'Gnaviyani',
      iso2: '29',
      countryId: 133,
    },
    {
      id: 2586,
      name: 'Haa Alif',
      iso2: '07',
      countryId: 133,
    },
    {
      id: 2597,
      name: 'Haa Dhaalu',
      iso2: '23',
      countryId: 133,
    },
    {
      id: 2596,
      name: 'Kaafu',
      iso2: '26',
      countryId: 133,
    },
    {
      id: 2601,
      name: 'Laamu',
      iso2: '05',
      countryId: 133,
    },
    {
      id: 2607,
      name: 'Lhaviyani',
      iso2: '03',
      countryId: 133,
    },
    {
      id: 2609,
      name: 'Malé',
      iso2: 'MLE',
      countryId: 133,
    },
    {
      id: 2608,
      name: 'Meemu',
      iso2: '12',
      countryId: 133,
    },
    {
      id: 2592,
      name: 'Noonu',
      iso2: '25',
      countryId: 133,
    },
    {
      id: 2602,
      name: 'Raa',
      iso2: '13',
      countryId: 133,
    },
    {
      id: 2585,
      name: 'Shaviyani',
      iso2: '24',
      countryId: 133,
    },
    {
      id: 2591,
      name: 'Thaa',
      iso2: '08',
      countryId: 133,
    },
    {
      id: 2584,
      name: 'Vaavu',
      iso2: '04',
      countryId: 133,
    },
    {
      id: 253,
      name: 'Bamako',
      iso2: 'BKO',
      countryId: 134,
    },
    {
      id: 258,
      name: 'Gao',
      iso2: '7',
      countryId: 134,
    },
    {
      id: 252,
      name: 'Kayes',
      iso2: '1',
      countryId: 134,
    },
    {
      id: 257,
      name: 'Kidal',
      iso2: '8',
      countryId: 134,
    },
    {
      id: 250,
      name: 'Koulikoro',
      iso2: '2',
      countryId: 134,
    },
    {
      id: 251,
      name: 'Ménaka',
      iso2: '9',
      countryId: 134,
    },
    {
      id: 255,
      name: 'Mopti',
      iso2: '5',
      countryId: 134,
    },
    {
      id: 249,
      name: 'Ségou',
      iso2: '4',
      countryId: 134,
    },
    {
      id: 254,
      name: 'Sikasso',
      iso2: '3',
      countryId: 134,
    },
    {
      id: 256,
      name: 'Taoudénit',
      iso2: '10',
      countryId: 134,
    },
    {
      id: 248,
      name: 'Tombouctou',
      iso2: '6',
      countryId: 134,
    },
    {
      id: 110,
      name: 'Attard',
      iso2: '01',
      countryId: 135,
    },
    {
      id: 108,
      name: 'Balzan',
      iso2: '02',
      countryId: 135,
    },
    {
      id: 107,
      name: 'Birgu',
      iso2: '03',
      countryId: 135,
    },
    {
      id: 97,
      name: 'Birkirkara',
      iso2: '04',
      countryId: 135,
    },
    {
      id: 88,
      name: 'Birżebbuġa',
      iso2: '05',
      countryId: 135,
    },
    {
      id: 138,
      name: 'Cospicua',
      iso2: '06',
      countryId: 135,
    },
    {
      id: 117,
      name: 'Dingli',
      iso2: '07',
      countryId: 135,
    },
    {
      id: 129,
      name: 'Fgura',
      iso2: '08',
      countryId: 135,
    },
    {
      id: 84,
      name: 'Floriana',
      iso2: '09',
      countryId: 135,
    },
    {
      id: 134,
      name: 'Fontana',
      iso2: '10',
      countryId: 135,
    },
    {
      id: 130,
      name: 'Għajnsielem',
      iso2: '13',
      countryId: 135,
    },
    {
      id: 92,
      name: 'Għarb',
      iso2: '14',
      countryId: 135,
    },
    {
      id: 120,
      name: 'Għargħur',
      iso2: '15',
      countryId: 135,
    },
    {
      id: 106,
      name: 'Għasri',
      iso2: '16',
      countryId: 135,
    },
    {
      id: 124,
      name: 'Għaxaq',
      iso2: '17',
      countryId: 135,
    },
    {
      id: 118,
      name: 'Gudja',
      iso2: '11',
      countryId: 135,
    },
    {
      id: 113,
      name: 'Gżira',
      iso2: '12',
      countryId: 135,
    },
    {
      id: 105,
      name: 'Ħamrun',
      iso2: '18',
      countryId: 135,
    },
    {
      id: 93,
      name: 'Iklin',
      iso2: '19',
      countryId: 135,
    },
    {
      id: 99,
      name: 'Kalkara',
      iso2: '21',
      countryId: 135,
    },
    {
      id: 91,
      name: 'Kerċem',
      iso2: '22',
      countryId: 135,
    },
    {
      id: 82,
      name: 'Kirkop',
      iso2: '23',
      countryId: 135,
    },
    {
      id: 126,
      name: 'Lija',
      iso2: '24',
      countryId: 135,
    },
    {
      id: 77,
      name: 'Luqa',
      iso2: '25',
      countryId: 135,
    },
    {
      id: 128,
      name: 'Marsa',
      iso2: '26',
      countryId: 135,
    },
    {
      id: 137,
      name: 'Marsaskala',
      iso2: '27',
      countryId: 135,
    },
    {
      id: 78,
      name: 'Marsaxlokk',
      iso2: '28',
      countryId: 135,
    },
    {
      id: 89,
      name: 'Mdina',
      iso2: '29',
      countryId: 135,
    },
    {
      id: 102,
      name: 'Mellieħa',
      iso2: '30',
      countryId: 135,
    },
    {
      id: 109,
      name: 'Mġarr',
      iso2: '31',
      countryId: 135,
    },
    {
      id: 140,
      name: 'Mosta',
      iso2: '32',
      countryId: 135,
    },
    {
      id: 74,
      name: 'Mqabba',
      iso2: '33',
      countryId: 135,
    },
    {
      id: 96,
      name: 'Msida',
      iso2: '34',
      countryId: 135,
    },
    {
      id: 131,
      name: 'Mtarfa',
      iso2: '35',
      countryId: 135,
    },
    {
      id: 132,
      name: 'Munxar',
      iso2: '36',
      countryId: 135,
    },
    {
      id: 133,
      name: 'Nadur',
      iso2: '37',
      countryId: 135,
    },
    {
      id: 112,
      name: 'Naxxar',
      iso2: '38',
      countryId: 135,
    },
    {
      id: 115,
      name: 'Paola',
      iso2: '39',
      countryId: 135,
    },
    {
      id: 125,
      name: 'Pembroke',
      iso2: '40',
      countryId: 135,
    },
    {
      id: 127,
      name: 'Pietà',
      iso2: '41',
      countryId: 135,
    },
    {
      id: 79,
      name: 'Qala',
      iso2: '42',
      countryId: 135,
    },
    {
      id: 119,
      name: 'Qormi',
      iso2: '43',
      countryId: 135,
    },
    {
      id: 111,
      name: 'Qrendi',
      iso2: '44',
      countryId: 135,
    },
    {
      id: 83,
      name: 'Rabat',
      iso2: '46',
      countryId: 135,
    },
    {
      id: 5642,
      name: 'Safi',
      iso2: '47',
      countryId: 135,
    },
    {
      id: 75,
      name: 'San Ġwann',
      iso2: '49',
      countryId: 135,
    },
    {
      id: 87,
      name: 'San Lawrenz',
      iso2: '50',
      countryId: 135,
    },
    {
      id: 116,
      name: 'Sannat',
      iso2: '52',
      countryId: 135,
    },
    {
      id: 94,
      name: 'Santa Luċija',
      iso2: '53',
      countryId: 135,
    },
    {
      id: 90,
      name: 'Santa Venera',
      iso2: '54',
      countryId: 135,
    },
    {
      id: 136,
      name: 'Senglea',
      iso2: '20',
      countryId: 135,
    },
    {
      id: 98,
      name: 'Siġġiewi',
      iso2: '55',
      countryId: 135,
    },
    {
      id: 104,
      name: 'Sliema',
      iso2: '56',
      countryId: 135,
    },
    {
      id: 100,
      name: "St. Julian's",
      iso2: '48',
      countryId: 135,
    },
    {
      id: 139,
      name: "St. Paul's Bay",
      iso2: '51',
      countryId: 135,
    },
    {
      id: 86,
      name: 'Swieqi',
      iso2: '57',
      countryId: 135,
    },
    {
      id: 122,
      name: "Ta' Xbiex",
      iso2: '58',
      countryId: 135,
    },
    {
      id: 103,
      name: 'Tarxien',
      iso2: '59',
      countryId: 135,
    },
    {
      id: 95,
      name: 'Valletta',
      iso2: '60',
      countryId: 135,
    },
    {
      id: 101,
      name: 'Victoria',
      iso2: '45',
      countryId: 135,
    },
    {
      id: 114,
      name: 'Xagħra',
      iso2: '61',
      countryId: 135,
    },
    {
      id: 121,
      name: 'Xewkija',
      iso2: '62',
      countryId: 135,
    },
    {
      id: 81,
      name: 'Xgħajra',
      iso2: '63',
      countryId: 135,
    },
    {
      id: 123,
      name: 'Żabbar',
      iso2: '64',
      countryId: 135,
    },
    {
      id: 85,
      name: 'Żebbuġ Gozo',
      iso2: '65',
      countryId: 135,
    },
    {
      id: 80,
      name: 'Żebbuġ Malta',
      iso2: '66',
      countryId: 135,
    },
    {
      id: 135,
      name: 'Żejtun',
      iso2: '67',
      countryId: 135,
    },
    {
      id: 76,
      name: 'Żurrieq',
      iso2: '68',
      countryId: 135,
    },
    {
      id: 5303,
      name: 'Ayre',
      iso2: '01',
      countryId: 136,
    },
    {
      id: 5304,
      name: 'Garff',
      iso2: '02',
      countryId: 136,
    },
    {
      id: 5305,
      name: 'Glenfaba',
      iso2: '03',
      countryId: 136,
    },
    {
      id: 5306,
      name: 'Michael',
      iso2: '04',
      countryId: 136,
    },
    {
      id: 5307,
      name: 'Middle',
      iso2: '05',
      countryId: 136,
    },
    {
      id: 5308,
      name: 'Rushen',
      iso2: '06',
      countryId: 136,
    },
    {
      id: 5643,
      name: 'Ailinglaplap',
      iso2: 'ALL',
      countryId: 137,
    },
    {
      id: 5644,
      name: 'Ailuk',
      iso2: 'ALK',
      countryId: 137,
    },
    {
      id: 5645,
      name: 'Arno',
      iso2: 'ARN',
      countryId: 137,
    },
    {
      id: 5646,
      name: 'Aur',
      iso2: 'AUR',
      countryId: 137,
    },
    {
      id: 5647,
      name: 'Bikini & Kili',
      iso2: 'KIL',
      countryId: 137,
    },
    {
      id: 5648,
      name: 'Ebon',
      iso2: 'EBO',
      countryId: 137,
    },
    {
      id: 5649,
      name: 'Enewetak & Ujelang',
      iso2: 'ENI',
      countryId: 137,
    },
    {
      id: 5650,
      name: 'Jabat',
      iso2: 'JAB',
      countryId: 137,
    },
    {
      id: 5651,
      name: 'Jaluit',
      iso2: 'JAL',
      countryId: 137,
    },
    {
      id: 5652,
      name: 'Kwajalein',
      iso2: 'KWA',
      countryId: 137,
    },
    {
      id: 5653,
      name: 'Lae',
      iso2: 'LAE',
      countryId: 137,
    },
    {
      id: 5654,
      name: 'Lib',
      iso2: 'LIB',
      countryId: 137,
    },
    {
      id: 5655,
      name: 'Likiep',
      iso2: 'LIK',
      countryId: 137,
    },
    {
      id: 5656,
      name: 'Majuro',
      iso2: 'MAJ',
      countryId: 137,
    },
    {
      id: 5657,
      name: 'Maloelap',
      iso2: 'MAL',
      countryId: 137,
    },
    {
      id: 5658,
      name: 'Mejit',
      iso2: 'MEJ',
      countryId: 137,
    },
    {
      id: 5659,
      name: 'Mili',
      iso2: 'MIL',
      countryId: 137,
    },
    {
      id: 5660,
      name: 'Namdrik',
      iso2: 'NMK',
      countryId: 137,
    },
    {
      id: 5661,
      name: 'Namu',
      iso2: 'NMU',
      countryId: 137,
    },
    {
      id: 2574,
      name: 'Ralik',
      iso2: 'L',
      countryId: 137,
    },
    {
      id: 2573,
      name: 'Ratak',
      iso2: 'T',
      countryId: 137,
    },
    {
      id: 5662,
      name: 'Rongelap',
      iso2: 'RON',
      countryId: 137,
    },
    {
      id: 5663,
      name: 'Ujae',
      iso2: 'UJA',
      countryId: 137,
    },
    {
      id: 5664,
      name: 'Utrik',
      iso2: 'UTI',
      countryId: 137,
    },
    {
      id: 5665,
      name: 'Wotho',
      iso2: 'WTH',
      countryId: 137,
    },
    {
      id: 5666,
      name: 'Wotje',
      iso2: 'WTJ',
      countryId: 137,
    },
    {
      id: 5398,
      name: 'Fort-de-France',
      iso2: '01',
      countryId: 138,
    },
    {
      id: 5399,
      name: 'La Trinité',
      iso2: '02',
      countryId: 138,
    },
    {
      id: 5400,
      name: 'Le Marin',
      iso2: '03',
      countryId: 138,
    },
    {
      id: 5401,
      name: 'Saint-Pierre',
      iso2: '04',
      countryId: 138,
    },
    {
      id: 3344,
      name: 'Adrar',
      iso2: '07',
      countryId: 139,
    },
    {
      id: 3349,
      name: 'Assaba',
      iso2: '03',
      countryId: 139,
    },
    {
      id: 3339,
      name: 'Brakna',
      iso2: '05',
      countryId: 139,
    },
    {
      id: 3346,
      name: 'Dakhlet Nouadhibou',
      iso2: '08',
      countryId: 139,
    },
    {
      id: 3341,
      name: 'Gorgol',
      iso2: '04',
      countryId: 139,
    },
    {
      id: 3350,
      name: 'Guidimaka',
      iso2: '10',
      countryId: 139,
    },
    {
      id: 3338,
      name: 'Hodh Ech Chargui',
      iso2: '01',
      countryId: 139,
    },
    {
      id: 3351,
      name: 'Hodh El Gharbi',
      iso2: '02',
      countryId: 139,
    },
    {
      id: 3342,
      name: 'Inchiri',
      iso2: '12',
      countryId: 139,
    },
    {
      id: 3343,
      name: 'Nouakchott-Nord',
      iso2: '14',
      countryId: 139,
    },
    {
      id: 3352,
      name: 'Nouakchott-Ouest',
      iso2: '13',
      countryId: 139,
    },
    {
      id: 3347,
      name: 'Nouakchott-Sud',
      iso2: '15',
      countryId: 139,
    },
    {
      id: 3345,
      name: 'Tagant',
      iso2: '09',
      countryId: 139,
    },
    {
      id: 3340,
      name: 'Tiris Zemmour',
      iso2: '11',
      countryId: 139,
    },
    {
      id: 3348,
      name: 'Trarza',
      iso2: '06',
      countryId: 139,
    },
    {
      id: 3248,
      name: 'Agalega Islands',
      iso2: 'AG',
      countryId: 140,
    },
    {
      id: 3259,
      name: 'Black River',
      iso2: 'BL',
      countryId: 140,
    },
    {
      id: 3254,
      name: 'Flacq',
      iso2: 'FL',
      countryId: 140,
    },
    {
      id: 3264,
      name: 'Grand Port',
      iso2: 'GP',
      countryId: 140,
    },
    {
      id: 3253,
      name: 'Moka',
      iso2: 'MO',
      countryId: 140,
    },
    {
      id: 3250,
      name: 'Pamplemousses',
      iso2: 'PA',
      countryId: 140,
    },
    {
      id: 3263,
      name: 'Plaines Wilhems',
      iso2: 'PW',
      countryId: 140,
    },
    {
      id: 3260,
      name: 'Port Louis',
      iso2: 'PL',
      countryId: 140,
    },
    {
      id: 3261,
      name: 'Rivière du Rempart',
      iso2: 'RR',
      countryId: 140,
    },
    {
      id: 3249,
      name: 'Rodrigues Island',
      iso2: 'RO',
      countryId: 140,
    },
    {
      id: 3251,
      name: 'Saint Brandon Islands',
      iso2: 'CC',
      countryId: 140,
    },
    {
      id: 3257,
      name: 'Savanne',
      iso2: 'SA',
      countryId: 140,
    },
    {
      id: 5415,
      name: 'Acoua',
      iso2: '14',
      countryId: 141,
    },
    {
      id: 5417,
      name: 'Bandraboua',
      iso2: '16',
      countryId: 141,
    },
    {
      id: 5406,
      name: 'Bandrélé',
      iso2: '05',
      countryId: 141,
    },
    {
      id: 5408,
      name: 'Boueni',
      iso2: '07',
      countryId: 141,
    },
    {
      id: 5412,
      name: 'Chiconi',
      iso2: '11',
      countryId: 141,
    },
    {
      id: 5409,
      name: 'Chirongui',
      iso2: '08',
      countryId: 141,
    },
    {
      id: 5405,
      name: 'Dembeni',
      iso2: '04',
      countryId: 141,
    },
    {
      id: 5402,
      name: 'Dzaoudzi',
      iso2: '01',
      countryId: 141,
    },
    {
      id: 5407,
      name: 'Kani Keli',
      iso2: '06',
      countryId: 141,
    },
    {
      id: 5418,
      name: 'Koungou',
      iso2: '17',
      countryId: 141,
    },
    {
      id: 5414,
      name: "M'Tsangamouji",
      iso2: '13',
      countryId: 141,
    },
    {
      id: 5404,
      name: 'Mamoudzou',
      iso2: '03',
      countryId: 141,
    },
    {
      id: 5416,
      name: 'Mtsamboro',
      iso2: '15',
      countryId: 141,
    },
    {
      id: 5411,
      name: 'Ouangani',
      iso2: '10',
      countryId: 141,
    },
    {
      id: 5403,
      name: 'Pamandzi',
      iso2: '02',
      countryId: 141,
    },
    {
      id: 5410,
      name: 'Sada',
      iso2: '09',
      countryId: 141,
    },
    {
      id: 5413,
      name: 'Tsingoni',
      iso2: '12',
      countryId: 141,
    },
    {
      id: 3456,
      name: 'Aguascalientes',
      iso2: 'AGU',
      countryId: 142,
    },
    {
      id: 3457,
      name: 'Baja California',
      iso2: 'BCN',
      countryId: 142,
    },
    {
      id: 3460,
      name: 'Baja California Sur',
      iso2: 'BCS',
      countryId: 142,
    },
    {
      id: 3475,
      name: 'Campeche',
      iso2: 'CAM',
      countryId: 142,
    },
    {
      id: 3451,
      name: 'Chiapas',
      iso2: 'CHP',
      countryId: 142,
    },
    {
      id: 3447,
      name: 'Chihuahua',
      iso2: 'CHH',
      countryId: 142,
    },
    {
      id: 3473,
      name: 'Ciudad de México',
      iso2: 'CMX',
      countryId: 142,
    },
    {
      id: 3471,
      name: 'Coahuila de Zaragoza',
      iso2: 'COA',
      countryId: 142,
    },
    {
      id: 3472,
      name: 'Colima',
      iso2: 'COL',
      countryId: 142,
    },
    {
      id: 3453,
      name: 'Durango',
      iso2: 'DUR',
      countryId: 142,
    },
    {
      id: 3450,
      name: 'Estado de México',
      iso2: 'MEX',
      countryId: 142,
    },
    {
      id: 3469,
      name: 'Guanajuato',
      iso2: 'GUA',
      countryId: 142,
    },
    {
      id: 3459,
      name: 'Guerrero',
      iso2: 'GRO',
      countryId: 142,
    },
    {
      id: 3470,
      name: 'Hidalgo',
      iso2: 'HID',
      countryId: 142,
    },
    {
      id: 4857,
      name: 'Jalisco',
      iso2: 'JAL',
      countryId: 142,
    },
    {
      id: 3474,
      name: 'Michoacán de Ocampo',
      iso2: 'MIC',
      countryId: 142,
    },
    {
      id: 3465,
      name: 'Morelos',
      iso2: 'MOR',
      countryId: 142,
    },
    {
      id: 3477,
      name: 'Nayarit',
      iso2: 'NAY',
      countryId: 142,
    },
    {
      id: 3452,
      name: 'Nuevo León',
      iso2: 'NLE',
      countryId: 142,
    },
    {
      id: 3448,
      name: 'Oaxaca',
      iso2: 'OAX',
      countryId: 142,
    },
    {
      id: 3476,
      name: 'Puebla',
      iso2: 'PUE',
      countryId: 142,
    },
    {
      id: 3455,
      name: 'Querétaro',
      iso2: 'QUE',
      countryId: 142,
    },
    {
      id: 3467,
      name: 'Quintana Roo',
      iso2: 'ROO',
      countryId: 142,
    },
    {
      id: 3461,
      name: 'San Luis Potosí',
      iso2: 'SLP',
      countryId: 142,
    },
    {
      id: 3449,
      name: 'Sinaloa',
      iso2: 'SIN',
      countryId: 142,
    },
    {
      id: 3468,
      name: 'Sonora',
      iso2: 'SON',
      countryId: 142,
    },
    {
      id: 3454,
      name: 'Tabasco',
      iso2: 'TAB',
      countryId: 142,
    },
    {
      id: 3463,
      name: 'Tamaulipas',
      iso2: 'TAM',
      countryId: 142,
    },
    {
      id: 3458,
      name: 'Tlaxcala',
      iso2: 'TLA',
      countryId: 142,
    },
    {
      id: 3464,
      name: 'Veracruz de Ignacio de la Llave',
      iso2: 'VER',
      countryId: 142,
    },
    {
      id: 3466,
      name: 'Yucatán',
      iso2: 'YUC',
      countryId: 142,
    },
    {
      id: 3462,
      name: 'Zacatecas',
      iso2: 'ZAC',
      countryId: 142,
    },
    {
      id: 2580,
      name: 'Chuuk',
      iso2: 'TRK',
      countryId: 143,
    },
    {
      id: 2583,
      name: 'Kosrae',
      iso2: 'KSA',
      countryId: 143,
    },
    {
      id: 2581,
      name: 'Pohnpei',
      iso2: 'PNI',
      countryId: 143,
    },
    {
      id: 2582,
      name: 'Yap',
      iso2: 'YAP',
      countryId: 143,
    },
    {
      id: 4368,
      name: 'Anenii Noi',
      iso2: 'AN',
      countryId: 144,
    },
    {
      id: 4393,
      name: 'Bălți',
      iso2: 'BA',
      countryId: 144,
    },
    {
      id: 4379,
      name: 'Basarabeasca',
      iso2: 'BS',
      countryId: 144,
    },
    {
      id: 4362,
      name: 'Bender',
      iso2: 'BD',
      countryId: 144,
    },
    {
      id: 4375,
      name: 'Briceni',
      iso2: 'BR',
      countryId: 144,
    },
    {
      id: 4391,
      name: 'Cahul',
      iso2: 'CA',
      countryId: 144,
    },
    {
      id: 4366,
      name: 'Călărași',
      iso2: 'CL',
      countryId: 144,
    },
    {
      id: 4380,
      name: 'Cantemir',
      iso2: 'CT',
      countryId: 144,
    },
    {
      id: 4365,
      name: 'Căușeni',
      iso2: 'CS',
      countryId: 144,
    },
    {
      id: 4373,
      name: 'Chișinău',
      iso2: 'CU',
      countryId: 144,
    },
    {
      id: 4360,
      name: 'Cimișlia',
      iso2: 'CM',
      countryId: 144,
    },
    {
      id: 4390,
      name: 'Criuleni',
      iso2: 'CR',
      countryId: 144,
    },
    {
      id: 4384,
      name: 'Dondușeni',
      iso2: 'DO',
      countryId: 144,
    },
    {
      id: 4392,
      name: 'Drochia',
      iso2: 'DR',
      countryId: 144,
    },
    {
      id: 4383,
      name: 'Dubăsari',
      iso2: 'DU',
      countryId: 144,
    },
    {
      id: 4387,
      name: 'Edineț',
      iso2: 'ED',
      countryId: 144,
    },
    {
      id: 4381,
      name: 'Fălești',
      iso2: 'FA',
      countryId: 144,
    },
    {
      id: 4370,
      name: 'Florești',
      iso2: 'FL',
      countryId: 144,
    },
    {
      id: 4385,
      name: 'Gagauzia',
      iso2: 'GA',
      countryId: 144,
    },
    {
      id: 4367,
      name: 'Glodeni',
      iso2: 'GL',
      countryId: 144,
    },
    {
      id: 4382,
      name: 'Hîncești',
      iso2: 'HI',
      countryId: 144,
    },
    {
      id: 4369,
      name: 'Ialoveni',
      iso2: 'IA',
      countryId: 144,
    },
    {
      id: 5667,
      name: 'Leova',
      iso2: 'LE',
      countryId: 144,
    },
    {
      id: 4363,
      name: 'Nisporeni',
      iso2: 'NI',
      countryId: 144,
    },
    {
      id: 4389,
      name: 'Ocnița',
      iso2: 'OC',
      countryId: 144,
    },
    {
      id: 4361,
      name: 'Orhei',
      iso2: 'OR',
      countryId: 144,
    },
    {
      id: 4394,
      name: 'Rezina',
      iso2: 'RE',
      countryId: 144,
    },
    {
      id: 4376,
      name: 'Rîșcani',
      iso2: 'RI',
      countryId: 144,
    },
    {
      id: 4364,
      name: 'Sîngerei',
      iso2: 'SI',
      countryId: 144,
    },
    {
      id: 4388,
      name: 'Șoldănești',
      iso2: 'SD',
      countryId: 144,
    },
    {
      id: 4374,
      name: 'Soroca',
      iso2: 'SO',
      countryId: 144,
    },
    {
      id: 4378,
      name: 'Ștefan Vodă',
      iso2: 'SV',
      countryId: 144,
    },
    {
      id: 4377,
      name: 'Strășeni',
      iso2: 'ST',
      countryId: 144,
    },
    {
      id: 4372,
      name: 'Taraclia',
      iso2: 'TA',
      countryId: 144,
    },
    {
      id: 4371,
      name: 'Telenești',
      iso2: 'TE',
      countryId: 144,
    },
    {
      id: 4395,
      name: 'Transnistria',
      iso2: 'SN',
      countryId: 144,
    },
    {
      id: 4386,
      name: 'Ungheni',
      iso2: 'UN',
      countryId: 144,
    },
    {
      id: 5668,
      name: 'Fontvieille',
      iso2: 'FO',
      countryId: 145,
    },
    {
      id: 5669,
      name: 'Jardin Exotique',
      iso2: 'JE',
      countryId: 145,
    },
    {
      id: 4917,
      name: 'La Colle',
      iso2: 'CL',
      countryId: 145,
    },
    {
      id: 4918,
      name: 'La Condamine',
      iso2: 'CO',
      countryId: 145,
    },
    {
      id: 5670,
      name: 'La Gare',
      iso2: 'GA',
      countryId: 145,
    },
    {
      id: 5671,
      name: 'La Source',
      iso2: 'SO',
      countryId: 145,
    },
    {
      id: 5672,
      name: 'Larvotto',
      iso2: 'LA',
      countryId: 145,
    },
    {
      id: 5673,
      name: 'Malbousquet',
      iso2: 'MA',
      countryId: 145,
    },
    {
      id: 5674,
      name: 'Monaco-Ville',
      iso2: 'MO',
      countryId: 145,
    },
    {
      id: 4919,
      name: 'Moneghetti',
      iso2: 'MG',
      countryId: 145,
    },
    {
      id: 5675,
      name: 'Monte-Carlo',
      iso2: 'MC',
      countryId: 145,
    },
    {
      id: 5676,
      name: 'Moulins',
      iso2: 'MU',
      countryId: 145,
    },
    {
      id: 5677,
      name: 'Port-Hercule',
      iso2: 'PH',
      countryId: 145,
    },
    {
      id: 5678,
      name: 'Saint-Roman',
      iso2: 'SR',
      countryId: 145,
    },
    {
      id: 5679,
      name: 'Sainte-Dévote',
      iso2: 'SD',
      countryId: 145,
    },
    {
      id: 5680,
      name: 'Spélugues',
      iso2: 'SP',
      countryId: 145,
    },
    {
      id: 5681,
      name: 'Vallon de la Rousse',
      iso2: 'VR',
      countryId: 145,
    },
    {
      id: 1973,
      name: 'Arkhangai',
      iso2: '073',
      countryId: 146,
    },
    {
      id: 1969,
      name: 'Bayan-Ölgii',
      iso2: '071',
      countryId: 146,
    },
    {
      id: 1976,
      name: 'Bayankhongor',
      iso2: '069',
      countryId: 146,
    },
    {
      id: 1961,
      name: 'Bulgan',
      iso2: '067',
      countryId: 146,
    },
    {
      id: 1962,
      name: 'Darkhan-Uul',
      iso2: '037',
      countryId: 146,
    },
    {
      id: 1963,
      name: 'Dornod',
      iso2: '061',
      countryId: 146,
    },
    {
      id: 1981,
      name: 'Dornogovi',
      iso2: '063',
      countryId: 146,
    },
    {
      id: 1970,
      name: 'Dundgovi',
      iso2: '059',
      countryId: 146,
    },
    {
      id: 1972,
      name: 'Govi-Altai',
      iso2: '065',
      countryId: 146,
    },
    {
      id: 1978,
      name: 'Govisümber',
      iso2: '064',
      countryId: 146,
    },
    {
      id: 1974,
      name: 'Khentii',
      iso2: '039',
      countryId: 146,
    },
    {
      id: 1964,
      name: 'Khovd',
      iso2: '043',
      countryId: 146,
    },
    {
      id: 1975,
      name: 'Khövsgöl',
      iso2: '041',
      countryId: 146,
    },
    {
      id: 1967,
      name: 'Ömnögovi',
      iso2: '053',
      countryId: 146,
    },
    {
      id: 1966,
      name: 'Orkhon',
      iso2: '035',
      countryId: 146,
    },
    {
      id: 1965,
      name: 'Övörkhangai',
      iso2: '055',
      countryId: 146,
    },
    {
      id: 1980,
      name: 'Selenge',
      iso2: '049',
      countryId: 146,
    },
    {
      id: 1977,
      name: 'Sükhbaatar',
      iso2: '051',
      countryId: 146,
    },
    {
      id: 1968,
      name: 'Töv',
      iso2: '047',
      countryId: 146,
    },
    {
      id: 5453,
      name: 'Ulaanbaatar',
      iso2: '001',
      countryId: 146,
    },
    {
      id: 1971,
      name: 'Uvs',
      iso2: '046',
      countryId: 146,
    },
    {
      id: 1979,
      name: 'Zavkhan',
      iso2: '057',
      countryId: 146,
    },
    {
      id: 23,
      name: 'Andrijevica',
      iso2: '01',
      countryId: 147,
    },
    {
      id: 13,
      name: 'Bar',
      iso2: '02',
      countryId: 147,
    },
    {
      id: 21,
      name: 'Berane',
      iso2: '03',
      countryId: 147,
    },
    {
      id: 25,
      name: 'Bijelo Polje',
      iso2: '04',
      countryId: 147,
    },
    {
      id: 30,
      name: 'Budva',
      iso2: '05',
      countryId: 147,
    },
    {
      id: 14,
      name: 'Danilovgrad',
      iso2: '07',
      countryId: 147,
    },
    {
      id: 24,
      name: 'Gusinje',
      iso2: '22',
      countryId: 147,
    },
    {
      id: 5682,
      name: 'Herceg-Novi',
      iso2: '08',
      countryId: 147,
    },
    {
      id: 31,
      name: 'Kolašin',
      iso2: '09',
      countryId: 147,
    },
    {
      id: 26,
      name: 'Kotor',
      iso2: '10',
      countryId: 147,
    },
    {
      id: 22,
      name: 'Mojkovac',
      iso2: '11',
      countryId: 147,
    },
    {
      id: 17,
      name: 'Nikšić',
      iso2: '12',
      countryId: 147,
    },
    {
      id: 28,
      name: 'Old Royal Capital Cetinje',
      iso2: '06',
      countryId: 147,
    },
    {
      id: 12,
      name: 'Petnjica',
      iso2: '23',
      countryId: 147,
    },
    {
      id: 19,
      name: 'Plav',
      iso2: '13',
      countryId: 147,
    },
    {
      id: 20,
      name: 'Pljevlja',
      iso2: '14',
      countryId: 147,
    },
    {
      id: 16,
      name: 'Plužine',
      iso2: '15',
      countryId: 147,
    },
    {
      id: 27,
      name: 'Podgorica',
      iso2: '16',
      countryId: 147,
    },
    {
      id: 15,
      name: 'Rožaje',
      iso2: '17',
      countryId: 147,
    },
    {
      id: 18,
      name: 'Šavnik',
      iso2: '18',
      countryId: 147,
    },
    {
      id: 29,
      name: 'Tivat',
      iso2: '19',
      countryId: 147,
    },
    {
      id: 5683,
      name: 'Tuzi',
      iso2: '24',
      countryId: 147,
    },
    {
      id: 33,
      name: 'Ulcinj',
      iso2: '20',
      countryId: 147,
    },
    {
      id: 32,
      name: 'Žabljak',
      iso2: '21',
      countryId: 147,
    },
    {
      id: 5684,
      name: 'Zeta',
      iso2: '25',
      countryId: 147,
    },
    {
      id: 5421,
      name: 'Saint Anthony',
      iso2: '03',
      countryId: 148,
    },
    {
      id: 5420,
      name: 'Saint Georges',
      iso2: '02',
      countryId: 148,
    },
    {
      id: 5419,
      name: 'Saint Peter',
      iso2: '01',
      countryId: 148,
    },
    {
      id: 4928,
      name: 'Agadir-Ida-Ou-Tanane',
      iso2: 'AGD',
      countryId: 149,
    },
    {
      id: 3320,
      name: 'Al Haouz',
      iso2: 'HAO',
      countryId: 149,
    },
    {
      id: 3267,
      name: 'Al Hoceïma',
      iso2: 'HOC',
      countryId: 149,
    },
    {
      id: 3266,
      name: 'Aousserd (EH)',
      iso2: 'AOU',
      countryId: 149,
    },
    {
      id: 3297,
      name: 'Assa-Zag (EH-partial)',
      iso2: 'ASZ',
      countryId: 149,
    },
    {
      id: 3321,
      name: 'Azilal',
      iso2: 'AZI',
      countryId: 149,
    },
    {
      id: 3272,
      name: 'Béni Mellal',
      iso2: 'BEM',
      countryId: 149,
    },
    {
      id: 3278,
      name: 'Béni Mellal-Khénifra',
      iso2: '05',
      countryId: 149,
    },
    {
      id: 3304,
      name: 'Benslimane',
      iso2: 'BES',
      countryId: 149,
    },
    {
      id: 3285,
      name: 'Berkane',
      iso2: 'BER',
      countryId: 149,
    },
    {
      id: 4929,
      name: 'Berrechid',
      iso2: 'BRR',
      countryId: 149,
    },
    {
      id: 3275,
      name: 'Boujdour (EH)',
      iso2: 'BOD',
      countryId: 149,
    },
    {
      id: 3270,
      name: 'Boulemane',
      iso2: 'BOM',
      countryId: 149,
    },
    {
      id: 4930,
      name: 'Casablanca',
      iso2: 'CAS',
      countryId: 149,
    },
    {
      id: 3303,
      name: 'Casablanca-Settat',
      iso2: '06',
      countryId: 149,
    },
    {
      id: 3310,
      name: 'Chefchaouen',
      iso2: 'CHE',
      countryId: 149,
    },
    {
      id: 3274,
      name: 'Chichaoua',
      iso2: 'CHI',
      countryId: 149,
    },
    {
      id: 3302,
      name: 'Chtouka-Ait Baha',
      iso2: 'CHT',
      countryId: 149,
    },
    {
      id: 3306,
      name: 'Dakhla-Oued Ed-Dahab (EH)',
      iso2: '12',
      countryId: 149,
    },
    {
      id: 3290,
      name: 'Drâa-Tafilalet',
      iso2: '08',
      countryId: 149,
    },
    {
      id: 4931,
      name: 'Driouch',
      iso2: 'DRI',
      countryId: 149,
    },
    {
      id: 3291,
      name: 'El Hajeb',
      iso2: 'HAJ',
      countryId: 149,
    },
    {
      id: 3280,
      name: 'El Jadida',
      iso2: 'JDI',
      countryId: 149,
    },
    {
      id: 3309,
      name: 'El Kelâa des Sraghna',
      iso2: 'KES',
      countryId: 149,
    },
    {
      id: 3299,
      name: 'Errachidia',
      iso2: 'ERR',
      countryId: 149,
    },
    {
      id: 3292,
      name: 'Es-Semara (EH-partial)',
      iso2: 'ESM',
      countryId: 149,
    },
    {
      id: 3316,
      name: 'Essaouira',
      iso2: 'ESI',
      countryId: 149,
    },
    {
      id: 3300,
      name: 'Fahs-Anjra',
      iso2: 'FAH',
      countryId: 149,
    },
    {
      id: 4932,
      name: 'Fès',
      iso2: 'FES',
      countryId: 149,
    },
    {
      id: 3313,
      name: 'Fès-Meknès',
      iso2: '03',
      countryId: 149,
    },
    {
      id: 3301,
      name: 'Figuig',
      iso2: 'FIG',
      countryId: 149,
    },
    {
      id: 4933,
      name: 'Fquih Ben Salah',
      iso2: 'FQH',
      countryId: 149,
    },
    {
      id: 3265,
      name: 'Guelmim',
      iso2: 'GUE',
      countryId: 149,
    },
    {
      id: 3305,
      name: 'Guelmim-Oued Noun (EH-partial)',
      iso2: '10',
      countryId: 149,
    },
    {
      id: 4934,
      name: 'Guercif',
      iso2: 'GUF',
      countryId: 149,
    },
    {
      id: 3325,
      name: 'Ifrane',
      iso2: 'IFR',
      countryId: 149,
    },
    {
      id: 3294,
      name: 'Inezgane-Ait Melloul',
      iso2: 'INE',
      countryId: 149,
    },
    {
      id: 3307,
      name: 'Jerada',
      iso2: 'JRA',
      countryId: 149,
    },
    {
      id: 3308,
      name: 'Kénitra',
      iso2: 'KEN',
      countryId: 149,
    },
    {
      id: 3276,
      name: 'Khémisset',
      iso2: 'KHE',
      countryId: 149,
    },
    {
      id: 3317,
      name: 'Khénifra',
      iso2: 'KHN',
      countryId: 149,
    },
    {
      id: 3326,
      name: 'Khouribga',
      iso2: 'KHO',
      countryId: 149,
    },
    {
      id: 3271,
      name: "L'Oriental",
      iso2: '02',
      countryId: 149,
    },
    {
      id: 3293,
      name: 'Laâyoune (EH)',
      iso2: 'LAA',
      countryId: 149,
    },
    {
      id: 3298,
      name: 'Laâyoune-Sakia El Hamra (EH-partial)',
      iso2: '11',
      countryId: 149,
    },
    {
      id: 3268,
      name: 'Larache',
      iso2: 'LAR',
      countryId: 149,
    },
    {
      id: 4936,
      name: 'M’diq-Fnideq',
      iso2: 'MDF',
      countryId: 149,
    },
    {
      id: 4935,
      name: 'Marrakech',
      iso2: 'MAR',
      countryId: 149,
    },
    {
      id: 3288,
      name: 'Marrakesh-Safi',
      iso2: '07',
      countryId: 149,
    },
    {
      id: 3284,
      name: 'Médiouna',
      iso2: 'MED',
      countryId: 149,
    },
    {
      id: 4937,
      name: 'Meknès',
      iso2: 'MEK',
      countryId: 149,
    },
    {
      id: 4938,
      name: 'Midelt',
      iso2: 'MID',
      countryId: 149,
    },
    {
      id: 4939,
      name: 'Mohammadia',
      iso2: 'MOH',
      countryId: 149,
    },
    {
      id: 3315,
      name: 'Moulay Yacoub',
      iso2: 'MOU',
      countryId: 149,
    },
    {
      id: 3281,
      name: 'Nador',
      iso2: 'NAD',
      countryId: 149,
    },
    {
      id: 3287,
      name: 'Nouaceur',
      iso2: 'NOU',
      countryId: 149,
    },
    {
      id: 3269,
      name: 'Ouarzazate',
      iso2: 'OUA',
      countryId: 149,
    },
    {
      id: 3319,
      name: 'Oued Ed-Dahab (EH)',
      iso2: 'OUD',
      countryId: 149,
    },
    {
      id: 4941,
      name: 'Ouezzane',
      iso2: 'OUZ',
      countryId: 149,
    },
    {
      id: 4940,
      name: 'Oujda-Angad',
      iso2: 'OUJ',
      countryId: 149,
    },
    {
      id: 4942,
      name: 'Rabat',
      iso2: 'RAB',
      countryId: 149,
    },
    {
      id: 4927,
      name: 'Rabat-Salé-Kénitra',
      iso2: '04',
      countryId: 149,
    },
    {
      id: 4943,
      name: 'Rehamna',
      iso2: 'REH',
      countryId: 149,
    },
    {
      id: 3311,
      name: 'Safi',
      iso2: 'SAF',
      countryId: 149,
    },
    {
      id: 4944,
      name: 'Salé',
      iso2: 'SAL',
      countryId: 149,
    },
    {
      id: 3289,
      name: 'Sefrou',
      iso2: 'SEF',
      countryId: 149,
    },
    {
      id: 3282,
      name: 'Settat',
      iso2: 'SET',
      countryId: 149,
    },
    {
      id: 4945,
      name: 'Sidi Bennour',
      iso2: 'SIB',
      countryId: 149,
    },
    {
      id: 4946,
      name: 'Sidi Ifni',
      iso2: 'SIF',
      countryId: 149,
    },
    {
      id: 3279,
      name: 'Sidi Kacem',
      iso2: 'SIK',
      countryId: 149,
    },
    {
      id: 4952,
      name: 'Sidi Slimane',
      iso2: 'SIL',
      countryId: 149,
    },
    {
      id: 4947,
      name: 'Skhirate-Témara',
      iso2: 'SKH',
      countryId: 149,
    },
    {
      id: 3295,
      name: 'Souss-Massa',
      iso2: '09',
      countryId: 149,
    },
    {
      id: 3286,
      name: 'Tan-Tan (EH-partial)',
      iso2: 'TNT',
      countryId: 149,
    },
    {
      id: 4950,
      name: 'Tanger-Assilah',
      iso2: 'TNG',
      countryId: 149,
    },
    {
      id: 3324,
      name: 'Tanger-Tétouan-Al Hoceïma',
      iso2: '01',
      countryId: 149,
    },
    {
      id: 3323,
      name: 'Taounate',
      iso2: 'TAO',
      countryId: 149,
    },
    {
      id: 3322,
      name: 'Taourirt',
      iso2: 'TAI',
      countryId: 149,
    },
    {
      id: 4948,
      name: 'Tarfaya (EH-partial)',
      iso2: 'TAF',
      countryId: 149,
    },
    {
      id: 3314,
      name: 'Taroudannt',
      iso2: 'TAR',
      countryId: 149,
    },
    {
      id: 3312,
      name: 'Tata',
      iso2: 'TAT',
      countryId: 149,
    },
    {
      id: 3296,
      name: 'Taza',
      iso2: 'TAZ',
      countryId: 149,
    },
    {
      id: 3318,
      name: 'Tétouan',
      iso2: 'TET',
      countryId: 149,
    },
    {
      id: 4949,
      name: 'Tinghir',
      iso2: 'TIN',
      countryId: 149,
    },
    {
      id: 3277,
      name: 'Tiznit',
      iso2: 'TIZ',
      countryId: 149,
    },
    {
      id: 4951,
      name: 'Youssoufia',
      iso2: 'YUS',
      countryId: 149,
    },
    {
      id: 3283,
      name: 'Zagora',
      iso2: 'ZAG',
      countryId: 149,
    },
    {
      id: 3327,
      name: 'Cabo Delgado',
      iso2: 'P',
      countryId: 150,
    },
    {
      id: 3329,
      name: 'Gaza',
      iso2: 'G',
      countryId: 150,
    },
    {
      id: 3330,
      name: 'Inhambane',
      iso2: 'I',
      countryId: 150,
    },
    {
      id: 3337,
      name: 'Manica',
      iso2: 'B',
      countryId: 150,
    },
    {
      id: 3332,
      name: 'Maputo',
      iso2: 'L',
      countryId: 150,
    },
    {
      id: 3335,
      name: 'Maputo',
      iso2: 'MPM',
      countryId: 150,
    },
    {
      id: 3336,
      name: 'Nampula',
      iso2: 'N',
      countryId: 150,
    },
    {
      id: 3333,
      name: 'Niassa',
      iso2: 'A',
      countryId: 150,
    },
    {
      id: 3331,
      name: 'Sofala',
      iso2: 'S',
      countryId: 150,
    },
    {
      id: 3334,
      name: 'Tete',
      iso2: 'T',
      countryId: 150,
    },
    {
      id: 3328,
      name: 'Zambezia',
      iso2: 'Q',
      countryId: 150,
    },
    {
      id: 2142,
      name: 'Ayeyarwady',
      iso2: '07',
      countryId: 151,
    },
    {
      id: 2141,
      name: 'Bago',
      iso2: '02',
      countryId: 151,
    },
    {
      id: 2137,
      name: 'Chin',
      iso2: '14',
      countryId: 151,
    },
    {
      id: 2143,
      name: 'Kachin',
      iso2: '11',
      countryId: 151,
    },
    {
      id: 2144,
      name: 'Kayah',
      iso2: '12',
      countryId: 151,
    },
    {
      id: 2133,
      name: 'Kayin',
      iso2: '13',
      countryId: 151,
    },
    {
      id: 2136,
      name: 'Magway',
      iso2: '03',
      countryId: 151,
    },
    {
      id: 2134,
      name: 'Mandalay',
      iso2: '04',
      countryId: 151,
    },
    {
      id: 2147,
      name: 'Mon State',
      iso2: '15',
      countryId: 151,
    },
    {
      id: 2146,
      name: 'Naypyidaw',
      iso2: '18',
      countryId: 151,
    },
    {
      id: 2138,
      name: 'Rakhine',
      iso2: '16',
      countryId: 151,
    },
    {
      id: 2145,
      name: 'Sagaing',
      iso2: '01',
      countryId: 151,
    },
    {
      id: 2139,
      name: 'Shan',
      iso2: '17',
      countryId: 151,
    },
    {
      id: 2140,
      name: 'Tanintharyi',
      iso2: '05',
      countryId: 151,
    },
    {
      id: 2135,
      name: 'Yangon',
      iso2: '06',
      countryId: 151,
    },
    {
      id: 43,
      name: 'Erongo',
      iso2: 'ER',
      countryId: 152,
    },
    {
      id: 38,
      name: 'Hardap',
      iso2: 'HA',
      countryId: 152,
    },
    {
      id: 45,
      name: 'Karas',
      iso2: 'KA',
      countryId: 152,
    },
    {
      id: 36,
      name: 'Kavango East',
      iso2: 'KE',
      countryId: 152,
    },
    {
      id: 35,
      name: 'Kavango West',
      iso2: 'KW',
      countryId: 152,
    },
    {
      id: 44,
      name: 'Khomas',
      iso2: 'KH',
      countryId: 152,
    },
    {
      id: 34,
      name: 'Kunene',
      iso2: 'KU',
      countryId: 152,
    },
    {
      id: 40,
      name: 'Ohangwena',
      iso2: 'OW',
      countryId: 152,
    },
    {
      id: 41,
      name: 'Omaheke',
      iso2: 'OH',
      countryId: 152,
    },
    {
      id: 39,
      name: 'Omusati',
      iso2: 'OS',
      countryId: 152,
    },
    {
      id: 37,
      name: 'Oshana',
      iso2: 'ON',
      countryId: 152,
    },
    {
      id: 42,
      name: 'Oshikoto',
      iso2: 'OT',
      countryId: 152,
    },
    {
      id: 46,
      name: 'Otjozondjupa',
      iso2: 'OD',
      countryId: 152,
    },
    {
      id: 47,
      name: 'Zambezi',
      iso2: 'CA',
      countryId: 152,
    },
    {
      id: 4656,
      name: 'Aiwo',
      iso2: '01',
      countryId: 153,
    },
    {
      id: 4658,
      name: 'Anabar',
      iso2: '02',
      countryId: 153,
    },
    {
      id: 4667,
      name: 'Anetan',
      iso2: '03',
      countryId: 153,
    },
    {
      id: 4663,
      name: 'Anibare',
      iso2: '04',
      countryId: 153,
    },
    {
      id: 4660,
      name: 'Baiti',
      iso2: '05',
      countryId: 153,
    },
    {
      id: 4665,
      name: 'Boe',
      iso2: '06',
      countryId: 153,
    },
    {
      id: 4662,
      name: 'Buada',
      iso2: '07',
      countryId: 153,
    },
    {
      id: 4666,
      name: 'Denigomodu',
      iso2: '08',
      countryId: 153,
    },
    {
      id: 4654,
      name: 'Ewa',
      iso2: '09',
      countryId: 153,
    },
    {
      id: 4661,
      name: 'Ijuw',
      iso2: '10',
      countryId: 153,
    },
    {
      id: 4657,
      name: 'Meneng',
      iso2: '11',
      countryId: 153,
    },
    {
      id: 4659,
      name: 'Nibok',
      iso2: '12',
      countryId: 153,
    },
    {
      id: 4655,
      name: 'Uaboe',
      iso2: '13',
      countryId: 153,
    },
    {
      id: 4664,
      name: 'Yaren',
      iso2: '14',
      countryId: 153,
    },
    {
      id: 2073,
      name: 'Bagmati',
      iso2: 'P3',
      countryId: 154,
    },
    {
      id: 2069,
      name: 'Gandaki',
      iso2: 'P4',
      countryId: 154,
    },
    {
      id: 2068,
      name: 'Karnali',
      iso2: 'P6',
      countryId: 154,
    },
    {
      id: 2066,
      name: 'Koshi',
      iso2: 'P1',
      countryId: 154,
    },
    {
      id: 2067,
      name: 'Lumbini',
      iso2: 'P5',
      countryId: 154,
    },
    {
      id: 5240,
      name: 'Madhesh',
      iso2: 'P2',
      countryId: 154,
    },
    {
      id: 5241,
      name: 'Sudurpashchim',
      iso2: 'P7',
      countryId: 154,
    },
    {
      id: 2613,
      name: 'Drenthe',
      iso2: 'DR',
      countryId: 156,
    },
    {
      id: 2619,
      name: 'Flevoland',
      iso2: 'FL',
      countryId: 156,
    },
    {
      id: 2622,
      name: 'Friesland',
      iso2: 'FR',
      countryId: 156,
    },
    {
      id: 2611,
      name: 'Gelderland',
      iso2: 'GE',
      countryId: 156,
    },
    {
      id: 2617,
      name: 'Groningen',
      iso2: 'GR',
      countryId: 156,
    },
    {
      id: 2615,
      name: 'Limburg',
      iso2: 'LI',
      countryId: 156,
    },
    {
      id: 2623,
      name: 'North Brabant',
      iso2: 'NB',
      countryId: 156,
    },
    {
      id: 2612,
      name: 'North Holland',
      iso2: 'NH',
      countryId: 156,
    },
    {
      id: 2618,
      name: 'Overijssel',
      iso2: 'OV',
      countryId: 156,
    },
    {
      id: 2614,
      name: 'South Holland',
      iso2: 'ZH',
      countryId: 156,
    },
    {
      id: 2610,
      name: 'Utrecht',
      iso2: 'UT',
      countryId: 156,
    },
    {
      id: 2620,
      name: 'Zeeland',
      iso2: 'ZE',
      countryId: 156,
    },
    {
      id: 5227,
      name: 'Loyalty Islands Province',
      iso2: '03',
      countryId: 157,
    },
    {
      id: 5226,
      name: 'North Province',
      iso2: '02',
      countryId: 157,
    },
    {
      id: 5225,
      name: 'South Province',
      iso2: '01',
      countryId: 157,
    },
    {
      id: 4072,
      name: 'Auckland',
      iso2: 'AUK',
      countryId: 158,
    },
    {
      id: 4074,
      name: 'Bay of Plenty',
      iso2: 'BOP',
      countryId: 158,
    },
    {
      id: 4066,
      name: 'Canterbury',
      iso2: 'CAN',
      countryId: 158,
    },
    {
      id: 4067,
      name: 'Chatham Islands',
      iso2: 'CIT',
      countryId: 158,
    },
    {
      id: 4068,
      name: 'Gisborne',
      iso2: 'GIS',
      countryId: 158,
    },
    {
      id: 4075,
      name: "Hawke's Bay",
      iso2: 'HKB',
      countryId: 158,
    },
    {
      id: 4060,
      name: 'Manawatu-Whanganui',
      iso2: 'MWT',
      countryId: 158,
    },
    {
      id: 4063,
      name: 'Marlborough',
      iso2: 'MBH',
      countryId: 158,
    },
    {
      id: 4070,
      name: 'Nelson',
      iso2: 'NSN',
      countryId: 158,
    },
    {
      id: 4059,
      name: 'Northland',
      iso2: 'NTL',
      countryId: 158,
    },
    {
      id: 4062,
      name: 'Otago',
      iso2: 'OTA',
      countryId: 158,
    },
    {
      id: 4071,
      name: 'Southland',
      iso2: 'STL',
      countryId: 158,
    },
    {
      id: 4069,
      name: 'Taranaki',
      iso2: 'TKI',
      countryId: 158,
    },
    {
      id: 4073,
      name: 'Tasman',
      iso2: 'TAS',
      countryId: 158,
    },
    {
      id: 4061,
      name: 'Waikato',
      iso2: 'WKO',
      countryId: 158,
    },
    {
      id: 4065,
      name: 'Wellington',
      iso2: 'WGN',
      countryId: 158,
    },
    {
      id: 4064,
      name: 'West Coast',
      iso2: 'WTC',
      countryId: 158,
    },
    {
      id: 946,
      name: 'Boaco',
      iso2: 'BO',
      countryId: 159,
    },
    {
      id: 950,
      name: 'Carazo',
      iso2: 'CA',
      countryId: 159,
    },
    {
      id: 954,
      name: 'Chinandega',
      iso2: 'CI',
      countryId: 159,
    },
    {
      id: 940,
      name: 'Chontales',
      iso2: 'CO',
      countryId: 159,
    },
    {
      id: 945,
      name: 'Estelí',
      iso2: 'ES',
      countryId: 159,
    },
    {
      id: 943,
      name: 'Granada',
      iso2: 'GR',
      countryId: 159,
    },
    {
      id: 955,
      name: 'Jinotega',
      iso2: 'JI',
      countryId: 159,
    },
    {
      id: 944,
      name: 'León',
      iso2: 'LE',
      countryId: 159,
    },
    {
      id: 948,
      name: 'Madriz',
      iso2: 'MD',
      countryId: 159,
    },
    {
      id: 941,
      name: 'Managua',
      iso2: 'MN',
      countryId: 159,
    },
    {
      id: 953,
      name: 'Masaya',
      iso2: 'MS',
      countryId: 159,
    },
    {
      id: 947,
      name: 'Matagalpa',
      iso2: 'MT',
      countryId: 159,
    },
    {
      id: 951,
      name: 'North Caribbean Coast',
      iso2: 'AN',
      countryId: 159,
    },
    {
      id: 4964,
      name: 'Nueva Segovia',
      iso2: 'NS',
      countryId: 159,
    },
    {
      id: 949,
      name: 'Río San Juan',
      iso2: 'SJ',
      countryId: 159,
    },
    {
      id: 942,
      name: 'Rivas',
      iso2: 'RI',
      countryId: 159,
    },
    {
      id: 952,
      name: 'South Caribbean Coast',
      iso2: 'AS',
      countryId: 159,
    },
    {
      id: 71,
      name: 'Agadez',
      iso2: '1',
      countryId: 160,
    },
    {
      id: 72,
      name: 'Diffa',
      iso2: '2',
      countryId: 160,
    },
    {
      id: 68,
      name: 'Dosso',
      iso2: '3',
      countryId: 160,
    },
    {
      id: 70,
      name: 'Maradi',
      iso2: '4',
      countryId: 160,
    },
    {
      id: 5685,
      name: 'Niamey',
      iso2: '8',
      countryId: 160,
    },
    {
      id: 73,
      name: 'Tahoua',
      iso2: '5',
      countryId: 160,
    },
    {
      id: 67,
      name: 'Tillabéri',
      iso2: '6',
      countryId: 160,
    },
    {
      id: 69,
      name: 'Zinder',
      iso2: '7',
      countryId: 160,
    },
    {
      id: 303,
      name: 'Abia',
      iso2: 'AB',
      countryId: 161,
    },
    {
      id: 293,
      name: 'Abuja Federal Capital Territory',
      iso2: 'FC',
      countryId: 161,
    },
    {
      id: 320,
      name: 'Adamawa',
      iso2: 'AD',
      countryId: 161,
    },
    {
      id: 304,
      name: 'Akwa Ibom',
      iso2: 'AK',
      countryId: 161,
    },
    {
      id: 315,
      name: 'Anambra',
      iso2: 'AN',
      countryId: 161,
    },
    {
      id: 312,
      name: 'Bauchi',
      iso2: 'BA',
      countryId: 161,
    },
    {
      id: 305,
      name: 'Bayelsa',
      iso2: 'BY',
      countryId: 161,
    },
    {
      id: 291,
      name: 'Benue',
      iso2: 'BE',
      countryId: 161,
    },
    {
      id: 307,
      name: 'Borno',
      iso2: 'BO',
      countryId: 161,
    },
    {
      id: 314,
      name: 'Cross River',
      iso2: 'CR',
      countryId: 161,
    },
    {
      id: 316,
      name: 'Delta',
      iso2: 'DE',
      countryId: 161,
    },
    {
      id: 311,
      name: 'Ebonyi',
      iso2: 'EB',
      countryId: 161,
    },
    {
      id: 318,
      name: 'Edo',
      iso2: 'ED',
      countryId: 161,
    },
    {
      id: 309,
      name: 'Ekiti',
      iso2: 'EK',
      countryId: 161,
    },
    {
      id: 289,
      name: 'Enugu',
      iso2: 'EN',
      countryId: 161,
    },
    {
      id: 310,
      name: 'Gombe',
      iso2: 'GO',
      countryId: 161,
    },
    {
      id: 308,
      name: 'Imo',
      iso2: 'IM',
      countryId: 161,
    },
    {
      id: 288,
      name: 'Jigawa',
      iso2: 'JI',
      countryId: 161,
    },
    {
      id: 294,
      name: 'Kaduna',
      iso2: 'KD',
      countryId: 161,
    },
    {
      id: 300,
      name: 'Kano',
      iso2: 'KN',
      countryId: 161,
    },
    {
      id: 313,
      name: 'Katsina',
      iso2: 'KT',
      countryId: 161,
    },
    {
      id: 290,
      name: 'Kebbi',
      iso2: 'KE',
      countryId: 161,
    },
    {
      id: 298,
      name: 'Kogi',
      iso2: 'KO',
      countryId: 161,
    },
    {
      id: 295,
      name: 'Kwara',
      iso2: 'KW',
      countryId: 161,
    },
    {
      id: 306,
      name: 'Lagos',
      iso2: 'LA',
      countryId: 161,
    },
    {
      id: 301,
      name: 'Nasarawa',
      iso2: 'NA',
      countryId: 161,
    },
    {
      id: 317,
      name: 'Niger',
      iso2: 'NI',
      countryId: 161,
    },
    {
      id: 323,
      name: 'Ogun',
      iso2: 'OG',
      countryId: 161,
    },
    {
      id: 321,
      name: 'Ondo',
      iso2: 'ON',
      countryId: 161,
    },
    {
      id: 322,
      name: 'Osun',
      iso2: 'OS',
      countryId: 161,
    },
    {
      id: 296,
      name: 'Oyo',
      iso2: 'OY',
      countryId: 161,
    },
    {
      id: 302,
      name: 'Plateau',
      iso2: 'PL',
      countryId: 161,
    },
    {
      id: 4926,
      name: 'Rivers',
      iso2: 'RI',
      countryId: 161,
    },
    {
      id: 292,
      name: 'Sokoto',
      iso2: 'SO',
      countryId: 161,
    },
    {
      id: 319,
      name: 'Taraba',
      iso2: 'TA',
      countryId: 161,
    },
    {
      id: 297,
      name: 'Yobe',
      iso2: 'YO',
      countryId: 161,
    },
    {
      id: 299,
      name: 'Zamfara',
      iso2: 'ZA',
      countryId: 161,
    },
    {
      id: 5435,
      name: 'Alofi North',
      iso2: '14',
      countryId: 162,
    },
    {
      id: 5434,
      name: 'Alofi South',
      iso2: '13',
      countryId: 162,
    },
    {
      id: 5432,
      name: 'Avatele',
      iso2: '11',
      countryId: 162,
    },
    {
      id: 5430,
      name: 'Hakupu',
      iso2: '09',
      countryId: 162,
    },
    {
      id: 5425,
      name: 'Hikutavake',
      iso2: '04',
      countryId: 162,
    },
    {
      id: 5428,
      name: 'Lakepa',
      iso2: '07',
      countryId: 162,
    },
    {
      id: 5429,
      name: 'Liku',
      iso2: '08',
      countryId: 162,
    },
    {
      id: 5422,
      name: 'Makefu',
      iso2: '01',
      countryId: 162,
    },
    {
      id: 5427,
      name: 'Mutalau',
      iso2: '06',
      countryId: 162,
    },
    {
      id: 5424,
      name: 'Namukulu',
      iso2: '03',
      countryId: 162,
    },
    {
      id: 5433,
      name: 'Tamakautoga',
      iso2: '12',
      countryId: 162,
    },
    {
      id: 5426,
      name: 'Toi',
      iso2: '05',
      countryId: 162,
    },
    {
      id: 5423,
      name: 'Tuapa',
      iso2: '02',
      countryId: 162,
    },
    {
      id: 5431,
      name: 'Vaiea',
      iso2: '10',
      countryId: 162,
    },
    {
      id: 3998,
      name: 'Chagang',
      iso2: '04',
      countryId: 115,
    },
    {
      id: 5719,
      name: 'Kaesong',
      iso2: '15',
      countryId: 115,
    },
    {
      id: 3999,
      name: 'Kangwon',
      iso2: '07',
      countryId: 115,
    },
    {
      id: 5718,
      name: 'Nampho',
      iso2: '14',
      countryId: 115,
    },
    {
      id: 3995,
      name: 'North Hamgyong',
      iso2: '09',
      countryId: 115,
    },
    {
      id: 4004,
      name: 'North Hwanghae',
      iso2: '06',
      countryId: 115,
    },
    {
      id: 4002,
      name: 'North Pyongan',
      iso2: '03',
      countryId: 115,
    },
    {
      id: 4005,
      name: 'Pyongyang',
      iso2: '01',
      countryId: 115,
    },
    {
      id: 4001,
      name: 'Rason',
      iso2: '13',
      countryId: 115,
    },
    {
      id: 3996,
      name: 'Ryanggang',
      iso2: '10',
      countryId: 115,
    },
    {
      id: 4000,
      name: 'South Hamgyong',
      iso2: '08',
      countryId: 115,
    },
    {
      id: 4003,
      name: 'South Hwanghae',
      iso2: '05',
      countryId: 115,
    },
    {
      id: 3997,
      name: 'South Pyongan',
      iso2: '02',
      countryId: 115,
    },
    {
      id: 703,
      name: 'Aerodrom',
      iso2: '801',
      countryId: 129,
    },
    {
      id: 656,
      name: 'Aračinovo',
      iso2: '802',
      countryId: 129,
    },
    {
      id: 716,
      name: 'Berovo',
      iso2: '201',
      countryId: 129,
    },
    {
      id: 679,
      name: 'Bitola',
      iso2: '501',
      countryId: 129,
    },
    {
      id: 649,
      name: 'Bogdanci',
      iso2: '401',
      countryId: 129,
    },
    {
      id: 721,
      name: 'Bogovinje',
      iso2: '601',
      countryId: 129,
    },
    {
      id: 652,
      name: 'Bosilovo',
      iso2: '402',
      countryId: 129,
    },
    {
      id: 660,
      name: 'Brvenica',
      iso2: '602',
      countryId: 129,
    },
    {
      id: 694,
      name: 'Butel',
      iso2: '803',
      countryId: 129,
    },
    {
      id: 704,
      name: 'Čair',
      iso2: '815',
      countryId: 129,
    },
    {
      id: 676,
      name: 'Čaška',
      iso2: '109',
      countryId: 129,
    },
    {
      id: 702,
      name: 'Centar',
      iso2: '814',
      countryId: 129,
    },
    {
      id: 720,
      name: 'Centar Župa',
      iso2: '313',
      countryId: 129,
    },
    {
      id: 644,
      name: 'Češinovo-Obleševo',
      iso2: '210',
      countryId: 129,
    },
    {
      id: 715,
      name: 'Čučer-Sandevo',
      iso2: '816',
      countryId: 129,
    },
    {
      id: 5726,
      name: 'Debar',
      iso2: '303',
      countryId: 129,
    },
    {
      id: 645,
      name: 'Debarca',
      iso2: '304',
      countryId: 129,
    },
    {
      id: 695,
      name: 'Delčevo',
      iso2: '203',
      countryId: 129,
    },
    {
      id: 687,
      name: 'Demir Hisar',
      iso2: '502',
      countryId: 129,
    },
    {
      id: 655,
      name: 'Demir Kapija',
      iso2: '103',
      countryId: 129,
    },
    {
      id: 697,
      name: 'Dojran',
      iso2: '406',
      countryId: 129,
    },
    {
      id: 675,
      name: 'Dolneni',
      iso2: '503',
      countryId: 129,
    },
    {
      id: 707,
      name: 'Gazi Baba',
      iso2: '804',
      countryId: 129,
    },
    {
      id: 648,
      name: 'Gevgelija',
      iso2: '405',
      countryId: 129,
    },
    {
      id: 722,
      name: 'Gjorče Petrov',
      iso2: '805',
      countryId: 129,
    },
    {
      id: 693,
      name: 'Gostivar',
      iso2: '604',
      countryId: 129,
    },
    {
      id: 708,
      name: 'Gradsko',
      iso2: '102',
      countryId: 129,
    },
    {
      id: 690,
      name: 'Ilinden',
      iso2: '807',
      countryId: 129,
    },
    {
      id: 678,
      name: 'Jegunovce',
      iso2: '606',
      countryId: 129,
    },
    {
      id: 674,
      name: 'Karbinci',
      iso2: '205',
      countryId: 129,
    },
    {
      id: 681,
      name: 'Karpoš',
      iso2: '808',
      countryId: 129,
    },
    {
      id: 713,
      name: 'Kavadarci',
      iso2: '104',
      countryId: 129,
    },
    {
      id: 688,
      name: 'Kičevo',
      iso2: '307',
      countryId: 129,
    },
    {
      id: 686,
      name: 'Kisela Voda',
      iso2: '809',
      countryId: 129,
    },
    {
      id: 723,
      name: 'Kočani',
      iso2: '206',
      countryId: 129,
    },
    {
      id: 665,
      name: 'Konče',
      iso2: '407',
      countryId: 129,
    },
    {
      id: 641,
      name: 'Kratovo',
      iso2: '701',
      countryId: 129,
    },
    {
      id: 677,
      name: 'Kriva Palanka',
      iso2: '702',
      countryId: 129,
    },
    {
      id: 647,
      name: 'Krivogaštani',
      iso2: '504',
      countryId: 129,
    },
    {
      id: 714,
      name: 'Kruševo',
      iso2: '505',
      countryId: 129,
    },
    {
      id: 683,
      name: 'Kumanovo',
      iso2: '703',
      countryId: 129,
    },
    {
      id: 659,
      name: 'Lipkovo',
      iso2: '704',
      countryId: 129,
    },
    {
      id: 705,
      name: 'Lozovo',
      iso2: '105',
      countryId: 129,
    },
    {
      id: 701,
      name: 'Makedonska Kamenica',
      iso2: '207',
      countryId: 129,
    },
    {
      id: 692,
      name: 'Makedonski Brod',
      iso2: '308',
      countryId: 129,
    },
    {
      id: 669,
      name: 'Mavrovo and Rostuša',
      iso2: '607',
      countryId: 129,
    },
    {
      id: 653,
      name: 'Mogila',
      iso2: '506',
      countryId: 129,
    },
    {
      id: 664,
      name: 'Negotino',
      iso2: '106',
      countryId: 129,
    },
    {
      id: 696,
      name: 'Novaci',
      iso2: '507',
      countryId: 129,
    },
    {
      id: 718,
      name: 'Novo Selo',
      iso2: '408',
      countryId: 129,
    },
    {
      id: 699,
      name: 'Ohrid',
      iso2: '310',
      countryId: 129,
    },
    {
      id: 685,
      name: 'Pehčevo',
      iso2: '208',
      countryId: 129,
    },
    {
      id: 698,
      name: 'Petrovec',
      iso2: '810',
      countryId: 129,
    },
    {
      id: 670,
      name: 'Plasnica',
      iso2: '311',
      countryId: 129,
    },
    {
      id: 666,
      name: 'Prilep',
      iso2: '508',
      countryId: 129,
    },
    {
      id: 646,
      name: 'Probištip',
      iso2: '209',
      countryId: 129,
    },
    {
      id: 709,
      name: 'Radoviš',
      iso2: '409',
      countryId: 129,
    },
    {
      id: 717,
      name: 'Rankovce',
      iso2: '705',
      countryId: 129,
    },
    {
      id: 712,
      name: 'Resen',
      iso2: '509',
      countryId: 129,
    },
    {
      id: 691,
      name: 'Rosoman',
      iso2: '107',
      countryId: 129,
    },
    {
      id: 667,
      name: 'Saraj',
      iso2: '811',
      countryId: 129,
    },
    {
      id: 719,
      name: 'Sopište',
      iso2: '812',
      countryId: 129,
    },
    {
      id: 643,
      name: 'Staro Nagoričane',
      iso2: '706',
      countryId: 129,
    },
    {
      id: 661,
      name: 'Štip',
      iso2: '211',
      countryId: 129,
    },
    {
      id: 700,
      name: 'Struga',
      iso2: '312',
      countryId: 129,
    },
    {
      id: 710,
      name: 'Strumica',
      iso2: '410',
      countryId: 129,
    },
    {
      id: 711,
      name: 'Studeničani',
      iso2: '813',
      countryId: 129,
    },
    {
      id: 680,
      name: 'Šuto Orizari',
      iso2: '817',
      countryId: 129,
    },
    {
      id: 640,
      name: 'Sveti Nikole',
      iso2: '108',
      countryId: 129,
    },
    {
      id: 654,
      name: 'Tearce',
      iso2: '608',
      countryId: 129,
    },
    {
      id: 663,
      name: 'Tetovo',
      iso2: '609',
      countryId: 129,
    },
    {
      id: 671,
      name: 'Valandovo',
      iso2: '403',
      countryId: 129,
    },
    {
      id: 658,
      name: 'Vasilevo',
      iso2: '404',
      countryId: 129,
    },
    {
      id: 651,
      name: 'Veles',
      iso2: '101',
      countryId: 129,
    },
    {
      id: 662,
      name: 'Vevčani',
      iso2: '301',
      countryId: 129,
    },
    {
      id: 672,
      name: 'Vinica',
      iso2: '202',
      countryId: 129,
    },
    {
      id: 689,
      name: 'Vrapčište',
      iso2: '603',
      countryId: 129,
    },
    {
      id: 706,
      name: 'Zelenikovo',
      iso2: '806',
      countryId: 129,
    },
    {
      id: 668,
      name: 'Želino',
      iso2: '605',
      countryId: 129,
    },
    {
      id: 673,
      name: 'Zrnovci',
      iso2: '204',
      countryId: 129,
    },
    {
      id: 1014,
      name: 'Agder',
      iso2: '42',
      countryId: 165,
    },
    {
      id: 5448,
      name: 'Akershus',
      iso2: '32',
      countryId: 165,
    },
    {
      id: 5449,
      name: 'Buskerud',
      iso2: '33',
      countryId: 165,
    },
    {
      id: 1015,
      name: 'Finnmark',
      iso2: '56',
      countryId: 165,
    },
    {
      id: 1009,
      name: 'Innlandet',
      iso2: '34',
      countryId: 165,
    },
    {
      id: 1026,
      name: 'Jan Mayen',
      iso2: '22',
      countryId: 165,
    },
    {
      id: 1020,
      name: 'Møre og Romsdal',
      iso2: '15',
      countryId: 165,
    },
    {
      id: 1025,
      name: 'Nordland',
      iso2: '18',
      countryId: 165,
    },
    {
      id: 1007,
      name: 'Oslo',
      iso2: '03',
      countryId: 165,
    },
    {
      id: 5450,
      name: 'Østfold',
      iso2: '31',
      countryId: 165,
    },
    {
      id: 1021,
      name: 'Rogaland',
      iso2: '11',
      countryId: 165,
    },
    {
      id: 1013,
      name: 'Svalbard',
      iso2: '21',
      countryId: 165,
    },
    {
      id: 1024,
      name: 'Telemark',
      iso2: '40',
      countryId: 165,
    },
    {
      id: 5451,
      name: 'Troms',
      iso2: '55',
      countryId: 165,
    },
    {
      id: 1006,
      name: 'Trøndelag',
      iso2: '50',
      countryId: 165,
    },
    {
      id: 5452,
      name: 'Vestfold',
      iso2: '39',
      countryId: 165,
    },
    {
      id: 1018,
      name: 'Vestland',
      iso2: '46',
      countryId: 165,
    },
    {
      id: 3058,
      name: 'Ad Dakhiliyah',
      iso2: 'DA',
      countryId: 166,
    },
    {
      id: 3047,
      name: 'Ad Dhahirah',
      iso2: 'ZA',
      countryId: 166,
    },
    {
      id: 3048,
      name: 'Al Batinah North',
      iso2: 'BS',
      countryId: 166,
    },
    {
      id: 3049,
      name: 'Al Batinah South',
      iso2: 'BJ',
      countryId: 166,
    },
    {
      id: 3059,
      name: 'Al Buraimi',
      iso2: 'BU',
      countryId: 166,
    },
    {
      id: 3056,
      name: 'Al Wusta',
      iso2: 'WU',
      countryId: 166,
    },
    {
      id: 3053,
      name: 'Ash Sharqiyah North',
      iso2: 'SS',
      countryId: 166,
    },
    {
      id: 3054,
      name: 'Ash Sharqiyah South',
      iso2: 'SJ',
      countryId: 166,
    },
    {
      id: 3057,
      name: 'Dhofar',
      iso2: 'ZU',
      countryId: 166,
    },
    {
      id: 3052,
      name: 'Musandam',
      iso2: 'MU',
      countryId: 166,
    },
    {
      id: 3055,
      name: 'Muscat',
      iso2: 'MA',
      countryId: 166,
    },
    {
      id: 3172,
      name: 'Azad Kashmir',
      iso2: 'JK',
      countryId: 167,
    },
    {
      id: 3174,
      name: 'Balochistan',
      iso2: 'BA',
      countryId: 167,
    },
    {
      id: 3170,
      name: 'Gilgit-Baltistan',
      iso2: 'GB',
      countryId: 167,
    },
    {
      id: 3169,
      name: 'Islamabad',
      iso2: 'IS',
      countryId: 167,
    },
    {
      id: 3171,
      name: 'Khyber Pakhtunkhwa',
      iso2: 'KP',
      countryId: 167,
    },
    {
      id: 3176,
      name: 'Punjab',
      iso2: 'PB',
      countryId: 167,
    },
    {
      id: 3175,
      name: 'Sindh',
      iso2: 'SD',
      countryId: 167,
    },
    {
      id: 4540,
      name: 'Aimeliik',
      iso2: '002',
      countryId: 168,
    },
    {
      id: 4528,
      name: 'Airai',
      iso2: '004',
      countryId: 168,
    },
    {
      id: 4538,
      name: 'Angaur',
      iso2: '010',
      countryId: 168,
    },
    {
      id: 4529,
      name: 'Hatohobei',
      iso2: '050',
      countryId: 168,
    },
    {
      id: 4539,
      name: 'Kayangel',
      iso2: '100',
      countryId: 168,
    },
    {
      id: 4532,
      name: 'Koror',
      iso2: '150',
      countryId: 168,
    },
    {
      id: 4530,
      name: 'Melekeok',
      iso2: '212',
      countryId: 168,
    },
    {
      id: 4537,
      name: 'Ngaraard',
      iso2: '214',
      countryId: 168,
    },
    {
      id: 4533,
      name: 'Ngarchelong',
      iso2: '218',
      countryId: 168,
    },
    {
      id: 4527,
      name: 'Ngardmau',
      iso2: '222',
      countryId: 168,
    },
    {
      id: 4531,
      name: 'Ngatpang',
      iso2: '224',
      countryId: 168,
    },
    {
      id: 4536,
      name: 'Ngchesar',
      iso2: '226',
      countryId: 168,
    },
    {
      id: 4541,
      name: 'Ngeremlengui',
      iso2: '227',
      countryId: 168,
    },
    {
      id: 4534,
      name: 'Ngiwal',
      iso2: '228',
      countryId: 168,
    },
    {
      id: 4526,
      name: 'Peleliu',
      iso2: '350',
      countryId: 168,
    },
    {
      id: 4535,
      name: 'Sonsorol',
      iso2: '370',
      countryId: 168,
    },
    {
      id: 5118,
      name: 'Bethlehem',
      iso2: 'BTH',
      countryId: 169,
    },
    {
      id: 5119,
      name: 'Deir El Balah',
      iso2: 'DEB',
      countryId: 169,
    },
    {
      id: 5120,
      name: 'Gaza',
      iso2: 'GZA',
      countryId: 169,
    },
    {
      id: 5121,
      name: 'Hebron',
      iso2: 'HBN',
      countryId: 169,
    },
    {
      id: 5122,
      name: 'Jenin',
      iso2: 'JEN',
      countryId: 169,
    },
    {
      id: 5123,
      name: 'Jericho ',
      iso2: 'JRH',
      countryId: 169,
    },
    {
      id: 5124,
      name: 'Jerusalem (Quds)',
      iso2: 'JEM',
      countryId: 169,
    },
    {
      id: 5125,
      name: 'Khan Yunis',
      iso2: 'KYS',
      countryId: 169,
    },
    {
      id: 5126,
      name: 'Nablus',
      iso2: 'NBS',
      countryId: 169,
    },
    {
      id: 5127,
      name: 'North Gaza',
      iso2: 'NGZ',
      countryId: 169,
    },
    {
      id: 5128,
      name: 'Qalqilya',
      iso2: 'QQA',
      countryId: 169,
    },
    {
      id: 5129,
      name: 'Rafah',
      iso2: 'RFH',
      countryId: 169,
    },
    {
      id: 5130,
      name: 'Ramallah',
      iso2: 'RBH',
      countryId: 169,
    },
    {
      id: 5131,
      name: 'Salfit',
      iso2: 'SLT',
      countryId: 169,
    },
    {
      id: 5132,
      name: 'Tubas',
      iso2: 'TBS',
      countryId: 169,
    },
    {
      id: 5133,
      name: 'Tulkarm',
      iso2: 'TKM',
      countryId: 169,
    },
    {
      id: 1393,
      name: 'Bocas del Toro',
      iso2: '1',
      countryId: 170,
    },
    {
      id: 1397,
      name: 'Chiriquí Province',
      iso2: '4',
      countryId: 170,
    },
    {
      id: 1387,
      name: 'Coclé',
      iso2: '2',
      countryId: 170,
    },
    {
      id: 1386,
      name: 'Colón',
      iso2: '3',
      countryId: 170,
    },
    {
      id: 1385,
      name: 'Darién',
      iso2: '5',
      countryId: 170,
    },
    {
      id: 1396,
      name: 'Emberá-Wounaan Comarca',
      iso2: 'EM',
      countryId: 170,
    },
    {
      id: 1388,
      name: 'Guna',
      iso2: 'KY',
      countryId: 170,
    },
    {
      id: 1389,
      name: 'Herrera',
      iso2: '6',
      countryId: 170,
    },
    {
      id: 1390,
      name: 'Los Santos',
      iso2: '7',
      countryId: 170,
    },
    {
      id: 5686,
      name: 'Naso Tjër Di',
      iso2: 'NT',
      countryId: 170,
    },
    {
      id: 1391,
      name: 'Ngöbe-Buglé Comarca',
      iso2: 'NB',
      countryId: 170,
    },
    {
      id: 1395,
      name: 'Panamá',
      iso2: '8',
      countryId: 170,
    },
    {
      id: 1394,
      name: 'Panamá Oeste',
      iso2: '10',
      countryId: 170,
    },
    {
      id: 1392,
      name: 'Veraguas',
      iso2: '9',
      countryId: 170,
    },
    {
      id: 4831,
      name: 'Bougainville',
      iso2: 'NSB',
      countryId: 171,
    },
    {
      id: 4847,
      name: 'Central',
      iso2: 'CPM',
      countryId: 171,
    },
    {
      id: 4846,
      name: 'Chimbu',
      iso2: 'CPK',
      countryId: 171,
    },
    {
      id: 4834,
      name: 'East New Britain',
      iso2: 'EBR',
      countryId: 171,
    },
    {
      id: 5228,
      name: 'East Sepik',
      iso2: 'ESW',
      countryId: 171,
    },
    {
      id: 4845,
      name: 'Eastern Highlands',
      iso2: 'EHG',
      countryId: 171,
    },
    {
      id: 4848,
      name: 'Enga',
      iso2: 'EPW',
      countryId: 171,
    },
    {
      id: 4839,
      name: 'Gulf',
      iso2: 'GPK',
      countryId: 171,
    },
    {
      id: 4833,
      name: 'Hela',
      iso2: 'HLA',
      countryId: 171,
    },
    {
      id: 4832,
      name: 'Jiwaka',
      iso2: 'JWK',
      countryId: 171,
    },
    {
      id: 4843,
      name: 'Madang',
      iso2: 'MPM',
      countryId: 171,
    },
    {
      id: 4842,
      name: 'Manus',
      iso2: 'MRL',
      countryId: 171,
    },
    {
      id: 4849,
      name: 'Milne Bay',
      iso2: 'MBA',
      countryId: 171,
    },
    {
      id: 4835,
      name: 'Morobe',
      iso2: 'MPL',
      countryId: 171,
    },
    {
      id: 4841,
      name: 'New Ireland',
      iso2: 'NIK',
      countryId: 171,
    },
    {
      id: 4838,
      name: 'Oro',
      iso2: 'NPP',
      countryId: 171,
    },
    {
      id: 4837,
      name: 'Port Moresby',
      iso2: 'NCD',
      countryId: 171,
    },
    {
      id: 4836,
      name: 'Sandaun',
      iso2: 'SAN',
      countryId: 171,
    },
    {
      id: 4844,
      name: 'Southern Highlands',
      iso2: 'SHM',
      countryId: 171,
    },
    {
      id: 4830,
      name: 'West New Britain',
      iso2: 'WBK',
      countryId: 171,
    },
    {
      id: 4850,
      name: 'Western',
      iso2: 'WPD',
      countryId: 171,
    },
    {
      id: 4840,
      name: 'Western Highlands',
      iso2: 'WHM',
      countryId: 171,
    },
    {
      id: 2785,
      name: 'Alto Paraguay',
      iso2: '16',
      countryId: 172,
    },
    {
      id: 2784,
      name: 'Alto Paraná',
      iso2: '10',
      countryId: 172,
    },
    {
      id: 2782,
      name: 'Amambay',
      iso2: '13',
      countryId: 172,
    },
    {
      id: 5221,
      name: 'Asuncion',
      iso2: 'ASU',
      countryId: 172,
    },
    {
      id: 2780,
      name: 'Boquerón',
      iso2: '19',
      countryId: 172,
    },
    {
      id: 2773,
      name: 'Caaguazú',
      iso2: '5',
      countryId: 172,
    },
    {
      id: 2775,
      name: 'Caazapá',
      iso2: '6',
      countryId: 172,
    },
    {
      id: 2771,
      name: 'Canindeyú',
      iso2: '14',
      countryId: 172,
    },
    {
      id: 2777,
      name: 'Central',
      iso2: '11',
      countryId: 172,
    },
    {
      id: 2779,
      name: 'Concepción',
      iso2: '1',
      countryId: 172,
    },
    {
      id: 2783,
      name: 'Cordillera',
      iso2: '3',
      countryId: 172,
    },
    {
      id: 2772,
      name: 'Guairá',
      iso2: '4',
      countryId: 172,
    },
    {
      id: 2778,
      name: 'Itapúa',
      iso2: '7',
      countryId: 172,
    },
    {
      id: 2786,
      name: 'Misiones',
      iso2: '8',
      countryId: 172,
    },
    {
      id: 2781,
      name: 'Ñeembucú',
      iso2: '12',
      countryId: 172,
    },
    {
      id: 2774,
      name: 'Paraguarí',
      iso2: '9',
      countryId: 172,
    },
    {
      id: 2770,
      name: 'Presidente Hayes',
      iso2: '15',
      countryId: 172,
    },
    {
      id: 2776,
      name: 'San Pedro',
      iso2: '2',
      countryId: 172,
    },
    {
      id: 3685,
      name: 'Amazonas',
      iso2: 'AMA',
      countryId: 173,
    },
    {
      id: 3680,
      name: 'Áncash',
      iso2: 'ANC',
      countryId: 173,
    },
    {
      id: 3699,
      name: 'Apurímac',
      iso2: 'APU',
      countryId: 173,
    },
    {
      id: 3681,
      name: 'Arequipa',
      iso2: 'ARE',
      countryId: 173,
    },
    {
      id: 3692,
      name: 'Ayacucho',
      iso2: 'AYA',
      countryId: 173,
    },
    {
      id: 3688,
      name: 'Cajamarca',
      iso2: 'CAJ',
      countryId: 173,
    },
    {
      id: 3701,
      name: 'Callao',
      iso2: 'CAL',
      countryId: 173,
    },
    {
      id: 3691,
      name: 'Cusco',
      iso2: 'CUS',
      countryId: 173,
    },
    {
      id: 3679,
      name: 'Huancavelica',
      iso2: 'HUV',
      countryId: 173,
    },
    {
      id: 3687,
      name: 'Huanuco',
      iso2: 'HUC',
      countryId: 173,
    },
    {
      id: 3700,
      name: 'Ica',
      iso2: 'ICA',
      countryId: 173,
    },
    {
      id: 3693,
      name: 'Junín',
      iso2: 'JUN',
      countryId: 173,
    },
    {
      id: 3683,
      name: 'La Libertad',
      iso2: 'LAL',
      countryId: 173,
    },
    {
      id: 3702,
      name: 'Lambayeque',
      iso2: 'LAM',
      countryId: 173,
    },
    {
      id: 3695,
      name: 'Lima',
      iso2: 'LIM',
      countryId: 173,
    },
    {
      id: 4922,
      name: 'Loreto',
      iso2: 'LOR',
      countryId: 173,
    },
    {
      id: 3678,
      name: 'Madre de Dios',
      iso2: 'MDD',
      countryId: 173,
    },
    {
      id: 3698,
      name: 'Moquegua',
      iso2: 'MOQ',
      countryId: 173,
    },
    {
      id: 5687,
      name: 'Municipalidad Metropolitana de Lima',
      iso2: 'LMA',
      countryId: 173,
    },
    {
      id: 3686,
      name: 'Pasco',
      iso2: 'PAS',
      countryId: 173,
    },
    {
      id: 3697,
      name: 'Piura',
      iso2: 'PIU',
      countryId: 173,
    },
    {
      id: 3682,
      name: 'Puno',
      iso2: 'PUN',
      countryId: 173,
    },
    {
      id: 3694,
      name: 'San Martín',
      iso2: 'SAM',
      countryId: 173,
    },
    {
      id: 3696,
      name: 'Tacna',
      iso2: 'TAC',
      countryId: 173,
    },
    {
      id: 3689,
      name: 'Tumbes',
      iso2: 'TUM',
      countryId: 173,
    },
    {
      id: 3684,
      name: 'Ucayali',
      iso2: 'UCA',
      countryId: 173,
    },
    {
      id: 1324,
      name: 'Abra',
      iso2: 'ABR',
      countryId: 174,
    },
    {
      id: 1323,
      name: 'Agusan del Norte',
      iso2: 'AGN',
      countryId: 174,
    },
    {
      id: 1326,
      name: 'Agusan del Sur',
      iso2: 'AGS',
      countryId: 174,
    },
    {
      id: 1331,
      name: 'Aklan',
      iso2: 'AKL',
      countryId: 174,
    },
    {
      id: 1337,
      name: 'Albay',
      iso2: 'ALB',
      countryId: 174,
    },
    {
      id: 1336,
      name: 'Antique',
      iso2: 'ANT',
      countryId: 174,
    },
    {
      id: 1334,
      name: 'Apayao',
      iso2: 'APA',
      countryId: 174,
    },
    {
      id: 1341,
      name: 'Aurora',
      iso2: 'AUR',
      countryId: 174,
    },
    {
      id: 1316,
      name: 'Autonomous Region in Muslim Mindanao',
      iso2: '14',
      countryId: 174,
    },
    {
      id: 1346,
      name: 'Basilan',
      iso2: 'BAS',
      countryId: 174,
    },
    {
      id: 1344,
      name: 'Bataan',
      iso2: 'BAN',
      countryId: 174,
    },
    {
      id: 1352,
      name: 'Batanes',
      iso2: 'BTN',
      countryId: 174,
    },
    {
      id: 1359,
      name: 'Batangas',
      iso2: 'BTG',
      countryId: 174,
    },
    {
      id: 1363,
      name: 'Benguet',
      iso2: 'BEN',
      countryId: 174,
    },
    {
      id: 1304,
      name: 'Bicol',
      iso2: '05',
      countryId: 174,
    },
    {
      id: 1274,
      name: 'Biliran',
      iso2: 'BIL',
      countryId: 174,
    },
    {
      id: 1272,
      name: 'Bohol',
      iso2: 'BOH',
      countryId: 174,
    },
    {
      id: 1270,
      name: 'Bukidnon',
      iso2: 'BUK',
      countryId: 174,
    },
    {
      id: 1278,
      name: 'Bulacan',
      iso2: 'BUL',
      countryId: 174,
    },
    {
      id: 1279,
      name: 'Cagayan',
      iso2: 'CAG',
      countryId: 174,
    },
    {
      id: 1342,
      name: 'Cagayan Valley',
      iso2: '02',
      countryId: 174,
    },
    {
      id: 1294,
      name: 'Calabarzon',
      iso2: '40',
      countryId: 174,
    },
    {
      id: 1283,
      name: 'Camarines Norte',
      iso2: 'CAN',
      countryId: 174,
    },
    {
      id: 1287,
      name: 'Camarines Sur',
      iso2: 'CAS',
      countryId: 174,
    },
    {
      id: 1285,
      name: 'Camiguin',
      iso2: 'CAM',
      countryId: 174,
    },
    {
      id: 1292,
      name: 'Capiz',
      iso2: 'CAP',
      countryId: 174,
    },
    {
      id: 1314,
      name: 'Caraga',
      iso2: '13',
      countryId: 174,
    },
    {
      id: 1301,
      name: 'Catanduanes',
      iso2: 'CAT',
      countryId: 174,
    },
    {
      id: 1307,
      name: 'Cavite',
      iso2: 'CAV',
      countryId: 174,
    },
    {
      id: 1306,
      name: 'Cebu',
      iso2: 'CEB',
      countryId: 174,
    },
    {
      id: 1345,
      name: 'Central Luzon',
      iso2: '03',
      countryId: 174,
    },
    {
      id: 1308,
      name: 'Central Visayas',
      iso2: '07',
      countryId: 174,
    },
    {
      id: 1335,
      name: 'Cordillera Administrative',
      iso2: '15',
      countryId: 174,
    },
    {
      id: 1320,
      name: 'Cotabato',
      iso2: 'NCO',
      countryId: 174,
    },
    {
      id: 1340,
      name: 'Davao',
      iso2: '11',
      countryId: 174,
    },
    {
      id: 1311,
      name: 'Davao de Oro',
      iso2: 'COM',
      countryId: 174,
    },
    {
      id: 1319,
      name: 'Davao del Norte',
      iso2: 'DAV',
      countryId: 174,
    },
    {
      id: 1318,
      name: 'Davao del Sur',
      iso2: 'DAS',
      countryId: 174,
    },
    {
      id: 1309,
      name: 'Davao Occidental',
      iso2: 'DVO',
      countryId: 174,
    },
    {
      id: 1289,
      name: 'Davao Oriental',
      iso2: 'DAO',
      countryId: 174,
    },
    {
      id: 1291,
      name: 'Dinagat Islands',
      iso2: 'DIN',
      countryId: 174,
    },
    {
      id: 1290,
      name: 'Eastern Samar',
      iso2: 'EAS',
      countryId: 174,
    },
    {
      id: 1322,
      name: 'Eastern Visayas',
      iso2: '08',
      countryId: 174,
    },
    {
      id: 1303,
      name: 'Guimaras',
      iso2: 'GUI',
      countryId: 174,
    },
    {
      id: 1300,
      name: 'Ifugao',
      iso2: 'IFU',
      countryId: 174,
    },
    {
      id: 1355,
      name: 'Ilocos',
      iso2: '01',
      countryId: 174,
    },
    {
      id: 1298,
      name: 'Ilocos Norte',
      iso2: 'ILN',
      countryId: 174,
    },
    {
      id: 1321,
      name: 'Ilocos Sur',
      iso2: 'ILS',
      countryId: 174,
    },
    {
      id: 1315,
      name: 'Iloilo',
      iso2: 'ILI',
      countryId: 174,
    },
    {
      id: 1313,
      name: 'Isabela',
      iso2: 'ISA',
      countryId: 174,
    },
    {
      id: 1312,
      name: 'Kalinga',
      iso2: 'KAL',
      countryId: 174,
    },
    {
      id: 1317,
      name: 'La Union',
      iso2: 'LUN',
      countryId: 174,
    },
    {
      id: 1328,
      name: 'Laguna',
      iso2: 'LAG',
      countryId: 174,
    },
    {
      id: 1327,
      name: 'Lanao del Norte',
      iso2: 'LAN',
      countryId: 174,
    },
    {
      id: 1333,
      name: 'Lanao del Sur',
      iso2: 'LAS',
      countryId: 174,
    },
    {
      id: 1332,
      name: 'Leyte',
      iso2: 'LEY',
      countryId: 174,
    },
    {
      id: 1330,
      name: 'Maguindanao del Norte',
      iso2: 'MGN',
      countryId: 174,
    },
    {
      id: 1347,
      name: 'Maguindanao del Sur',
      iso2: 'MGS',
      countryId: 174,
    },
    {
      id: 1329,
      name: 'Marinduque',
      iso2: 'MAD',
      countryId: 174,
    },
    {
      id: 1338,
      name: 'Masbate',
      iso2: 'MAS',
      countryId: 174,
    },
    {
      id: 1299,
      name: 'Mimaropa',
      iso2: '41',
      countryId: 174,
    },
    {
      id: 1343,
      name: 'Misamis Occidental',
      iso2: 'MSC',
      countryId: 174,
    },
    {
      id: 1348,
      name: 'Misamis Oriental',
      iso2: 'MSR',
      countryId: 174,
    },
    {
      id: 1353,
      name: 'Mountain Province',
      iso2: 'MOU',
      countryId: 174,
    },
    {
      id: 5324,
      name: 'National Capital Region (Metro Manila)',
      iso2: '00',
      countryId: 174,
    },
    {
      id: 1351,
      name: 'Negros Occidental',
      iso2: 'NEC',
      countryId: 174,
    },
    {
      id: 1350,
      name: 'Negros Oriental',
      iso2: 'NER',
      countryId: 174,
    },
    {
      id: 1339,
      name: 'Northern Mindanao',
      iso2: '10',
      countryId: 174,
    },
    {
      id: 1349,
      name: 'Northern Samar',
      iso2: 'NSA',
      countryId: 174,
    },
    {
      id: 1360,
      name: 'Nueva Ecija',
      iso2: 'NUE',
      countryId: 174,
    },
    {
      id: 1358,
      name: 'Nueva Vizcaya',
      iso2: 'NUV',
      countryId: 174,
    },
    {
      id: 1356,
      name: 'Occidental Mindoro',
      iso2: 'MDC',
      countryId: 174,
    },
    {
      id: 1354,
      name: 'Oriental Mindoro',
      iso2: 'MDR',
      countryId: 174,
    },
    {
      id: 1361,
      name: 'Palawan',
      iso2: 'PLW',
      countryId: 174,
    },
    {
      id: 1365,
      name: 'Pampanga',
      iso2: 'PAM',
      countryId: 174,
    },
    {
      id: 1364,
      name: 'Pangasinan',
      iso2: 'PAN',
      countryId: 174,
    },
    {
      id: 1275,
      name: 'Quezon',
      iso2: 'QUE',
      countryId: 174,
    },
    {
      id: 1273,
      name: 'Quirino',
      iso2: 'QUI',
      countryId: 174,
    },
    {
      id: 1271,
      name: 'Rizal',
      iso2: 'RIZ',
      countryId: 174,
    },
    {
      id: 1269,
      name: 'Romblon',
      iso2: 'ROM',
      countryId: 174,
    },
    {
      id: 1277,
      name: 'Sarangani',
      iso2: 'SAR',
      countryId: 174,
    },
    {
      id: 1276,
      name: 'Siquijor',
      iso2: 'SIG',
      countryId: 174,
    },
    {
      id: 1310,
      name: 'Soccsksargen',
      iso2: '12',
      countryId: 174,
    },
    {
      id: 1281,
      name: 'Sorsogon',
      iso2: 'SOR',
      countryId: 174,
    },
    {
      id: 1280,
      name: 'South Cotabato',
      iso2: 'SCO',
      countryId: 174,
    },
    {
      id: 1284,
      name: 'Southern Leyte',
      iso2: 'SLE',
      countryId: 174,
    },
    {
      id: 1282,
      name: 'Sultan Kudarat',
      iso2: 'SUK',
      countryId: 174,
    },
    {
      id: 1288,
      name: 'Sulu',
      iso2: 'SLU',
      countryId: 174,
    },
    {
      id: 1286,
      name: 'Surigao del Norte',
      iso2: 'SUN',
      countryId: 174,
    },
    {
      id: 1296,
      name: 'Surigao del Sur',
      iso2: 'SUR',
      countryId: 174,
    },
    {
      id: 1295,
      name: 'Tarlac',
      iso2: 'TAR',
      countryId: 174,
    },
    {
      id: 1293,
      name: 'Tawi-Tawi',
      iso2: 'TAW',
      countryId: 174,
    },
    {
      id: 5115,
      name: 'Western Samar',
      iso2: 'WSA',
      countryId: 174,
    },
    {
      id: 1305,
      name: 'Western Visayas',
      iso2: '06',
      countryId: 174,
    },
    {
      id: 1297,
      name: 'Zambales',
      iso2: 'ZMB',
      countryId: 174,
    },
    {
      id: 1302,
      name: 'Zamboanga del Norte',
      iso2: 'ZAN',
      countryId: 174,
    },
    {
      id: 1357,
      name: 'Zamboanga del Sur',
      iso2: 'ZAS',
      countryId: 174,
    },
    {
      id: 1325,
      name: 'Zamboanga Peninsula',
      iso2: '09',
      countryId: 174,
    },
    {
      id: 1362,
      name: 'Zamboanga Sibugay',
      iso2: 'ZSI',
      countryId: 174,
    },
    {
      id: 1634,
      name: 'Greater Poland',
      iso2: '30',
      countryId: 176,
    },
    {
      id: 1630,
      name: 'Holy Cross',
      iso2: '26',
      countryId: 176,
    },
    {
      id: 1625,
      name: 'Kuyavia-Pomerania',
      iso2: '04',
      countryId: 176,
    },
    {
      id: 1635,
      name: 'Lesser Poland',
      iso2: '12',
      countryId: 176,
    },
    {
      id: 1629,
      name: 'Lower Silesia',
      iso2: '02',
      countryId: 176,
    },
    {
      id: 1638,
      name: 'Lublin',
      iso2: '06',
      countryId: 176,
    },
    {
      id: 1631,
      name: 'Lubusz',
      iso2: '08',
      countryId: 176,
    },
    {
      id: 1636,
      name: 'Łódź',
      iso2: '10',
      countryId: 176,
    },
    {
      id: 1637,
      name: 'Mazovia',
      iso2: '14',
      countryId: 176,
    },
    {
      id: 1632,
      name: 'Podlaskie',
      iso2: '20',
      countryId: 176,
    },
    {
      id: 1624,
      name: 'Pomerania',
      iso2: '22',
      countryId: 176,
    },
    {
      id: 1623,
      name: 'Silesia',
      iso2: '24',
      countryId: 176,
    },
    {
      id: 1626,
      name: 'Subcarpathia',
      iso2: '18',
      countryId: 176,
    },
    {
      id: 1622,
      name: 'Upper Silesia',
      iso2: '16',
      countryId: 176,
    },
    {
      id: 1628,
      name: 'Warmia-Masuria',
      iso2: '28',
      countryId: 176,
    },
    {
      id: 1633,
      name: 'West Pomerania',
      iso2: '32',
      countryId: 176,
    },
    {
      id: 2233,
      name: 'Açores',
      iso2: '20',
      countryId: 177,
    },
    {
      id: 2235,
      name: 'Aveiro',
      iso2: '01',
      countryId: 177,
    },
    {
      id: 2230,
      name: 'Beja',
      iso2: '02',
      countryId: 177,
    },
    {
      id: 2244,
      name: 'Braga',
      iso2: '03',
      countryId: 177,
    },
    {
      id: 2229,
      name: 'Bragança',
      iso2: '04',
      countryId: 177,
    },
    {
      id: 2241,
      name: 'Castelo Branco',
      iso2: '05',
      countryId: 177,
    },
    {
      id: 2246,
      name: 'Coimbra',
      iso2: '06',
      countryId: 177,
    },
    {
      id: 2236,
      name: 'Évora',
      iso2: '07',
      countryId: 177,
    },
    {
      id: 2239,
      name: 'Faro',
      iso2: '08',
      countryId: 177,
    },
    {
      id: 4859,
      name: 'Guarda',
      iso2: '09',
      countryId: 177,
    },
    {
      id: 2240,
      name: 'Leiria',
      iso2: '10',
      countryId: 177,
    },
    {
      id: 2228,
      name: 'Lisbon',
      iso2: '11',
      countryId: 177,
    },
    {
      id: 2231,
      name: 'Madeira',
      iso2: '30',
      countryId: 177,
    },
    {
      id: 2232,
      name: 'Portalegre',
      iso2: '12',
      countryId: 177,
    },
    {
      id: 2243,
      name: 'Porto',
      iso2: '13',
      countryId: 177,
    },
    {
      id: 2238,
      name: 'Santarém',
      iso2: '14',
      countryId: 177,
    },
    {
      id: 2242,
      name: 'Setúbal',
      iso2: '15',
      countryId: 177,
    },
    {
      id: 2245,
      name: 'Viana do Castelo',
      iso2: '16',
      countryId: 177,
    },
    {
      id: 2234,
      name: 'Vila Real',
      iso2: '17',
      countryId: 177,
    },
    {
      id: 2237,
      name: 'Viseu',
      iso2: '18',
      countryId: 177,
    },
    {
      id: 5134,
      name: 'Adjuntas',
      iso2: '001',
      countryId: 178,
    },
    {
      id: 5135,
      name: 'Aguada',
      iso2: '003',
      countryId: 178,
    },
    {
      id: 5136,
      name: 'Aguadilla',
      iso2: '005',
      countryId: 178,
    },
    {
      id: 5137,
      name: 'Aguas Buenas',
      iso2: '007',
      countryId: 178,
    },
    {
      id: 5138,
      name: 'Aibonito',
      iso2: '009',
      countryId: 178,
    },
    {
      id: 5139,
      name: 'Añasco',
      iso2: '011',
      countryId: 178,
    },
    {
      id: 5081,
      name: 'Arecibo',
      iso2: 'AR',
      countryId: 178,
    },
    {
      id: 5141,
      name: 'Arroyo',
      iso2: '015',
      countryId: 178,
    },
    {
      id: 5142,
      name: 'Barceloneta',
      iso2: '017',
      countryId: 178,
    },
    {
      id: 5143,
      name: 'Barranquitas',
      iso2: '019',
      countryId: 178,
    },
    {
      id: 5076,
      name: 'Bayamon',
      iso2: 'BY',
      countryId: 178,
    },
    {
      id: 5145,
      name: 'Cabo Rojo',
      iso2: '023',
      countryId: 178,
    },
    {
      id: 5079,
      name: 'Caguas',
      iso2: 'CG',
      countryId: 178,
    },
    {
      id: 5147,
      name: 'Camuy',
      iso2: '027',
      countryId: 178,
    },
    {
      id: 5148,
      name: 'Canóvanas',
      iso2: '029',
      countryId: 178,
    },
    {
      id: 5077,
      name: 'Carolina',
      iso2: 'CL',
      countryId: 178,
    },
    {
      id: 5150,
      name: 'Cataño',
      iso2: '033',
      countryId: 178,
    },
    {
      id: 5151,
      name: 'Cayey',
      iso2: '035',
      countryId: 178,
    },
    {
      id: 5152,
      name: 'Ceiba',
      iso2: '037',
      countryId: 178,
    },
    {
      id: 5153,
      name: 'Ciales',
      iso2: '039',
      countryId: 178,
    },
    {
      id: 5154,
      name: 'Cidra',
      iso2: '041',
      countryId: 178,
    },
    {
      id: 5155,
      name: 'Coamo',
      iso2: '043',
      countryId: 178,
    },
    {
      id: 5156,
      name: 'Comerío',
      iso2: '045',
      countryId: 178,
    },
    {
      id: 5157,
      name: 'Corozal',
      iso2: '047',
      countryId: 178,
    },
    {
      id: 5158,
      name: 'Culebra',
      iso2: '049',
      countryId: 178,
    },
    {
      id: 5159,
      name: 'Dorado',
      iso2: '051',
      countryId: 178,
    },
    {
      id: 5160,
      name: 'Fajardo',
      iso2: '053',
      countryId: 178,
    },
    {
      id: 5161,
      name: 'Florida',
      iso2: '054',
      countryId: 178,
    },
    {
      id: 5162,
      name: 'Guánica',
      iso2: '055',
      countryId: 178,
    },
    {
      id: 5163,
      name: 'Guayama',
      iso2: '057',
      countryId: 178,
    },
    {
      id: 5164,
      name: 'Guayanilla',
      iso2: '059',
      countryId: 178,
    },
    {
      id: 5080,
      name: 'Guaynabo',
      iso2: 'GN',
      countryId: 178,
    },
    {
      id: 5166,
      name: 'Gurabo',
      iso2: '063',
      countryId: 178,
    },
    {
      id: 5167,
      name: 'Hatillo',
      iso2: '065',
      countryId: 178,
    },
    {
      id: 5168,
      name: 'Hormigueros',
      iso2: '067',
      countryId: 178,
    },
    {
      id: 5169,
      name: 'Humacao',
      iso2: '069',
      countryId: 178,
    },
    {
      id: 5170,
      name: 'Isabela',
      iso2: '071',
      countryId: 178,
    },
    {
      id: 5171,
      name: 'Jayuya',
      iso2: '073',
      countryId: 178,
    },
    {
      id: 5172,
      name: 'Juana Díaz',
      iso2: '075',
      countryId: 178,
    },
    {
      id: 5173,
      name: 'Juncos',
      iso2: '077',
      countryId: 178,
    },
    {
      id: 5174,
      name: 'Lajas',
      iso2: '079',
      countryId: 178,
    },
    {
      id: 5175,
      name: 'Lares',
      iso2: '081',
      countryId: 178,
    },
    {
      id: 5176,
      name: 'Las Marías',
      iso2: '083',
      countryId: 178,
    },
    {
      id: 5177,
      name: 'Las Piedras',
      iso2: '085',
      countryId: 178,
    },
    {
      id: 5178,
      name: 'Loíza',
      iso2: '087',
      countryId: 178,
    },
    {
      id: 5179,
      name: 'Luquillo',
      iso2: '089',
      countryId: 178,
    },
    {
      id: 5180,
      name: 'Manatí',
      iso2: '091',
      countryId: 178,
    },
    {
      id: 5181,
      name: 'Maricao',
      iso2: '093',
      countryId: 178,
    },
    {
      id: 5182,
      name: 'Maunabo',
      iso2: '095',
      countryId: 178,
    },
    {
      id: 5083,
      name: 'Mayagüez',
      iso2: 'MG',
      countryId: 178,
    },
    {
      id: 5184,
      name: 'Moca',
      iso2: '099',
      countryId: 178,
    },
    {
      id: 5185,
      name: 'Morovis',
      iso2: '101',
      countryId: 178,
    },
    {
      id: 5186,
      name: 'Naguabo',
      iso2: '103',
      countryId: 178,
    },
    {
      id: 5187,
      name: 'Naranjito',
      iso2: '105',
      countryId: 178,
    },
    {
      id: 5188,
      name: 'Orocovis',
      iso2: '107',
      countryId: 178,
    },
    {
      id: 5189,
      name: 'Patillas',
      iso2: '109',
      countryId: 178,
    },
    {
      id: 5190,
      name: 'Peñuelas',
      iso2: '111',
      countryId: 178,
    },
    {
      id: 5078,
      name: 'Ponce',
      iso2: 'PO',
      countryId: 178,
    },
    {
      id: 5192,
      name: 'Quebradillas',
      iso2: '115',
      countryId: 178,
    },
    {
      id: 5193,
      name: 'Rincón',
      iso2: '117',
      countryId: 178,
    },
    {
      id: 5194,
      name: 'Río Grande',
      iso2: '119',
      countryId: 178,
    },
    {
      id: 5195,
      name: 'Sabana Grande',
      iso2: '121',
      countryId: 178,
    },
    {
      id: 5196,
      name: 'Salinas',
      iso2: '123',
      countryId: 178,
    },
    {
      id: 5197,
      name: 'San Germán',
      iso2: '125',
      countryId: 178,
    },
    {
      id: 5075,
      name: 'San Juan',
      iso2: 'SJ',
      countryId: 178,
    },
    {
      id: 5199,
      name: 'San Lorenzo',
      iso2: '129',
      countryId: 178,
    },
    {
      id: 5200,
      name: 'San Sebastián',
      iso2: '131',
      countryId: 178,
    },
    {
      id: 5201,
      name: 'Santa Isabel',
      iso2: '133',
      countryId: 178,
    },
    {
      id: 5202,
      name: 'Toa Alta',
      iso2: '135',
      countryId: 178,
    },
    {
      id: 5082,
      name: 'Toa Baja',
      iso2: 'TB',
      countryId: 178,
    },
    {
      id: 5084,
      name: 'Trujillo Alto',
      iso2: 'TA',
      countryId: 178,
    },
    {
      id: 5205,
      name: 'Utuado',
      iso2: '141',
      countryId: 178,
    },
    {
      id: 5206,
      name: 'Vega Alta',
      iso2: '143',
      countryId: 178,
    },
    {
      id: 5207,
      name: 'Vega Baja',
      iso2: '145',
      countryId: 178,
    },
    {
      id: 5208,
      name: 'Vieques',
      iso2: '147',
      countryId: 178,
    },
    {
      id: 5209,
      name: 'Villalba',
      iso2: '149',
      countryId: 178,
    },
    {
      id: 5210,
      name: 'Yabucoa',
      iso2: '151',
      countryId: 178,
    },
    {
      id: 5211,
      name: 'Yauco',
      iso2: '153',
      countryId: 178,
    },
    {
      id: 3182,
      name: 'Al Daayen',
      iso2: 'ZA',
      countryId: 179,
    },
    {
      id: 3183,
      name: 'Al Khor',
      iso2: 'KH',
      countryId: 179,
    },
    {
      id: 3177,
      name: 'Al Rayyan',
      iso2: 'RA',
      countryId: 179,
    },
    {
      id: 3179,
      name: 'Al Wakrah',
      iso2: 'WA',
      countryId: 179,
    },
    {
      id: 3178,
      name: 'Al-Shahaniya',
      iso2: 'SH',
      countryId: 179,
    },
    {
      id: 3181,
      name: 'Doha',
      iso2: 'DA',
      countryId: 179,
    },
    {
      id: 3180,
      name: 'Madinat ash Shamal',
      iso2: 'MS',
      countryId: 179,
    },
    {
      id: 3184,
      name: 'Umm Salal',
      iso2: 'US',
      countryId: 179,
    },
    {
      id: 5436,
      name: 'Saint-Benoît',
      iso2: '01',
      countryId: 180,
    },
    {
      id: 5437,
      name: 'Saint-Denis',
      iso2: '02',
      countryId: 180,
    },
    {
      id: 5438,
      name: 'Saint-Paul',
      iso2: '03',
      countryId: 180,
    },
    {
      id: 5439,
      name: 'Saint-Pierre',
      iso2: '04',
      countryId: 180,
    },
    {
      id: 4724,
      name: 'Alba',
      iso2: 'AB',
      countryId: 181,
    },
    {
      id: 4739,
      name: 'Arad',
      iso2: 'AR',
      countryId: 181,
    },
    {
      id: 4722,
      name: 'Arges',
      iso2: 'AG',
      countryId: 181,
    },
    {
      id: 4744,
      name: 'Bacău',
      iso2: 'BC',
      countryId: 181,
    },
    {
      id: 4723,
      name: 'Bihor',
      iso2: 'BH',
      countryId: 181,
    },
    {
      id: 4733,
      name: 'Bistrița-Năsăud',
      iso2: 'BN',
      countryId: 181,
    },
    {
      id: 4740,
      name: 'Botoșani',
      iso2: 'BT',
      countryId: 181,
    },
    {
      id: 4736,
      name: 'Braila',
      iso2: 'BR',
      countryId: 181,
    },
    {
      id: 4759,
      name: 'Brașov',
      iso2: 'BV',
      countryId: 181,
    },
    {
      id: 4730,
      name: 'Bucharest',
      iso2: 'B',
      countryId: 181,
    },
    {
      id: 4756,
      name: 'Buzău',
      iso2: 'BZ',
      countryId: 181,
    },
    {
      id: 4732,
      name: 'Călărași',
      iso2: 'CL',
      countryId: 181,
    },
    {
      id: 4753,
      name: 'Caraș-Severin',
      iso2: 'CS',
      countryId: 181,
    },
    {
      id: 4734,
      name: 'Cluj',
      iso2: 'CJ',
      countryId: 181,
    },
    {
      id: 4737,
      name: 'Constanța',
      iso2: 'CT',
      countryId: 181,
    },
    {
      id: 4754,
      name: 'Covasna',
      iso2: 'CV',
      countryId: 181,
    },
    {
      id: 4745,
      name: 'Dâmbovița',
      iso2: 'DB',
      countryId: 181,
    },
    {
      id: 4742,
      name: 'Dolj',
      iso2: 'DJ',
      countryId: 181,
    },
    {
      id: 4747,
      name: 'Galați',
      iso2: 'GL',
      countryId: 181,
    },
    {
      id: 4726,
      name: 'Giurgiu',
      iso2: 'GR',
      countryId: 181,
    },
    {
      id: 4750,
      name: 'Gorj',
      iso2: 'GJ',
      countryId: 181,
    },
    {
      id: 4749,
      name: 'Harghita',
      iso2: 'HR',
      countryId: 181,
    },
    {
      id: 4721,
      name: 'Hunedoara',
      iso2: 'HD',
      countryId: 181,
    },
    {
      id: 4743,
      name: 'Ialomița',
      iso2: 'IL',
      countryId: 181,
    },
    {
      id: 4735,
      name: 'Iași',
      iso2: 'IS',
      countryId: 181,
    },
    {
      id: 4725,
      name: 'Ilfov',
      iso2: 'IF',
      countryId: 181,
    },
    {
      id: 4760,
      name: 'Maramureș',
      iso2: 'MM',
      countryId: 181,
    },
    {
      id: 4751,
      name: 'Mehedinți',
      iso2: 'MH',
      countryId: 181,
    },
    {
      id: 4915,
      name: 'Mureș',
      iso2: 'MS',
      countryId: 181,
    },
    {
      id: 4731,
      name: 'Neamț',
      iso2: 'NT',
      countryId: 181,
    },
    {
      id: 4738,
      name: 'Olt',
      iso2: 'OT',
      countryId: 181,
    },
    {
      id: 4729,
      name: 'Prahova',
      iso2: 'PH',
      countryId: 181,
    },
    {
      id: 4741,
      name: 'Sălaj',
      iso2: 'SJ',
      countryId: 181,
    },
    {
      id: 4746,
      name: 'Satu Mare',
      iso2: 'SM',
      countryId: 181,
    },
    {
      id: 4755,
      name: 'Sibiu',
      iso2: 'SB',
      countryId: 181,
    },
    {
      id: 4720,
      name: 'Suceava',
      iso2: 'SV',
      countryId: 181,
    },
    {
      id: 4728,
      name: 'Teleorman',
      iso2: 'TR',
      countryId: 181,
    },
    {
      id: 4748,
      name: 'Timiș',
      iso2: 'TM',
      countryId: 181,
    },
    {
      id: 4727,
      name: 'Tulcea',
      iso2: 'TL',
      countryId: 181,
    },
    {
      id: 4757,
      name: 'Vâlcea',
      iso2: 'VL',
      countryId: 181,
    },
    {
      id: 4752,
      name: 'Vaslui',
      iso2: 'VS',
      countryId: 181,
    },
    {
      id: 4758,
      name: 'Vrancea',
      iso2: 'VN',
      countryId: 181,
    },
    {
      id: 1852,
      name: 'Adygea',
      iso2: 'AD',
      countryId: 182,
    },
    {
      id: 1911,
      name: 'Altai',
      iso2: 'ALT',
      countryId: 182,
    },
    {
      id: 1876,
      name: 'Altai',
      iso2: 'AL',
      countryId: 182,
    },
    {
      id: 1858,
      name: 'Amur',
      iso2: 'AMU',
      countryId: 182,
    },
    {
      id: 1849,
      name: 'Arkhangelsk',
      iso2: 'ARK',
      countryId: 182,
    },
    {
      id: 1866,
      name: 'Astrakhan',
      iso2: 'AST',
      countryId: 182,
    },
    {
      id: 1854,
      name: 'Bashkortostan',
      iso2: 'BA',
      countryId: 182,
    },
    {
      id: 1903,
      name: 'Belgorod',
      iso2: 'BEL',
      countryId: 182,
    },
    {
      id: 1867,
      name: 'Bryansk',
      iso2: 'BRY',
      countryId: 182,
    },
    {
      id: 1842,
      name: 'Buryatia',
      iso2: 'BU',
      countryId: 182,
    },
    {
      id: 1893,
      name: 'Chechen',
      iso2: 'CE',
      countryId: 182,
    },
    {
      id: 1845,
      name: 'Chelyabinsk',
      iso2: 'CHE',
      countryId: 182,
    },
    {
      id: 1859,
      name: 'Chukotka',
      iso2: 'CHU',
      countryId: 182,
    },
    {
      id: 1914,
      name: 'Chuvash',
      iso2: 'CU',
      countryId: 182,
    },
    {
      id: 1850,
      name: 'Dagestan',
      iso2: 'DA',
      countryId: 182,
    },
    {
      id: 1884,
      name: 'Ingushetia',
      iso2: 'IN',
      countryId: 182,
    },
    {
      id: 1880,
      name: 'Irkutsk',
      iso2: 'IRK',
      countryId: 182,
    },
    {
      id: 1864,
      name: 'Ivanovo',
      iso2: 'IVA',
      countryId: 182,
    },
    {
      id: 1835,
      name: 'Jewish',
      iso2: 'YEV',
      countryId: 182,
    },
    {
      id: 1892,
      name: 'Kabardino-Balkar',
      iso2: 'KB',
      countryId: 182,
    },
    {
      id: 1902,
      name: 'Kaliningrad',
      iso2: 'KGD',
      countryId: 182,
    },
    {
      id: 1883,
      name: 'Kalmykia',
      iso2: 'KL',
      countryId: 182,
    },
    {
      id: 1844,
      name: 'Kaluga',
      iso2: 'KLU',
      countryId: 182,
    },
    {
      id: 1865,
      name: 'Kamchatka',
      iso2: 'KAM',
      countryId: 182,
    },
    {
      id: 1869,
      name: 'Karachay-Cherkess',
      iso2: 'KC',
      countryId: 182,
    },
    {
      id: 1841,
      name: 'Karelia',
      iso2: 'KR',
      countryId: 182,
    },
    {
      id: 1897,
      name: 'Kemerovo',
      iso2: 'KEM',
      countryId: 182,
    },
    {
      id: 1873,
      name: 'Khabarovsk',
      iso2: 'KHA',
      countryId: 182,
    },
    {
      id: 1877,
      name: 'Khakassia',
      iso2: 'KK',
      countryId: 182,
    },
    {
      id: 1838,
      name: 'Khanty-Mansi',
      iso2: 'KHM',
      countryId: 182,
    },
    {
      id: 1890,
      name: 'Kirov',
      iso2: 'KIR',
      countryId: 182,
    },
    {
      id: 1899,
      name: 'Komi',
      iso2: 'KO',
      countryId: 182,
    },
    {
      id: 1910,
      name: 'Kostroma',
      iso2: 'KOS',
      countryId: 182,
    },
    {
      id: 1891,
      name: 'Krasnodar',
      iso2: 'KDA',
      countryId: 182,
    },
    {
      id: 1840,
      name: 'Krasnoyarsk',
      iso2: 'KYA',
      countryId: 182,
    },
    {
      id: 1915,
      name: 'Kurgan',
      iso2: 'KGN',
      countryId: 182,
    },
    {
      id: 1855,
      name: 'Kursk',
      iso2: 'KRS',
      countryId: 182,
    },
    {
      id: 1896,
      name: 'Leningrad',
      iso2: 'LEN',
      countryId: 182,
    },
    {
      id: 1889,
      name: 'Lipetsk',
      iso2: 'LIP',
      countryId: 182,
    },
    {
      id: 1839,
      name: 'Magadan',
      iso2: 'MAG',
      countryId: 182,
    },
    {
      id: 1870,
      name: 'Mari El',
      iso2: 'ME',
      countryId: 182,
    },
    {
      id: 1898,
      name: 'Mordovia',
      iso2: 'MO',
      countryId: 182,
    },
    {
      id: 1882,
      name: 'Moscow',
      iso2: 'MOS',
      countryId: 182,
    },
    {
      id: 1901,
      name: 'Moscow',
      iso2: 'MOW',
      countryId: 182,
    },
    {
      id: 1843,
      name: 'Murmansk',
      iso2: 'MUR',
      countryId: 182,
    },
    {
      id: 1836,
      name: 'Nenets',
      iso2: 'NEN',
      countryId: 182,
    },
    {
      id: 1857,
      name: 'Nizhny Novgorod',
      iso2: 'NIZ',
      countryId: 182,
    },
    {
      id: 1853,
      name: 'North Ossetia-Alania',
      iso2: 'SE',
      countryId: 182,
    },
    {
      id: 1834,
      name: 'Novgorod',
      iso2: 'NGR',
      countryId: 182,
    },
    {
      id: 1888,
      name: 'Novosibirsk',
      iso2: 'NVS',
      countryId: 182,
    },
    {
      id: 1846,
      name: 'Omsk',
      iso2: 'OMS',
      countryId: 182,
    },
    {
      id: 1886,
      name: 'Orenburg',
      iso2: 'ORE',
      countryId: 182,
    },
    {
      id: 1908,
      name: 'Oryol',
      iso2: 'ORL',
      countryId: 182,
    },
    {
      id: 1909,
      name: 'Penza',
      iso2: 'PNZ',
      countryId: 182,
    },
    {
      id: 1871,
      name: 'Perm',
      iso2: 'PER',
      countryId: 182,
    },
    {
      id: 1833,
      name: 'Primorsky',
      iso2: 'PRI',
      countryId: 182,
    },
    {
      id: 1863,
      name: 'Pskov',
      iso2: 'PSK',
      countryId: 182,
    },
    {
      id: 1837,
      name: 'Rostov',
      iso2: 'ROS',
      countryId: 182,
    },
    {
      id: 1905,
      name: 'Ryazan',
      iso2: 'RYA',
      countryId: 182,
    },
    {
      id: 1879,
      name: 'Saint Petersburg',
      iso2: 'SPE',
      countryId: 182,
    },
    {
      id: 1848,
      name: 'Sakha',
      iso2: 'SA',
      countryId: 182,
    },
    {
      id: 1875,
      name: 'Sakhalin',
      iso2: 'SAK',
      countryId: 182,
    },
    {
      id: 1862,
      name: 'Samara',
      iso2: 'SAM',
      countryId: 182,
    },
    {
      id: 1887,
      name: 'Saratov',
      iso2: 'SAR',
      countryId: 182,
    },
    {
      id: 1885,
      name: 'Smolensk',
      iso2: 'SMO',
      countryId: 182,
    },
    {
      id: 1868,
      name: 'Stavropol',
      iso2: 'STA',
      countryId: 182,
    },
    {
      id: 1894,
      name: 'Sverdlovsk',
      iso2: 'SVE',
      countryId: 182,
    },
    {
      id: 1878,
      name: 'Tambov',
      iso2: 'TAM',
      countryId: 182,
    },
    {
      id: 1861,
      name: 'Tatarstan',
      iso2: 'TA',
      countryId: 182,
    },
    {
      id: 1872,
      name: 'Tomsk',
      iso2: 'TOM',
      countryId: 182,
    },
    {
      id: 1895,
      name: 'Tula',
      iso2: 'TUL',
      countryId: 182,
    },
    {
      id: 1900,
      name: 'Tuva',
      iso2: 'TY',
      countryId: 182,
    },
    {
      id: 1860,
      name: 'Tver',
      iso2: 'TVE',
      countryId: 182,
    },
    {
      id: 1907,
      name: 'Tyumen',
      iso2: 'TYU',
      countryId: 182,
    },
    {
      id: 1913,
      name: 'Udmurt',
      iso2: 'UD',
      countryId: 182,
    },
    {
      id: 1856,
      name: 'Ulyanovsk',
      iso2: 'ULY',
      countryId: 182,
    },
    {
      id: 1881,
      name: 'Vladimir',
      iso2: 'VLA',
      countryId: 182,
    },
    {
      id: 4916,
      name: 'Volgograd Oblast',
      iso2: 'VGG',
      countryId: 182,
    },
    {
      id: 1874,
      name: 'Vologda',
      iso2: 'VLG',
      countryId: 182,
    },
    {
      id: 1906,
      name: 'Voronezh',
      iso2: 'VOR',
      countryId: 182,
    },
    {
      id: 1847,
      name: 'Yamalo-Nenets',
      iso2: 'YAN',
      countryId: 182,
    },
    {
      id: 1851,
      name: 'Yaroslavl',
      iso2: 'YAR',
      countryId: 182,
    },
    {
      id: 1904,
      name: 'Zabaykalsky',
      iso2: 'ZAB',
      countryId: 182,
    },
    {
      id: 261,
      name: 'Eastern',
      iso2: '02',
      countryId: 183,
    },
    {
      id: 262,
      name: 'Kigali',
      iso2: '01',
      countryId: 183,
    },
    {
      id: 263,
      name: 'Northern',
      iso2: '03',
      countryId: 183,
    },
    {
      id: 259,
      name: 'Southern',
      iso2: '05',
      countryId: 183,
    },
    {
      id: 260,
      name: 'Western',
      iso2: '04',
      countryId: 183,
    },
    {
      id: 5440,
      name: 'Alarm Forest',
      iso2: '01',
      countryId: 184,
    },
    {
      id: 5441,
      name: 'Blue Hill',
      iso2: '02',
      countryId: 184,
    },
    {
      id: 5442,
      name: 'Half Tree Hollow',
      iso2: '03',
      countryId: 184,
    },
    {
      id: 5443,
      name: 'Jamestown',
      iso2: '04',
      countryId: 184,
    },
    {
      id: 5444,
      name: 'Levelwood',
      iso2: '05',
      countryId: 184,
    },
    {
      id: 5445,
      name: 'Longwood',
      iso2: '06',
      countryId: 184,
    },
    {
      id: 5447,
      name: "Saint Paul's",
      iso2: '08',
      countryId: 184,
    },
    {
      id: 5446,
      name: 'Sandy Bay',
      iso2: '07',
      countryId: 184,
    },
    {
      id: 3833,
      name: 'Christ Church Nichola Town',
      iso2: '01',
      countryId: 185,
    },
    {
      id: 3832,
      name: 'Nevis',
      iso2: 'N',
      countryId: 185,
    },
    {
      id: 3836,
      name: 'Saint Anne Sandy Point',
      iso2: '02',
      countryId: 185,
    },
    {
      id: 5348,
      name: 'Saint George Basseterre',
      iso2: '03',
      countryId: 185,
    },
    {
      id: 3837,
      name: 'Saint George Gingerland',
      iso2: '04',
      countryId: 185,
    },
    {
      id: 3835,
      name: 'Saint James Windward',
      iso2: '05',
      countryId: 185,
    },
    {
      id: 3845,
      name: 'Saint John Capisterre',
      iso2: '06',
      countryId: 185,
    },
    {
      id: 3840,
      name: 'Saint John Figtree',
      iso2: '07',
      countryId: 185,
    },
    {
      id: 3841,
      name: 'Saint Kitts',
      iso2: 'K',
      countryId: 185,
    },
    {
      id: 3844,
      name: 'Saint Mary Cayon',
      iso2: '08',
      countryId: 185,
    },
    {
      id: 3834,
      name: 'Saint Paul Capisterre',
      iso2: '09',
      countryId: 185,
    },
    {
      id: 3838,
      name: 'Saint Paul Charlestown',
      iso2: '10',
      countryId: 185,
    },
    {
      id: 3831,
      name: 'Saint Peter Basseterre',
      iso2: '11',
      countryId: 185,
    },
    {
      id: 3839,
      name: 'Saint Thomas Lowland',
      iso2: '12',
      countryId: 185,
    },
    {
      id: 3842,
      name: 'Saint Thomas Middle Island',
      iso2: '13',
      countryId: 185,
    },
    {
      id: 3843,
      name: 'Trinity Palmetto Point',
      iso2: '15',
      countryId: 185,
    },
    {
      id: 3757,
      name: 'Anse la Raye',
      iso2: '01',
      countryId: 186,
    },
    {
      id: 3761,
      name: 'Canaries',
      iso2: '12',
      countryId: 186,
    },
    {
      id: 3758,
      name: 'Castries',
      iso2: '02',
      countryId: 186,
    },
    {
      id: 3760,
      name: 'Choiseul',
      iso2: '03',
      countryId: 186,
    },
    {
      id: 3756,
      name: 'Dennery',
      iso2: '05',
      countryId: 186,
    },
    {
      id: 3766,
      name: 'Gros Islet',
      iso2: '06',
      countryId: 186,
    },
    {
      id: 3759,
      name: 'Laborie',
      iso2: '07',
      countryId: 186,
    },
    {
      id: 3762,
      name: 'Micoud',
      iso2: '08',
      countryId: 186,
    },
    {
      id: 3764,
      name: 'Soufrière',
      iso2: '10',
      countryId: 186,
    },
    {
      id: 3763,
      name: 'Vieux Fort',
      iso2: '11',
      countryId: 186,
    },
    {
      id: 3389,
      name: 'Charlotte',
      iso2: '01',
      countryId: 188,
    },
    {
      id: 3388,
      name: 'Grenadines',
      iso2: '06',
      countryId: 188,
    },
    {
      id: 3386,
      name: 'Saint Andrew',
      iso2: '02',
      countryId: 188,
    },
    {
      id: 3387,
      name: 'Saint David',
      iso2: '03',
      countryId: 188,
    },
    {
      id: 3384,
      name: 'Saint George',
      iso2: '04',
      countryId: 188,
    },
    {
      id: 3385,
      name: 'Saint Patrick',
      iso2: '05',
      countryId: 188,
    },
    {
      id: 4763,
      name: "A'ana",
      iso2: 'AA',
      countryId: 191,
    },
    {
      id: 4761,
      name: 'Aiga-i-le-Tai',
      iso2: 'AL',
      countryId: 191,
    },
    {
      id: 4765,
      name: 'Atua',
      iso2: 'AT',
      countryId: 191,
    },
    {
      id: 4764,
      name: "Fa'asaleleaga",
      iso2: 'FA',
      countryId: 191,
    },
    {
      id: 4769,
      name: "Gaga'emauga",
      iso2: 'GE',
      countryId: 191,
    },
    {
      id: 4771,
      name: "Gaga'ifomauga",
      iso2: 'GI',
      countryId: 191,
    },
    {
      id: 4767,
      name: 'Palauli',
      iso2: 'PA',
      countryId: 191,
    },
    {
      id: 4762,
      name: "Satupa'itea",
      iso2: 'SA',
      countryId: 191,
    },
    {
      id: 4770,
      name: 'Tuamasaga',
      iso2: 'TU',
      countryId: 191,
    },
    {
      id: 4768,
      name: "Va'a-o-Fonoti",
      iso2: 'VF',
      countryId: 191,
    },
    {
      id: 4766,
      name: 'Vaisigano',
      iso2: 'VS',
      countryId: 191,
    },
    {
      id: 59,
      name: 'Acquaviva',
      iso2: '01',
      countryId: 192,
    },
    {
      id: 61,
      name: 'Borgo Maggiore',
      iso2: '06',
      countryId: 192,
    },
    {
      id: 60,
      name: 'Chiesanuova',
      iso2: '02',
      countryId: 192,
    },
    {
      id: 64,
      name: 'Domagnano',
      iso2: '03',
      countryId: 192,
    },
    {
      id: 62,
      name: 'Faetano',
      iso2: '04',
      countryId: 192,
    },
    {
      id: 66,
      name: 'Fiorentino',
      iso2: '05',
      countryId: 192,
    },
    {
      id: 63,
      name: 'Montegiardino',
      iso2: '08',
      countryId: 192,
    },
    {
      id: 58,
      name: 'San Marino',
      iso2: '07',
      countryId: 192,
    },
    {
      id: 65,
      name: 'Serravalle',
      iso2: '09',
      countryId: 192,
    },
    {
      id: 5728,
      name: 'Água Grande',
      iso2: '01',
      countryId: 193,
    },
    {
      id: 5729,
      name: 'Cantagalo',
      iso2: '02',
      countryId: 193,
    },
    {
      id: 5730,
      name: 'Caué',
      iso2: '03',
      countryId: 193,
    },
    {
      id: 5731,
      name: 'Lemba',
      iso2: '04',
      countryId: 193,
    },
    {
      id: 5732,
      name: 'Lobata',
      iso2: '05',
      countryId: 193,
    },
    {
      id: 5733,
      name: 'Mé-Zóchi',
      iso2: '06',
      countryId: 193,
    },
    {
      id: 5734,
      name: 'Príncipe',
      iso2: 'P',
      countryId: 193,
    },
    {
      id: 2859,
      name: 'Al Bahah',
      iso2: '11',
      countryId: 194,
    },
    {
      id: 2857,
      name: 'Al Jawf',
      iso2: '12',
      countryId: 194,
    },
    {
      id: 2851,
      name: 'Al Madinah',
      iso2: '03',
      countryId: 194,
    },
    {
      id: 2861,
      name: 'Al-Qassim',
      iso2: '05',
      countryId: 194,
    },
    {
      id: 2853,
      name: 'Asir',
      iso2: '14',
      countryId: 194,
    },
    {
      id: 2856,
      name: 'Eastern Province',
      iso2: '04',
      countryId: 194,
    },
    {
      id: 2855,
      name: "Ha'il",
      iso2: '06',
      countryId: 194,
    },
    {
      id: 2858,
      name: 'Jizan',
      iso2: '09',
      countryId: 194,
    },
    {
      id: 2850,
      name: 'Makkah',
      iso2: '02',
      countryId: 194,
    },
    {
      id: 2860,
      name: 'Najran',
      iso2: '10',
      countryId: 194,
    },
    {
      id: 2854,
      name: 'Northern Borders',
      iso2: '08',
      countryId: 194,
    },
    {
      id: 2849,
      name: 'Riyadh',
      iso2: '01',
      countryId: 194,
    },
    {
      id: 2852,
      name: 'Tabuk',
      iso2: '07',
      countryId: 194,
    },
    {
      id: 473,
      name: 'Dakar',
      iso2: 'DK',
      countryId: 195,
    },
    {
      id: 480,
      name: 'Diourbel Region',
      iso2: 'DB',
      countryId: 195,
    },
    {
      id: 479,
      name: 'Fatick',
      iso2: 'FK',
      countryId: 195,
    },
    {
      id: 475,
      name: 'Kaffrine',
      iso2: 'KA',
      countryId: 195,
    },
    {
      id: 483,
      name: 'Kaolack',
      iso2: 'KL',
      countryId: 195,
    },
    {
      id: 481,
      name: 'Kédougou',
      iso2: 'KE',
      countryId: 195,
    },
    {
      id: 474,
      name: 'Kolda',
      iso2: 'KD',
      countryId: 195,
    },
    {
      id: 485,
      name: 'Louga',
      iso2: 'LG',
      countryId: 195,
    },
    {
      id: 476,
      name: 'Matam',
      iso2: 'MT',
      countryId: 195,
    },
    {
      id: 477,
      name: 'Saint-Louis',
      iso2: 'SL',
      countryId: 195,
    },
    {
      id: 482,
      name: 'Sédhiou',
      iso2: 'SE',
      countryId: 195,
    },
    {
      id: 486,
      name: 'Tambacounda Region',
      iso2: 'TC',
      countryId: 195,
    },
    {
      id: 484,
      name: 'Thiès Region',
      iso2: 'TH',
      countryId: 195,
    },
    {
      id: 478,
      name: 'Ziguinchor',
      iso2: 'ZG',
      countryId: 195,
    },
    {
      id: 3728,
      name: 'Belgrade',
      iso2: '00',
      countryId: 196,
    },
    {
      id: 3717,
      name: 'Bor',
      iso2: '14',
      countryId: 196,
    },
    {
      id: 3732,
      name: 'Braničevo',
      iso2: '11',
      countryId: 196,
    },
    {
      id: 3716,
      name: 'Central Banat',
      iso2: '02',
      countryId: 196,
    },
    {
      id: 3715,
      name: 'Jablanica',
      iso2: '23',
      countryId: 196,
    },
    {
      id: 3724,
      name: 'Kolubara',
      iso2: '09',
      countryId: 196,
    },
    {
      id: 5689,
      name: 'Kosovo',
      iso2: '25',
      countryId: 196,
    },
    {
      id: 5688,
      name: 'Kosovo-Metohija',
      iso2: 'KM',
      countryId: 196,
    },
    {
      id: 5693,
      name: 'Kosovo-Pomoravlje',
      iso2: '29',
      countryId: 196,
    },
    {
      id: 5692,
      name: 'Kosovska Mitrovica',
      iso2: '28',
      countryId: 196,
    },
    {
      id: 3719,
      name: 'Mačva',
      iso2: '08',
      countryId: 196,
    },
    {
      id: 3727,
      name: 'Moravica',
      iso2: '17',
      countryId: 196,
    },
    {
      id: 3722,
      name: 'Nišava',
      iso2: '20',
      countryId: 196,
    },
    {
      id: 3714,
      name: 'North Bačka',
      iso2: '01',
      countryId: 196,
    },
    {
      id: 3736,
      name: 'North Banat',
      iso2: '03',
      countryId: 196,
    },
    {
      id: 3721,
      name: 'Pčinja',
      iso2: '24',
      countryId: 196,
    },
    {
      id: 5690,
      name: 'Peć',
      iso2: '26',
      countryId: 196,
    },
    {
      id: 3712,
      name: 'Pirot',
      iso2: '22',
      countryId: 196,
    },
    {
      id: 3741,
      name: 'Podunavlje',
      iso2: '10',
      countryId: 196,
    },
    {
      id: 3737,
      name: 'Pomoravlje',
      iso2: '13',
      countryId: 196,
    },
    {
      id: 5691,
      name: 'Prizren',
      iso2: '27',
      countryId: 196,
    },
    {
      id: 3720,
      name: 'Rasina',
      iso2: '19',
      countryId: 196,
    },
    {
      id: 3725,
      name: 'Raška',
      iso2: '18',
      countryId: 196,
    },
    {
      id: 3711,
      name: 'South Bačka',
      iso2: '06',
      countryId: 196,
    },
    {
      id: 3713,
      name: 'South Banat',
      iso2: '04',
      countryId: 196,
    },
    {
      id: 3740,
      name: 'Srem',
      iso2: '07',
      countryId: 196,
    },
    {
      id: 3734,
      name: 'Šumadija',
      iso2: '12',
      countryId: 196,
    },
    {
      id: 3718,
      name: 'Toplica',
      iso2: '21',
      countryId: 196,
    },
    {
      id: 3733,
      name: 'Vojvodina',
      iso2: 'VO',
      countryId: 196,
    },
    {
      id: 3726,
      name: 'West Bačka',
      iso2: '05',
      countryId: 196,
    },
    {
      id: 3731,
      name: 'Zaječar',
      iso2: '15',
      countryId: 196,
    },
    {
      id: 3729,
      name: 'Zlatibor',
      iso2: '16',
      countryId: 196,
    },
    {
      id: 513,
      name: 'Anse Boileau',
      iso2: '02',
      countryId: 197,
    },
    {
      id: 5694,
      name: 'Anse Etoile',
      iso2: '03',
      countryId: 197,
    },
    {
      id: 502,
      name: 'Anse Royale',
      iso2: '05',
      countryId: 197,
    },
    {
      id: 506,
      name: 'Anse-aux-Pins',
      iso2: '01',
      countryId: 197,
    },
    {
      id: 508,
      name: 'Au Cap',
      iso2: '04',
      countryId: 197,
    },
    {
      id: 497,
      name: 'Baie Lazare',
      iso2: '06',
      countryId: 197,
    },
    {
      id: 514,
      name: 'Baie Sainte Anne',
      iso2: '07',
      countryId: 197,
    },
    {
      id: 512,
      name: 'Beau Vallon',
      iso2: '08',
      countryId: 197,
    },
    {
      id: 515,
      name: 'Bel Air',
      iso2: '09',
      countryId: 197,
    },
    {
      id: 505,
      name: 'Bel Ombre',
      iso2: '10',
      countryId: 197,
    },
    {
      id: 517,
      name: 'Cascade',
      iso2: '11',
      countryId: 197,
    },
    {
      id: 503,
      name: 'Glacis',
      iso2: '12',
      countryId: 197,
    },
    {
      id: 500,
      name: "Grand'Anse Mahé",
      iso2: '13',
      countryId: 197,
    },
    {
      id: 504,
      name: "Grand'Anse Praslin",
      iso2: '14',
      countryId: 197,
    },
    {
      id: 5695,
      name: 'Ile Perseverance I',
      iso2: '26',
      countryId: 197,
    },
    {
      id: 5696,
      name: 'Ile Perseverance II',
      iso2: '27',
      countryId: 197,
    },
    {
      id: 495,
      name: 'La Digue',
      iso2: '15',
      countryId: 197,
    },
    {
      id: 516,
      name: 'La Rivière Anglaise',
      iso2: '16',
      countryId: 197,
    },
    {
      id: 499,
      name: 'Les Mamelles',
      iso2: '24',
      countryId: 197,
    },
    {
      id: 494,
      name: 'Mont Buxton',
      iso2: '17',
      countryId: 197,
    },
    {
      id: 498,
      name: 'Mont Fleuri',
      iso2: '18',
      countryId: 197,
    },
    {
      id: 511,
      name: 'Plaisance',
      iso2: '19',
      countryId: 197,
    },
    {
      id: 510,
      name: 'Pointe La Rue',
      iso2: '20',
      countryId: 197,
    },
    {
      id: 507,
      name: 'Port Glaud',
      iso2: '21',
      countryId: 197,
    },
    {
      id: 501,
      name: 'Roche Caiman',
      iso2: '25',
      countryId: 197,
    },
    {
      id: 496,
      name: 'Saint Louis',
      iso2: '22',
      countryId: 197,
    },
    {
      id: 509,
      name: 'Takamaka',
      iso2: '23',
      countryId: 197,
    },
    {
      id: 914,
      name: 'Eastern',
      iso2: 'E',
      countryId: 198,
    },
    {
      id: 5697,
      name: 'North Western',
      iso2: 'NW',
      countryId: 198,
    },
    {
      id: 911,
      name: 'Northern',
      iso2: 'N',
      countryId: 198,
    },
    {
      id: 912,
      name: 'Southern',
      iso2: 'S',
      countryId: 198,
    },
    {
      id: 913,
      name: 'Western',
      iso2: 'W',
      countryId: 198,
    },
    {
      id: 4651,
      name: 'Central Singapore',
      iso2: '01',
      countryId: 199,
    },
    {
      id: 4649,
      name: 'North East',
      iso2: '02',
      countryId: 199,
    },
    {
      id: 4653,
      name: 'North West',
      iso2: '03',
      countryId: 199,
    },
    {
      id: 4650,
      name: 'South East',
      iso2: '04',
      countryId: 199,
    },
    {
      id: 4652,
      name: 'South West',
      iso2: '05',
      countryId: 199,
    },
    {
      id: 4352,
      name: 'Banská Bystrica',
      iso2: 'BC',
      countryId: 200,
    },
    {
      id: 4356,
      name: 'Bratislava',
      iso2: 'BL',
      countryId: 200,
    },
    {
      id: 4353,
      name: 'Košice',
      iso2: 'KI',
      countryId: 200,
    },
    {
      id: 4357,
      name: 'Nitra',
      iso2: 'NI',
      countryId: 200,
    },
    {
      id: 4354,
      name: 'Prešov',
      iso2: 'PV',
      countryId: 200,
    },
    {
      id: 4358,
      name: 'Trenčín',
      iso2: 'TC',
      countryId: 200,
    },
    {
      id: 4355,
      name: 'Trnava',
      iso2: 'TA',
      countryId: 200,
    },
    {
      id: 4359,
      name: 'Žilina',
      iso2: 'ZI',
      countryId: 200,
    },
    {
      id: 4183,
      name: 'Ajdovščina',
      iso2: '001',
      countryId: 201,
    },
    {
      id: 4326,
      name: 'Ankaran',
      iso2: '213',
      countryId: 201,
    },
    {
      id: 4318,
      name: 'Apače',
      iso2: '195',
      countryId: 201,
    },
    {
      id: 4301,
      name: 'Beltinci',
      iso2: '002',
      countryId: 201,
    },
    {
      id: 4166,
      name: 'Benedikt',
      iso2: '148',
      countryId: 201,
    },
    {
      id: 4179,
      name: 'Bistrica ob Sotli',
      iso2: '149',
      countryId: 201,
    },
    {
      id: 4202,
      name: 'Bled',
      iso2: '003',
      countryId: 201,
    },
    {
      id: 4278,
      name: 'Bloke',
      iso2: '150',
      countryId: 201,
    },
    {
      id: 4282,
      name: 'Bohinj',
      iso2: '004',
      countryId: 201,
    },
    {
      id: 4200,
      name: 'Borovnica',
      iso2: '005',
      countryId: 201,
    },
    {
      id: 4181,
      name: 'Bovec',
      iso2: '006',
      countryId: 201,
    },
    {
      id: 4141,
      name: 'Braslovče',
      iso2: '151',
      countryId: 201,
    },
    {
      id: 4240,
      name: 'Brda',
      iso2: '007',
      countryId: 201,
    },
    {
      id: 4215,
      name: 'Brežice',
      iso2: '009',
      countryId: 201,
    },
    {
      id: 4165,
      name: 'Brezovica',
      iso2: '008',
      countryId: 201,
    },
    {
      id: 4147,
      name: 'Cankova',
      iso2: '152',
      countryId: 201,
    },
    {
      id: 4191,
      name: 'Celje',
      iso2: '011',
      countryId: 201,
    },
    {
      id: 4310,
      name: 'Cerklje na Gorenjskem',
      iso2: '012',
      countryId: 201,
    },
    {
      id: 4162,
      name: 'Cerknica',
      iso2: '013',
      countryId: 201,
    },
    {
      id: 4178,
      name: 'Cerkno',
      iso2: '014',
      countryId: 201,
    },
    {
      id: 4176,
      name: 'Cerkvenjak',
      iso2: '153',
      countryId: 201,
    },
    {
      id: 4309,
      name: 'Cirkulane',
      iso2: '196',
      countryId: 201,
    },
    {
      id: 4151,
      name: 'Črenšovci',
      iso2: '015',
      countryId: 201,
    },
    {
      id: 4232,
      name: 'Črna na Koroškem',
      iso2: '016',
      countryId: 201,
    },
    {
      id: 4291,
      name: 'Črnomelj',
      iso2: '017',
      countryId: 201,
    },
    {
      id: 4304,
      name: 'Destrnik',
      iso2: '018',
      countryId: 201,
    },
    {
      id: 4167,
      name: 'Divača',
      iso2: '019',
      countryId: 201,
    },
    {
      id: 4295,
      name: 'Dobje',
      iso2: '154',
      countryId: 201,
    },
    {
      id: 4216,
      name: 'Dobrepolje',
      iso2: '020',
      countryId: 201,
    },
    {
      id: 4252,
      name: 'Dobrna',
      iso2: '155',
      countryId: 201,
    },
    {
      id: 4308,
      name: 'Dobrova–Polhov Gradec',
      iso2: '021',
      countryId: 201,
    },
    {
      id: 4189,
      name: 'Dobrovnik',
      iso2: '156',
      countryId: 201,
    },
    {
      id: 4173,
      name: 'Dol pri Ljubljani',
      iso2: '022',
      countryId: 201,
    },
    {
      id: 4281,
      name: 'Dolenjske Toplice',
      iso2: '157',
      countryId: 201,
    },
    {
      id: 4159,
      name: 'Domžale',
      iso2: '023',
      countryId: 201,
    },
    {
      id: 4290,
      name: 'Dornava',
      iso2: '024',
      countryId: 201,
    },
    {
      id: 4345,
      name: 'Dravograd',
      iso2: '025',
      countryId: 201,
    },
    {
      id: 4213,
      name: 'Duplek',
      iso2: '026',
      countryId: 201,
    },
    {
      id: 4293,
      name: 'Gorenja Vas–Poljane',
      iso2: '027',
      countryId: 201,
    },
    {
      id: 4210,
      name: 'Gorišnica',
      iso2: '028',
      countryId: 201,
    },
    {
      id: 4284,
      name: 'Gorje',
      iso2: '207',
      countryId: 201,
    },
    {
      id: 4343,
      name: 'Gornja Radgona',
      iso2: '029',
      countryId: 201,
    },
    {
      id: 4339,
      name: 'Gornji Grad',
      iso2: '030',
      countryId: 201,
    },
    {
      id: 4271,
      name: 'Gornji Petrovci',
      iso2: '031',
      countryId: 201,
    },
    {
      id: 4217,
      name: 'Grad',
      iso2: '158',
      countryId: 201,
    },
    {
      id: 4336,
      name: 'Grosuplje',
      iso2: '032',
      countryId: 201,
    },
    {
      id: 4145,
      name: 'Hajdina',
      iso2: '159',
      countryId: 201,
    },
    {
      id: 4175,
      name: 'Hoče–Slivnica',
      iso2: '160',
      countryId: 201,
    },
    {
      id: 4327,
      name: 'Hodoš',
      iso2: '161',
      countryId: 201,
    },
    {
      id: 4193,
      name: 'Horjul',
      iso2: '162',
      countryId: 201,
    },
    {
      id: 4341,
      name: 'Hrastnik',
      iso2: '034',
      countryId: 201,
    },
    {
      id: 4321,
      name: 'Hrpelje–Kozina',
      iso2: '035',
      countryId: 201,
    },
    {
      id: 4152,
      name: 'Idrija',
      iso2: '036',
      countryId: 201,
    },
    {
      id: 4286,
      name: 'Ig',
      iso2: '037',
      countryId: 201,
    },
    {
      id: 4344,
      name: 'Ilirska Bistrica',
      iso2: '038',
      countryId: 201,
    },
    {
      id: 4305,
      name: 'Ivančna Gorica',
      iso2: '039',
      countryId: 201,
    },
    {
      id: 4322,
      name: 'Izola',
      iso2: '040',
      countryId: 201,
    },
    {
      id: 4337,
      name: 'Jesenice',
      iso2: '041',
      countryId: 201,
    },
    {
      id: 4203,
      name: 'Jezersko',
      iso2: '163',
      countryId: 201,
    },
    {
      id: 4266,
      name: 'Juršinci',
      iso2: '042',
      countryId: 201,
    },
    {
      id: 4180,
      name: 'Kamnik',
      iso2: '043',
      countryId: 201,
    },
    {
      id: 4227,
      name: 'Kanal ob Soči',
      iso2: '044',
      countryId: 201,
    },
    {
      id: 4150,
      name: 'Kidričevo',
      iso2: '045',
      countryId: 201,
    },
    {
      id: 4243,
      name: 'Kobarid',
      iso2: '046',
      countryId: 201,
    },
    {
      id: 4325,
      name: 'Kobilje',
      iso2: '047',
      countryId: 201,
    },
    {
      id: 4335,
      name: 'Kočevje',
      iso2: '048',
      countryId: 201,
    },
    {
      id: 4315,
      name: 'Komen',
      iso2: '049',
      countryId: 201,
    },
    {
      id: 4283,
      name: 'Komenda',
      iso2: '164',
      countryId: 201,
    },
    {
      id: 4319,
      name: 'Koper',
      iso2: '050',
      countryId: 201,
    },
    {
      id: 4254,
      name: 'Kostanjevica na Krki',
      iso2: '197',
      countryId: 201,
    },
    {
      id: 4331,
      name: 'Kostel',
      iso2: '165',
      countryId: 201,
    },
    {
      id: 4186,
      name: 'Kozje',
      iso2: '051',
      countryId: 201,
    },
    {
      id: 4287,
      name: 'Kranj',
      iso2: '052',
      countryId: 201,
    },
    {
      id: 4340,
      name: 'Kranjska Gora',
      iso2: '053',
      countryId: 201,
    },
    {
      id: 4238,
      name: 'Križevci',
      iso2: '166',
      countryId: 201,
    },
    {
      id: 4314,
      name: 'Krško',
      iso2: '054',
      countryId: 201,
    },
    {
      id: 4197,
      name: 'Kungota',
      iso2: '055',
      countryId: 201,
    },
    {
      id: 4211,
      name: 'Kuzma',
      iso2: '056',
      countryId: 201,
    },
    {
      id: 4338,
      name: 'Laško',
      iso2: '057',
      countryId: 201,
    },
    {
      id: 4142,
      name: 'Lenart',
      iso2: '058',
      countryId: 201,
    },
    {
      id: 4225,
      name: 'Lendava',
      iso2: '059',
      countryId: 201,
    },
    {
      id: 4347,
      name: 'Litija',
      iso2: '060',
      countryId: 201,
    },
    {
      id: 4270,
      name: 'Ljubljana',
      iso2: '061',
      countryId: 201,
    },
    {
      id: 4294,
      name: 'Ljubno',
      iso2: '062',
      countryId: 201,
    },
    {
      id: 4351,
      name: 'Ljutomer',
      iso2: '063',
      countryId: 201,
    },
    {
      id: 4306,
      name: 'Log–Dragomer',
      iso2: '208',
      countryId: 201,
    },
    {
      id: 4350,
      name: 'Logatec',
      iso2: '064',
      countryId: 201,
    },
    {
      id: 4174,
      name: 'Loška Dolina',
      iso2: '065',
      countryId: 201,
    },
    {
      id: 4158,
      name: 'Loški Potok',
      iso2: '066',
      countryId: 201,
    },
    {
      id: 4156,
      name: 'Lovrenc na Pohorju',
      iso2: '167',
      countryId: 201,
    },
    {
      id: 4219,
      name: 'Luče',
      iso2: '067',
      countryId: 201,
    },
    {
      id: 4302,
      name: 'Lukovica',
      iso2: '068',
      countryId: 201,
    },
    {
      id: 4157,
      name: 'Majšperk',
      iso2: '069',
      countryId: 201,
    },
    {
      id: 4224,
      name: 'Makole',
      iso2: '198',
      countryId: 201,
    },
    {
      id: 4242,
      name: 'Maribor',
      iso2: '070',
      countryId: 201,
    },
    {
      id: 4244,
      name: 'Markovci',
      iso2: '168',
      countryId: 201,
    },
    {
      id: 4349,
      name: 'Medvode',
      iso2: '071',
      countryId: 201,
    },
    {
      id: 4348,
      name: 'Mengeš',
      iso2: '072',
      countryId: 201,
    },
    {
      id: 4323,
      name: 'Metlika',
      iso2: '073',
      countryId: 201,
    },
    {
      id: 4265,
      name: 'Mežica',
      iso2: '074',
      countryId: 201,
    },
    {
      id: 4223,
      name: 'Miklavž na Dravskem Polju',
      iso2: '169',
      countryId: 201,
    },
    {
      id: 4220,
      name: 'Miren–Kostanjevica',
      iso2: '075',
      countryId: 201,
    },
    {
      id: 4298,
      name: 'Mirna',
      iso2: '212',
      countryId: 201,
    },
    {
      id: 4237,
      name: 'Mirna Peč',
      iso2: '170',
      countryId: 201,
    },
    {
      id: 4212,
      name: 'Mislinja',
      iso2: '076',
      countryId: 201,
    },
    {
      id: 4297,
      name: 'Mokronog–Trebelno',
      iso2: '199',
      countryId: 201,
    },
    {
      id: 4168,
      name: 'Moravče',
      iso2: '077',
      countryId: 201,
    },
    {
      id: 4218,
      name: 'Moravske Toplice',
      iso2: '078',
      countryId: 201,
    },
    {
      id: 4190,
      name: 'Mozirje',
      iso2: '079',
      countryId: 201,
    },
    {
      id: 4313,
      name: 'Murska Sobota',
      iso2: '080',
      countryId: 201,
    },
    {
      id: 4208,
      name: 'Muta',
      iso2: '081',
      countryId: 201,
    },
    {
      id: 4177,
      name: 'Naklo',
      iso2: '082',
      countryId: 201,
    },
    {
      id: 4329,
      name: 'Nazarje',
      iso2: '083',
      countryId: 201,
    },
    {
      id: 4205,
      name: 'Nova Gorica',
      iso2: '084',
      countryId: 201,
    },
    {
      id: 4236,
      name: 'Novo Mesto',
      iso2: '085',
      countryId: 201,
    },
    {
      id: 4320,
      name: 'Odranci',
      iso2: '086',
      countryId: 201,
    },
    {
      id: 4143,
      name: 'Oplotnica',
      iso2: '171',
      countryId: 201,
    },
    {
      id: 4221,
      name: 'Ormož',
      iso2: '087',
      countryId: 201,
    },
    {
      id: 4199,
      name: 'Osilnica',
      iso2: '088',
      countryId: 201,
    },
    {
      id: 4172,
      name: 'Pesnica',
      iso2: '089',
      countryId: 201,
    },
    {
      id: 4201,
      name: 'Piran',
      iso2: '090',
      countryId: 201,
    },
    {
      id: 4184,
      name: 'Pivka',
      iso2: '091',
      countryId: 201,
    },
    {
      id: 4146,
      name: 'Podčetrtek',
      iso2: '092',
      countryId: 201,
    },
    {
      id: 4161,
      name: 'Podlehnik',
      iso2: '172',
      countryId: 201,
    },
    {
      id: 4234,
      name: 'Podvelka',
      iso2: '093',
      countryId: 201,
    },
    {
      id: 4239,
      name: 'Poljčane',
      iso2: '200',
      countryId: 201,
    },
    {
      id: 4272,
      name: 'Polzela',
      iso2: '173',
      countryId: 201,
    },
    {
      id: 4330,
      name: 'Postojna',
      iso2: '094',
      countryId: 201,
    },
    {
      id: 4188,
      name: 'Prebold',
      iso2: '174',
      countryId: 201,
    },
    {
      id: 4303,
      name: 'Preddvor',
      iso2: '095',
      countryId: 201,
    },
    {
      id: 4274,
      name: 'Prevalje',
      iso2: '175',
      countryId: 201,
    },
    {
      id: 4228,
      name: 'Ptuj',
      iso2: '096',
      countryId: 201,
    },
    {
      id: 4288,
      name: 'Puconci',
      iso2: '097',
      countryId: 201,
    },
    {
      id: 4204,
      name: 'Rače–Fram',
      iso2: '098',
      countryId: 201,
    },
    {
      id: 4195,
      name: 'Radeče',
      iso2: '099',
      countryId: 201,
    },
    {
      id: 4292,
      name: 'Radenci',
      iso2: '100',
      countryId: 201,
    },
    {
      id: 4275,
      name: 'Radlje ob Dravi',
      iso2: '101',
      countryId: 201,
    },
    {
      id: 4231,
      name: 'Radovljica',
      iso2: '102',
      countryId: 201,
    },
    {
      id: 4155,
      name: 'Ravne na Koroškem',
      iso2: '103',
      countryId: 201,
    },
    {
      id: 4206,
      name: 'Razkrižje',
      iso2: '176',
      countryId: 201,
    },
    {
      id: 4160,
      name: 'Rečica ob Savinji',
      iso2: '209',
      countryId: 201,
    },
    {
      id: 4253,
      name: 'Renče–Vogrsko',
      iso2: '201',
      countryId: 201,
    },
    {
      id: 4235,
      name: 'Ribnica',
      iso2: '104',
      countryId: 201,
    },
    {
      id: 4207,
      name: 'Ribnica na Pohorju',
      iso2: '177',
      countryId: 201,
    },
    {
      id: 4233,
      name: 'Rogaška Slatina',
      iso2: '106',
      countryId: 201,
    },
    {
      id: 4264,
      name: 'Rogašovci',
      iso2: '105',
      countryId: 201,
    },
    {
      id: 4209,
      name: 'Rogatec',
      iso2: '107',
      countryId: 201,
    },
    {
      id: 4280,
      name: 'Ruše',
      iso2: '108',
      countryId: 201,
    },
    {
      id: 4222,
      name: 'Šalovci',
      iso2: '033',
      countryId: 201,
    },
    {
      id: 4230,
      name: 'Selnica ob Dravi',
      iso2: '178',
      countryId: 201,
    },
    {
      id: 4346,
      name: 'Semič',
      iso2: '109',
      countryId: 201,
    },
    {
      id: 4317,
      name: 'Šempeter–Vrtojba',
      iso2: '183',
      countryId: 201,
    },
    {
      id: 4299,
      name: 'Šenčur',
      iso2: '117',
      countryId: 201,
    },
    {
      id: 4324,
      name: 'Šentilj',
      iso2: '118',
      countryId: 201,
    },
    {
      id: 4241,
      name: 'Šentjernej',
      iso2: '119',
      countryId: 201,
    },
    {
      id: 4171,
      name: 'Šentjur',
      iso2: '120',
      countryId: 201,
    },
    {
      id: 4311,
      name: 'Šentrupert',
      iso2: '211',
      countryId: 201,
    },
    {
      id: 4268,
      name: 'Sevnica',
      iso2: '110',
      countryId: 201,
    },
    {
      id: 4149,
      name: 'Sežana',
      iso2: '111',
      countryId: 201,
    },
    {
      id: 4170,
      name: 'Škocjan',
      iso2: '121',
      countryId: 201,
    },
    {
      id: 4316,
      name: 'Škofja Loka',
      iso2: '122',
      countryId: 201,
    },
    {
      id: 4187,
      name: 'Škofljica',
      iso2: '123',
      countryId: 201,
    },
    {
      id: 4169,
      name: 'Slovenj Gradec',
      iso2: '112',
      countryId: 201,
    },
    {
      id: 4332,
      name: 'Slovenska Bistrica',
      iso2: '113',
      countryId: 201,
    },
    {
      id: 4198,
      name: 'Slovenske Konjice',
      iso2: '114',
      countryId: 201,
    },
    {
      id: 4285,
      name: 'Šmarje pri Jelšah',
      iso2: '124',
      countryId: 201,
    },
    {
      id: 4289,
      name: 'Šmarješke Toplice',
      iso2: '206',
      countryId: 201,
    },
    {
      id: 4296,
      name: 'Šmartno ob Paki',
      iso2: '125',
      countryId: 201,
    },
    {
      id: 4279,
      name: 'Šmartno pri Litiji',
      iso2: '194',
      countryId: 201,
    },
    {
      id: 4277,
      name: 'Sodražica',
      iso2: '179',
      countryId: 201,
    },
    {
      id: 4261,
      name: 'Solčava',
      iso2: '180',
      countryId: 201,
    },
    {
      id: 4248,
      name: 'Šoštanj',
      iso2: '126',
      countryId: 201,
    },
    {
      id: 4263,
      name: 'Središče ob Dravi',
      iso2: '202',
      countryId: 201,
    },
    {
      id: 4259,
      name: 'Starše',
      iso2: '115',
      countryId: 201,
    },
    {
      id: 4185,
      name: 'Štore',
      iso2: '127',
      countryId: 201,
    },
    {
      id: 4333,
      name: 'Straža',
      iso2: '203',
      countryId: 201,
    },
    {
      id: 4164,
      name: 'Sveta Ana',
      iso2: '181',
      countryId: 201,
    },
    {
      id: 4260,
      name: 'Sveta Trojica v Slovenskih Goricah',
      iso2: '204',
      countryId: 201,
    },
    {
      id: 4229,
      name: 'Sveti Andraž v Slovenskih Goricah',
      iso2: '182',
      countryId: 201,
    },
    {
      id: 4255,
      name: 'Sveti Jurij ob Ščavnici',
      iso2: '116',
      countryId: 201,
    },
    {
      id: 4328,
      name: 'Sveti Jurij v Slovenskih Goricah',
      iso2: '210',
      countryId: 201,
    },
    {
      id: 4273,
      name: 'Sveti Tomaž',
      iso2: '205',
      countryId: 201,
    },
    {
      id: 4194,
      name: 'Tabor',
      iso2: '184',
      countryId: 201,
    },
    {
      id: 4312,
      name: 'Tišina',
      iso2: '010',
      countryId: 201,
    },
    {
      id: 4247,
      name: 'Tolmin',
      iso2: '128',
      countryId: 201,
    },
    {
      id: 4246,
      name: 'Trbovlje',
      iso2: '129',
      countryId: 201,
    },
    {
      id: 4214,
      name: 'Trebnje',
      iso2: '130',
      countryId: 201,
    },
    {
      id: 4153,
      name: 'Trnovska Vas',
      iso2: '185',
      countryId: 201,
    },
    {
      id: 4250,
      name: 'Tržič',
      iso2: '131',
      countryId: 201,
    },
    {
      id: 4334,
      name: 'Trzin',
      iso2: '186',
      countryId: 201,
    },
    {
      id: 4251,
      name: 'Turnišče',
      iso2: '132',
      countryId: 201,
    },
    {
      id: 5698,
      name: 'Velenje',
      iso2: '133',
      countryId: 201,
    },
    {
      id: 4267,
      name: 'Velika Polana',
      iso2: '187',
      countryId: 201,
    },
    {
      id: 4144,
      name: 'Velike Lašče',
      iso2: '134',
      countryId: 201,
    },
    {
      id: 4257,
      name: 'Veržej',
      iso2: '188',
      countryId: 201,
    },
    {
      id: 4300,
      name: 'Videm',
      iso2: '135',
      countryId: 201,
    },
    {
      id: 4196,
      name: 'Vipava',
      iso2: '136',
      countryId: 201,
    },
    {
      id: 4148,
      name: 'Vitanje',
      iso2: '137',
      countryId: 201,
    },
    {
      id: 4154,
      name: 'Vodice',
      iso2: '138',
      countryId: 201,
    },
    {
      id: 4245,
      name: 'Vojnik',
      iso2: '139',
      countryId: 201,
    },
    {
      id: 4163,
      name: 'Vransko',
      iso2: '189',
      countryId: 201,
    },
    {
      id: 4262,
      name: 'Vrhnika',
      iso2: '140',
      countryId: 201,
    },
    {
      id: 4226,
      name: 'Vuzenica',
      iso2: '141',
      countryId: 201,
    },
    {
      id: 4269,
      name: 'Zagorje ob Savi',
      iso2: '142',
      countryId: 201,
    },
    {
      id: 4258,
      name: 'Žalec',
      iso2: '190',
      countryId: 201,
    },
    {
      id: 4182,
      name: 'Zavrč',
      iso2: '143',
      countryId: 201,
    },
    {
      id: 4256,
      name: 'Železniki',
      iso2: '146',
      countryId: 201,
    },
    {
      id: 4249,
      name: 'Žetale',
      iso2: '191',
      countryId: 201,
    },
    {
      id: 4192,
      name: 'Žiri',
      iso2: '147',
      countryId: 201,
    },
    {
      id: 4276,
      name: 'Žirovnica',
      iso2: '192',
      countryId: 201,
    },
    {
      id: 4342,
      name: 'Zreče',
      iso2: '144',
      countryId: 201,
    },
    {
      id: 4307,
      name: 'Žužemberk',
      iso2: '193',
      countryId: 201,
    },
    {
      id: 4784,
      name: 'Central',
      iso2: 'CE',
      countryId: 202,
    },
    {
      id: 4781,
      name: 'Choiseul',
      iso2: 'CH',
      countryId: 202,
    },
    {
      id: 4785,
      name: 'Guadalcanal',
      iso2: 'GU',
      countryId: 202,
    },
    {
      id: 4778,
      name: 'Honiara',
      iso2: 'CT',
      countryId: 202,
    },
    {
      id: 4780,
      name: 'Isabel',
      iso2: 'IS',
      countryId: 202,
    },
    {
      id: 4782,
      name: 'Makira-Ulawa',
      iso2: 'MK',
      countryId: 202,
    },
    {
      id: 4783,
      name: 'Malaita',
      iso2: 'ML',
      countryId: 202,
    },
    {
      id: 4787,
      name: 'Rennell and Bellona',
      iso2: 'RB',
      countryId: 202,
    },
    {
      id: 4779,
      name: 'Temotu',
      iso2: 'TE',
      countryId: 202,
    },
    {
      id: 4786,
      name: 'Western',
      iso2: 'WE',
      countryId: 202,
    },
    {
      id: 925,
      name: 'Awdal',
      iso2: 'AW',
      countryId: 203,
    },
    {
      id: 917,
      name: 'Bakool',
      iso2: 'BK',
      countryId: 203,
    },
    {
      id: 927,
      name: 'Banaadir',
      iso2: 'BN',
      countryId: 203,
    },
    {
      id: 930,
      name: 'Bari',
      iso2: 'BR',
      countryId: 203,
    },
    {
      id: 926,
      name: 'Bay',
      iso2: 'BY',
      countryId: 203,
    },
    {
      id: 918,
      name: 'Galguduud',
      iso2: 'GA',
      countryId: 203,
    },
    {
      id: 928,
      name: 'Gedo',
      iso2: 'GE',
      countryId: 203,
    },
    {
      id: 915,
      name: 'Hiran',
      iso2: 'HI',
      countryId: 203,
    },
    {
      id: 924,
      name: 'Lower Juba',
      iso2: 'JH',
      countryId: 203,
    },
    {
      id: 921,
      name: 'Lower Shebelle',
      iso2: 'SH',
      countryId: 203,
    },
    {
      id: 922,
      name: 'Middle Juba',
      iso2: 'JD',
      countryId: 203,
    },
    {
      id: 923,
      name: 'Middle Shebelle',
      iso2: 'SD',
      countryId: 203,
    },
    {
      id: 916,
      name: 'Mudug',
      iso2: 'MU',
      countryId: 203,
    },
    {
      id: 920,
      name: 'Nugal',
      iso2: 'NU',
      countryId: 203,
    },
    {
      id: 919,
      name: 'Sanaag',
      iso2: 'SA',
      countryId: 203,
    },
    {
      id: 5699,
      name: 'Sool',
      iso2: 'SO',
      countryId: 203,
    },
    {
      id: 929,
      name: 'Togdheer',
      iso2: 'TO',
      countryId: 203,
    },
    {
      id: 5700,
      name: 'Woqooyi Galbeed',
      iso2: 'WO',
      countryId: 203,
    },
    {
      id: 938,
      name: 'Eastern Cape',
      iso2: 'EC',
      countryId: 204,
    },
    {
      id: 932,
      name: 'Free State',
      iso2: 'FS',
      countryId: 204,
    },
    {
      id: 936,
      name: 'Gauteng',
      iso2: 'GP',
      countryId: 204,
    },
    {
      id: 935,
      name: 'KwaZulu-Natal',
      iso2: 'KZN',
      countryId: 204,
    },
    {
      id: 933,
      name: 'Limpopo',
      iso2: 'LP',
      countryId: 204,
    },
    {
      id: 937,
      name: 'Mpumalanga',
      iso2: 'MP',
      countryId: 204,
    },
    {
      id: 934,
      name: 'North West',
      iso2: 'NW',
      countryId: 204,
    },
    {
      id: 931,
      name: 'Northern Cape',
      iso2: 'NC',
      countryId: 204,
    },
    {
      id: 939,
      name: 'Western Cape',
      iso2: 'WC',
      countryId: 204,
    },
    {
      id: 3860,
      name: 'Busan',
      iso2: '26',
      countryId: 116,
    },
    {
      id: 3846,
      name: 'Daegu',
      iso2: '27',
      countryId: 116,
    },
    {
      id: 3850,
      name: 'Daejeon',
      iso2: '30',
      countryId: 116,
    },
    {
      id: 3862,
      name: 'Gangwon',
      iso2: '42',
      countryId: 116,
    },
    {
      id: 3858,
      name: 'Gwangju',
      iso2: '29',
      countryId: 116,
    },
    {
      id: 3847,
      name: 'Gyeonggi',
      iso2: '41',
      countryId: 116,
    },
    {
      id: 3848,
      name: 'Incheon',
      iso2: '28',
      countryId: 116,
    },
    {
      id: 3853,
      name: 'Jeju',
      iso2: '49',
      countryId: 116,
    },
    {
      id: 3854,
      name: 'North Chungcheong',
      iso2: '43',
      countryId: 116,
    },
    {
      id: 3855,
      name: 'North Gyeongsang',
      iso2: '47',
      countryId: 116,
    },
    {
      id: 3851,
      name: 'North Jeolla',
      iso2: '45',
      countryId: 116,
    },
    {
      id: 3861,
      name: 'Sejong City',
      iso2: '50',
      countryId: 116,
    },
    {
      id: 3849,
      name: 'Seoul',
      iso2: '11',
      countryId: 116,
    },
    {
      id: 3859,
      name: 'South Chungcheong',
      iso2: '44',
      countryId: 116,
    },
    {
      id: 3857,
      name: 'South Gyeongsang',
      iso2: '48',
      countryId: 116,
    },
    {
      id: 3856,
      name: 'South Jeolla',
      iso2: '46',
      countryId: 116,
    },
    {
      id: 3852,
      name: 'Ulsan',
      iso2: '31',
      countryId: 116,
    },
    {
      id: 2092,
      name: 'Central Equatoria',
      iso2: 'EC',
      countryId: 206,
    },
    {
      id: 2093,
      name: 'Eastern Equatoria',
      iso2: 'EE',
      countryId: 206,
    },
    {
      id: 2094,
      name: 'Jonglei State',
      iso2: 'JG',
      countryId: 206,
    },
    {
      id: 2090,
      name: 'Lakes',
      iso2: 'LK',
      countryId: 206,
    },
    {
      id: 2088,
      name: 'Northern Bahr el Ghazal',
      iso2: 'BN',
      countryId: 206,
    },
    {
      id: 2085,
      name: 'Unity',
      iso2: 'UY',
      countryId: 206,
    },
    {
      id: 2086,
      name: 'Upper Nile',
      iso2: 'NU',
      countryId: 206,
    },
    {
      id: 2087,
      name: 'Warrap',
      iso2: 'WR',
      countryId: 206,
    },
    {
      id: 2091,
      name: 'Western Bahr el Ghazal',
      iso2: 'BW',
      countryId: 206,
    },
    {
      id: 2089,
      name: 'Western Equatoria',
      iso2: 'EW',
      countryId: 206,
    },
    {
      id: 5089,
      name: 'A Coruña',
      iso2: 'C',
      countryId: 207,
    },
    {
      id: 5109,
      name: 'Albacete',
      iso2: 'AB',
      countryId: 207,
    },
    {
      id: 5108,
      name: 'Alicante',
      iso2: 'A',
      countryId: 207,
    },
    {
      id: 5095,
      name: 'Almeria',
      iso2: 'AL',
      countryId: 207,
    },
    {
      id: 5325,
      name: 'Andalusia',
      iso2: 'AN',
      countryId: 207,
    },
    {
      id: 5093,
      name: 'Araba',
      iso2: 'VI',
      countryId: 207,
    },
    {
      id: 5326,
      name: 'Aragon',
      iso2: 'AR',
      countryId: 207,
    },
    {
      id: 1160,
      name: 'Asturias',
      iso2: 'O',
      countryId: 207,
    },
    {
      id: 5701,
      name: 'Asturias, Principality of',
      iso2: 'AS',
      countryId: 207,
    },
    {
      id: 1189,
      name: 'Ávila',
      iso2: 'AV',
      countryId: 207,
    },
    {
      id: 5092,
      name: 'Badajoz',
      iso2: 'BA',
      countryId: 207,
    },
    {
      id: 5335,
      name: 'Balearic Islands',
      iso2: 'IB',
      countryId: 207,
    },
    {
      id: 5102,
      name: 'Barcelona',
      iso2: 'B',
      countryId: 207,
    },
    {
      id: 5332,
      name: 'Basque State',
      iso2: 'PV',
      countryId: 207,
    },
    {
      id: 5094,
      name: 'Bizkaia',
      iso2: 'BI',
      countryId: 207,
    },
    {
      id: 1146,
      name: 'Burgos',
      iso2: 'BU',
      countryId: 207,
    },
    {
      id: 1190,
      name: 'Caceres',
      iso2: 'CC',
      countryId: 207,
    },
    {
      id: 5096,
      name: 'Cádiz',
      iso2: 'CA',
      countryId: 207,
    },
    {
      id: 5222,
      name: 'Canary Islands',
      iso2: 'CN',
      countryId: 207,
    },
    {
      id: 1170,
      name: 'Cantabria',
      iso2: 'S',
      countryId: 207,
    },
    {
      id: 5702,
      name: 'Cantabria',
      iso2: 'CB',
      countryId: 207,
    },
    {
      id: 5110,
      name: 'Castellón',
      iso2: 'CS',
      countryId: 207,
    },
    {
      id: 5329,
      name: 'Castile and Leon',
      iso2: 'CL',
      countryId: 207,
    },
    {
      id: 5330,
      name: 'Castilla-La Mancha',
      iso2: 'CM',
      countryId: 207,
    },
    {
      id: 5331,
      name: 'Catalonia',
      iso2: 'CT',
      countryId: 207,
    },
    {
      id: 5223,
      name: 'Ceuta',
      iso2: 'CE',
      countryId: 207,
    },
    {
      id: 5105,
      name: 'Ciudad Real',
      iso2: 'CR',
      countryId: 207,
    },
    {
      id: 5337,
      name: 'Community of Madrid',
      iso2: 'MD',
      countryId: 207,
    },
    {
      id: 5097,
      name: 'Córdoba',
      iso2: 'CO',
      countryId: 207,
    },
    {
      id: 5106,
      name: 'Cuenca',
      iso2: 'CU',
      countryId: 207,
    },
    {
      id: 5333,
      name: 'Estremadura',
      iso2: 'EX',
      countryId: 207,
    },
    {
      id: 5334,
      name: 'Galicia',
      iso2: 'GA',
      countryId: 207,
    },
    {
      id: 1191,
      name: 'Gipuzkoa',
      iso2: 'SS',
      countryId: 207,
    },
    {
      id: 5103,
      name: 'Girona',
      iso2: 'GI',
      countryId: 207,
    },
    {
      id: 5098,
      name: 'Granada',
      iso2: 'GR',
      countryId: 207,
    },
    {
      id: 5107,
      name: 'Guadalajara',
      iso2: 'GU',
      countryId: 207,
    },
    {
      id: 5099,
      name: 'Huelva',
      iso2: 'H',
      countryId: 207,
    },
    {
      id: 1177,
      name: 'Huesca',
      iso2: 'HU',
      countryId: 207,
    },
    {
      id: 1174,
      name: 'Islas Baleares',
      iso2: 'PM',
      countryId: 207,
    },
    {
      id: 5100,
      name: 'Jaén',
      iso2: 'J',
      countryId: 207,
    },
    {
      id: 5703,
      name: 'La Rioja',
      iso2: 'RI',
      countryId: 207,
    },
    {
      id: 1171,
      name: 'La Rioja',
      iso2: 'LO',
      countryId: 207,
    },
    {
      id: 1185,
      name: 'Las Palmas',
      iso2: 'GC',
      countryId: 207,
    },
    {
      id: 1200,
      name: 'León',
      iso2: 'LE',
      countryId: 207,
    },
    {
      id: 5104,
      name: 'Lleida',
      iso2: 'L',
      countryId: 207,
    },
    {
      id: 5090,
      name: 'Lugo',
      iso2: 'LU',
      countryId: 207,
    },
    {
      id: 1158,
      name: 'Madrid',
      iso2: 'M',
      countryId: 207,
    },
    {
      id: 5101,
      name: 'Málaga',
      iso2: 'MA',
      countryId: 207,
    },
    {
      id: 5224,
      name: 'Melilla',
      iso2: 'ML',
      countryId: 207,
    },
    {
      id: 1176,
      name: 'Murcia',
      iso2: 'MU',
      countryId: 207,
    },
    {
      id: 1204,
      name: 'Navarra',
      iso2: 'NA',
      countryId: 207,
    },
    {
      id: 5339,
      name: 'Navarre',
      iso2: 'NC',
      countryId: 207,
    },
    {
      id: 5091,
      name: 'Ourense',
      iso2: 'OR',
      countryId: 207,
    },
    {
      id: 1157,
      name: 'Palencia',
      iso2: 'P',
      countryId: 207,
    },
    {
      id: 1167,
      name: 'Pontevedra',
      iso2: 'PO',
      countryId: 207,
    },
    {
      id: 5338,
      name: 'Region of Murcia',
      iso2: 'MC',
      countryId: 207,
    },
    {
      id: 1147,
      name: 'Salamanca',
      iso2: 'SA',
      countryId: 207,
    },
    {
      id: 5112,
      name: 'Santa Cruz de Tenerife',
      iso2: 'TF',
      countryId: 207,
    },
    {
      id: 1192,
      name: 'Segovia',
      iso2: 'SG',
      countryId: 207,
    },
    {
      id: 1193,
      name: 'Sevilla',
      iso2: 'SE',
      countryId: 207,
    },
    {
      id: 1208,
      name: 'Soria',
      iso2: 'SO',
      countryId: 207,
    },
    {
      id: 1203,
      name: 'Tarragona',
      iso2: 'T',
      countryId: 207,
    },
    {
      id: 5111,
      name: 'Teruel',
      iso2: 'TE',
      countryId: 207,
    },
    {
      id: 1205,
      name: 'Toledo',
      iso2: 'TO',
      countryId: 207,
    },
    {
      id: 1175,
      name: 'Valencia',
      iso2: 'V',
      countryId: 207,
    },
    {
      id: 5340,
      name: 'Valencian Community',
      iso2: 'VC',
      countryId: 207,
    },
    {
      id: 1183,
      name: 'Valladolid',
      iso2: 'VA',
      countryId: 207,
    },
    {
      id: 1161,
      name: 'Zamora',
      iso2: 'ZA',
      countryId: 207,
    },
    {
      id: 5113,
      name: 'Zaragoza',
      iso2: 'Z',
      countryId: 207,
    },
    {
      id: 2799,
      name: 'Ampara',
      iso2: '52',
      countryId: 208,
    },
    {
      id: 2816,
      name: 'Anuradhapura',
      iso2: '71',
      countryId: 208,
    },
    {
      id: 2790,
      name: 'Badulla',
      iso2: '81',
      countryId: 208,
    },
    {
      id: 2818,
      name: 'Batticaloa',
      iso2: '51',
      countryId: 208,
    },
    {
      id: 2798,
      name: 'Central',
      iso2: '2',
      countryId: 208,
    },
    {
      id: 2815,
      name: 'Colombo',
      iso2: '11',
      countryId: 208,
    },
    {
      id: 2808,
      name: 'Eastern',
      iso2: '5',
      countryId: 208,
    },
    {
      id: 2792,
      name: 'Galle',
      iso2: '31',
      countryId: 208,
    },
    {
      id: 2804,
      name: 'Gampaha',
      iso2: '12',
      countryId: 208,
    },
    {
      id: 2791,
      name: 'Hambantota',
      iso2: '33',
      countryId: 208,
    },
    {
      id: 2787,
      name: 'Jaffna',
      iso2: '41',
      countryId: 208,
    },
    {
      id: 2789,
      name: 'Kalutara',
      iso2: '13',
      countryId: 208,
    },
    {
      id: 2788,
      name: 'Kandy',
      iso2: '21',
      countryId: 208,
    },
    {
      id: 2797,
      name: 'Kegalle',
      iso2: '92',
      countryId: 208,
    },
    {
      id: 2793,
      name: 'Kilinochchi',
      iso2: '42',
      countryId: 208,
    },
    {
      id: 5342,
      name: 'Kurunegala',
      iso2: '61',
      countryId: 208,
    },
    {
      id: 2805,
      name: 'Mannar',
      iso2: '43',
      countryId: 208,
    },
    {
      id: 2810,
      name: 'Matale',
      iso2: '22',
      countryId: 208,
    },
    {
      id: 2806,
      name: 'Matara',
      iso2: '32',
      countryId: 208,
    },
    {
      id: 2819,
      name: 'Monaragala',
      iso2: '82',
      countryId: 208,
    },
    {
      id: 2814,
      name: 'Mullaitivu',
      iso2: '45',
      countryId: 208,
    },
    {
      id: 2800,
      name: 'North Central',
      iso2: '7',
      countryId: 208,
    },
    {
      id: 2817,
      name: 'North Western',
      iso2: '6',
      countryId: 208,
    },
    {
      id: 2813,
      name: 'Northern',
      iso2: '4',
      countryId: 208,
    },
    {
      id: 2794,
      name: 'Nuwara Eliya',
      iso2: '23',
      countryId: 208,
    },
    {
      id: 2812,
      name: 'Polonnaruwa',
      iso2: '72',
      countryId: 208,
    },
    {
      id: 2796,
      name: 'Puttalam',
      iso2: '62',
      countryId: 208,
    },
    {
      id: 2807,
      name: 'Ratnapura',
      iso2: '91',
      countryId: 208,
    },
    {
      id: 2803,
      name: 'Sabaragamuwa',
      iso2: '9',
      countryId: 208,
    },
    {
      id: 2801,
      name: 'Southern',
      iso2: '3',
      countryId: 208,
    },
    {
      id: 2795,
      name: 'Trincomalee',
      iso2: '53',
      countryId: 208,
    },
    {
      id: 2811,
      name: 'Uva',
      iso2: '8',
      countryId: 208,
    },
    {
      id: 2809,
      name: 'Vavuniya',
      iso2: '44',
      countryId: 208,
    },
    {
      id: 2802,
      name: 'Western',
      iso2: '1',
      countryId: 208,
    },
    {
      id: 885,
      name: 'Al Jazirah',
      iso2: 'GZ',
      countryId: 209,
    },
    {
      id: 886,
      name: 'Al Qadarif',
      iso2: 'GD',
      countryId: 209,
    },
    {
      id: 887,
      name: 'Blue Nile',
      iso2: 'NB',
      countryId: 209,
    },
    {
      id: 896,
      name: 'Central Darfur',
      iso2: 'DC',
      countryId: 209,
    },
    {
      id: 892,
      name: 'East Darfur',
      iso2: 'DE',
      countryId: 209,
    },
    {
      id: 884,
      name: 'Kassala',
      iso2: 'KA',
      countryId: 209,
    },
    {
      id: 881,
      name: 'Khartoum',
      iso2: 'KH',
      countryId: 209,
    },
    {
      id: 890,
      name: 'North Darfur',
      iso2: 'DN',
      countryId: 209,
    },
    {
      id: 893,
      name: 'North Kordofan',
      iso2: 'KN',
      countryId: 209,
    },
    {
      id: 895,
      name: 'Northern',
      iso2: 'NO',
      countryId: 209,
    },
    {
      id: 880,
      name: 'Red Sea',
      iso2: 'RS',
      countryId: 209,
    },
    {
      id: 891,
      name: 'River Nile',
      iso2: 'NR',
      countryId: 209,
    },
    {
      id: 882,
      name: 'Sennar',
      iso2: 'SI',
      countryId: 209,
    },
    {
      id: 894,
      name: 'South Darfur',
      iso2: 'DS',
      countryId: 209,
    },
    {
      id: 883,
      name: 'South Kordofan',
      iso2: 'KS',
      countryId: 209,
    },
    {
      id: 888,
      name: 'West Darfur',
      iso2: 'DW',
      countryId: 209,
    },
    {
      id: 889,
      name: 'West Kordofan',
      iso2: 'GK',
      countryId: 209,
    },
    {
      id: 879,
      name: 'White Nile',
      iso2: 'NW',
      countryId: 209,
    },
    {
      id: 2846,
      name: 'Brokopondo',
      iso2: 'BR',
      countryId: 210,
    },
    {
      id: 2839,
      name: 'Commewijne',
      iso2: 'CM',
      countryId: 210,
    },
    {
      id: 2842,
      name: 'Coronie',
      iso2: 'CR',
      countryId: 210,
    },
    {
      id: 2845,
      name: 'Marowijne',
      iso2: 'MA',
      countryId: 210,
    },
    {
      id: 2840,
      name: 'Nickerie',
      iso2: 'NI',
      countryId: 210,
    },
    {
      id: 2841,
      name: 'Para',
      iso2: 'PR',
      countryId: 210,
    },
    {
      id: 2843,
      name: 'Paramaribo',
      iso2: 'PM',
      countryId: 210,
    },
    {
      id: 2848,
      name: 'Saramacca',
      iso2: 'SA',
      countryId: 210,
    },
    {
      id: 2847,
      name: 'Sipaliwini',
      iso2: 'SI',
      countryId: 210,
    },
    {
      id: 2844,
      name: 'Wanica',
      iso2: 'WA',
      countryId: 210,
    },
    {
      id: 1537,
      name: 'Blekinge',
      iso2: 'K',
      countryId: 213,
    },
    {
      id: 1534,
      name: 'Dalarna',
      iso2: 'W',
      countryId: 213,
    },
    {
      id: 1533,
      name: 'Gävleborg',
      iso2: 'X',
      countryId: 213,
    },
    {
      id: 1546,
      name: 'Gotland',
      iso2: 'I',
      countryId: 213,
    },
    {
      id: 1548,
      name: 'Halland',
      iso2: 'N',
      countryId: 213,
    },
    {
      id: 5117,
      name: 'Jämtland',
      iso2: 'Z',
      countryId: 213,
    },
    {
      id: 1550,
      name: 'Jönköping',
      iso2: 'F',
      countryId: 213,
    },
    {
      id: 1544,
      name: 'Kalmar',
      iso2: 'H',
      countryId: 213,
    },
    {
      id: 1542,
      name: 'Kronoberg',
      iso2: 'G',
      countryId: 213,
    },
    {
      id: 1538,
      name: 'Norrbotten',
      iso2: 'BD',
      countryId: 213,
    },
    {
      id: 1539,
      name: 'Örebro',
      iso2: 'T',
      countryId: 213,
    },
    {
      id: 1536,
      name: 'Östergötland',
      iso2: 'E',
      countryId: 213,
    },
    {
      id: 1541,
      name: 'Skåne',
      iso2: 'M',
      countryId: 213,
    },
    {
      id: 1540,
      name: 'Södermanland',
      iso2: 'D',
      countryId: 213,
    },
    {
      id: 1551,
      name: 'Stockholm',
      iso2: 'AB',
      countryId: 213,
    },
    {
      id: 1545,
      name: 'Uppsala',
      iso2: 'C',
      countryId: 213,
    },
    {
      id: 1535,
      name: 'Värmland',
      iso2: 'S',
      countryId: 213,
    },
    {
      id: 1543,
      name: 'Västerbotten',
      iso2: 'AC',
      countryId: 213,
    },
    {
      id: 1552,
      name: 'Västernorrland',
      iso2: 'Y',
      countryId: 213,
    },
    {
      id: 1549,
      name: 'Västmanland',
      iso2: 'U',
      countryId: 213,
    },
    {
      id: 1547,
      name: 'Västra Götaland',
      iso2: 'O',
      countryId: 213,
    },
    {
      id: 1639,
      name: 'Aargau',
      iso2: 'AG',
      countryId: 214,
    },
    {
      id: 1655,
      name: 'Appenzell Ausserrhoden',
      iso2: 'AR',
      countryId: 214,
    },
    {
      id: 1649,
      name: 'Appenzell Innerrhoden',
      iso2: 'AI',
      countryId: 214,
    },
    {
      id: 1641,
      name: 'Basel-Land',
      iso2: 'BL',
      countryId: 214,
    },
    {
      id: 4957,
      name: 'Basel-Stadt',
      iso2: 'BS',
      countryId: 214,
    },
    {
      id: 1645,
      name: 'Bern',
      iso2: 'BE',
      countryId: 214,
    },
    {
      id: 1640,
      name: 'Fribourg',
      iso2: 'FR',
      countryId: 214,
    },
    {
      id: 1647,
      name: 'Geneva',
      iso2: 'GE',
      countryId: 214,
    },
    {
      id: 1661,
      name: 'Glarus',
      iso2: 'GL',
      countryId: 214,
    },
    {
      id: 1660,
      name: 'Graubünden',
      iso2: 'GR',
      countryId: 214,
    },
    {
      id: 1658,
      name: 'Jura',
      iso2: 'JU',
      countryId: 214,
    },
    {
      id: 1663,
      name: 'Lucerne',
      iso2: 'LU',
      countryId: 214,
    },
    {
      id: 1659,
      name: 'Neuchâtel',
      iso2: 'NE',
      countryId: 214,
    },
    {
      id: 1652,
      name: 'Nidwalden',
      iso2: 'NW',
      countryId: 214,
    },
    {
      id: 1650,
      name: 'Obwalden',
      iso2: 'OW',
      countryId: 214,
    },
    {
      id: 1654,
      name: 'Schaffhausen',
      iso2: 'SH',
      countryId: 214,
    },
    {
      id: 1653,
      name: 'Schwyz',
      iso2: 'SZ',
      countryId: 214,
    },
    {
      id: 1662,
      name: 'Solothurn',
      iso2: 'SO',
      countryId: 214,
    },
    {
      id: 1644,
      name: 'St. Gallen',
      iso2: 'SG',
      countryId: 214,
    },
    {
      id: 1657,
      name: 'Thurgau',
      iso2: 'TG',
      countryId: 214,
    },
    {
      id: 1643,
      name: 'Ticino',
      iso2: 'TI',
      countryId: 214,
    },
    {
      id: 1642,
      name: 'Uri',
      iso2: 'UR',
      countryId: 214,
    },
    {
      id: 1648,
      name: 'Valais',
      iso2: 'VS',
      countryId: 214,
    },
    {
      id: 1651,
      name: 'Vaud',
      iso2: 'VD',
      countryId: 214,
    },
    {
      id: 1646,
      name: 'Zug',
      iso2: 'ZG',
      countryId: 214,
    },
    {
      id: 1656,
      name: 'Zürich',
      iso2: 'ZH',
      countryId: 214,
    },
    {
      id: 2941,
      name: 'Al-Hasakah',
      iso2: 'HA',
      countryId: 215,
    },
    {
      id: 2944,
      name: 'Al-Raqqah',
      iso2: 'RA',
      countryId: 215,
    },
    {
      id: 2946,
      name: 'Aleppo',
      iso2: 'HL',
      countryId: 215,
    },
    {
      id: 2936,
      name: 'As-Suwayda',
      iso2: 'SU',
      countryId: 215,
    },
    {
      id: 2939,
      name: 'Damascus',
      iso2: 'DI',
      countryId: 215,
    },
    {
      id: 2945,
      name: 'Daraa',
      iso2: 'DR',
      countryId: 215,
    },
    {
      id: 2937,
      name: 'Deir ez-Zor',
      iso2: 'DY',
      countryId: 215,
    },
    {
      id: 2934,
      name: 'Hama',
      iso2: 'HM',
      countryId: 215,
    },
    {
      id: 2942,
      name: 'Homs',
      iso2: 'HI',
      countryId: 215,
    },
    {
      id: 2940,
      name: 'Idlib',
      iso2: 'ID',
      countryId: 215,
    },
    {
      id: 2938,
      name: 'Latakia',
      iso2: 'LA',
      countryId: 215,
    },
    {
      id: 2943,
      name: 'Quneitra',
      iso2: 'QU',
      countryId: 215,
    },
    {
      id: 2935,
      name: 'Rif Dimashq',
      iso2: 'RD',
      countryId: 215,
    },
    {
      id: 2947,
      name: 'Tartus',
      iso2: 'TA',
      countryId: 215,
    },
    {
      id: 3404,
      name: 'Changhua',
      iso2: 'CHA',
      countryId: 216,
    },
    {
      id: 3408,
      name: 'Chiayi',
      iso2: 'CYI',
      countryId: 216,
    },
    {
      id: 5704,
      name: 'Chiayi County',
      iso2: 'CYQ',
      countryId: 216,
    },
    {
      id: 3417,
      name: 'Hsinchu',
      iso2: 'HSZ',
      countryId: 216,
    },
    {
      id: 5705,
      name: 'Hsinchu County',
      iso2: 'HSQ',
      countryId: 216,
    },
    {
      id: 3411,
      name: 'Hualien',
      iso2: 'HUA',
      countryId: 216,
    },
    {
      id: 3412,
      name: 'Kaohsiung',
      iso2: 'KHH',
      countryId: 216,
    },
    {
      id: 4965,
      name: 'Keelung',
      iso2: 'KEE',
      countryId: 216,
    },
    {
      id: 3415,
      name: 'Kinmen',
      iso2: 'KIN',
      countryId: 216,
    },
    {
      id: 3420,
      name: 'Lienchiang',
      iso2: 'LIE',
      countryId: 216,
    },
    {
      id: 3413,
      name: 'Miaoli',
      iso2: 'MIA',
      countryId: 216,
    },
    {
      id: 3407,
      name: 'Nantou',
      iso2: 'NAN',
      countryId: 216,
    },
    {
      id: 4966,
      name: 'New Taipei',
      iso2: 'NWT',
      countryId: 216,
    },
    {
      id: 3403,
      name: 'Penghu',
      iso2: 'PEN',
      countryId: 216,
    },
    {
      id: 3405,
      name: 'Pingtung',
      iso2: 'PIF',
      countryId: 216,
    },
    {
      id: 3406,
      name: 'Taichung',
      iso2: 'TXG',
      countryId: 216,
    },
    {
      id: 3421,
      name: 'Tainan',
      iso2: 'TNN',
      countryId: 216,
    },
    {
      id: 3422,
      name: 'Taipei',
      iso2: 'TPE',
      countryId: 216,
    },
    {
      id: 3410,
      name: 'Taitung',
      iso2: 'TTT',
      countryId: 216,
    },
    {
      id: 3419,
      name: 'Taoyuan',
      iso2: 'TAO',
      countryId: 216,
    },
    {
      id: 3402,
      name: 'Yilan',
      iso2: 'ILA',
      countryId: 216,
    },
    {
      id: 3416,
      name: 'Yunlin',
      iso2: 'YUN',
      countryId: 216,
    },
    {
      id: 5706,
      name: 'Dushanbe',
      iso2: 'DU',
      countryId: 217,
    },
    {
      id: 3399,
      name: 'Gorno-Badakhshan',
      iso2: 'GB',
      countryId: 217,
    },
    {
      id: 3398,
      name: 'Khatlon',
      iso2: 'KT',
      countryId: 217,
    },
    {
      id: 3397,
      name: 'Nohiyahoi Tobei Jumhurí ',
      iso2: 'RA',
      countryId: 217,
    },
    {
      id: 3400,
      name: 'Sughd ',
      iso2: 'SU',
      countryId: 217,
    },
    {
      id: 1491,
      name: 'Arusha',
      iso2: '01',
      countryId: 218,
    },
    {
      id: 1490,
      name: 'Dar es Salaam',
      iso2: '02',
      countryId: 218,
    },
    {
      id: 1466,
      name: 'Dodoma',
      iso2: '03',
      countryId: 218,
    },
    {
      id: 1481,
      name: 'Geita',
      iso2: '27',
      countryId: 218,
    },
    {
      id: 1489,
      name: 'Iringa',
      iso2: '04',
      countryId: 218,
    },
    {
      id: 1465,
      name: 'Kagera',
      iso2: '05',
      countryId: 218,
    },
    {
      id: 1482,
      name: 'Katavi',
      iso2: '28',
      countryId: 218,
    },
    {
      id: 1478,
      name: 'Kigoma',
      iso2: '08',
      countryId: 218,
    },
    {
      id: 1467,
      name: 'Kilimanjaro',
      iso2: '09',
      countryId: 218,
    },
    {
      id: 1483,
      name: 'Lindi',
      iso2: '12',
      countryId: 218,
    },
    {
      id: 1484,
      name: 'Manyara',
      iso2: '26',
      countryId: 218,
    },
    {
      id: 1468,
      name: 'Mara',
      iso2: '13',
      countryId: 218,
    },
    {
      id: 4955,
      name: 'Mbeya',
      iso2: '14',
      countryId: 218,
    },
    {
      id: 1470,
      name: 'Morogoro',
      iso2: '16',
      countryId: 218,
    },
    {
      id: 1476,
      name: 'Mtwara',
      iso2: '17',
      countryId: 218,
    },
    {
      id: 1479,
      name: 'Mwanza',
      iso2: '18',
      countryId: 218,
    },
    {
      id: 1480,
      name: 'Njombe',
      iso2: '29',
      countryId: 218,
    },
    {
      id: 1488,
      name: 'Pemba North',
      iso2: '06',
      countryId: 218,
    },
    {
      id: 1472,
      name: 'Pemba South',
      iso2: '10',
      countryId: 218,
    },
    {
      id: 1485,
      name: 'Pwani',
      iso2: '19',
      countryId: 218,
    },
    {
      id: 1477,
      name: 'Rukwa',
      iso2: '20',
      countryId: 218,
    },
    {
      id: 1486,
      name: 'Ruvuma',
      iso2: '21',
      countryId: 218,
    },
    {
      id: 1463,
      name: 'Shinyanga',
      iso2: '22',
      countryId: 218,
    },
    {
      id: 1464,
      name: 'Simiyu',
      iso2: '30',
      countryId: 218,
    },
    {
      id: 1474,
      name: 'Singida',
      iso2: '23',
      countryId: 218,
    },
    {
      id: 4956,
      name: 'Songwe',
      iso2: '31',
      countryId: 218,
    },
    {
      id: 1469,
      name: 'Tabora',
      iso2: '24',
      countryId: 218,
    },
    {
      id: 1487,
      name: 'Tanga',
      iso2: '25',
      countryId: 218,
    },
    {
      id: 1473,
      name: 'Zanzibar North',
      iso2: '07',
      countryId: 218,
    },
    {
      id: 1471,
      name: 'Zanzibar South',
      iso2: '11',
      countryId: 218,
    },
    {
      id: 1475,
      name: 'Zanzibar West',
      iso2: '15',
      countryId: 218,
    },
    {
      id: 3523,
      name: 'Amnat Charoen',
      iso2: '37',
      countryId: 219,
    },
    {
      id: 3519,
      name: 'Ang Thong',
      iso2: '15',
      countryId: 219,
    },
    {
      id: 3554,
      name: 'Bangkok',
      iso2: '10',
      countryId: 219,
    },
    {
      id: 3533,
      name: 'Bueng Kan',
      iso2: '38',
      countryId: 219,
    },
    {
      id: 3534,
      name: 'Buri Ram',
      iso2: '31',
      countryId: 219,
    },
    {
      id: 3552,
      name: 'Chachoengsao',
      iso2: '24',
      countryId: 219,
    },
    {
      id: 3522,
      name: 'Chai Nat',
      iso2: '18',
      countryId: 219,
    },
    {
      id: 4954,
      name: 'Chaiyaphum',
      iso2: '36',
      countryId: 219,
    },
    {
      id: 3486,
      name: 'Chanthaburi',
      iso2: '22',
      countryId: 219,
    },
    {
      id: 3491,
      name: 'Chiang Mai',
      iso2: '50',
      countryId: 219,
    },
    {
      id: 3498,
      name: 'Chiang Rai',
      iso2: '57',
      countryId: 219,
    },
    {
      id: 3513,
      name: 'Chon Buri',
      iso2: '20',
      countryId: 219,
    },
    {
      id: 3526,
      name: 'Chumphon',
      iso2: '86',
      countryId: 219,
    },
    {
      id: 3550,
      name: 'Kalasin',
      iso2: '46',
      countryId: 219,
    },
    {
      id: 3516,
      name: 'Kamphaeng Phet',
      iso2: '62',
      countryId: 219,
    },
    {
      id: 3511,
      name: 'Kanchanaburi',
      iso2: '71',
      countryId: 219,
    },
    {
      id: 3485,
      name: 'Khon Kaen',
      iso2: '40',
      countryId: 219,
    },
    {
      id: 3478,
      name: 'Krabi',
      iso2: '81',
      countryId: 219,
    },
    {
      id: 3544,
      name: 'Lampang',
      iso2: '52',
      countryId: 219,
    },
    {
      id: 3483,
      name: 'Lamphun',
      iso2: '51',
      countryId: 219,
    },
    {
      id: 3509,
      name: 'Loei',
      iso2: '42',
      countryId: 219,
    },
    {
      id: 3543,
      name: 'Lop Buri',
      iso2: '16',
      countryId: 219,
    },
    {
      id: 3505,
      name: 'Mae Hong Son',
      iso2: '58',
      countryId: 219,
    },
    {
      id: 3517,
      name: 'Maha Sarakham',
      iso2: '44',
      countryId: 219,
    },
    {
      id: 3546,
      name: 'Mukdahan',
      iso2: '49',
      countryId: 219,
    },
    {
      id: 3535,
      name: 'Nakhon Nayok',
      iso2: '26',
      countryId: 219,
    },
    {
      id: 3503,
      name: 'Nakhon Pathom',
      iso2: '73',
      countryId: 219,
    },
    {
      id: 3548,
      name: 'Nakhon Phanom',
      iso2: '48',
      countryId: 219,
    },
    {
      id: 3497,
      name: 'Nakhon Ratchasima',
      iso2: '30',
      countryId: 219,
    },
    {
      id: 3492,
      name: 'Nakhon Sawan',
      iso2: '60',
      countryId: 219,
    },
    {
      id: 3520,
      name: 'Nakhon Si Thammarat',
      iso2: '80',
      countryId: 219,
    },
    {
      id: 3530,
      name: 'Nan',
      iso2: '55',
      countryId: 219,
    },
    {
      id: 3553,
      name: 'Narathiwat',
      iso2: '96',
      countryId: 219,
    },
    {
      id: 3480,
      name: 'Nong Bua Lam Phu',
      iso2: '39',
      countryId: 219,
    },
    {
      id: 3484,
      name: 'Nong Khai',
      iso2: '43',
      countryId: 219,
    },
    {
      id: 3495,
      name: 'Nonthaburi',
      iso2: '12',
      countryId: 219,
    },
    {
      id: 3500,
      name: 'Pathum Thani',
      iso2: '13',
      countryId: 219,
    },
    {
      id: 3540,
      name: 'Pattani',
      iso2: '94',
      countryId: 219,
    },
    {
      id: 3507,
      name: 'Pattaya',
      iso2: 'S',
      countryId: 219,
    },
    {
      id: 3549,
      name: 'Phangnga',
      iso2: '82',
      countryId: 219,
    },
    {
      id: 3488,
      name: 'Phatthalung',
      iso2: '93',
      countryId: 219,
    },
    {
      id: 3538,
      name: 'Phayao',
      iso2: '56',
      countryId: 219,
    },
    {
      id: 3515,
      name: 'Phetchabun',
      iso2: '67',
      countryId: 219,
    },
    {
      id: 3532,
      name: 'Phetchaburi',
      iso2: '76',
      countryId: 219,
    },
    {
      id: 3514,
      name: 'Phichit',
      iso2: '66',
      countryId: 219,
    },
    {
      id: 3506,
      name: 'Phitsanulok',
      iso2: '65',
      countryId: 219,
    },
    {
      id: 3494,
      name: 'Phra Nakhon Si Ayutthaya',
      iso2: '14',
      countryId: 219,
    },
    {
      id: 3528,
      name: 'Phrae',
      iso2: '54',
      countryId: 219,
    },
    {
      id: 3536,
      name: 'Phuket',
      iso2: '83',
      countryId: 219,
    },
    {
      id: 3542,
      name: 'Prachin Buri',
      iso2: '25',
      countryId: 219,
    },
    {
      id: 3508,
      name: 'Prachuap Khiri Khan',
      iso2: '77',
      countryId: 219,
    },
    {
      id: 3479,
      name: 'Ranong',
      iso2: '85',
      countryId: 219,
    },
    {
      id: 3499,
      name: 'Ratchaburi',
      iso2: '70',
      countryId: 219,
    },
    {
      id: 3518,
      name: 'Rayong',
      iso2: '21',
      countryId: 219,
    },
    {
      id: 3510,
      name: 'Roi Et',
      iso2: '45',
      countryId: 219,
    },
    {
      id: 3529,
      name: 'Sa Kaeo',
      iso2: '27',
      countryId: 219,
    },
    {
      id: 3501,
      name: 'Sakon Nakhon',
      iso2: '47',
      countryId: 219,
    },
    {
      id: 3481,
      name: 'Samut Prakan',
      iso2: '11',
      countryId: 219,
    },
    {
      id: 3504,
      name: 'Samut Sakhon',
      iso2: '74',
      countryId: 219,
    },
    {
      id: 3502,
      name: 'Samut Songkhram',
      iso2: '75',
      countryId: 219,
    },
    {
      id: 3487,
      name: 'Saraburi',
      iso2: '19',
      countryId: 219,
    },
    {
      id: 3537,
      name: 'Satun',
      iso2: '91',
      countryId: 219,
    },
    {
      id: 3547,
      name: 'Si Sa Ket',
      iso2: '33',
      countryId: 219,
    },
    {
      id: 3490,
      name: 'Sing Buri',
      iso2: '17',
      countryId: 219,
    },
    {
      id: 3539,
      name: 'Songkhla',
      iso2: '90',
      countryId: 219,
    },
    {
      id: 3545,
      name: 'Sukhothai',
      iso2: '64',
      countryId: 219,
    },
    {
      id: 3524,
      name: 'Suphan Buri',
      iso2: '72',
      countryId: 219,
    },
    {
      id: 3482,
      name: 'Surat Thani',
      iso2: '84',
      countryId: 219,
    },
    {
      id: 3531,
      name: 'Surin',
      iso2: '32',
      countryId: 219,
    },
    {
      id: 3525,
      name: 'Tak',
      iso2: '63',
      countryId: 219,
    },
    {
      id: 3541,
      name: 'Trang',
      iso2: '92',
      countryId: 219,
    },
    {
      id: 3496,
      name: 'Trat',
      iso2: '23',
      countryId: 219,
    },
    {
      id: 3512,
      name: 'Ubon Ratchathani',
      iso2: '34',
      countryId: 219,
    },
    {
      id: 3527,
      name: 'Udon Thani',
      iso2: '41',
      countryId: 219,
    },
    {
      id: 3551,
      name: 'Uthai Thani',
      iso2: '61',
      countryId: 219,
    },
    {
      id: 3489,
      name: 'Uttaradit',
      iso2: '53',
      countryId: 219,
    },
    {
      id: 3493,
      name: 'Yala',
      iso2: '95',
      countryId: 219,
    },
    {
      id: 3521,
      name: 'Yasothon',
      iso2: '35',
      countryId: 219,
    },
    {
      id: 3601,
      name: 'Acklins',
      iso2: 'AK',
      countryId: 17,
    },
    {
      id: 3593,
      name: 'Berry Islands',
      iso2: 'BY',
      countryId: 17,
    },
    {
      id: 3629,
      name: 'Bimini',
      iso2: 'BI',
      countryId: 17,
    },
    {
      id: 3605,
      name: 'Black Point',
      iso2: 'BP',
      countryId: 17,
    },
    {
      id: 3611,
      name: 'Cat Island',
      iso2: 'CI',
      countryId: 17,
    },
    {
      id: 3603,
      name: 'Central Abaco',
      iso2: 'CO',
      countryId: 17,
    },
    {
      id: 3631,
      name: 'Central Andros',
      iso2: 'CS',
      countryId: 17,
    },
    {
      id: 3596,
      name: 'Central Eleuthera',
      iso2: 'CE',
      countryId: 17,
    },
    {
      id: 3621,
      name: 'Crooked Island',
      iso2: 'CK',
      countryId: 17,
    },
    {
      id: 3614,
      name: 'East Grand Bahama',
      iso2: 'EG',
      countryId: 17,
    },
    {
      id: 3612,
      name: 'Exuma',
      iso2: 'EX',
      countryId: 17,
    },
    {
      id: 3626,
      name: 'Freeport',
      iso2: 'FP',
      countryId: 17,
    },
    {
      id: 3632,
      name: 'Grand Cay',
      iso2: 'GC',
      countryId: 17,
    },
    {
      id: 3613,
      name: 'Harbour Island',
      iso2: 'HI',
      countryId: 17,
    },
    {
      id: 3624,
      name: 'Hope Town',
      iso2: 'HT',
      countryId: 17,
    },
    {
      id: 3609,
      name: 'Inagua',
      iso2: 'IN',
      countryId: 17,
    },
    {
      id: 3610,
      name: 'Long Island',
      iso2: 'LI',
      countryId: 17,
    },
    {
      id: 3625,
      name: 'Mangrove Cay',
      iso2: 'MC',
      countryId: 17,
    },
    {
      id: 3633,
      name: 'Mayaguana',
      iso2: 'MG',
      countryId: 17,
    },
    {
      id: 5717,
      name: "Moore's Island",
      iso2: 'MI',
      countryId: 17,
    },
    {
      id: 4881,
      name: 'New Providence',
      iso2: 'NP',
      countryId: 17,
    },
    {
      id: 3616,
      name: 'North Abaco',
      iso2: 'NO',
      countryId: 17,
    },
    {
      id: 3617,
      name: 'North Andros',
      iso2: 'NS',
      countryId: 17,
    },
    {
      id: 3602,
      name: 'North Eleuthera',
      iso2: 'NE',
      countryId: 17,
    },
    {
      id: 3615,
      name: 'Ragged Island',
      iso2: 'RI',
      countryId: 17,
    },
    {
      id: 3600,
      name: 'Rum Cay',
      iso2: 'RC',
      countryId: 17,
    },
    {
      id: 3627,
      name: 'San Salvador Island',
      iso2: 'SS',
      countryId: 17,
    },
    {
      id: 3608,
      name: 'South Abaco',
      iso2: 'SO',
      countryId: 17,
    },
    {
      id: 3622,
      name: 'South Andros',
      iso2: 'SA',
      countryId: 17,
    },
    {
      id: 3607,
      name: 'South Eleuthera',
      iso2: 'SE',
      countryId: 17,
    },
    {
      id: 3630,
      name: 'Spanish Wells',
      iso2: 'SW',
      countryId: 17,
    },
    {
      id: 3599,
      name: 'West Grand Bahama',
      iso2: 'WG',
      countryId: 17,
    },
    {
      id: 2666,
      name: 'Banjul',
      iso2: 'B',
      countryId: 80,
    },
    {
      id: 2669,
      name: 'Central River',
      iso2: 'M',
      countryId: 80,
    },
    {
      id: 2670,
      name: 'Lower River',
      iso2: 'L',
      countryId: 80,
    },
    {
      id: 2671,
      name: 'North Bank',
      iso2: 'N',
      countryId: 80,
    },
    {
      id: 2668,
      name: 'Upper River',
      iso2: 'U',
      countryId: 80,
    },
    {
      id: 2667,
      name: 'West Coast',
      iso2: 'W',
      countryId: 80,
    },
    {
      id: 4520,
      name: 'Aileu',
      iso2: 'AL',
      countryId: 63,
    },
    {
      id: 4518,
      name: 'Ainaro',
      iso2: 'AN',
      countryId: 63,
    },
    {
      id: 4521,
      name: 'Baucau',
      iso2: 'BA',
      countryId: 63,
    },
    {
      id: 4525,
      name: 'Bobonaro',
      iso2: 'BO',
      countryId: 63,
    },
    {
      id: 4522,
      name: 'Cova Lima',
      iso2: 'CO',
      countryId: 63,
    },
    {
      id: 4524,
      name: 'Dili',
      iso2: 'DI',
      countryId: 63,
    },
    {
      id: 4516,
      name: 'Ermera',
      iso2: 'ER',
      countryId: 63,
    },
    {
      id: 4523,
      name: 'Lautém',
      iso2: 'LA',
      countryId: 63,
    },
    {
      id: 4515,
      name: 'Liquiçá',
      iso2: 'LI',
      countryId: 63,
    },
    {
      id: 4517,
      name: 'Manatuto',
      iso2: 'MT',
      countryId: 63,
    },
    {
      id: 4519,
      name: 'Manufahi',
      iso2: 'MF',
      countryId: 63,
    },
    {
      id: 5550,
      name: 'Oecusse',
      iso2: 'OE',
      countryId: 63,
    },
    {
      id: 4514,
      name: 'Viqueque',
      iso2: 'VI',
      countryId: 63,
    },
    {
      id: 2575,
      name: 'Centrale',
      iso2: 'C',
      countryId: 220,
    },
    {
      id: 2579,
      name: 'Kara',
      iso2: 'K',
      countryId: 220,
    },
    {
      id: 2576,
      name: 'Maritime',
      iso2: 'M',
      countryId: 220,
    },
    {
      id: 2577,
      name: 'Plateaux',
      iso2: 'P',
      countryId: 220,
    },
    {
      id: 2578,
      name: 'Savanes',
      iso2: 'S',
      countryId: 220,
    },
    {
      id: 3913,
      name: 'Haʻapai',
      iso2: '02',
      countryId: 222,
    },
    {
      id: 3915,
      name: 'ʻEua',
      iso2: '01',
      countryId: 222,
    },
    {
      id: 3914,
      name: 'Niuas',
      iso2: '03',
      countryId: 222,
    },
    {
      id: 3912,
      name: 'Tongatapu',
      iso2: '04',
      countryId: 222,
    },
    {
      id: 3911,
      name: 'Vavaʻu',
      iso2: '05',
      countryId: 222,
    },
    {
      id: 3362,
      name: 'Arima',
      iso2: 'ARI',
      countryId: 223,
    },
    {
      id: 3366,
      name: 'Chaguanas',
      iso2: 'CHA',
      countryId: 223,
    },
    {
      id: 3354,
      name: 'Couva-Tabaquite-Talparo',
      iso2: 'CTT',
      countryId: 223,
    },
    {
      id: 3367,
      name: 'Diego Martin',
      iso2: 'DMN',
      countryId: 223,
    },
    {
      id: 3355,
      name: 'Eastern Tobago',
      iso2: 'ETO',
      countryId: 223,
    },
    {
      id: 3365,
      name: 'Penal-Debe',
      iso2: 'PED',
      countryId: 223,
    },
    {
      id: 3360,
      name: 'Point Fortin',
      iso2: 'PTF',
      countryId: 223,
    },
    {
      id: 3363,
      name: 'Port of Spain',
      iso2: 'POS',
      countryId: 223,
    },
    {
      id: 3368,
      name: 'Princes Town',
      iso2: 'PRT',
      countryId: 223,
    },
    {
      id: 3356,
      name: 'Rio Claro-Mayaro',
      iso2: 'MRC',
      countryId: 223,
    },
    {
      id: 3359,
      name: 'San Fernando',
      iso2: 'SFO',
      countryId: 223,
    },
    {
      id: 3357,
      name: 'San Juan-Laventille',
      iso2: 'SJL',
      countryId: 223,
    },
    {
      id: 3361,
      name: 'Sangre Grande',
      iso2: 'SGE',
      countryId: 223,
    },
    {
      id: 3364,
      name: 'Siparia',
      iso2: 'SIP',
      countryId: 223,
    },
    {
      id: 5735,
      name: 'Tobago',
      iso2: 'TOB',
      countryId: 223,
    },
    {
      id: 3358,
      name: 'Tunapuna-Piarco',
      iso2: 'TUP',
      countryId: 223,
    },
    {
      id: 3353,
      name: 'Western Tobago',
      iso2: 'WTO',
      countryId: 223,
    },
    {
      id: 2550,
      name: 'Ariana',
      iso2: '12',
      countryId: 224,
    },
    {
      id: 2572,
      name: 'Béja',
      iso2: '31',
      countryId: 224,
    },
    {
      id: 2566,
      name: 'Ben Arous',
      iso2: '13',
      countryId: 224,
    },
    {
      id: 2551,
      name: 'Bizerte',
      iso2: '23',
      countryId: 224,
    },
    {
      id: 2558,
      name: 'Gabès',
      iso2: '81',
      countryId: 224,
    },
    {
      id: 2556,
      name: 'Gafsa',
      iso2: '71',
      countryId: 224,
    },
    {
      id: 2552,
      name: 'Jendouba',
      iso2: '32',
      countryId: 224,
    },
    {
      id: 2564,
      name: 'Kairouan',
      iso2: '41',
      countryId: 224,
    },
    {
      id: 2570,
      name: 'Kasserine',
      iso2: '42',
      countryId: 224,
    },
    {
      id: 2562,
      name: 'Kebili',
      iso2: '73',
      countryId: 224,
    },
    {
      id: 2561,
      name: 'Kef',
      iso2: '33',
      countryId: 224,
    },
    {
      id: 2568,
      name: 'Mahdia',
      iso2: '53',
      countryId: 224,
    },
    {
      id: 2555,
      name: 'Manouba',
      iso2: '14',
      countryId: 224,
    },
    {
      id: 2560,
      name: 'Medenine',
      iso2: '82',
      countryId: 224,
    },
    {
      id: 2553,
      name: 'Monastir',
      iso2: '52',
      countryId: 224,
    },
    {
      id: 5116,
      name: 'Nabeul',
      iso2: '21',
      countryId: 224,
    },
    {
      id: 2557,
      name: 'Sfax',
      iso2: '61',
      countryId: 224,
    },
    {
      id: 2567,
      name: 'Sidi Bouzid',
      iso2: '43',
      countryId: 224,
    },
    {
      id: 2563,
      name: 'Siliana',
      iso2: '34',
      countryId: 224,
    },
    {
      id: 2571,
      name: 'Sousse',
      iso2: '51',
      countryId: 224,
    },
    {
      id: 2559,
      name: 'Tataouine',
      iso2: '83',
      countryId: 224,
    },
    {
      id: 2569,
      name: 'Tozeur',
      iso2: '72',
      countryId: 224,
    },
    {
      id: 2554,
      name: 'Tunis',
      iso2: '11',
      countryId: 224,
    },
    {
      id: 2565,
      name: 'Zaghouan',
      iso2: '22',
      countryId: 224,
    },
    {
      id: 2212,
      name: 'Adana',
      iso2: '01',
      countryId: 225,
    },
    {
      id: 2155,
      name: 'Adıyaman',
      iso2: '02',
      countryId: 225,
    },
    {
      id: 2179,
      name: 'Afyonkarahisar',
      iso2: '03',
      countryId: 225,
    },
    {
      id: 2193,
      name: 'Ağrı',
      iso2: '04',
      countryId: 225,
    },
    {
      id: 2210,
      name: 'Aksaray',
      iso2: '68',
      countryId: 225,
    },
    {
      id: 2161,
      name: 'Amasya',
      iso2: '05',
      countryId: 225,
    },
    {
      id: 2217,
      name: 'Ankara',
      iso2: '06',
      countryId: 225,
    },
    {
      id: 2169,
      name: 'Antalya',
      iso2: '07',
      countryId: 225,
    },
    {
      id: 2185,
      name: 'Ardahan',
      iso2: '75',
      countryId: 225,
    },
    {
      id: 2191,
      name: 'Artvin',
      iso2: '08',
      countryId: 225,
    },
    {
      id: 2187,
      name: 'Aydın',
      iso2: '09',
      countryId: 225,
    },
    {
      id: 2175,
      name: 'Balıkesir',
      iso2: '10',
      countryId: 225,
    },
    {
      id: 2148,
      name: 'Bartın',
      iso2: '74',
      countryId: 225,
    },
    {
      id: 2194,
      name: 'Batman',
      iso2: '72',
      countryId: 225,
    },
    {
      id: 2177,
      name: 'Bayburt',
      iso2: '69',
      countryId: 225,
    },
    {
      id: 2221,
      name: 'Bilecik',
      iso2: '11',
      countryId: 225,
    },
    {
      id: 2153,
      name: 'Bingöl',
      iso2: '12',
      countryId: 225,
    },
    {
      id: 2215,
      name: 'Bitlis',
      iso2: '13',
      countryId: 225,
    },
    {
      id: 2172,
      name: 'Bolu',
      iso2: '14',
      countryId: 225,
    },
    {
      id: 2209,
      name: 'Burdur',
      iso2: '15',
      countryId: 225,
    },
    {
      id: 2163,
      name: 'Bursa',
      iso2: '16',
      countryId: 225,
    },
    {
      id: 2216,
      name: 'Çanakkale',
      iso2: '17',
      countryId: 225,
    },
    {
      id: 2168,
      name: 'Çankırı',
      iso2: '18',
      countryId: 225,
    },
    {
      id: 2173,
      name: 'Çorum',
      iso2: '19',
      countryId: 225,
    },
    {
      id: 2157,
      name: 'Denizli',
      iso2: '20',
      countryId: 225,
    },
    {
      id: 2226,
      name: 'Diyarbakır',
      iso2: '21',
      countryId: 225,
    },
    {
      id: 2202,
      name: 'Düzce',
      iso2: '81',
      countryId: 225,
    },
    {
      id: 2151,
      name: 'Edirne',
      iso2: '22',
      countryId: 225,
    },
    {
      id: 2159,
      name: 'Elazığ',
      iso2: '23',
      countryId: 225,
    },
    {
      id: 2160,
      name: 'Erzincan',
      iso2: '24',
      countryId: 225,
    },
    {
      id: 2165,
      name: 'Erzurum',
      iso2: '25',
      countryId: 225,
    },
    {
      id: 2164,
      name: 'Eskişehir',
      iso2: '26',
      countryId: 225,
    },
    {
      id: 2203,
      name: 'Gaziantep',
      iso2: '27',
      countryId: 225,
    },
    {
      id: 2186,
      name: 'Giresun',
      iso2: '28',
      countryId: 225,
    },
    {
      id: 2204,
      name: 'Gümüşhane',
      iso2: '29',
      countryId: 225,
    },
    {
      id: 2190,
      name: 'Hakkâri',
      iso2: '30',
      countryId: 225,
    },
    {
      id: 2211,
      name: 'Hatay',
      iso2: '31',
      countryId: 225,
    },
    {
      id: 2166,
      name: 'Iğdır',
      iso2: '76',
      countryId: 225,
    },
    {
      id: 2222,
      name: 'Isparta',
      iso2: '32',
      countryId: 225,
    },
    {
      id: 2170,
      name: 'İstanbul',
      iso2: '34',
      countryId: 225,
    },
    {
      id: 2205,
      name: 'İzmir',
      iso2: '35',
      countryId: 225,
    },
    {
      id: 2227,
      name: 'Kahramanmaraş',
      iso2: '46',
      countryId: 225,
    },
    {
      id: 2223,
      name: 'Karabük',
      iso2: '78',
      countryId: 225,
    },
    {
      id: 2184,
      name: 'Karaman',
      iso2: '70',
      countryId: 225,
    },
    {
      id: 2208,
      name: 'Kars',
      iso2: '36',
      countryId: 225,
    },
    {
      id: 2197,
      name: 'Kastamonu',
      iso2: '37',
      countryId: 225,
    },
    {
      id: 2200,
      name: 'Kayseri',
      iso2: '38',
      countryId: 225,
    },
    {
      id: 2154,
      name: 'Kilis',
      iso2: '79',
      countryId: 225,
    },
    {
      id: 2178,
      name: 'Kırıkkale',
      iso2: '71',
      countryId: 225,
    },
    {
      id: 2176,
      name: 'Kırklareli',
      iso2: '39',
      countryId: 225,
    },
    {
      id: 2180,
      name: 'Kırşehir',
      iso2: '40',
      countryId: 225,
    },
    {
      id: 2195,
      name: 'Kocaeli',
      iso2: '41',
      countryId: 225,
    },
    {
      id: 2171,
      name: 'Konya',
      iso2: '42',
      countryId: 225,
    },
    {
      id: 2149,
      name: 'Kütahya',
      iso2: '43',
      countryId: 225,
    },
    {
      id: 2158,
      name: 'Malatya',
      iso2: '44',
      countryId: 225,
    },
    {
      id: 2198,
      name: 'Manisa',
      iso2: '45',
      countryId: 225,
    },
    {
      id: 2224,
      name: 'Mardin',
      iso2: '47',
      countryId: 225,
    },
    {
      id: 2156,
      name: 'Mersin',
      iso2: '33',
      countryId: 225,
    },
    {
      id: 2182,
      name: 'Muğla',
      iso2: '48',
      countryId: 225,
    },
    {
      id: 2162,
      name: 'Muş',
      iso2: '49',
      countryId: 225,
    },
    {
      id: 2196,
      name: 'Nevşehir',
      iso2: '50',
      countryId: 225,
    },
    {
      id: 2189,
      name: 'Niğde',
      iso2: '51',
      countryId: 225,
    },
    {
      id: 2174,
      name: 'Ordu',
      iso2: '52',
      countryId: 225,
    },
    {
      id: 2214,
      name: 'Osmaniye',
      iso2: '80',
      countryId: 225,
    },
    {
      id: 2219,
      name: 'Rize',
      iso2: '53',
      countryId: 225,
    },
    {
      id: 2150,
      name: 'Sakarya',
      iso2: '54',
      countryId: 225,
    },
    {
      id: 2220,
      name: 'Samsun',
      iso2: '55',
      countryId: 225,
    },
    {
      id: 2183,
      name: 'Şanlıurfa',
      iso2: '63',
      countryId: 225,
    },
    {
      id: 2207,
      name: 'Siirt',
      iso2: '56',
      countryId: 225,
    },
    {
      id: 4854,
      name: 'Sinop',
      iso2: '57',
      countryId: 225,
    },
    {
      id: 2181,
      name: 'Sivas',
      iso2: '58',
      countryId: 225,
    },
    {
      id: 2225,
      name: 'Şırnak',
      iso2: '73',
      countryId: 225,
    },
    {
      id: 2167,
      name: 'Tekirdağ',
      iso2: '59',
      countryId: 225,
    },
    {
      id: 2199,
      name: 'Tokat',
      iso2: '60',
      countryId: 225,
    },
    {
      id: 2206,
      name: 'Trabzon',
      iso2: '61',
      countryId: 225,
    },
    {
      id: 2192,
      name: 'Tunceli',
      iso2: '62',
      countryId: 225,
    },
    {
      id: 2201,
      name: 'Uşak',
      iso2: '64',
      countryId: 225,
    },
    {
      id: 2152,
      name: 'Van',
      iso2: '65',
      countryId: 225,
    },
    {
      id: 2218,
      name: 'Yalova',
      iso2: '77',
      countryId: 225,
    },
    {
      id: 2188,
      name: 'Yozgat',
      iso2: '66',
      countryId: 225,
    },
    {
      id: 2213,
      name: 'Zonguldak',
      iso2: '67',
      countryId: 225,
    },
    {
      id: 3374,
      name: 'Ahal',
      iso2: 'A',
      countryId: 226,
    },
    {
      id: 3371,
      name: 'Ashgabat',
      iso2: 'S',
      countryId: 226,
    },
    {
      id: 3372,
      name: 'Balkan',
      iso2: 'B',
      countryId: 226,
    },
    {
      id: 3373,
      name: 'Daşoguz',
      iso2: 'D',
      countryId: 226,
    },
    {
      id: 3370,
      name: 'Lebap',
      iso2: 'L',
      countryId: 226,
    },
    {
      id: 3369,
      name: 'Mary',
      iso2: 'M',
      countryId: 226,
    },
    {
      id: 5367,
      name: 'Grand Turk',
      iso2: '05',
      countryId: 227,
    },
    {
      id: 5365,
      name: 'Middle Caicos',
      iso2: '03',
      countryId: 227,
    },
    {
      id: 5364,
      name: 'North Caicos',
      iso2: '02',
      countryId: 227,
    },
    {
      id: 5363,
      name: 'Providenciales',
      iso2: '01',
      countryId: 227,
    },
    {
      id: 5368,
      name: 'Salt Cay',
      iso2: '06',
      countryId: 227,
    },
    {
      id: 5366,
      name: 'South Caicos',
      iso2: '04',
      countryId: 227,
    },
    {
      id: 3951,
      name: 'Funafuti',
      iso2: 'FUN',
      countryId: 228,
    },
    {
      id: 3947,
      name: 'Nanumanga',
      iso2: 'NMG',
      countryId: 228,
    },
    {
      id: 3949,
      name: 'Nanumea',
      iso2: 'NMA',
      countryId: 228,
    },
    {
      id: 3946,
      name: 'Niutao Island Council',
      iso2: 'NIT',
      countryId: 228,
    },
    {
      id: 3948,
      name: 'Nui',
      iso2: 'NUI',
      countryId: 228,
    },
    {
      id: 3952,
      name: 'Nukufetau',
      iso2: 'NKF',
      countryId: 228,
    },
    {
      id: 3953,
      name: 'Nukulaelae',
      iso2: 'NKL',
      countryId: 228,
    },
    {
      id: 3950,
      name: 'Vaitupu',
      iso2: 'VAI',
      countryId: 228,
    },
    {
      id: 329,
      name: 'Abim',
      iso2: '314',
      countryId: 229,
    },
    {
      id: 361,
      name: 'Adjumani',
      iso2: '301',
      countryId: 229,
    },
    {
      id: 392,
      name: 'Agago',
      iso2: '322',
      countryId: 229,
    },
    {
      id: 344,
      name: 'Alebtong',
      iso2: '323',
      countryId: 229,
    },
    {
      id: 416,
      name: 'Amolatar',
      iso2: '315',
      countryId: 229,
    },
    {
      id: 353,
      name: 'Amudat',
      iso2: '324',
      countryId: 229,
    },
    {
      id: 352,
      name: 'Amuria',
      iso2: '216',
      countryId: 229,
    },
    {
      id: 335,
      name: 'Amuru',
      iso2: '316',
      countryId: 229,
    },
    {
      id: 328,
      name: 'Apac',
      iso2: '302',
      countryId: 229,
    },
    {
      id: 447,
      name: 'Arua',
      iso2: '303',
      countryId: 229,
    },
    {
      id: 441,
      name: 'Budaka',
      iso2: '217',
      countryId: 229,
    },
    {
      id: 349,
      name: 'Bududa',
      iso2: '218',
      countryId: 229,
    },
    {
      id: 387,
      name: 'Bugiri',
      iso2: '201',
      countryId: 229,
    },
    {
      id: 5350,
      name: 'Bugweri',
      iso2: '235',
      countryId: 229,
    },
    {
      id: 391,
      name: 'Buhweju',
      iso2: '420',
      countryId: 229,
    },
    {
      id: 377,
      name: 'Buikwe',
      iso2: '117',
      countryId: 229,
    },
    {
      id: 343,
      name: 'Bukedea',
      iso2: '219',
      countryId: 229,
    },
    {
      id: 375,
      name: 'Bukomansimbi',
      iso2: '118',
      countryId: 229,
    },
    {
      id: 385,
      name: 'Bukwo',
      iso2: '220',
      countryId: 229,
    },
    {
      id: 428,
      name: 'Bulambuli',
      iso2: '225',
      countryId: 229,
    },
    {
      id: 389,
      name: 'Buliisa',
      iso2: '416',
      countryId: 229,
    },
    {
      id: 419,
      name: 'Bundibugyo',
      iso2: '401',
      countryId: 229,
    },
    {
      id: 381,
      name: 'Bunyangabu',
      iso2: '430',
      countryId: 229,
    },
    {
      id: 386,
      name: 'Bushenyi',
      iso2: '402',
      countryId: 229,
    },
    {
      id: 431,
      name: 'Busia',
      iso2: '202',
      countryId: 229,
    },
    {
      id: 365,
      name: 'Butaleja',
      iso2: '221',
      countryId: 229,
    },
    {
      id: 384,
      name: 'Butambala',
      iso2: '119',
      countryId: 229,
    },
    {
      id: 388,
      name: 'Butebo',
      iso2: '233',
      countryId: 229,
    },
    {
      id: 414,
      name: 'Buvuma',
      iso2: '120',
      countryId: 229,
    },
    {
      id: 380,
      name: 'Buyende',
      iso2: '226',
      countryId: 229,
    },
    {
      id: 396,
      name: 'Central',
      iso2: 'C',
      countryId: 229,
    },
    {
      id: 341,
      name: 'Dokolo',
      iso2: '317',
      countryId: 229,
    },
    {
      id: 372,
      name: 'Eastern',
      iso2: 'E',
      countryId: 229,
    },
    {
      id: 366,
      name: 'Gomba',
      iso2: '121',
      countryId: 229,
    },
    {
      id: 413,
      name: 'Gulu',
      iso2: '304',
      countryId: 229,
    },
    {
      id: 5358,
      name: 'Hoima',
      iso2: '403',
      countryId: 229,
    },
    {
      id: 339,
      name: 'Ibanda',
      iso2: '417',
      countryId: 229,
    },
    {
      id: 340,
      name: 'Iganga',
      iso2: '203',
      countryId: 229,
    },
    {
      id: 383,
      name: 'Isingiro',
      iso2: '418',
      countryId: 229,
    },
    {
      id: 367,
      name: 'Jinja',
      iso2: '204',
      countryId: 229,
    },
    {
      id: 434,
      name: 'Kaabong',
      iso2: '318',
      countryId: 229,
    },
    {
      id: 426,
      name: 'Kabale',
      iso2: '404',
      countryId: 229,
    },
    {
      id: 326,
      name: 'Kabarole',
      iso2: '405',
      countryId: 229,
    },
    {
      id: 336,
      name: 'Kaberamaido',
      iso2: '213',
      countryId: 229,
    },
    {
      id: 403,
      name: 'Kagadi',
      iso2: '427',
      countryId: 229,
    },
    {
      id: 399,
      name: 'Kakumiro',
      iso2: '428',
      countryId: 229,
    },
    {
      id: 5352,
      name: 'Kalaki',
      iso2: '237',
      countryId: 229,
    },
    {
      id: 405,
      name: 'Kalangala',
      iso2: '101',
      countryId: 229,
    },
    {
      id: 398,
      name: 'Kaliro',
      iso2: '222',
      countryId: 229,
    },
    {
      id: 394,
      name: 'Kalungu',
      iso2: '122',
      countryId: 229,
    },
    {
      id: 382,
      name: 'Kampala',
      iso2: '102',
      countryId: 229,
    },
    {
      id: 334,
      name: 'Kamuli',
      iso2: '205',
      countryId: 229,
    },
    {
      id: 360,
      name: 'Kamwenge',
      iso2: '413',
      countryId: 229,
    },
    {
      id: 373,
      name: 'Kanungu',
      iso2: '414',
      countryId: 229,
    },
    {
      id: 432,
      name: 'Kapchorwa',
      iso2: '206',
      countryId: 229,
    },
    {
      id: 5351,
      name: 'Kapelebyong',
      iso2: '236',
      countryId: 229,
    },
    {
      id: 5355,
      name: 'Karenga',
      iso2: '335',
      countryId: 229,
    },
    {
      id: 5349,
      name: 'Kasanda',
      iso2: '126',
      countryId: 229,
    },
    {
      id: 440,
      name: 'Kasese',
      iso2: '406',
      countryId: 229,
    },
    {
      id: 420,
      name: 'Katakwi',
      iso2: '207',
      countryId: 229,
    },
    {
      id: 368,
      name: 'Kayunga',
      iso2: '112',
      countryId: 229,
    },
    {
      id: 5360,
      name: 'Kazo',
      iso2: '433',
      countryId: 229,
    },
    {
      id: 436,
      name: 'Kibaale',
      iso2: '407',
      countryId: 229,
    },
    {
      id: 347,
      name: 'Kiboga',
      iso2: '103',
      countryId: 229,
    },
    {
      id: 338,
      name: 'Kibuku',
      iso2: '227',
      countryId: 229,
    },
    {
      id: 5359,
      name: 'Kikuube',
      iso2: '432',
      countryId: 229,
    },
    {
      id: 355,
      name: 'Kiruhura',
      iso2: '419',
      countryId: 229,
    },
    {
      id: 346,
      name: 'Kiryandongo',
      iso2: '421',
      countryId: 229,
    },
    {
      id: 409,
      name: 'Kisoro',
      iso2: '408',
      countryId: 229,
    },
    {
      id: 5361,
      name: 'Kitagwenda',
      iso2: '434',
      countryId: 229,
    },
    {
      id: 348,
      name: 'Kitgum',
      iso2: '305',
      countryId: 229,
    },
    {
      id: 345,
      name: 'Koboko',
      iso2: '319',
      countryId: 229,
    },
    {
      id: 401,
      name: 'Kole',
      iso2: '325',
      countryId: 229,
    },
    {
      id: 443,
      name: 'Kotido',
      iso2: '306',
      countryId: 229,
    },
    {
      id: 425,
      name: 'Kumi',
      iso2: '208',
      countryId: 229,
    },
    {
      id: 5353,
      name: 'Kwania',
      iso2: '333',
      countryId: 229,
    },
    {
      id: 369,
      name: 'Kween',
      iso2: '228',
      countryId: 229,
    },
    {
      id: 325,
      name: 'Kyankwanzi',
      iso2: '123',
      countryId: 229,
    },
    {
      id: 437,
      name: 'Kyegegwa',
      iso2: '422',
      countryId: 229,
    },
    {
      id: 402,
      name: 'Kyenjojo',
      iso2: '415',
      countryId: 229,
    },
    {
      id: 448,
      name: 'Kyotera',
      iso2: '125',
      countryId: 229,
    },
    {
      id: 411,
      name: 'Lamwo',
      iso2: '326',
      countryId: 229,
    },
    {
      id: 342,
      name: 'Lira',
      iso2: '307',
      countryId: 229,
    },
    {
      id: 445,
      name: 'Luuka',
      iso2: '229',
      countryId: 229,
    },
    {
      id: 433,
      name: 'Luwero',
      iso2: '104',
      countryId: 229,
    },
    {
      id: 417,
      name: 'Lwengo',
      iso2: '124',
      countryId: 229,
    },
    {
      id: 376,
      name: 'Lyantonde',
      iso2: '114',
      countryId: 229,
    },
    {
      id: 5356,
      name: 'Madi-Okollo',
      iso2: '336',
      countryId: 229,
    },
    {
      id: 438,
      name: 'Manafwa',
      iso2: '223',
      countryId: 229,
    },
    {
      id: 421,
      name: 'Maracha',
      iso2: '320',
      countryId: 229,
    },
    {
      id: 356,
      name: 'Masaka',
      iso2: '105',
      countryId: 229,
    },
    {
      id: 354,
      name: 'Masindi',
      iso2: '409',
      countryId: 229,
    },
    {
      id: 418,
      name: 'Mayuge',
      iso2: '214',
      countryId: 229,
    },
    {
      id: 350,
      name: 'Mbale',
      iso2: '209',
      countryId: 229,
    },
    {
      id: 415,
      name: 'Mbarara',
      iso2: '410',
      countryId: 229,
    },
    {
      id: 435,
      name: 'Mitooma',
      iso2: '423',
      countryId: 229,
    },
    {
      id: 364,
      name: 'Mityana',
      iso2: '115',
      countryId: 229,
    },
    {
      id: 395,
      name: 'Moroto',
      iso2: '308',
      countryId: 229,
    },
    {
      id: 363,
      name: 'Moyo',
      iso2: '309',
      countryId: 229,
    },
    {
      id: 327,
      name: 'Mpigi',
      iso2: '106',
      countryId: 229,
    },
    {
      id: 371,
      name: 'Mubende',
      iso2: '107',
      countryId: 229,
    },
    {
      id: 410,
      name: 'Mukono',
      iso2: '108',
      countryId: 229,
    },
    {
      id: 5354,
      name: 'Nabilatuk',
      iso2: '334',
      countryId: 229,
    },
    {
      id: 393,
      name: 'Nakapiripirit',
      iso2: '311',
      countryId: 229,
    },
    {
      id: 423,
      name: 'Nakaseke',
      iso2: '116',
      countryId: 229,
    },
    {
      id: 406,
      name: 'Nakasongola',
      iso2: '109',
      countryId: 229,
    },
    {
      id: 351,
      name: 'Namayingo',
      iso2: '230',
      countryId: 229,
    },
    {
      id: 400,
      name: 'Namisindwa',
      iso2: '234',
      countryId: 229,
    },
    {
      id: 337,
      name: 'Namutumba',
      iso2: '224',
      countryId: 229,
    },
    {
      id: 430,
      name: 'Napak',
      iso2: '327',
      countryId: 229,
    },
    {
      id: 446,
      name: 'Nebbi',
      iso2: '310',
      countryId: 229,
    },
    {
      id: 424,
      name: 'Ngora',
      iso2: '231',
      countryId: 229,
    },
    {
      id: 332,
      name: 'Northern',
      iso2: 'N',
      countryId: 229,
    },
    {
      id: 422,
      name: 'Ntoroko',
      iso2: '424',
      countryId: 229,
    },
    {
      id: 404,
      name: 'Ntungamo',
      iso2: '411',
      countryId: 229,
    },
    {
      id: 378,
      name: 'Nwoya',
      iso2: '328',
      countryId: 229,
    },
    {
      id: 5357,
      name: 'Obongi',
      iso2: '337',
      countryId: 229,
    },
    {
      id: 374,
      name: 'Omoro',
      iso2: '331',
      countryId: 229,
    },
    {
      id: 390,
      name: 'Otuke',
      iso2: '329',
      countryId: 229,
    },
    {
      id: 397,
      name: 'Oyam',
      iso2: '321',
      countryId: 229,
    },
    {
      id: 408,
      name: 'Pader',
      iso2: '312',
      countryId: 229,
    },
    {
      id: 357,
      name: 'Pakwach',
      iso2: '332',
      countryId: 229,
    },
    {
      id: 412,
      name: 'Pallisa',
      iso2: '210',
      countryId: 229,
    },
    {
      id: 439,
      name: 'Rakai',
      iso2: '110',
      countryId: 229,
    },
    {
      id: 358,
      name: 'Rubanda',
      iso2: '429',
      countryId: 229,
    },
    {
      id: 442,
      name: 'Rubirizi',
      iso2: '425',
      countryId: 229,
    },
    {
      id: 331,
      name: 'Rukiga',
      iso2: '431',
      countryId: 229,
    },
    {
      id: 324,
      name: 'Rukungiri',
      iso2: '412',
      countryId: 229,
    },
    {
      id: 5362,
      name: 'Rwampara',
      iso2: '435',
      countryId: 229,
    },
    {
      id: 427,
      name: 'Sembabule',
      iso2: '111',
      countryId: 229,
    },
    {
      id: 333,
      name: 'Serere',
      iso2: '232',
      countryId: 229,
    },
    {
      id: 407,
      name: 'Sheema',
      iso2: '426',
      countryId: 229,
    },
    {
      id: 429,
      name: 'Sironko',
      iso2: '215',
      countryId: 229,
    },
    {
      id: 444,
      name: 'Soroti',
      iso2: '211',
      countryId: 229,
    },
    {
      id: 359,
      name: 'Tororo',
      iso2: '212',
      countryId: 229,
    },
    {
      id: 362,
      name: 'Wakiso',
      iso2: '113',
      countryId: 229,
    },
    {
      id: 370,
      name: 'Western',
      iso2: 'W',
      countryId: 229,
    },
    {
      id: 330,
      name: 'Yumbe',
      iso2: '313',
      countryId: 229,
    },
    {
      id: 379,
      name: 'Zombo',
      iso2: '330',
      countryId: 229,
    },
    {
      id: 4689,
      name: 'Autonomous Republic of Crimea',
      iso2: '43',
      countryId: 230,
    },
    {
      id: 4680,
      name: 'Cherkaska',
      iso2: '71',
      countryId: 230,
    },
    {
      id: 4692,
      name: 'Chernihivska',
      iso2: '74',
      countryId: 230,
    },
    {
      id: 4678,
      name: 'Chernivetska',
      iso2: '77',
      countryId: 230,
    },
    {
      id: 4675,
      name: 'Dnipropetrovska',
      iso2: '12',
      countryId: 230,
    },
    {
      id: 4691,
      name: 'Donetska',
      iso2: '14',
      countryId: 230,
    },
    {
      id: 4682,
      name: 'Ivano-Frankivska',
      iso2: '26',
      countryId: 230,
    },
    {
      id: 4686,
      name: 'Kharkivska',
      iso2: '63',
      countryId: 230,
    },
    {
      id: 4684,
      name: 'Khersonska',
      iso2: '65',
      countryId: 230,
    },
    {
      id: 4681,
      name: 'Khmelnytska',
      iso2: '68',
      countryId: 230,
    },
    {
      id: 4677,
      name: 'Kirovohradska',
      iso2: '35',
      countryId: 230,
    },
    {
      id: 4676,
      name: 'Kyiv',
      iso2: '30',
      countryId: 230,
    },
    {
      id: 4671,
      name: 'Kyivska',
      iso2: '32',
      countryId: 230,
    },
    {
      id: 4673,
      name: 'Luhanska',
      iso2: '09',
      countryId: 230,
    },
    {
      id: 4672,
      name: 'Lvivska',
      iso2: '46',
      countryId: 230,
    },
    {
      id: 4679,
      name: 'Mykolaivska',
      iso2: '48',
      countryId: 230,
    },
    {
      id: 4688,
      name: 'Odeska',
      iso2: '51',
      countryId: 230,
    },
    {
      id: 5071,
      name: 'Poltavska',
      iso2: '53',
      countryId: 230,
    },
    {
      id: 4683,
      name: 'Rivnenska',
      iso2: '56',
      countryId: 230,
    },
    {
      id: 1912,
      name: 'Sevastopol',
      iso2: '40',
      countryId: 230,
    },
    {
      id: 4685,
      name: 'Sumska',
      iso2: '59',
      countryId: 230,
    },
    {
      id: 4674,
      name: 'Ternopilska',
      iso2: '61',
      countryId: 230,
    },
    {
      id: 4669,
      name: 'Vinnytska',
      iso2: '05',
      countryId: 230,
    },
    {
      id: 4690,
      name: 'Volynska',
      iso2: '07',
      countryId: 230,
    },
    {
      id: 4670,
      name: 'Zakarpatska',
      iso2: '21',
      countryId: 230,
    },
    {
      id: 4687,
      name: 'Zaporizka',
      iso2: '23',
      countryId: 230,
    },
    {
      id: 4668,
      name: 'Zhytomyrska',
      iso2: '18',
      countryId: 230,
    },
    {
      id: 3396,
      name: 'Abu Dhabi',
      iso2: 'AZ',
      countryId: 231,
    },
    {
      id: 3395,
      name: 'Ajman',
      iso2: 'AJ',
      countryId: 231,
    },
    {
      id: 3391,
      name: 'Dubai',
      iso2: 'DU',
      countryId: 231,
    },
    {
      id: 3393,
      name: 'Fujairah',
      iso2: 'FU',
      countryId: 231,
    },
    {
      id: 3394,
      name: 'Ras Al Khaimah',
      iso2: 'RK',
      countryId: 231,
    },
    {
      id: 3390,
      name: 'Sharjah',
      iso2: 'SH',
      countryId: 231,
    },
    {
      id: 3392,
      name: 'Umm Al Quwain',
      iso2: 'UQ',
      countryId: 231,
    },
    {
      id: 2463,
      name: 'Aberdeen',
      iso2: 'ABE',
      countryId: 232,
    },
    {
      id: 2401,
      name: 'Aberdeenshire',
      iso2: 'ABD',
      countryId: 232,
    },
    {
      id: 2387,
      name: 'Angus',
      iso2: 'ANS',
      countryId: 232,
    },
    {
      id: 2412,
      name: 'Antrim and Newtownabbey',
      iso2: 'ANN',
      countryId: 232,
    },
    {
      id: 2523,
      name: 'Ards and North Down',
      iso2: 'AND',
      countryId: 232,
    },
    {
      id: 2392,
      name: 'Argyll and Bute',
      iso2: 'AGB',
      countryId: 232,
    },
    {
      id: 2324,
      name: 'Armagh, Banbridge and Craigavon',
      iso2: 'ABC',
      countryId: 232,
    },
    {
      id: 2356,
      name: 'Barking and Dagenham',
      iso2: 'BDG',
      countryId: 232,
    },
    {
      id: 2520,
      name: 'Barnet',
      iso2: 'BNE',
      countryId: 232,
    },
    {
      id: 2499,
      name: 'Barnsley',
      iso2: 'BNS',
      countryId: 232,
    },
    {
      id: 2339,
      name: 'Bath and North East Somerset',
      iso2: 'BAS',
      countryId: 232,
    },
    {
      id: 2507,
      name: 'Bedford',
      iso2: 'BDF',
      countryId: 232,
    },
    {
      id: 2311,
      name: 'Belfast',
      iso2: 'BFS',
      countryId: 232,
    },
    {
      id: 2307,
      name: 'Bexley',
      iso2: 'BEX',
      countryId: 232,
    },
    {
      id: 2425,
      name: 'Birmingham',
      iso2: 'BIR',
      countryId: 232,
    },
    {
      id: 2329,
      name: 'Blackburn with Darwen',
      iso2: 'BBD',
      countryId: 232,
    },
    {
      id: 2451,
      name: 'Blackpool',
      iso2: 'BPL',
      countryId: 232,
    },
    {
      id: 2530,
      name: 'Blaenau Gwent',
      iso2: 'BGW',
      countryId: 232,
    },
    {
      id: 2504,
      name: 'Bolton',
      iso2: 'BOL',
      countryId: 232,
    },
    {
      id: 5459,
      name: 'Bournemouth, Christchurch and Poole',
      iso2: 'BCP',
      countryId: 232,
    },
    {
      id: 2470,
      name: 'Bracknell Forest',
      iso2: 'BRC',
      countryId: 232,
    },
    {
      id: 2529,
      name: 'Bradford',
      iso2: 'BRD',
      countryId: 232,
    },
    {
      id: 2291,
      name: 'Brent',
      iso2: 'BEN',
      countryId: 232,
    },
    {
      id: 2452,
      name: 'Bridgend',
      iso2: 'BGE',
      countryId: 232,
    },
    {
      id: 2395,
      name: 'Brighton and Hove',
      iso2: 'BNH',
      countryId: 232,
    },
    {
      id: 2413,
      name: 'Bristol',
      iso2: 'BST',
      countryId: 232,
    },
    {
      id: 2490,
      name: 'Bromley',
      iso2: 'BRY',
      countryId: 232,
    },
    {
      id: 2405,
      name: 'Buckinghamshire',
      iso2: 'BKM',
      countryId: 232,
    },
    {
      id: 2459,
      name: 'Bury',
      iso2: 'BUR',
      countryId: 232,
    },
    {
      id: 2298,
      name: 'Caerphilly',
      iso2: 'CAY',
      countryId: 232,
    },
    {
      id: 2517,
      name: 'Calderdale',
      iso2: 'CLD',
      countryId: 232,
    },
    {
      id: 2423,
      name: 'Cambridgeshire',
      iso2: 'CAM',
      countryId: 232,
    },
    {
      id: 2349,
      name: 'Camden',
      iso2: 'CMD',
      countryId: 232,
    },
    {
      id: 2528,
      name: 'Cardiff',
      iso2: 'CRF',
      countryId: 232,
    },
    {
      id: 2484,
      name: 'Carmarthenshire',
      iso2: 'CMN',
      countryId: 232,
    },
    {
      id: 2316,
      name: 'Causeway Coast and Glens',
      iso2: 'CCG',
      countryId: 232,
    },
    {
      id: 2303,
      name: 'Central Bedfordshire',
      iso2: 'CBF',
      countryId: 232,
    },
    {
      id: 2509,
      name: 'Ceredigion',
      iso2: 'CGN',
      countryId: 232,
    },
    {
      id: 2444,
      name: 'Cheshire East',
      iso2: 'CHE',
      countryId: 232,
    },
    {
      id: 2442,
      name: 'Cheshire West and Chester',
      iso2: 'CHW',
      countryId: 232,
    },
    {
      id: 2475,
      name: 'City of Kingston upon Hull',
      iso2: 'KHL',
      countryId: 232,
    },
    {
      id: 2294,
      name: 'City of Southampton',
      iso2: 'STH',
      countryId: 232,
    },
    {
      id: 2450,
      name: 'Clackmannanshire',
      iso2: 'CLK',
      countryId: 232,
    },
    {
      id: 2352,
      name: 'Conwy',
      iso2: 'CWY',
      countryId: 232,
    },
    {
      id: 2312,
      name: 'Cornwall',
      iso2: 'CON',
      countryId: 232,
    },
    {
      id: 2438,
      name: 'Coventry',
      iso2: 'COV',
      countryId: 232,
    },
    {
      id: 2512,
      name: 'Croydon',
      iso2: 'CRY',
      countryId: 232,
    },
    {
      id: 2334,
      name: 'Cumbria',
      iso2: 'CMA',
      countryId: 232,
    },
    {
      id: 2389,
      name: 'Darlington',
      iso2: 'DAL',
      countryId: 232,
    },
    {
      id: 2497,
      name: 'Denbighshire',
      iso2: 'DEN',
      countryId: 232,
    },
    {
      id: 2485,
      name: 'Derby',
      iso2: 'DER',
      countryId: 232,
    },
    {
      id: 2403,
      name: 'Derbyshire',
      iso2: 'DBY',
      countryId: 232,
    },
    {
      id: 2446,
      name: 'Derry City and Strabane',
      iso2: 'DRS',
      countryId: 232,
    },
    {
      id: 2491,
      name: 'Devon',
      iso2: 'DEV',
      countryId: 232,
    },
    {
      id: 2364,
      name: 'Doncaster',
      iso2: 'DNC',
      countryId: 232,
    },
    {
      id: 2345,
      name: 'Dorset',
      iso2: 'DOR',
      countryId: 232,
    },
    {
      id: 2457,
      name: 'Dudley',
      iso2: 'DUD',
      countryId: 232,
    },
    {
      id: 2415,
      name: 'Dumfries and Galloway',
      iso2: 'DGY',
      countryId: 232,
    },
    {
      id: 2511,
      name: 'Dundee',
      iso2: 'DND',
      countryId: 232,
    },
    {
      id: 2406,
      name: 'Durham',
      iso2: 'DUR',
      countryId: 232,
    },
    {
      id: 2532,
      name: 'Ealing',
      iso2: 'EAL',
      countryId: 232,
    },
    {
      id: 2374,
      name: 'East Ayrshire',
      iso2: 'EAY',
      countryId: 232,
    },
    {
      id: 2454,
      name: 'East Dunbartonshire',
      iso2: 'EDU',
      countryId: 232,
    },
    {
      id: 2462,
      name: 'East Lothian',
      iso2: 'ELN',
      countryId: 232,
    },
    {
      id: 2333,
      name: 'East Renfrewshire',
      iso2: 'ERW',
      countryId: 232,
    },
    {
      id: 2370,
      name: 'East Riding of Yorkshire',
      iso2: 'ERY',
      countryId: 232,
    },
    {
      id: 2414,
      name: 'East Sussex',
      iso2: 'ESX',
      countryId: 232,
    },
    {
      id: 2428,
      name: 'Edinburgh',
      iso2: 'EDH',
      countryId: 232,
    },
    {
      id: 2476,
      name: 'Enfield',
      iso2: 'ENF',
      countryId: 232,
    },
    {
      id: 2336,
      name: 'England',
      iso2: 'ENG',
      countryId: 232,
    },
    {
      id: 2410,
      name: 'Essex',
      iso2: 'ESS',
      countryId: 232,
    },
    {
      id: 2344,
      name: 'Falkirk',
      iso2: 'FAL',
      countryId: 232,
    },
    {
      id: 2366,
      name: 'Fermanagh and Omagh',
      iso2: 'FMO',
      countryId: 232,
    },
    {
      id: 2479,
      name: 'Fife',
      iso2: 'FIF',
      countryId: 232,
    },
    {
      id: 2437,
      name: 'Flintshire',
      iso2: 'FLN',
      countryId: 232,
    },
    {
      id: 2431,
      name: 'Gateshead',
      iso2: 'GAT',
      countryId: 232,
    },
    {
      id: 2404,
      name: 'Glasgow',
      iso2: 'GLG',
      countryId: 232,
    },
    {
      id: 2373,
      name: 'Gloucestershire',
      iso2: 'GLS',
      countryId: 232,
    },
    {
      id: 2492,
      name: 'Greenwich',
      iso2: 'GRE',
      countryId: 232,
    },
    {
      id: 2379,
      name: 'Gwynedd',
      iso2: 'GWN',
      countryId: 232,
    },
    {
      id: 2411,
      name: 'Hackney',
      iso2: 'HCK',
      countryId: 232,
    },
    {
      id: 2466,
      name: 'Halton',
      iso2: 'HAL',
      countryId: 232,
    },
    {
      id: 2448,
      name: 'Hammersmith and Fulham',
      iso2: 'HMF',
      countryId: 232,
    },
    {
      id: 2435,
      name: 'Hampshire',
      iso2: 'HAM',
      countryId: 232,
    },
    {
      id: 2306,
      name: 'Haringey',
      iso2: 'HRY',
      countryId: 232,
    },
    {
      id: 2385,
      name: 'Harrow',
      iso2: 'HRW',
      countryId: 232,
    },
    {
      id: 2309,
      name: 'Hartlepool',
      iso2: 'HPL',
      countryId: 232,
    },
    {
      id: 2347,
      name: 'Havering',
      iso2: 'HAV',
      countryId: 232,
    },
    {
      id: 2500,
      name: 'Herefordshire',
      iso2: 'HEF',
      countryId: 232,
    },
    {
      id: 2369,
      name: 'Hertfordshire',
      iso2: 'HRT',
      countryId: 232,
    },
    {
      id: 2383,
      name: 'Highland',
      iso2: 'HLD',
      countryId: 232,
    },
    {
      id: 2376,
      name: 'Hillingdon',
      iso2: 'HIL',
      countryId: 232,
    },
    {
      id: 2380,
      name: 'Hounslow',
      iso2: 'HNS',
      countryId: 232,
    },
    {
      id: 2388,
      name: 'Inverclyde',
      iso2: 'IVC',
      countryId: 232,
    },
    {
      id: 5458,
      name: 'Isle of Anglesey',
      iso2: 'AGY',
      countryId: 232,
    },
    {
      id: 2289,
      name: 'Isle of Wight',
      iso2: 'IOW',
      countryId: 232,
    },
    {
      id: 2343,
      name: 'Isles of Scilly',
      iso2: 'IOS',
      countryId: 232,
    },
    {
      id: 2319,
      name: 'Islington',
      iso2: 'ISL',
      countryId: 232,
    },
    {
      id: 2368,
      name: 'Kensington and Chelsea',
      iso2: 'KEC',
      countryId: 232,
    },
    {
      id: 2464,
      name: 'Kent',
      iso2: 'KEN',
      countryId: 232,
    },
    {
      id: 2481,
      name: 'Kingston upon Thames',
      iso2: 'KTT',
      countryId: 232,
    },
    {
      id: 2371,
      name: 'Kirklees',
      iso2: 'KIR',
      countryId: 232,
    },
    {
      id: 2330,
      name: 'Knowsley',
      iso2: 'KWL',
      countryId: 232,
    },
    {
      id: 2396,
      name: 'Lambeth',
      iso2: 'LBH',
      countryId: 232,
    },
    {
      id: 2495,
      name: 'Lancashire',
      iso2: 'LAN',
      countryId: 232,
    },
    {
      id: 2503,
      name: 'Leeds',
      iso2: 'LDS',
      countryId: 232,
    },
    {
      id: 2318,
      name: 'Leicester',
      iso2: 'LCE',
      countryId: 232,
    },
    {
      id: 2516,
      name: 'Leicestershire',
      iso2: 'LEC',
      countryId: 232,
    },
    {
      id: 2358,
      name: 'Lewisham',
      iso2: 'LEW',
      countryId: 232,
    },
    {
      id: 2355,
      name: 'Lincolnshire',
      iso2: 'LIN',
      countryId: 232,
    },
    {
      id: 2460,
      name: 'Lisburn and Castlereagh',
      iso2: 'LBC',
      countryId: 232,
    },
    {
      id: 2340,
      name: 'Liverpool',
      iso2: 'LIV',
      countryId: 232,
    },
    {
      id: 2424,
      name: 'London',
      iso2: 'LND',
      countryId: 232,
    },
    {
      id: 5460,
      name: 'Luton',
      iso2: 'LUT',
      countryId: 232,
    },
    {
      id: 2398,
      name: 'Manchester',
      iso2: 'MAN',
      countryId: 232,
    },
    {
      id: 2381,
      name: 'Medway',
      iso2: 'MDW',
      countryId: 232,
    },
    {
      id: 2328,
      name: 'Merthyr Tydfil',
      iso2: 'MTY',
      countryId: 232,
    },
    {
      id: 2483,
      name: 'Merton',
      iso2: 'MRT',
      countryId: 232,
    },
    {
      id: 2429,
      name: 'Mid and East Antrim',
      iso2: 'MEA',
      countryId: 232,
    },
    {
      id: 2399,
      name: 'Mid Ulster',
      iso2: 'MUL',
      countryId: 232,
    },
    {
      id: 2332,
      name: 'Middlesbrough',
      iso2: 'MDB',
      countryId: 232,
    },
    {
      id: 2519,
      name: 'Midlothian',
      iso2: 'MLN',
      countryId: 232,
    },
    {
      id: 2416,
      name: 'Milton Keynes',
      iso2: 'MIK',
      countryId: 232,
    },
    {
      id: 2402,
      name: 'Monmouthshire',
      iso2: 'MON',
      countryId: 232,
    },
    {
      id: 2360,
      name: 'Moray',
      iso2: 'MRY',
      countryId: 232,
    },
    {
      id: 2351,
      name: 'Neath Port Talbot',
      iso2: 'NTL',
      countryId: 232,
    },
    {
      id: 2458,
      name: 'Newcastle upon Tyne',
      iso2: 'NET',
      countryId: 232,
    },
    {
      id: 2418,
      name: 'Newham',
      iso2: 'NWM',
      countryId: 232,
    },
    {
      id: 2524,
      name: 'Newport',
      iso2: 'NWP',
      countryId: 232,
    },
    {
      id: 2534,
      name: 'Newry, Mourne and Down',
      iso2: 'NMD',
      countryId: 232,
    },
    {
      id: 2473,
      name: 'Norfolk',
      iso2: 'NFK',
      countryId: 232,
    },
    {
      id: 2535,
      name: 'North Ayrshire',
      iso2: 'NAY',
      countryId: 232,
    },
    {
      id: 2384,
      name: 'North East Lincolnshire',
      iso2: 'NEL',
      countryId: 232,
    },
    {
      id: 2487,
      name: 'North Lanarkshire',
      iso2: 'NLK',
      countryId: 232,
    },
    {
      id: 2453,
      name: 'North Lincolnshire',
      iso2: 'NLN',
      countryId: 232,
    },
    {
      id: 5461,
      name: 'North Northamptonshire',
      iso2: 'NNH',
      countryId: 232,
    },
    {
      id: 2430,
      name: 'North Somerset',
      iso2: 'NSM',
      countryId: 232,
    },
    {
      id: 2521,
      name: 'North Tyneside',
      iso2: 'NTY',
      countryId: 232,
    },
    {
      id: 2522,
      name: 'North Yorkshire',
      iso2: 'NYK',
      countryId: 232,
    },
    {
      id: 2337,
      name: 'Northern Ireland',
      iso2: 'NIR',
      countryId: 232,
    },
    {
      id: 2365,
      name: 'Northumberland',
      iso2: 'NBL',
      countryId: 232,
    },
    {
      id: 2359,
      name: 'Nottingham',
      iso2: 'NGM',
      countryId: 232,
    },
    {
      id: 2456,
      name: 'Nottinghamshire',
      iso2: 'NTT',
      countryId: 232,
    },
    {
      id: 2477,
      name: 'Oldham',
      iso2: 'OLD',
      countryId: 232,
    },
    {
      id: 2474,
      name: 'Orkney Islands',
      iso2: 'ORK',
      countryId: 232,
    },
    {
      id: 2353,
      name: 'Outer Hebrides',
      iso2: 'ELS',
      countryId: 232,
    },
    {
      id: 2321,
      name: 'Oxfordshire',
      iso2: 'OXF',
      countryId: 232,
    },
    {
      id: 2486,
      name: 'Pembrokeshire',
      iso2: 'PEM',
      countryId: 232,
    },
    {
      id: 2325,
      name: 'Perth and Kinross',
      iso2: 'PKN',
      countryId: 232,
    },
    {
      id: 2297,
      name: 'Peterborough',
      iso2: 'PTE',
      countryId: 232,
    },
    {
      id: 2514,
      name: 'Plymouth',
      iso2: 'PLY',
      countryId: 232,
    },
    {
      id: 2305,
      name: 'Portsmouth',
      iso2: 'POR',
      countryId: 232,
    },
    {
      id: 2441,
      name: 'Powys',
      iso2: 'POW',
      countryId: 232,
    },
    {
      id: 2455,
      name: 'Reading',
      iso2: 'RDG',
      countryId: 232,
    },
    {
      id: 2397,
      name: 'Redbridge',
      iso2: 'RDB',
      countryId: 232,
    },
    {
      id: 2527,
      name: 'Redcar and Cleveland',
      iso2: 'RCC',
      countryId: 232,
    },
    {
      id: 2443,
      name: 'Renfrewshire',
      iso2: 'RFW',
      countryId: 232,
    },
    {
      id: 2301,
      name: 'Rhondda Cynon Taf',
      iso2: 'RCT',
      countryId: 232,
    },
    {
      id: 2501,
      name: 'Richmond upon Thames',
      iso2: 'RIC',
      countryId: 232,
    },
    {
      id: 2327,
      name: 'Rochdale',
      iso2: 'RCH',
      countryId: 232,
    },
    {
      id: 2308,
      name: 'Rotherham',
      iso2: 'ROT',
      countryId: 232,
    },
    {
      id: 2472,
      name: 'Rutland',
      iso2: 'RUT',
      countryId: 232,
    },
    {
      id: 2493,
      name: 'Salford',
      iso2: 'SLF',
      countryId: 232,
    },
    {
      id: 2341,
      name: 'Sandwell',
      iso2: 'SAW',
      countryId: 232,
    },
    {
      id: 2335,
      name: 'Scotland',
      iso2: 'SCT',
      countryId: 232,
    },
    {
      id: 2346,
      name: 'Scottish Borders',
      iso2: 'SCB',
      countryId: 232,
    },
    {
      id: 2518,
      name: 'Sefton',
      iso2: 'SFT',
      countryId: 232,
    },
    {
      id: 2295,
      name: 'Sheffield',
      iso2: 'SHF',
      countryId: 232,
    },
    {
      id: 2300,
      name: 'Shetland Islands',
      iso2: 'ZET',
      countryId: 232,
    },
    {
      id: 2407,
      name: 'Shropshire',
      iso2: 'SHR',
      countryId: 232,
    },
    {
      id: 2427,
      name: 'Slough',
      iso2: 'SLG',
      countryId: 232,
    },
    {
      id: 2469,
      name: 'Solihull',
      iso2: 'SOL',
      countryId: 232,
    },
    {
      id: 2386,
      name: 'Somerset',
      iso2: 'SOM',
      countryId: 232,
    },
    {
      id: 2377,
      name: 'South Ayrshire',
      iso2: 'SAY',
      countryId: 232,
    },
    {
      id: 2400,
      name: 'South Gloucestershire',
      iso2: 'SGC',
      countryId: 232,
    },
    {
      id: 2362,
      name: 'South Lanarkshire',
      iso2: 'SLK',
      countryId: 232,
    },
    {
      id: 2409,
      name: 'South Tyneside',
      iso2: 'STY',
      countryId: 232,
    },
    {
      id: 2323,
      name: 'Southend-on-Sea',
      iso2: 'SOS',
      countryId: 232,
    },
    {
      id: 2432,
      name: 'Southwark',
      iso2: 'SWK',
      countryId: 232,
    },
    {
      id: 2290,
      name: 'St Helens',
      iso2: 'SHN',
      countryId: 232,
    },
    {
      id: 2447,
      name: 'Staffordshire',
      iso2: 'STS',
      countryId: 232,
    },
    {
      id: 2488,
      name: 'Stirling',
      iso2: 'STG',
      countryId: 232,
    },
    {
      id: 2394,
      name: 'Stockport',
      iso2: 'SKP',
      countryId: 232,
    },
    {
      id: 2421,
      name: 'Stockton-on-Tees',
      iso2: 'STT',
      countryId: 232,
    },
    {
      id: 2506,
      name: 'Stoke-on-Trent',
      iso2: 'STE',
      countryId: 232,
    },
    {
      id: 2467,
      name: 'Suffolk',
      iso2: 'SFK',
      countryId: 232,
    },
    {
      id: 2372,
      name: 'Sunderland',
      iso2: 'SND',
      countryId: 232,
    },
    {
      id: 2526,
      name: 'Surrey',
      iso2: 'SRY',
      countryId: 232,
    },
    {
      id: 2313,
      name: 'Sutton',
      iso2: 'STN',
      countryId: 232,
    },
    {
      id: 2433,
      name: 'Swansea',
      iso2: 'SWA',
      countryId: 232,
    },
    {
      id: 2422,
      name: 'Swindon',
      iso2: 'SWD',
      countryId: 232,
    },
    {
      id: 2367,
      name: 'Tameside',
      iso2: 'TAM',
      countryId: 232,
    },
    {
      id: 2310,
      name: 'Telford and Wrekin',
      iso2: 'TFW',
      countryId: 232,
    },
    {
      id: 2468,
      name: 'Thurrock',
      iso2: 'THR',
      countryId: 232,
    },
    {
      id: 2478,
      name: 'Torbay',
      iso2: 'TOB',
      countryId: 232,
    },
    {
      id: 2496,
      name: 'Torfaen',
      iso2: 'TOF',
      countryId: 232,
    },
    {
      id: 2390,
      name: 'Tower Hamlets',
      iso2: 'TWH',
      countryId: 232,
    },
    {
      id: 2293,
      name: 'Trafford',
      iso2: 'TRF',
      countryId: 232,
    },
    {
      id: 2299,
      name: 'Vale of Glamorgan',
      iso2: 'VGL',
      countryId: 232,
    },
    {
      id: 2465,
      name: 'Wakefield',
      iso2: 'WKF',
      countryId: 232,
    },
    {
      id: 2338,
      name: 'Wales',
      iso2: 'WLS',
      countryId: 232,
    },
    {
      id: 2292,
      name: 'Walsall',
      iso2: 'WLL',
      countryId: 232,
    },
    {
      id: 2326,
      name: 'Waltham Forest',
      iso2: 'WFT',
      countryId: 232,
    },
    {
      id: 2434,
      name: 'Wandsworth',
      iso2: 'WND',
      countryId: 232,
    },
    {
      id: 2420,
      name: 'Warrington',
      iso2: 'WRT',
      countryId: 232,
    },
    {
      id: 2505,
      name: 'Warwickshire',
      iso2: 'WAR',
      countryId: 232,
    },
    {
      id: 2471,
      name: 'West Berkshire',
      iso2: 'WBK',
      countryId: 232,
    },
    {
      id: 2440,
      name: 'West Dunbartonshire',
      iso2: 'WDU',
      countryId: 232,
    },
    {
      id: 2354,
      name: 'West Lothian',
      iso2: 'WLN',
      countryId: 232,
    },
    {
      id: 5462,
      name: 'West Northamptonshire',
      iso2: 'WNH',
      countryId: 232,
    },
    {
      id: 2296,
      name: 'West Sussex',
      iso2: 'WSX',
      countryId: 232,
    },
    {
      id: 2357,
      name: 'Westminster',
      iso2: 'WSM',
      countryId: 232,
    },
    {
      id: 2320,
      name: 'Wigan',
      iso2: 'WGN',
      countryId: 232,
    },
    {
      id: 2391,
      name: 'Wiltshire',
      iso2: 'WIL',
      countryId: 232,
    },
    {
      id: 2482,
      name: 'Windsor and Maidenhead',
      iso2: 'WNM',
      countryId: 232,
    },
    {
      id: 2408,
      name: 'Wirral',
      iso2: 'WRL',
      countryId: 232,
    },
    {
      id: 2419,
      name: 'Wokingham',
      iso2: 'WOK',
      countryId: 232,
    },
    {
      id: 2489,
      name: 'Wolverhampton',
      iso2: 'WLV',
      countryId: 232,
    },
    {
      id: 2510,
      name: 'Worcestershire',
      iso2: 'WOR',
      countryId: 232,
    },
    {
      id: 2436,
      name: 'Wrexham',
      iso2: 'WRX',
      countryId: 232,
    },
    {
      id: 2426,
      name: 'York',
      iso2: 'YOR',
      countryId: 232,
    },
    {
      id: 1456,
      name: 'Alabama',
      iso2: 'AL',
      countryId: 233,
    },
    {
      id: 1400,
      name: 'Alaska',
      iso2: 'AK',
      countryId: 233,
    },
    {
      id: 1424,
      name: 'American Samoa',
      iso2: 'AS',
      countryId: 233,
    },
    {
      id: 1434,
      name: 'Arizona',
      iso2: 'AZ',
      countryId: 233,
    },
    {
      id: 1444,
      name: 'Arkansas',
      iso2: 'AR',
      countryId: 233,
    },
    {
      id: 1416,
      name: 'California',
      iso2: 'CA',
      countryId: 233,
    },
    {
      id: 1450,
      name: 'Colorado',
      iso2: 'CO',
      countryId: 233,
    },
    {
      id: 1435,
      name: 'Connecticut',
      iso2: 'CT',
      countryId: 233,
    },
    {
      id: 1399,
      name: 'Delaware',
      iso2: 'DE',
      countryId: 233,
    },
    {
      id: 1437,
      name: 'District of Columbia',
      iso2: 'DC',
      countryId: 233,
    },
    {
      id: 1436,
      name: 'Florida',
      iso2: 'FL',
      countryId: 233,
    },
    {
      id: 1455,
      name: 'Georgia',
      iso2: 'GA',
      countryId: 233,
    },
    {
      id: 1412,
      name: 'Guam',
      iso2: 'GU',
      countryId: 233,
    },
    {
      id: 1411,
      name: 'Hawaii',
      iso2: 'HI',
      countryId: 233,
    },
    {
      id: 1460,
      name: 'Idaho',
      iso2: 'ID',
      countryId: 233,
    },
    {
      id: 1425,
      name: 'Illinois',
      iso2: 'IL',
      countryId: 233,
    },
    {
      id: 1440,
      name: 'Indiana',
      iso2: 'IN',
      countryId: 233,
    },
    {
      id: 1459,
      name: 'Iowa',
      iso2: 'IA',
      countryId: 233,
    },
    {
      id: 1406,
      name: 'Kansas',
      iso2: 'KS',
      countryId: 233,
    },
    {
      id: 1419,
      name: 'Kentucky',
      iso2: 'KY',
      countryId: 233,
    },
    {
      id: 1457,
      name: 'Louisiana',
      iso2: 'LA',
      countryId: 233,
    },
    {
      id: 1453,
      name: 'Maine',
      iso2: 'ME',
      countryId: 233,
    },
    {
      id: 1401,
      name: 'Maryland',
      iso2: 'MD',
      countryId: 233,
    },
    {
      id: 1433,
      name: 'Massachusetts',
      iso2: 'MA',
      countryId: 233,
    },
    {
      id: 1426,
      name: 'Michigan',
      iso2: 'MI',
      countryId: 233,
    },
    {
      id: 1420,
      name: 'Minnesota',
      iso2: 'MN',
      countryId: 233,
    },
    {
      id: 1430,
      name: 'Mississippi',
      iso2: 'MS',
      countryId: 233,
    },
    {
      id: 1451,
      name: 'Missouri',
      iso2: 'MO',
      countryId: 233,
    },
    {
      id: 1446,
      name: 'Montana',
      iso2: 'MT',
      countryId: 233,
    },
    {
      id: 1408,
      name: 'Nebraska',
      iso2: 'NE',
      countryId: 233,
    },
    {
      id: 1458,
      name: 'Nevada',
      iso2: 'NV',
      countryId: 233,
    },
    {
      id: 1404,
      name: 'New Hampshire',
      iso2: 'NH',
      countryId: 233,
    },
    {
      id: 1417,
      name: 'New Jersey',
      iso2: 'NJ',
      countryId: 233,
    },
    {
      id: 1423,
      name: 'New Mexico',
      iso2: 'NM',
      countryId: 233,
    },
    {
      id: 1452,
      name: 'New York',
      iso2: 'NY',
      countryId: 233,
    },
    {
      id: 1447,
      name: 'North Carolina',
      iso2: 'NC',
      countryId: 233,
    },
    {
      id: 1418,
      name: 'North Dakota',
      iso2: 'ND',
      countryId: 233,
    },
    {
      id: 1431,
      name: 'Northern Mariana Islands',
      iso2: 'MP',
      countryId: 233,
    },
    {
      id: 4851,
      name: 'Ohio',
      iso2: 'OH',
      countryId: 233,
    },
    {
      id: 1421,
      name: 'Oklahoma',
      iso2: 'OK',
      countryId: 233,
    },
    {
      id: 1415,
      name: 'Oregon',
      iso2: 'OR',
      countryId: 233,
    },
    {
      id: 1422,
      name: 'Pennsylvania',
      iso2: 'PA',
      countryId: 233,
    },
    {
      id: 1449,
      name: 'Puerto Rico',
      iso2: 'PR',
      countryId: 233,
    },
    {
      id: 1461,
      name: 'Rhode Island',
      iso2: 'RI',
      countryId: 233,
    },
    {
      id: 1443,
      name: 'South Carolina',
      iso2: 'SC',
      countryId: 233,
    },
    {
      id: 1445,
      name: 'South Dakota',
      iso2: 'SD',
      countryId: 233,
    },
    {
      id: 1454,
      name: 'Tennessee',
      iso2: 'TN',
      countryId: 233,
    },
    {
      id: 1407,
      name: 'Texas',
      iso2: 'TX',
      countryId: 233,
    },
    {
      id: 1432,
      name: 'United States Minor Outlying Islands',
      iso2: 'UM',
      countryId: 233,
    },
    {
      id: 1413,
      name: 'United States Virgin Islands',
      iso2: 'VI',
      countryId: 233,
    },
    {
      id: 1414,
      name: 'Utah',
      iso2: 'UT',
      countryId: 233,
    },
    {
      id: 1409,
      name: 'Vermont',
      iso2: 'VT',
      countryId: 233,
    },
    {
      id: 1427,
      name: 'Virginia',
      iso2: 'VA',
      countryId: 233,
    },
    {
      id: 1462,
      name: 'Washington',
      iso2: 'WA',
      countryId: 233,
    },
    {
      id: 1429,
      name: 'West Virginia',
      iso2: 'WV',
      countryId: 233,
    },
    {
      id: 1441,
      name: 'Wisconsin',
      iso2: 'WI',
      countryId: 233,
    },
    {
      id: 1442,
      name: 'Wyoming',
      iso2: 'WY',
      countryId: 233,
    },
    {
      id: 5212,
      name: 'Baker Island',
      iso2: '81',
      countryId: 234,
    },
    {
      id: 5213,
      name: 'Howland Island',
      iso2: '84',
      countryId: 234,
    },
    {
      id: 5214,
      name: 'Jarvis Island',
      iso2: '86',
      countryId: 234,
    },
    {
      id: 5215,
      name: 'Johnston Atoll',
      iso2: '67',
      countryId: 234,
    },
    {
      id: 5216,
      name: 'Kingman Reef',
      iso2: '89',
      countryId: 234,
    },
    {
      id: 5217,
      name: 'Midway Islands',
      iso2: '71',
      countryId: 234,
    },
    {
      id: 5218,
      name: 'Navassa Island',
      iso2: '76',
      countryId: 234,
    },
    {
      id: 5219,
      name: 'Palmyra Atoll',
      iso2: '95',
      countryId: 234,
    },
    {
      id: 5220,
      name: 'Wake Island',
      iso2: '79',
      countryId: 234,
    },
    {
      id: 3205,
      name: 'Artigas',
      iso2: 'AR',
      countryId: 235,
    },
    {
      id: 3213,
      name: 'Canelones',
      iso2: 'CA',
      countryId: 235,
    },
    {
      id: 3211,
      name: 'Cerro Largo',
      iso2: 'CL',
      countryId: 235,
    },
    {
      id: 3208,
      name: 'Colonia',
      iso2: 'CO',
      countryId: 235,
    },
    {
      id: 3209,
      name: 'Durazno',
      iso2: 'DU',
      countryId: 235,
    },
    {
      id: 3203,
      name: 'Flores',
      iso2: 'FS',
      countryId: 235,
    },
    {
      id: 3217,
      name: 'Florida',
      iso2: 'FD',
      countryId: 235,
    },
    {
      id: 3215,
      name: 'Lavalleja',
      iso2: 'LA',
      countryId: 235,
    },
    {
      id: 3206,
      name: 'Maldonado',
      iso2: 'MA',
      countryId: 235,
    },
    {
      id: 3218,
      name: 'Montevideo',
      iso2: 'MO',
      countryId: 235,
    },
    {
      id: 3212,
      name: 'Paysandú',
      iso2: 'PA',
      countryId: 235,
    },
    {
      id: 3210,
      name: 'Río Negro',
      iso2: 'RN',
      countryId: 235,
    },
    {
      id: 3207,
      name: 'Rivera',
      iso2: 'RV',
      countryId: 235,
    },
    {
      id: 3216,
      name: 'Rocha',
      iso2: 'RO',
      countryId: 235,
    },
    {
      id: 3220,
      name: 'Salto',
      iso2: 'SA',
      countryId: 235,
    },
    {
      id: 3204,
      name: 'San José',
      iso2: 'SJ',
      countryId: 235,
    },
    {
      id: 3219,
      name: 'Soriano',
      iso2: 'SO',
      countryId: 235,
    },
    {
      id: 3221,
      name: 'Tacuarembó',
      iso2: 'TA',
      countryId: 235,
    },
    {
      id: 3214,
      name: 'Treinta y Tres',
      iso2: 'TT',
      countryId: 235,
    },
    {
      id: 2540,
      name: 'Andijan',
      iso2: 'AN',
      countryId: 236,
    },
    {
      id: 2541,
      name: 'Bukhara',
      iso2: 'BU',
      countryId: 236,
    },
    {
      id: 2538,
      name: 'Fergana',
      iso2: 'FA',
      countryId: 236,
    },
    {
      id: 2545,
      name: 'Jizzakh',
      iso2: 'JI',
      countryId: 236,
    },
    {
      id: 2548,
      name: 'Karakalpakstan',
      iso2: 'QR',
      countryId: 236,
    },
    {
      id: 2537,
      name: 'Namangan',
      iso2: 'NG',
      countryId: 236,
    },
    {
      id: 2542,
      name: 'Navoiy',
      iso2: 'NW',
      countryId: 236,
    },
    {
      id: 2543,
      name: 'Qashqadaryo',
      iso2: 'QA',
      countryId: 236,
    },
    {
      id: 2544,
      name: 'Samarqand',
      iso2: 'SA',
      countryId: 236,
    },
    {
      id: 2547,
      name: 'Sirdaryo',
      iso2: 'SI',
      countryId: 236,
    },
    {
      id: 2546,
      name: 'Surxondaryo',
      iso2: 'SU',
      countryId: 236,
    },
    {
      id: 2536,
      name: 'Tashkent',
      iso2: 'TK',
      countryId: 236,
    },
    {
      id: 2549,
      name: 'Tashkent',
      iso2: 'TO',
      countryId: 236,
    },
    {
      id: 2539,
      name: 'Xorazm',
      iso2: 'XO',
      countryId: 236,
    },
    {
      id: 4775,
      name: 'Malampa',
      iso2: 'MAP',
      countryId: 237,
    },
    {
      id: 4773,
      name: 'Penama',
      iso2: 'PAM',
      countryId: 237,
    },
    {
      id: 4776,
      name: 'Sanma',
      iso2: 'SAM',
      countryId: 237,
    },
    {
      id: 4774,
      name: 'Shefa',
      iso2: 'SEE',
      countryId: 237,
    },
    {
      id: 4777,
      name: 'Tafea',
      iso2: 'TAE',
      countryId: 237,
    },
    {
      id: 4772,
      name: 'Torba',
      iso2: 'TOB',
      countryId: 237,
    },
    {
      id: 2044,
      name: 'Amazonas',
      iso2: 'Z',
      countryId: 239,
    },
    {
      id: 2050,
      name: 'Anzoátegui',
      iso2: 'B',
      countryId: 239,
    },
    {
      id: 4856,
      name: 'Apure',
      iso2: 'C',
      countryId: 239,
    },
    {
      id: 2047,
      name: 'Aragua',
      iso2: 'D',
      countryId: 239,
    },
    {
      id: 2049,
      name: 'Barinas',
      iso2: 'E',
      countryId: 239,
    },
    {
      id: 2039,
      name: 'Bolívar',
      iso2: 'F',
      countryId: 239,
    },
    {
      id: 2040,
      name: 'Carabobo',
      iso2: 'G',
      countryId: 239,
    },
    {
      id: 2034,
      name: 'Cojedes',
      iso2: 'H',
      countryId: 239,
    },
    {
      id: 2051,
      name: 'Delta Amacuro',
      iso2: 'Y',
      countryId: 239,
    },
    {
      id: 4855,
      name: 'Distrito Capital',
      iso2: 'A',
      countryId: 239,
    },
    {
      id: 2035,
      name: 'Falcón',
      iso2: 'I',
      countryId: 239,
    },
    {
      id: 2045,
      name: 'Guárico',
      iso2: 'J',
      countryId: 239,
    },
    {
      id: 2055,
      name: 'La Guaira',
      iso2: 'X',
      countryId: 239,
    },
    {
      id: 2038,
      name: 'Lara',
      iso2: 'K',
      countryId: 239,
    },
    {
      id: 2053,
      name: 'Mérida',
      iso2: 'L',
      countryId: 239,
    },
    {
      id: 2037,
      name: 'Miranda',
      iso2: 'M',
      countryId: 239,
    },
    {
      id: 2054,
      name: 'Monagas',
      iso2: 'N',
      countryId: 239,
    },
    {
      id: 2052,
      name: 'Nueva Esparta',
      iso2: 'O',
      countryId: 239,
    },
    {
      id: 2036,
      name: 'Portuguesa',
      iso2: 'P',
      countryId: 239,
    },
    {
      id: 2056,
      name: 'Sucre',
      iso2: 'R',
      countryId: 239,
    },
    {
      id: 2048,
      name: 'Táchira',
      iso2: 'S',
      countryId: 239,
    },
    {
      id: 2043,
      name: 'Trujillo',
      iso2: 'T',
      countryId: 239,
    },
    {
      id: 2046,
      name: 'Venezuela',
      iso2: 'W',
      countryId: 239,
    },
    {
      id: 2041,
      name: 'Yaracuy',
      iso2: 'U',
      countryId: 239,
    },
    {
      id: 2042,
      name: 'Zulia',
      iso2: 'V',
      countryId: 239,
    },
    {
      id: 3794,
      name: 'An Giang',
      iso2: '44',
      countryId: 240,
    },
    {
      id: 3791,
      name: 'Bắc Ninh',
      iso2: '56',
      countryId: 240,
    },
    {
      id: 3778,
      name: 'Cà Mau',
      iso2: '59',
      countryId: 240,
    },
    {
      id: 4925,
      name: 'Cần Thơ',
      iso2: 'CT',
      countryId: 240,
    },
    {
      id: 3782,
      name: 'Cao Bằng',
      iso2: '04',
      countryId: 240,
    },
    {
      id: 3806,
      name: 'Đà Nẵng',
      iso2: 'DN',
      countryId: 240,
    },
    {
      id: 3829,
      name: 'Đắk Lắk',
      iso2: '33',
      countryId: 240,
    },
    {
      id: 3773,
      name: 'Điện Biên',
      iso2: '71',
      countryId: 240,
    },
    {
      id: 3821,
      name: 'Đồng Nai',
      iso2: '39',
      countryId: 240,
    },
    {
      id: 3769,
      name: 'Đồng Tháp',
      iso2: '45',
      countryId: 240,
    },
    {
      id: 3813,
      name: 'Gia Lai',
      iso2: '30',
      countryId: 240,
    },
    {
      id: 3810,
      name: 'Hà Nội',
      iso2: 'HN',
      countryId: 240,
    },
    {
      id: 3816,
      name: 'Hà Tĩnh',
      iso2: '23',
      countryId: 240,
    },
    {
      id: 3783,
      name: 'Hải Phòng',
      iso2: 'HP',
      countryId: 240,
    },
    {
      id: 3811,
      name: 'Hồ Chí Minh',
      iso2: 'SG',
      countryId: 240,
    },
    {
      id: 3768,
      name: 'Hưng Yên',
      iso2: '66',
      countryId: 240,
    },
    {
      id: 3793,
      name: 'Khánh Hòa',
      iso2: '34',
      countryId: 240,
    },
    {
      id: 3825,
      name: 'Lai Châu',
      iso2: '01',
      countryId: 240,
    },
    {
      id: 3818,
      name: 'Lâm Đồng',
      iso2: '35',
      countryId: 240,
    },
    {
      id: 3792,
      name: 'Lạng Sơn',
      iso2: '09',
      countryId: 240,
    },
    {
      id: 3817,
      name: 'Lào Cai',
      iso2: '02',
      countryId: 240,
    },
    {
      id: 3780,
      name: 'Nghệ An',
      iso2: '22',
      countryId: 240,
    },
    {
      id: 3786,
      name: 'Ninh Bình',
      iso2: '18',
      countryId: 240,
    },
    {
      id: 3801,
      name: 'Phú Thọ',
      iso2: '68',
      countryId: 240,
    },
    {
      id: 3828,
      name: 'Quảng Ngãi',
      iso2: '29',
      countryId: 240,
    },
    {
      id: 3814,
      name: 'Quảng Ninh',
      iso2: '13',
      countryId: 240,
    },
    {
      id: 3803,
      name: 'Quảng Trị',
      iso2: '25',
      countryId: 240,
    },
    {
      id: 3812,
      name: 'Sơn La',
      iso2: '05',
      countryId: 240,
    },
    {
      id: 3826,
      name: 'Tây Ninh',
      iso2: '37',
      countryId: 240,
    },
    {
      id: 3807,
      name: 'Thái Nguyên',
      iso2: '69',
      countryId: 240,
    },
    {
      id: 3771,
      name: 'Thanh Hóa',
      iso2: '21',
      countryId: 240,
    },
    {
      id: 3798,
      name: 'Thừa Thiên-Huế',
      iso2: '26',
      countryId: 240,
    },
    {
      id: 3795,
      name: 'Tuyên Quang',
      iso2: '07',
      countryId: 240,
    },
    {
      id: 3790,
      name: 'Vĩnh Long',
      iso2: '49',
      countryId: 240,
    },
    {
      id: 5074,
      name: 'Saint Croix',
      iso2: 'SC',
      countryId: 242,
    },
    {
      id: 5073,
      name: 'Saint John',
      iso2: 'SJ',
      countryId: 242,
    },
    {
      id: 5072,
      name: 'Saint Thomas',
      iso2: 'ST',
      countryId: 242,
    },
    {
      id: 5709,
      name: 'Alo',
      iso2: 'AL',
      countryId: 243,
    },
    {
      id: 5708,
      name: 'Sigave',
      iso2: 'SG',
      countryId: 243,
    },
    {
      id: 5707,
      name: 'Uvea',
      iso2: 'UV',
      countryId: 243,
    },
    {
      id: 1237,
      name: 'Abyan',
      iso2: 'AB',
      countryId: 245,
    },
    {
      id: 5467,
      name: "Ad Dali'",
      iso2: 'DA',
      countryId: 245,
    },
    {
      id: 1242,
      name: 'Adan',
      iso2: 'AD',
      countryId: 245,
    },
    {
      id: 1240,
      name: "Al Bayda'",
      iso2: 'BA',
      countryId: 245,
    },
    {
      id: 1241,
      name: 'Al Hudaydah',
      iso2: 'HU',
      countryId: 245,
    },
    {
      id: 1243,
      name: 'Al Jawf',
      iso2: 'JA',
      countryId: 245,
    },
    {
      id: 1251,
      name: 'Al Mahrah',
      iso2: 'MR',
      countryId: 245,
    },
    {
      id: 1235,
      name: 'Al Mahwit',
      iso2: 'MW',
      countryId: 245,
    },
    {
      id: 1232,
      name: 'Amanat Al Asimah',
      iso2: 'SA',
      countryId: 245,
    },
    {
      id: 1250,
      name: 'Amran',
      iso2: 'AM',
      countryId: 245,
    },
    {
      id: 1246,
      name: 'Dhamar',
      iso2: 'DH',
      countryId: 245,
    },
    {
      id: 1238,
      name: 'Hadhramaut',
      iso2: 'HD',
      countryId: 245,
    },
    {
      id: 1244,
      name: 'Hajjah',
      iso2: 'HJ',
      countryId: 245,
    },
    {
      id: 1233,
      name: 'Ibb',
      iso2: 'IB',
      countryId: 245,
    },
    {
      id: 1245,
      name: 'Lahij',
      iso2: 'LA',
      countryId: 245,
    },
    {
      id: 1234,
      name: "Ma'rib",
      iso2: 'MA',
      countryId: 245,
    },
    {
      id: 1248,
      name: 'Raymah',
      iso2: 'RA',
      countryId: 245,
    },
    {
      id: 1249,
      name: 'Saada',
      iso2: 'SD',
      countryId: 245,
    },
    {
      id: 1236,
      name: "Sana'a",
      iso2: 'SN',
      countryId: 245,
    },
    {
      id: 1247,
      name: 'Shabwah',
      iso2: 'SH',
      countryId: 245,
    },
    {
      id: 1239,
      name: 'Socotra',
      iso2: 'SU',
      countryId: 245,
    },
    {
      id: 1231,
      name: "Ta'izz",
      iso2: 'TA',
      countryId: 245,
    },
    {
      id: 1986,
      name: 'Central',
      iso2: '02',
      countryId: 246,
    },
    {
      id: 1984,
      name: 'Copperbelt',
      iso2: '08',
      countryId: 246,
    },
    {
      id: 1991,
      name: 'Eastern',
      iso2: '03',
      countryId: 246,
    },
    {
      id: 1987,
      name: 'Luapula',
      iso2: '04',
      countryId: 246,
    },
    {
      id: 1988,
      name: 'Lusaka',
      iso2: '09',
      countryId: 246,
    },
    {
      id: 1989,
      name: 'Muchinga',
      iso2: '10',
      countryId: 246,
    },
    {
      id: 1982,
      name: 'Northern',
      iso2: '05',
      countryId: 246,
    },
    {
      id: 1985,
      name: 'Northwestern',
      iso2: '06',
      countryId: 246,
    },
    {
      id: 1990,
      name: 'Southern',
      iso2: '07',
      countryId: 246,
    },
    {
      id: 1983,
      name: 'Western',
      iso2: '01',
      countryId: 246,
    },
    {
      id: 1956,
      name: 'Bulawayo',
      iso2: 'BU',
      countryId: 247,
    },
    {
      id: 1958,
      name: 'Harare',
      iso2: 'HA',
      countryId: 247,
    },
    {
      id: 1959,
      name: 'Manicaland',
      iso2: 'MA',
      countryId: 247,
    },
    {
      id: 1955,
      name: 'Mashonaland Central',
      iso2: 'MC',
      countryId: 247,
    },
    {
      id: 1951,
      name: 'Mashonaland East',
      iso2: 'ME',
      countryId: 247,
    },
    {
      id: 1953,
      name: 'Mashonaland West',
      iso2: 'MW',
      countryId: 247,
    },
    {
      id: 1960,
      name: 'Masvingo',
      iso2: 'MV',
      countryId: 247,
    },
    {
      id: 1954,
      name: 'Matabeleland North',
      iso2: 'MN',
      countryId: 247,
    },
    {
      id: 1952,
      name: 'Matabeleland South',
      iso2: 'MS',
      countryId: 247,
    },
    {
      id: 1957,
      name: 'Midlands',
      iso2: 'MI',
      countryId: 247,
    },
  ]
}

export async function getStateDataById(id: number): Promise<IState> {
  const list = await getStateListData()
  console.debug('got state list')
  console.debug('id:', id)
  const state = list.find((s: IState) => s.id == id)
  if (!state) {
    throw new Error(`Can't find state '${id}'`)
  }
  return state
}

export async function getStateListDataByCountryId(
  id: number
): Promise<IState[]> {
  const list = await getStateListData()
  console.debug('got state list')
  console.debug('id:', id)
  const states = list.filter((c: IState) => c.countryId == id)
  if (!states) {
    throw new Error(`Can't find states for country '${id}'`)
  }
  return states
}
